import React,{useState,useEffect,createContext,useContext,useMemo,useRef,useCallback,Component,Children,Fragment,forwardRef,cloneElement,PureComponent}from'react';import {getDisplayName,wrapDisplayName,compose,mapProps,pure,setDisplayName,defaultProps,withStateHandlers,withState,lifecycle,branch,withProps,withHandlers,withPropsOnChange}from'recompose';import {warn,padding,spacing,font as font$1,size as size$3,zIndex,shadow as shadow$1,border as border$3,transition as transition$1,merge as merge$2,media,Button as Button$8,Glyph,IconButton as IconButton$4,SlideAnimation,dropdownEnhancers,Dropdown as Dropdown$3,Modal as Modal$5,Title3 as Title3$2,Stack,Dialog as Dialog$3,Hint as Hint$3,Toast as Toast$1,Title1 as Title1$2,Title2 as Title2$2,Title4 as Title4$2,Article as Article$2,Body as Body$2,Caption as Caption$1,stickWidgetToInput,Date as Date$1,Time,DateTime,DropZone as DropZone$2,File,TextInput,DropdownSelect as DropdownSelect$4,EmailInput as EmailInput$1,NumberInput as NumberInput$1,Url,Table as Table$2,Cell as Cell$2,withTableContext,HeaderCell as HeaderCell$2,Tag as Tag$1,uncontrollable,ToastsContainer as ToastsContainer$3,StrongCaption as StrongCaption$1,triggerOnCompleteOnEnter,onBlurWithRelatedTarget}from'@signavio/ui/core';import _extends from'@babel/runtime/helpers/extends';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import _isString from'lodash/isString';import _defineProperty from'@babel/runtime/helpers/defineProperty';import _slicedToArray from'@babel/runtime/helpers/slicedToArray';import _merge from'lodash/merge';import Color$3 from'color';import _partial from'lodash/partial';import useStylesBase from'substyle';import TransitionGroup from'react-transition-group/TransitionGroup';import _classCallCheck from'@babel/runtime/helpers/classCallCheck';import _createClass from'@babel/runtime/helpers/createClass';import _assertThisInitialized from'@babel/runtime/helpers/assertThisInitialized';import _inherits from'@babel/runtime/helpers/inherits';import _possibleConstructorReturn from'@babel/runtime/helpers/possibleConstructorReturn';import _getPrototypeOf from'@babel/runtime/helpers/getPrototypeOf';import _toConsumableArray from'@babel/runtime/helpers/toConsumableArray';import _uniqBy from'lodash/uniqBy';import _includes from'lodash/includes';import startsWith from'lodash/startsWith';import _omit$1 from'lodash/fp/omit';import _typeof from'@babel/runtime/helpers/typeof';import invariant from'invariant';import _memoize from'lodash/memoize';import _identity from'lodash/identity';import _compact from'lodash/compact';import _omit from'lodash/omit';import keycode from'keycode';import _uniqueId from'lodash/uniqueId';import _omitBy from'lodash/omitBy';import _isUndefined from'lodash/isUndefined';import _isNil from'lodash/isNil';import {SortableHandle,SortableElement,arrayMove,SortableContainer}from'react-sortable-hoc';import _isFunction from'lodash/isFunction';import TextareaBase from'react-textarea-autosize';import {isValid,parseISO,getDaysInMonth,getMonth,startOfMonth,getDay,isToday,addDays,subDays,getDate,format,isSameDay,parse,isAfter,isEqual,isMatch}from'date-fns';import*as dateLocales from'date-fns/locale';import ReactDOM,{createPortal,findDOMNode}from'react-dom';import _without from'lodash/without';import _isNaN from'lodash/isNaN';import PT from'prop-types';import _get from'lodash/get';import _reverse from'lodash/reverse';import Transition from'react-transition-group/Transition';import VirtualList from'react-tiny-virtual-list';import _keys from'lodash/keys';// A higher-order component that can be used to mark components as deprecated
// If users render a deprecated components they will get a warning.

var deprecate = function deprecate(messageOrPropsMessages) {
  var warningShown = {
    general: false
  };
  if (_isString(messageOrPropsMessages)) {
    return function (WrappedComponent) {
      return function (props) {
        if (!warningShown.general) {
          warningShown.general = true;
          warn("<".concat(getDisplayName(WrappedComponent), " /> is deprecated: ").concat(messageOrPropsMessages));
        }
        return /*#__PURE__*/React.createElement(WrappedComponent, props);
      };
    };
  }
  return function (WrappedComponent) {
    return function (props) {
      _keys(messageOrPropsMessages).filter(function (propName) {
        return props[propName] !== undefined;
      }).forEach(function (propName) {
        if (!warningShown[propName]) {
          warningShown[propName] = true;
          warn("Passing prop `".concat(propName, "` to <").concat(getDisplayName(WrappedComponent), " /> is deprecated: ").concat(messageOrPropsMessages[propName]));
        }
      });
      return /*#__PURE__*/React.createElement(WrappedComponent, props);
    };
  };
};
var deprecate$1 = deprecate;var sealStyleProp = function sealStyleProp(WrappedComponent) {
  if (!WrappedComponent) {
    throw new Error('Received invalid component. Check the exports.');
  }
  var warningShown = false;
  var SealedComponent = function SealedComponent(props) {
    if (props.style) {
      if (!warningShown) {
        warningShown = true;
        warn("<".concat(getDisplayName(WrappedComponent), "> is passed a `style` prop. Do not customize styling of components from @signavio/ui."));
      }
    }
    return /*#__PURE__*/React.createElement(WrappedComponent, props);
  };
  SealedComponent.displayName = wrapDisplayName(WrappedComponent, 'styleSealed');
  return SealedComponent;
};
var sealStyleProp$1 = sealStyleProp;function backgroundColor(color, _ref) {
  var primary = _ref.primary,
    secondary = _ref.secondary,
    mono = _ref.mono;
  if (primary) {
    return color.header.primary || color.primary.base;
  }
  if (secondary) {
    return color.header.secondary || color.secondary.base;
  }
  if (mono) {
    return color.header.mono || color.mono.middle;
  }
  return null;
}var onSurface$1 = Color$3('#000000');
var onContrast$1 = Color$3('#FFFFFF');
var themePrimary$2 = Color$3('#AD0F5B');
var themeSecondary$1 = Color$3('#01737A');
var themeDanger$2 = Color$3('#C12028');
var background$2 = '#F2F2F2';
var surface$1 = '#FFFFFF';
var contrast$1 = '#242424';
var primary$2 = {
  base: themePrimary$2.hex(),
  dark: themePrimary$2.darken(0.3).hex(),
  // deprecated
  light: themePrimary$2.alpha(0.12).string(),
  // deprecated
  lighter: themePrimary$2.alpha(0.08).string() // deprecated
};

var secondary$2 = {
  base: themeSecondary$1.hex(),
  dark: themeSecondary$1.darken(0.3).hex(),
  // deprecated
  light: themeSecondary$1.alpha(0.12).string(),
  // deprecated
  lighter: themeSecondary$1.alpha(0.08).string() // deprecated
};

var danger$2 = {
  base: themeDanger$2.hex(),
  dark: themeDanger$2.darken(0.25).hex(),
  // deprecated
  light: themeDanger$2.alpha(0.12).string(),
  // deprecated
  lighter: themeDanger$2.alpha(0.08).string() // deprecated
};

// Text & Icon
var text$1 = {
  base: onSurface$1.alpha(0.9).string(),
  inactive: onSurface$1.alpha(0.64).string(),
  disabled: onSurface$1.alpha(0.42).string()
};
var contrastText$1 = {
  base: onContrast$1.string(),
  inactive: onContrast$1.alpha(0.8).string(),
  disabled: onContrast$1.alpha(0.56).string()
};
var coloredText$2 = {
  primary: primary$2.base,
  secondary: secondary$2.base,
  danger: danger$2.base
};

// Tints
var shading$1 = {
  onLight: onSurface$1.alpha(0.04).string(),
  onDark: onContrast$1.alpha(0.08).string()
};
var divider$1 = {
  base: onSurface$1.alpha(0.16).string(),
  contrast: onContrast$1.alpha(0.24).string()
};
var hover$3 = {
  base: onSurface$1.alpha(0.08).string(),
  contrast: onContrast$1.alpha(0.12).string()
};
var active$2 = {
  primary: primary$2.lighter,
  secondary: secondary$2.lighter,
  danger: danger$2.lighter,
  contrast: onContrast$1.alpha(0.42).string()
};
var activeHover$2 = {
  primary: primary$2.light,
  secondary: secondary$2.light,
  danger: danger$2.light,
  contrast: onContrast$1.alpha(0.33).string()
};

// Status
// Status
var status$2 = {
  info: '#0a6ed1',
  success: '#107e3e',
  warning: '#b3590a',
  danger: danger$2.base,
  light: {
    info: '#f5faff',
    success: '#f1fdf6',
    warning: '#fef7f1',
    danger: '#ffebeb'
  }
};
var extended11$1 = '#fb8824';
var extended12$1 = '#d1711e';
var extended21$1 = '#ffb300';
var extended22$1 = '#cc8f00';
var extended31$1 = '#359100';
var extended32$1 = '#276b00';
var extended41$1 = '#0f9660';
var extended42$1 = '#0b6e46';
var extended51$1 = '#0092b7';
var extended52$1 = '#006a85';
var extended61$1 = '#4a6ae5';
var extended62$1 = '#3c51b0';
var extended71$1 = '#9150f2';
var extended72$1 = '#6f3dba';
var extended81$1 = '#d13dc5';
var extended82$1 = '#a12f97';
var extended91$1 = '#db427d';
var extended92$1 = '#a6325e';

// Chart Palette Colors
var chartPrimary$1 = Color$3('#11bdc0');
var chartSecondary$1 = Color$3('#a1c265');
var chartTertiary$1 = Color$3('#e3b264');
var chart1$2 = {
  base: chartPrimary$1.hex(),
  min: '#afdada',
  max: chartPrimary$1.darken(0.32).saturate(0.16).hex()
};
var chart2$2 = {
  base: chartSecondary$1.hex(),
  min: chartSecondary$1.lighten(0.32).desaturate(0.24).hex(),
  max: chartSecondary$1.darken(0.32).saturate(0.16).hex()
};
var chart3$2 = {
  base: chartTertiary$1.hex(),
  min: chartTertiary$1.lighten(0.32).desaturate(0.24).hex(),
  max: chartTertiary$1.darken(0.32).saturate(0.16).hex()
};
var chart4$2 = {
  base: '#79b8d1'
};
var chart5$2 = {
  base: '#c58dd9'
};
var chart6$2 = {
  base: '#7cc492'
};
var chart7$2 = {
  base: '#d68dad'
};
var chart8$2 = {
  base: '#deca5b'
};
var chart9$2 = {
  base: '#8ba7e8'
};
var chart10$2 = {
  base: '#e3a581'
};
var chart11$2 = {
  base: '#a49be8'
};
var chartMono$2 = {
  base: '#808080',
  min: '#ddd',
  max: '#555'
};

// Content Type Colors
var externalLink$1 = extended61$1;
var dictionaryItem$1 = extended91$1;
var diagram$1 = extended71$1;
var system$1 = text$1.inactive;
var risk$1 = extended11$1;
var control$1 = extended31$1;
var folder$1 = extended21$1;
var header$4 = {}; // deprecated

var mono$1 = {
  ultradark: '#333',
  // deprecated
  dark: '#555',
  // deprecated
  middle: '#7f7f7f',
  // deprecated
  lighter: '#ccc',
  // deprecated
  light: '#ddd',
  // deprecated
  ultralight: '#eee' // deprecated
};var color$4=/*#__PURE__*/Object.freeze({__proto__:null,onSurface:onSurface$1,onContrast:onContrast$1,themePrimary:themePrimary$2,themeSecondary:themeSecondary$1,themeDanger:themeDanger$2,background:background$2,surface:surface$1,contrast:contrast$1,primary:primary$2,secondary:secondary$2,danger:danger$2,text:text$1,contrastText:contrastText$1,coloredText:coloredText$2,shading:shading$1,divider:divider$1,hover:hover$3,active:active$2,activeHover:activeHover$2,status:status$2,extended11:extended11$1,extended12:extended12$1,extended21:extended21$1,extended22:extended22$1,extended31:extended31$1,extended32:extended32$1,extended41:extended41$1,extended42:extended42$1,extended51:extended51$1,extended52:extended52$1,extended61:extended61$1,extended62:extended62$1,extended71:extended71$1,extended72:extended72$1,extended81:extended81$1,extended82:extended82$1,extended91:extended91$1,extended92:extended92$1,chartPrimary:chartPrimary$1,chartSecondary:chartSecondary$1,chartTertiary:chartTertiary$1,chart1:chart1$2,chart2:chart2$2,chart3:chart3$2,chart4:chart4$2,chart5:chart5$2,chart6:chart6$2,chart7:chart7$2,chart8:chart8$2,chart9:chart9$2,chart10:chart10$2,chart11:chart11$2,chartMono:chartMono$2,externalLink:externalLink$1,dictionaryItem:dictionaryItem$1,diagram:diagram$1,system:system$1,risk:risk$1,control:control$1,folder:folder$1,header:header$4,mono:mono$1});var logo$5 = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" width="88px" height="40px" viewBox="0 0 88 40"><path fill="#fff" d="M39.57,16.1c-0.39,0-0.7,0.3-0.7,0.65v8.57c0,0.2,0.2,0.64,0.7,0.64c0.5,0,0.7-0.43,0.7-0.64v-8.57C40.28,16.53,40.06,16.1,39.57,16.1zM46.07,26c1.37,0,2.55-0.4,2.63-0.45c0.1-0.05,0.3-0.19,0.38-0.3c0.08-0.1,0.14-0.25,0.14-0.44v-3.45c0-0.3-0.14-0.47-0.27-0.58c-0.1-0.1-0.34-0.23-0.6-0.2h-2.07c-0.3,0-0.69,0.2-0.69,0.63c0,0.34,0.29,0.6,0.69,0.6h1.53v2.7c-0.5,0.15-1,0.24-1.7,0.24c-1.33,0-2.37-0.66-2.37-2.09v-3.23c0-1.45,1.05-2.09,2.37-2.09c0.77,0,1.43,0.35,1.76,0.47c0.18,0.07,0.73,0.15,0.93-0.3c0.19-0.43-0.15-0.74-0.28-0.8c-0.63-0.33-1.54-0.59-2.4-0.59c-2.24,0-3.78,1.3-3.78,3.36v3.15C42.29,24.4,43.57,26,46.07,26zM83.86,16.1c-2.08,0-3.58,1.24-3.58,3.19v3.49c0,2.09,1.67,3.19,3.59,3.19c2.29,0,3.58-1.44,3.58-3.19V19.3C87.45,17.55,86.15,16.1,83.86,16.1zM86.04,22.83c0,1.08-0.7,1.9-2.17,1.9c-1.3,0-2.17-0.7-2.17-1.9v-3.56c0-1.26,0.9-1.94,2.17-1.94c1.34,0,2.17,0.73,2.17,1.94V22.83zM33.77,24.75c-0.69,0-1.35-0.23-2-0.57c-0.18-0.1-0.66-0.15-0.86,0.19c-0.24,0.39,0,0.76,0.27,0.93c0.48,0.29,1.66,0.68,2.6,0.68c2.4,0,3.28-1.69,3.28-2.68c0-1.95-1.5-2.6-3.08-3.24c-0.8-0.3-1.8-0.58-1.8-1.5c0-0.86,0.87-1.23,1.8-1.23c0.64,0,1.47,0.3,1.89,0.44c0.29,0.09,0.73,0,0.85-0.34c0.1-0.3,0-0.64-0.44-0.83c-0.65-0.27-1.55-0.48-2.23-0.48c-1.4,0-3.3,0.65-3.3,2.4c0,0.79,0.3,1.49,1,2c0.68,0.46,1.69,0.77,2,0.9c1.18,0.5,1.93,0.84,1.84,1.89C35.56,24.1,34.75,24.75,33.77,24.75zM74.87,16.14c-0.3-0.09-0.7-0-0.87,0.4c-0,0.1-2.56,7.1-2.56,7.1s-2.55-7.06-2.59-7.16c-0.13-0.3-0.4-0.47-0.84-0.37c-0.46,0.13-0.54,0.56-0.48,0.74c0.04,0.1,3.1,8.48,3.15,8.59c0.1,0.3,0.38,0.5,0.75,0.5c0.5,0,0.7-0.35,0.75-0.49c0.04-0.1,3.1-8.46,3.13-8.53C75.44,16.57,75.2,16.24,74.87,16.14zM67.68,25.6c0.07-0.13,0.1-0.3,0.04-0.47c-0.06-0.15-3.2-8.39-3.29-8.58c-0.1-0.3-0.46-0.46-0.74-0.46c-0.26,0-0.6,0.15-0.74,0.46c-0.08,0.2-3.2,8.4-3.29,8.58c-0.13,0.35,0.14,0.6,0.19,0.65c0.17,0.13,0.33,0.17,0.47,0.17c0.3,0,0.56-0.19,0.65-0.4c0.04-0.1,0.87-2.27,0.87-2.27h3.7c0,0,0.8,2.14,0.86,2.24c0.1,0.3,0.38,0.45,0.66,0.45C67.34,26,67.57,25.8,67.68,25.6zM62.3,22.04l1.38-3.67l1.38,3.67H62.3zM77.56,16.1c-0.38,0-0.7,0.3-0.7,0.65v8.57c0,0.2,0.2,0.64,0.7,0.64c0.5,0,0.7-0.43,0.7-0.64v-8.57C78.26,16.53,78.05,16.1,77.56,16.1zM58.2,25.25v-8.49c0-0.39-0.37-0.65-0.7-0.65c-0.35,0-0.7,0.26-0.7,0.65v6.36c0,0-4.04-6.58-4.08-6.65c-0.14-0.23-0.38-0.36-0.69-0.36c-0.4,0-0.78,0.3-0.78,0.7v8.5c0,0.35,0.33,0.64,0.7,0.64c0.4,0,0.7-0.3,0.7-0.64v-6.36c0,0,4,6.55,4.08,6.63c0.1,0.19,0.34,0.36,0.69,0.36C57.85,26,58.2,25.7,58.2,25.25z"/><path fill="#fff" d="M25.26,19.37c-0.09-0.16-0.28-0.3-0.5-0.3c-0.1-0-1.1-0.06-2-0.08c-0.2-0-0.73-0-1-0c-0.05,0-0.09,0-0.1-0c-0-0-0.06-0.04-0.08-0.09c-0.09-0.27-0.27-0.88-0.5-1.3c-0.2-0.39-0.47-0.74-0.66-1.1c-0.19-0.37-0.35-0.65-0.37-0.77c-0-0.1,0.83,0.27,0.9,0.3c0.07,0,0.29,0.1,0.4,0.1c0.1,0,0.2-0,0.4-0.2c0.25-0.2,0.28-0.46,0.26-0.68c-0-0.16-0.18-0.39-0.33-0.6c-0.15-0.2-0.3-0.43-0.37-0.63c-0.16-0.45-0.26-0.9-0.57-1.5c-0.2-0.4-0.73-0.7-1-0.85c-0.44-0.23-0.86-0.36-0.86-0.36c-0.48-2.08-1.19-2.96-3-3.47c-1.65-0.47-2.5-0.73-3.24-1.4c-0.1-0.1-0.23-0.14-0.3-0.09c-0.1,0.06-0.09,0.18-0,0.29c0.43,0.83,1.56,1.5,3.1,2.07c1.15,0.4,1.79,1.08,1.93,2.08c-0.3,0-0.69-0.18-0.77-0.2c-0.1-0-0.17-0-0.2,0c-0,0-0.06,0.06-0.04,0.16c0,0.1,0.13,0.6,0.35,1.05c0.23,0.43,0.29,0.54,0.37,0.66c-0.05,0.29-0.2,1.45-0.19,2.53c0,1.08-0,2.73-0.09,3c0,0-0.17,0.16-0.57,0.5c-0.4,0.35-2.69,2-3.66,2.6c-0.84,0.5-3.36,1.94-5.3,2.47c-0.77,0.2-0.89,0.2-0.9,0.34c-0,0.07,0.04,0.13,0.17,0.19c0.17,0.06,1.17,0.43,1.16,0.6c-0,0.48-0.44,1-0.7,1.76c-0.13,0.45-0.6,0.84-1.07,1.14c-0.24,0.15-0.47,0.28-0.66,0.38c-0.2,0.1-0.33,0.17-0.44,0.3c-0.2,0.3-0.27,0.67-0.66,1.06c-0.44,0.44-0.88,0.94-1.2,1.28c-0.37,0.39-0.78,1.29-1.07,1.56c-0.13,0.14-0.33,0.24-0.45,0.28c-0.1,0.04-0.38,0.08-0.43,0.24c-0.05,0.16-0.19,0.46-0.1,0.84c0.05,0.2,0.2,0.26,0.36,0.27c0.1,0,0.17-0.04,0.24-0.08c0.08-0.05,0.6-0.44,1.06-0.94c1.05-1.19,2.17-2.8,3.04-3.45c0.9-0.67,3.5-1.58,4.67-2.33c0.58-0.38,1.2-1,1.73-1.49c0.26-0.25,0.48-0.49,0.65-0.66c0.09-0.08,0.16-0.15,0.2-0.2c0-0,0.04-0,0.05-0.05c0.35-0.05,2.96-0.16,5.39-1c1.1-0.38,1.8-1,2.3-1.56c0.37-0.4,0.85-1.17,0.94-1.2c0.05-0,0.28-0.07,0.34-0.08c0.57-0.1,1.05-0.1,1.44-0.1c0.08,0,0.1,0,0.14,0c0,0-0.5,0.76-0.7,1c-0.2,0.27-0.5,0.5-0.74,0.66c-0.2,0.16-0.48,0.27-0.6,0.5c-0.13,0.24-0.33,0.5-0.78,0.7c-0.68,0.3-0.8,0.5-0.77,0.7c0,0.2,0.2,0.7,0.4,0.7c0.13,0,0.34-0.1,0.57-0.24c0.66-0.4,2.25-1.9,2.86-2.54c0.6-0.6,1.4-1.8,1.7-2.26C25.35,19.8,25.35,19.54,25.26,19.37z"/></svg>';
var logo$6 = logo$5;var lineHeight$1 = 1.5;
var name$1 = 'default';var defaultSignavioTheme=/*#__PURE__*/Object.freeze({__proto__:null,color:color$4,lineHeight:lineHeight$1,name:name$1,padding:padding,spacing:spacing,font:font$1,size:size$3,zIndex:zIndex,shadow:shadow$1,border:border$3,logo:logo$6});function ownKeys$1e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1e(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var calculateAbsoluteLineHeight$1 = function calculateAbsoluteLineHeight(fontSize, lineHeight) {
  return parseInt(fontSize, 10) * lineHeight;
};
var calculateHeight$1 = function calculateHeight(fontSize, lineHeight, verticalPadding) {
  return calculateAbsoluteLineHeight$1(fontSize, lineHeight) + 2 * verticalPadding;
};
var calculateVerticalPadding$1 = function calculateVerticalPadding(targetHeight, fontSize, lineHeight) {
  return (targetHeight - parseInt(fontSize, 10) * lineHeight) / 2;
};
var calculateIconSize$1 = function calculateIconSize(_ref) {
  var font = _ref.font,
    lineHeight = _ref.lineHeight,
    padding = _ref.padding;
  return calculateHeight$1(font.size.normal, lineHeight, padding.small);
};
var calculateSmallIconSize$1 = function calculateSmallIconSize(_ref2) {
  var font = _ref2.font,
    lineHeight = _ref2.lineHeight,
    padding = _ref2.padding;
  return calculateHeight$1(font.size.small, lineHeight, padding.xsmall);
};
function capitalize$1(str) {
  return str.replace(/(^| )(\w)/g, function (x) {
    return x.toUpperCase();
  });
}
function grayscale$1() {
  var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
  return {
    filter: "grayscale(".concat(amount, ")")
  };
}
function ellipsis$1() {
  return {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  };
}
function color$3(background) {
  var dark = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : text$1.base;
  var light = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : contrastText$1.base;
  if (!background) {
    return null;
  }
  return Color$3(background).isLight() ? dark : light;
}
var shadowOffset$1 = '2px';
var shadowColor$1 = 'rgba(0, 0, 0, 0.06)';
function boxShadow$1() {
  var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shadowOffset$1;
  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : shadowOffset$1;
  var spread = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var clr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : shadowColor$1;
  return {
    boxShadow: "".concat(left, " ").concat(top, " ").concat(spread, " ").concat(clr)
  };
}
function boxShadowInset$1() {
  var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0px';
  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '3px';
  var spread = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '5px';
  var clr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'rgba(0, 0, 0, 0.125)';
  return {
    boxShadow: "inset ".concat(left, " ").concat(top, " ").concat(spread, " ").concat(clr)
  };
}
function textColor$2(background) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$lighten = _ref3.lighten,
    lighten = _ref3$lighten === void 0 ? 0.5 : _ref3$lighten,
    _ref3$darken = _ref3.darken,
    darken = _ref3$darken === void 0 ? 0.4 : _ref3$darken;
  var clr = Color$3(background);
  return (clr.isLight() ? clr.darken(darken) : clr.lighten(lighten)).hex();
}

// eslint-disable-next-line no-underscore-dangle
function _border$1() {
  var _ref4;
  var borderWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var borderStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'solid';
  var borderColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'black';
  var position = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return _ref4 = {}, _defineProperty(_ref4, "border".concat(capitalize$1(position), "Width"), borderWidth), _defineProperty(_ref4, "border".concat(capitalize$1(position), "Style"), borderStyle), _defineProperty(_ref4, "border".concat(capitalize$1(position), "Color"), borderColor), _ref4;
}
function border$2() {
  var borderWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var borderStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'solid';
  var borderColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'black';
  return _objectSpread$1e(_objectSpread$1e(_objectSpread$1e(_objectSpread$1e({}, borderTop$1(borderWidth, borderStyle, borderColor)), borderBottom$1(borderWidth, borderStyle, borderColor)), borderLeft$1(borderWidth, borderStyle, borderColor)), borderRight$1(borderWidth, borderStyle, borderColor));
}
function popover$1(_ref5) {
  var mono = _ref5.mono;
  var localShadowOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : shadowOffset$1;
  return _objectSpread$1e(_objectSpread$1e({}, boxShadow$1(localShadowOffset, localShadowOffset)), border$2(1, 'solid', mono.lighter));
}
function hover$2(backgroundColor) {
  return Color$3(backgroundColor).darken(0.2).rgb().string();
}
var borderTop$1 = _partial(_border$1, _partial.placeholder, _partial.placeholder, _partial.placeholder, 'top');
var borderRight$1 = _partial(_border$1, _partial.placeholder, _partial.placeholder, _partial.placeholder, 'right');
var borderBottom$1 = _partial(_border$1, _partial.placeholder, _partial.placeholder, _partial.placeholder, 'bottom');
var borderLeft$1 = _partial(_border$1, _partial.placeholder, _partial.placeholder, _partial.placeholder, 'left');
function clearTransition$1() {
  return {
    transition: null
  };
}
var inputPadding = 2;

// TODO move to styled Input component
var input$1 = function input(_ref6) {
  var _ref6$color = _ref6.color,
    mono = _ref6$color.mono,
    primary = _ref6$color.primary,
    font = _ref6.font;
    _ref6.padding;
    var lineHeight = _ref6.lineHeight;
  return _objectSpread$1e(_objectSpread$1e({
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    background: 'none',
    fontSize: font.size.normal,
    lineHeight: lineHeight,
    paddingTop: inputPadding,
    paddingBottom: inputPadding,
    paddingRight: 0,
    paddingLeft: 0,
    // fixes a weird problem for inputs in Tiles in Safari
    margin: 0
  }, border$2(0)), {}, {
    '&focus': {
      borderColor: primary.base,
      outline: 0
    },
    ':focus': {
      borderColor: primary.base,
      outline: 0
    },
    '&disabled': {
      cursor: 'not-allowed',
      color: mono.middle
    }
  });
};
var placeholder$1 = function placeholder(_ref7) {
  var mono = _ref7.color.mono;
  return {
    color: mono.middle
  };
};
var applyGlobalFioriStyles = function applyGlobalFioriStyles() {
  var setBodyProperty = function setBodyProperty(property, value) {
    document.getElementsByTagName('body')[0].style.setProperty(property, value);
  };
  setBodyProperty('--glucose-bold-font-weight', '700');
  setBodyProperty('--glucose-main-font-weight', '400');
  setBodyProperty('--glucose-black-font-weight', '900');
  setBodyProperty('--glucose-link-text-color', 'var(--sapLinkColor, #0070F2)');
  setBodyProperty('--glucose-link-text-color-active', 'var(--sapLink_SubtleColor, #0057D2)');
  setBodyProperty('--glucose-pre-font-family', "'72Mono', '72Monofull', 'Lucida Console', monospace");
  setBodyProperty('--glucose-main-font-family', "'72', '72full', Arial, Helvetica, sans-serif");
  setBodyProperty('--glucose-icon-font-family', 'Horizon-Icons');
  setBodyProperty('--glucose-letter-spacing-title1', '0');
  setBodyProperty('--glucose-letter-spacing-title2', '0');
  setBodyProperty('--glucose-letter-spacing-title3', '0');
  setBodyProperty('--glucose-letter-spacing-button1', '0');
  setBodyProperty('--glucose-letter-spacing-button2', '0');
  setBodyProperty('--glucose-heading-font-family', "'72Black', '72Blackfull', Arial, Helvetica, sans-serif");
};
var getUpdatedThemeColors = function getUpdatedThemeColors(cssVariables) {
  var themeColors = {};
  var designTokens = Object.keys(cssVariables);
  designTokens.forEach(function (colorToken) {
    var _document$documentEle;
    var cssVariable = "--".concat(colorToken);
    themeColors[cssVariable] = cssVariables[colorToken];
    (_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.style.setProperty(cssVariable, cssVariables[colorToken]);
  });
  return themeColors;
};var utils$1=/*#__PURE__*/Object.freeze({__proto__:null,calculateAbsoluteLineHeight:calculateAbsoluteLineHeight$1,calculateHeight:calculateHeight$1,calculateVerticalPadding:calculateVerticalPadding$1,calculateIconSize:calculateIconSize$1,calculateSmallIconSize:calculateSmallIconSize$1,capitalize:capitalize$1,grayscale:grayscale$1,ellipsis:ellipsis$1,color:color$3,boxShadow:boxShadow$1,boxShadowInset:boxShadowInset$1,textColor:textColor$2,border:border$2,popover:popover$1,hover:hover$2,borderTop:borderTop$1,borderRight:borderRight$1,borderBottom:borderBottom$1,borderLeft:borderLeft$1,clearTransition:clearTransition$1,inputPadding:inputPadding,input:input$1,placeholder:placeholder$1,applyGlobalFioriStyles:applyGlobalFioriStyles,getUpdatedThemeColors:getUpdatedThemeColors,transition:transition$1,merge:merge$2});function textColor$1(themeColor, options) {
  return color$3(backgroundColor(themeColor, options));
}function backdropColor(color, options) {
  var background = backgroundColor(color, options);
  var isLight = Color$3(background).isLight();
  var result = Color$3(background)[isLight ? 'darken' : 'lighten'](0.1);
  return result.rgb().toString();
}var header$3=/*#__PURE__*/Object.freeze({__proto__:null,backgroundColor:backgroundColor,color:textColor$1,backdropColor:backdropColor});var size$2 = {
  xxsmall: '6pt',
  xsmall: '9pt',
  small: '12px',
  button: '14px',
  normal: '16px',
  large: '18px',
  xlarge: '20px',
  xxlarge: '24px',
  h1: '40px',
  h2: '30px',
  title1: '44px',
  title2: '34px',
  title3: '24px',
  title4: '18px',
  article: '16px',
  body: '14px'
};
var indicator = {
  normal: size$2.small,
  small: 9
};
var weight = {
  normal: 400,
  bold: 700,
  black: 900
};
var family = {
  normal: "'72', '72full', Arial, Helvetica, sans-serif",
  heading: "'72Black', '72Blackfull', Arial, Helvetica, sans-serif",
  monospace: '"72Mono", "72Monofull",  "Lucida Console", monospace'
};
var title1 = {
  fontFamily: family.heading,
  fontSize: size$2.title1,
  fontWeight: weight.black,
  letterSpacing: '0',
  lineHeight: '56px'
};
var title2 = {
  fontFamily: family.heading,
  fontSize: size$2.title2,
  fontWeight: weight.black,
  letterSpacing: '0',
  lineHeight: '44px'
};
var title3 = {
  fontFamily: family.heading,
  fontSize: size$2.title3,
  fontWeight: weight.black,
  letterSpacing: '0em',
  lineHeight: '32px'
};
var title4 = {
  fontFamily: family.normal,
  fontSize: size$2.title4,
  fontWeight: weight.bold,
  letterSpacing: '0em',
  lineHeight: '28px'
};
var article = {
  fontFamily: family.normal,
  fontSize: size$2.article,
  fontWeight: weight.normal,
  letterSpacing: '0em',
  lineHeight: '24px'
};
var body = {
  fontFamily: family.normal,
  fontWeight: weight.normal,
  fontSize: size$2.body,
  letterSpacing: '0em',
  lineHeight: '20px'
};
var caption = {
  fontFamily: family.normal,
  fontWeight: weight.normal,
  fontSize: size$2.small,
  letterSpacing: '0em',
  lineHeight: '20px'
};
var strongCaption = {
  fontFamily: family.normal,
  fontWeight: weight.bold,
  fontSize: size$2.small,
  letterSpacing: '0em',
  lineHeight: '20px'
};
var button1 = {
  fontFamily: family.normal,
  fontSize: size$2.button,
  fontWeight: weight.bold,
  letterSpacing: '0em',
  lineHeight: '16px'
};
var button2 = {
  fontFamily: family.normal,
  fontSize: size$2.small,
  fontWeight: weight.bold,
  letterSpacing: '0em',
  lineHeight: '16px'
};var font=/*#__PURE__*/Object.freeze({__proto__:null,size:size$2,indicator:indicator,weight:weight,family:family,title1:title1,title2:title2,title3:title3,title4:title4,article:article,body:body,caption:caption,strongCaption:strongCaption,button1:button1,button2:button2});var card = {
  boxShadow: '0 0 2px 0 rgba(85, 107, 130, 0.16), 0 4px 2px 0 rgba(85, 107, 130, 0.10)'
};
var menu = {
  boxShadow: '0 -1px 0 0 rgba(85, 107, 130, 0.10), 0 0 8px 0 rgba(85, 107, 130, 0.20)'
};
var modal$1 = {
  boxShadow: '0 2px 8px 0 rgba(85, 107, 130, 0.30)'
};
var header$2 = {
  boxShadow: '0 -1px 0 0 rgba(85, 107, 130, 0.10), 0 0 8px 0 rgba(85, 107, 130, 0.20)'
};var shadow=/*#__PURE__*/Object.freeze({__proto__:null,card:card,menu:menu,modal:modal$1,header:header$2});var button = {
  borderRadius: {
    regular: '8px',
    small: '6px'
  }
};
var modal = {
  borderRadius: '12px'
};
var hint = {
  borderRadius: '8px'
};
var chipDropDown = {
  borderRadius: '12px'
};
var tab = {
  borderRadius: {
    regular: '8px 8px 0 0',
    small: '6px 6px 0 0'
  }
};
var sidebarItem = {
  borderRadius: '0 8px 8px 0'
};var border$1=/*#__PURE__*/Object.freeze({__proto__:null,button:button,modal:modal,hint:hint,chipDropDown:chipDropDown,tab:tab,sidebarItem:sidebarItem});function ownKeys$1d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1d(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var sapMap = {
  primaryBase: '--sapBrandColor',
  themePrimary: '--sapBrandColor',
  secondaryBase: '--sapAccentColor',
  themeSecondary: '--sapAccentColor',
  danger: '--sapNegativeColor',
  themeDanger: '--sapNegativeColor',
  background: '--sapBackgroundColor',
  surface: '--sapBaseColor',
  contrast: '--sapShell_NeutralColor'
};
var onSurface = Color$3('#12171C');
var onContrast = Color$3('#FFFFFF');
var themePrimary$1 = Color$3('#0070F2');
var themeSecondary = Color$3('#5D36FF');
var themeDanger$1 = Color$3('#DC0D0E');
var background$1 = '#F5F6F7';
var surface = '#FFFFFF';
var contrast = '#12171C';
var primary$1 = {
  base: themePrimary$1.hex(),
  dark: themePrimary$1.darken(0.3).hex(),
  // deprecated
  light: themePrimary$1.alpha(0.12).string(),
  // deprecated
  lighter: themePrimary$1.alpha(0.08).string() // deprecated
};

var secondary$1 = {
  base: themeSecondary.hex(),
  dark: themeSecondary.darken(0.3).hex(),
  // deprecated
  light: themeSecondary.alpha(0.12).string(),
  // deprecated
  lighter: themeSecondary.alpha(0.08).string() // deprecated
};

var danger$1 = {
  base: themeDanger$1.hex(),
  dark: themeDanger$1.darken(0.25).hex(),
  // deprecated
  light: themeDanger$1.alpha(0.12).string(),
  // deprecated
  lighter: themeDanger$1.alpha(0.08).string() // deprecated
};

// Text & Icon
var text = {
  base: onSurface.alpha(0.9).string(),
  inactive: onSurface.alpha(0.64).string(),
  disabled: onSurface.alpha(0.42).string()
};
var contrastText = {
  base: onContrast.string(),
  inactive: onContrast.alpha(0.8).string(),
  disabled: onContrast.alpha(0.56).string()
};
var coloredText$1 = {
  primary: primary$1.base,
  secondary: secondary$1.base,
  danger: danger$1.base
};

// Tints
var shading = {
  onLight: onSurface.alpha(0.04).string(),
  onDark: onContrast.alpha(0.08).string()
};
var divider = {
  base: onSurface.alpha(0.16).string(),
  contrast: onContrast.alpha(0.24).string()
};
var hover$1 = {
  base: onSurface.alpha(0.08).string(),
  contrast: onContrast.alpha(0.12).string()
};
var active$1 = {
  primary: primary$1.lighter,
  secondary: primary$1.lighter,
  danger: danger$1.lighter,
  contrast: onContrast.alpha(0.33).string()
};
var activeHover$1 = {
  primary: primary$1.light,
  secondary: primary$1.light,
  danger: danger$1.light,
  contrast: onContrast.alpha(0.33).string()
};

// Status
var status$1 = {
  info: '#69767C',
  success: '#358A4D',
  warning: '#C67A0C',
  danger: '#B90C0D',
  light: {
    info: '#D5DADC',
    success: '#A1DBB1',
    warning: '#F8CC8C',
    danger: '#F99494'
  }
};
var extended11 = '#F56A00';
var extended12 = '#C35500';
var extended21 = '#C88500';
var extended22 = '#C88500';
var extended31 = '#36A41D';
var extended32 = '#188918';
var extended41 = '#04A6A1';
var extended42 = '#07838F';
var extended51 = '#09A0BF';
var extended52 = '#007FA9';
var extended61 = '#7A91D2';
var extended62 = '#5572C5';
var extended71 = '#7858FF';
var extended72 = '#5D36FF';
var extended81 = '#BC79D3';
var extended82 = '#A750C5';
var extended91 = '#FA4F96';
var extended92 = '#DF1278';
var qualitativeHue1 = '#5899DA';
var qualitativeHue2 = '#E8743B';
var qualitativeHue3 = '#19A979';
var qualitativeHue4 = '#ED4A7B';
var qualitativeHue5 = '#945ECF';
var qualitativeHue6 = '#13A4B4';
var qualitativeHue7 = '#525DF4';
var qualitativeHue8 = '#BF399E';
var qualitativeHue9 = '#6C8893';
var qualitativeHue10 = '#EE6868';
var qualitativeHue11 = '#2F6497';

// Chart Palette Colors
var chartPrimary = Color$3('#5899DA');
var chartSecondary = Color$3('#E8743B');
var chartTertiary = Color$3('#19A979');
var chart1$1 = {
  base: chartPrimary.hex(),
  min: '#93BFEB',
  max: '#1866B4'
};
var chart2$1 = {
  base: chartSecondary.hex(),
  min: '#F5AA85',
  max: '#CC4300'
};
var chart3$1 = {
  base: chartTertiary.hex(),
  min: '#66C2A3',
  max: '#03734D'
};
var chart4$1 = {
  base: '#89D1FF'
};
var chart5$1 = {
  base: '#B894FF'
};
var chart6$1 = {
  base: '#5DC122'
};
var chart7$1 = {
  base: '#FF8CB2'
};
var chart8$1 = {
  base: '#FFB727'
};
var chart9$1 = {
  base: '#B6C4E7'
};
var chart10$1 = {
  base: '#D9CDBA'
};
var chart11$1 = {
  base: '#DCB8E7'
};
var chartMono$1 = {
  base: '#848F94',
  min: '#BAC1C4',
  max: '#596468'
};

// Content Type Colors
var externalLink = extended61;
var dictionaryItem = extended91;
var diagram = extended71;
var system = text.inactive;
var risk = extended11;
var control = extended31;
var folder = extended21;
var header$1 = {
  primary: surface
};
var mono = {
  ultradark: '#333',
  // deprecated
  dark: '#555',
  // deprecated
  middle: '#7f7f7f',
  // deprecated
  lighter: '#ccc',
  // deprecated
  light: '#ddd',
  // deprecated
  ultralight: '#eee' // deprecated
};

function getColors(cssVariableObj) {
  var themePrimarySAP = Color$3(cssVariableObj[sapMap.primaryBase]) || themePrimary$1;
  var themeSecondarySAP = Color$3(cssVariableObj[sapMap.secondaryBase]) || themeSecondary;
  var themeDangerSAP = Color$3(cssVariableObj[sapMap.danger]) || themeDanger$1;
  var primarySAP = {
    base: themePrimarySAP.hex(),
    dark: themePrimarySAP.darken(0.3).hex(),
    light: themePrimarySAP.alpha(0.12).string(),
    lighter: themePrimarySAP.alpha(0.08).string()
  };
  var secondarySAP = {
    base: themeSecondarySAP.hex(),
    dark: themeSecondarySAP.darken(0.3).hex(),
    light: themeSecondarySAP.alpha(0.12).string(),
    lighter: themeSecondarySAP.alpha(0.08).string()
  };
  var dangerSAP = {
    base: themeDangerSAP.hex(),
    dark: themeDangerSAP.darken(0.3).hex(),
    light: themeDangerSAP.alpha(0.12).string(),
    lighter: themeDangerSAP.alpha(0.08).string()
  };
  return {
    onSurface: onSurface,
    onContrast: onContrast,
    themePrimary: themePrimarySAP,
    themeSecondary: themeSecondarySAP,
    themeDanger: themeDangerSAP,
    background: cssVariableObj[sapMap.background] || background$1,
    surface: cssVariableObj[sapMap.surface] || surface,
    contrast: cssVariableObj[sapMap.contrast] || contrast,
    primary: primarySAP,
    secondary: secondarySAP,
    danger: dangerSAP,
    text: text,
    contrastText: contrastText,
    coloredText: {
      primary: primarySAP.base,
      secondary: secondarySAP.base,
      danger: dangerSAP.base
    },
    shading: shading,
    divider: divider,
    hover: hover$1,
    active: {
      primary: primarySAP.lighter,
      secondary: primarySAP.lighter,
      danger: dangerSAP.lighter,
      contrast: onContrast.alpha(0.33).string()
    },
    activeHover: {
      primary: primarySAP.light,
      secondary: primarySAP.light,
      danger: dangerSAP.light,
      contrast: onContrast.alpha(0.33).string()
    },
    status: _objectSpread$1d(_objectSpread$1d({}, status$1), {}, {
      danger: dangerSAP.base,
      light: _objectSpread$1d(_objectSpread$1d({}, status$1.light), {}, {
        info: dangerSAP.light
      })
    }),
    extended11: extended11,
    extended12: extended12,
    extended21: extended21,
    extended22: extended22,
    extended31: extended31,
    extended32: extended32,
    extended41: extended41,
    extended42: extended42,
    extended51: extended51,
    extended52: extended52,
    extended61: extended61,
    extended62: extended62,
    extended71: extended71,
    extended72: extended72,
    extended81: extended81,
    extended82: extended82,
    extended91: extended91,
    extended92: extended92,
    chartPrimary: chartPrimary,
    chartSecondary: chartSecondary,
    chartTertiary: chartTertiary,
    chart1: chart1$1,
    chart2: chart2$1,
    chart3: chart3$1,
    chart4: chart4$1,
    chart5: chart5$1,
    chart6: chart6$1,
    chart7: chart7$1,
    chart8: chart8$1,
    chart9: chart9$1,
    chart10: chart10$1,
    chart11: chart11$1,
    chartMono: chartMono$1,
    externalLink: externalLink,
    dictionaryItem: dictionaryItem,
    diagram: diagram,
    system: system,
    risk: risk,
    control: control,
    folder: folder,
    header: header$1,
    mono: mono
  };
}var color$2=/*#__PURE__*/Object.freeze({__proto__:null,background:background$1,surface:surface,contrast:contrast,primary:primary$1,secondary:secondary$1,danger:danger$1,text:text,contrastText:contrastText,coloredText:coloredText$1,shading:shading,divider:divider,hover:hover$1,active:active$1,activeHover:activeHover$1,status:status$1,extended11:extended11,extended12:extended12,extended21:extended21,extended22:extended22,extended31:extended31,extended32:extended32,extended41:extended41,extended42:extended42,extended51:extended51,extended52:extended52,extended61:extended61,extended62:extended62,extended71:extended71,extended72:extended72,extended81:extended81,extended82:extended82,extended91:extended91,extended92:extended92,qualitativeHue1:qualitativeHue1,qualitativeHue2:qualitativeHue2,qualitativeHue3:qualitativeHue3,qualitativeHue4:qualitativeHue4,qualitativeHue5:qualitativeHue5,qualitativeHue6:qualitativeHue6,qualitativeHue7:qualitativeHue7,qualitativeHue8:qualitativeHue8,qualitativeHue9:qualitativeHue9,qualitativeHue10:qualitativeHue10,qualitativeHue11:qualitativeHue11,chart1:chart1$1,chart2:chart2$1,chart3:chart3$1,chart4:chart4$1,chart5:chart5$1,chart6:chart6$1,chart7:chart7$1,chart8:chart8$1,chart9:chart9$1,chart10:chart10$1,chart11:chart11$1,chartMono:chartMono$1,externalLink:externalLink,dictionaryItem:dictionaryItem,diagram:diagram,system:system,risk:risk,control:control,folder:folder,header:header$1,mono:mono,getColors:getColors});var logo$3 = '<svg version="1.0" xmlns="http://www.w3.org/2000/svg" x="0" y="0" width="142px" height="40px" viewBox="0 0 142 40"><path fill="#0076CB" d="m.2 22.75 2.2-1.29a3.88 3.88 0 0 0 3.55 2.24c1.33 0 2.3-.5 2.3-1.51s-.95-1.41-2.68-1.9c-2.35-.66-4.82-1.26-4.82-4 0-2.46 1.92-3.93 4.75-3.93 2.1-.09 4.09.94 5.23 2.7l-2 1.53a3.92 3.92 0 0 0-3.23-1.85c-1.23 0-1.9.55-1.9 1.32 0 1.05.98 1.42 2.7 1.9 2.31.62 4.76 1.35 4.76 4.07 0 2.12-1.6 4-5.26 4C2.95 26 1.18 24.62.2 22.75zm11.4 2.97 4.66-13.21h2.75l4.66 13.21h-2.92l-1-2.92h-4.48l-1 2.92H11.6zm4.4-5.03h3.08l-1.51-4.48h-.03L16 20.69zm9.13 5.03V12.58h4.8c2.81 0 5.37.74 5.37 4.21s-2.75 4.27-5.41 4.27h-1.88v4.66h-2.88zM28 18.8h1.97c1.79 0 2.47-.69 2.47-1.95 0-1.27-.66-1.92-2.47-1.92H28v3.87zM.2 22.75l2.2-1.29a3.88 3.88 0 0 0 3.55 2.24c1.33 0 2.3-.5 2.3-1.51s-.95-1.41-2.68-1.9c-2.35-.66-4.82-1.26-4.82-4 0-2.46 1.92-3.93 4.75-3.93 2.1-.09 4.09.94 5.23 2.7l-2 1.53a3.92 3.92 0 0 0-3.23-1.85c-1.23 0-1.9.55-1.9 1.32 0 1.05.98 1.42 2.7 1.9 2.31.62 4.76 1.35 4.76 4.07 0 2.12-1.6 4-5.26 4C2.95 26 1.18 24.62.2 22.75zm11.4 2.97 4.66-13.21h2.75l4.66 13.21h-2.92l-1-2.92h-4.48l-1 2.92H11.6zm4.4-5.03h3.08l-1.51-4.48h-.03L16 20.69zm9.13 5.03V12.58h4.8c2.81 0 5.37.74 5.37 4.21s-2.75 4.27-5.41 4.27h-1.88v4.66h-2.88zM28 18.8h1.97c1.79 0 2.47-.69 2.47-1.95 0-1.27-.66-1.92-2.47-1.92H28v3.87zm12.19 3.95 2.2-1.3a3.92 3.92 0 0 0 3.56 2.25c1.33 0 2.29-.5 2.29-1.51s-.96-1.41-2.69-1.9c-2.35-.66-4.81-1.26-4.81-4 0-2.46 1.92-3.93 4.75-3.93 2.1-.09 4.09.94 5.23 2.7l-2 1.53a3.94 3.94 0 0 0-3.23-1.85c-1.23 0-1.9.55-1.9 1.32 0 1.05.98 1.42 2.7 1.9 2.31.62 4.77 1.35 4.77 4.07 0 2.12-1.6 4-5.26 4-2.86-.03-4.64-1.41-5.61-3.28zM53 12.67h2.88v2.29H53v-2.29zm0 3.59h2.85v9.46h-2.83L53 16.26zm3.97 10.9c0-.92.77-1.55 1.65-1.9-.4-.24-.64-.67-.64-1.14 0-.78.62-1.46 1.37-1.94a3.05 3.05 0 0 1-1.55-2.72c0-1.9 1.52-3.4 4.27-3.4 1.15-.06 2.29.3 3.18 1.03.7-.56 1.55-.9 2.44-.98v2.2c-.54 0-1.08.07-1.6.21.12.3.18.62.18.95 0 1.92-1.48 3.37-4.2 3.37-.49 0-.98-.05-1.46-.16-.2.16-.32.3-.32.48 0 .35.37.42 1.07.46l1.42.09c3.25.12 4.57.91 4.57 2.69 0 1.95-2.29 2.9-5.44 2.9-3.72 0-4.93-.83-4.93-2.15h-.01zm7.84-.28c0-.59-.29-.85-2.53-.96l-1.49-.07-.62-.05c-.32.17-.53.49-.55.85 0 .81.77 1.21 2.7 1.21 1.49 0 2.5-.35 2.5-.97l-.01-.01zm-2.71-8.93a1.62 1.62 0 1 0 0 3.24c.9 0 1.62-.69 1.62-1.62s-.72-1.62-1.62-1.62zm7.02-1.69h2.87v1.5a4.05 4.05 0 0 1 3.27-1.69c1.6 0 2.75.8 2.75 2.75v6.9h-2.85v-6c0-.85-.32-1.3-1.1-1.3-.78.05-1.51.39-2.06.95v6.35h-2.87l-.01-9.46zm10.36 7.07c0-2.2 1.85-3.4 6-3.74v-.23c0-.69-.36-1.13-1.28-1.13a5.05 5.05 0 0 0-3.11 1.17l-1.21-1.65a6.64 6.64 0 0 1 4.73-1.69c2.6 0 3.67 1.28 3.67 3.72v3.64c-.05.78.04 1.56.26 2.31H85.7a4.68 4.68 0 0 1-.21-1.39 4.15 4.15 0 0 1-3.3 1.53 2.54 2.54 0 0 1-2.71-2.54zm6.01-.42v-1.76c-2.26.23-3.22.8-3.22 1.65 0 .61.42.91 1.05.91.79.04 1.58-.25 2.17-.8zm3.57-6.65h2.95L94 22.58h.03l2-6.31h2.69l-3.38 9.5h-2.88l-3.4-9.51zm10.81-3.59h2.88v2.29h-2.89l.01-2.29zm0 3.59h2.85v9.46h-2.85v-9.46zm4.61 4.74c0-3.72 2.54-4.95 4.86-4.95s4.84 1.23 4.84 4.95-2.54 4.95-4.84 4.95-4.84-1.28-4.84-4.96l-.02.01zm6.83 0c0-1.62-.55-2.86-1.98-2.86s-2 1.16-2 2.86c0 1.58.55 2.9 2 2.9 1.37.03 1.98-1.27 1.98-2.9z"/><path fill="#f0ab00" d="M141.13 18.44a.71.71 0 0 0-.55-.35c-.29 0-2.42-.12-3.3-.09-.09.03-.19 0-.21-.1a10.3 10.3 0 0 0-.55-1.43c-.39-.69-.85-1.3-1.12-2.04 0-.12.9.29.98.33.36.1.55.23.9-.1.23-.22.32-.46.28-.74-.14-.5-.58-.84-.75-1.33-.16-.56-.37-1.1-.62-1.62-.47-.7-1.27-1.04-2.03-1.31-.55-2.25-1.29-3.2-3.24-3.75-1.78-.5-2.75-.79-3.51-1.51-.1-.15-.23-.15-.3-.15s-.1.19-.03.31c.46.9 1.68 1.65 3.35 2.24 1.24.45 1.93 1.16 2.09 2.24-.29-.03-.57-.1-.84-.22-.21-.06-.33 0-.28.18.06.54.42 1.26.78 1.84-.13.91-.2 1.83-.2 2.75.03 1.07 0 2.15-.1 3.22a29.84 29.84 0 0 1-10.31 6.07c-.83.23-.96.24-1 .37-.03.13.04.14.18.2.14.06 1.27.46 1.26.66 0 .52-.48 1.06-.76 1.9-.24.53-.64.96-1.16 1.23-.43.3-.84.4-1.18.75-.18.41-.42.8-.72 1.14-.48.47-.95 1-1.3 1.38s-.85 1.4-1.16 1.7c-.26.33-.78.28-.95.57-.13.28-.17.6-.12.91.04.19.21.31.4.29.57-.17 1-.7 1.4-1.1 1.14-1.28 2.35-3.05 3.3-3.73.96-.68 3.8-1.71 5.05-2.53 1.05-.7 1.97-1.75 2.85-2.59 1.98-.13 3.94-.5 5.84-1.1a5.96 5.96 0 0 0 2.48-1.68c.4-.46.92-1.26 1-1.29a7.24 7.24 0 0 1 2.08-.2s-.55.81-.77 1.1c-.37.56-1.05.76-1.46 1.27a1.7 1.7 0 0 1-.85.78c-.73.34-.86.55-.83.78.03.23.23.75.45.77.22-.03.44-.12.62-.25 1.1-.84 2.13-1.76 3.09-2.75.68-.76 1.29-1.58 1.83-2.44a.7.7 0 0 0-.01-.58z"/></svg>';
var logo$4 = logo$3;var lineHeight = 1.5;
var name = 'reskin';var fioriMorningHorizonTheme=/*#__PURE__*/Object.freeze({__proto__:null,color:color$2,lineHeight:lineHeight,name:name,padding:padding,spacing:spacing,size:size$3,zIndex:zIndex,font:font,shadow:shadow,border:border$1,logo:logo$4});function ownKeys$1c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1c(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ThemeContext = /*#__PURE__*/createContext(defaultSignavioTheme);
var FioriStylesFlagContext = /*#__PURE__*/createContext(false);
var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
    children = _ref.children,
    withFioriStyles = _ref.withFioriStyles,
    customTheme = _ref.customTheme;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    colors = _useState2[0],
    setColors = _useState2[1];
  useEffect(function () {
    if (customTheme) {
      var themeColors = getUpdatedThemeColors(customTheme.root);
      var updatedColorSet = getColors(themeColors);
      setColors(updatedColorSet);
    }
  }, [customTheme]);
  var defaultTheme = withFioriStyles ? fioriMorningHorizonTheme : defaultSignavioTheme;
  var updatedDefaultTheme = colors ? _objectSpread$1c(_objectSpread$1c({}, defaultTheme), {}, {
    color: _objectSpread$1c({}, colors)
  }) : defaultTheme;
  useEffect(function () {
    if (withFioriStyles) applyGlobalFioriStyles();
  }, [withFioriStyles]);
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: _merge({}, updatedDefaultTheme, theme, customTheme)
  }, /*#__PURE__*/React.createElement(FioriStylesFlagContext.Provider, {
    value: withFioriStyles ? true : false
  }, children));
};
var ThemeProvider$1 = ThemeProvider;var getTheme = function getTheme(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
        theme: theme
      }, props));
    });
  };
};
var getTheme$1 = getTheme;function useFioriStyles() {
  return useContext(FioriStylesFlagContext);
}function useTheme() {
  return useContext(ThemeContext);
}function useBaseColor() {
  var fioriStyles = useFioriStyles();
  var _useTheme = useTheme(),
    color = _useTheme.color;
  return fioriStyles ? color.primary.base : color.secondary.base;
}var useStyles = function useStyles(defaultStyle, styleProps, modifiers) {
  var theme = useTheme();
  var resolvedDefaultStyle = useMemo(function () {
    return typeof defaultStyle === 'function' ? defaultStyle(theme) : defaultStyle;
  }, [defaultStyle, theme]);
  return useStylesBase(resolvedDefaultStyle, styleProps, modifiers);
};
var useStyles$1 = useStyles;var _excluded$1u = ["style", "className", "classNames"];
function createDefaultStyle(defaultStyle, getModifiers, shouldUpdate) {
  var enhance = function enhance(ComponentToWrap) {
    var DefaultStyleEnhancer = function DefaultStyleEnhancer(_ref) {
      var style = _ref.style,
        className = _ref.className,
        classNames = _ref.classNames,
        rest = _objectWithoutProperties(_ref, _excluded$1u);
      var stylesFunctionOfProps = typeof defaultStyle === 'function' && defaultStyle.length > 1;
      var lastUpdateProps = useRef({});
      if (stylesFunctionOfProps) {
        var resolvedShouldUpdate = shouldUpdate ? shouldUpdate(rest, lastUpdateProps.current) : true;
        if (resolvedShouldUpdate) {
          lastUpdateProps.current = rest;
        }
      }
      var resolvedDefaultStyle = useCallback(function (theme) {
        return typeof defaultStyle === 'function' ? defaultStyle(theme, rest) : defaultStyle;
      }, /* eslint-disable-next-line react-hooks/exhaustive-deps */
      [defaultStyle, lastUpdateProps.current]);
      var styles = useStyles$1(resolvedDefaultStyle, {
        style: style,
        className: className,
        classNames: classNames
      }, getModifiers && getModifiers(rest));
      return /*#__PURE__*/React.createElement(ComponentToWrap, _extends({}, rest, {
        style: styles
      }));
    };
    return DefaultStyleEnhancer;
  };
  return enhance;
}var logo$2 = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="126px" height="40px" viewBox="0 0 126 40"><path fill="#fff" d="M39.57,16.1c-.39,0-.7.3-.7.65v8.57c0,.2.2,.64.7,.64c.5,0,.7-.43.7-.64v-8.57C40.28,16.53,40.06,16.1,39.57,16.1zM46.07,26c1.37,0,2.55-.4,2.63-.45c.1-.05,.3-.19.38-.3c.08-.1.14-.25.14-.44v-3.45c0-.3-.14-.47-.27-.58c-.1-.1-.34-.23-.6-.2h-2.07c-.3,0-.69.2-.69.63c0,.34.29,.6.69,.6h1.53v2.7c-.5.15-1,.24-1.7.24c-1.33,0-2.37-.66-2.37-2.09v-3.23c0-1.45,1.05-2.09,2.37-2.09c.77,0,1.43.35,1.76.47c.18.07,.73.15,.93-.3c.19-.43-.15-.74-.28-.8c-.63-.33-1.54-.59-2.4-.59c-2.24,0-3.78,1.3-3.78,3.36v3.15C42.29,24.4,43.57,26,46.07,26zM83.86,16.1c-2.08,0-3.58,1.24-3.58,3.19v3.49c0,2.09,1.67,3.19,3.59,3.19c2.29,0,3.58-1.44,3.58-3.19V19.3C87.45,17.55,86.15,16.1,83.86,16.1zM86.04,22.83c0,1.08-.7,1.9-2.17,1.9c-1.3,0-2.17-.7-2.17-1.9v-3.56c0-1.26.9-1.94,2.17-1.94c1.34,0,2.17.73,2.17,1.94V22.83zM33.77,24.75c-.69,0-1.35-.23-2-.57c-.18-.1-.66-.15-.86.19c-.24.39,0,.76.27,.93c.48.29,1.66.68,2.6.68c2.4,0,3.28-1.69,3.28-2.68c0-1.95-1.5-2.6-3.08-3.24c-.8-.3-1.8-.58-1.8-1.5c0-.86.87-1.23,1.8-1.23c.64,0,1.47.3,1.89.44c.29.09,.73,0,.85-.34c.1-.3,0-.64-.44-.83c-.65-.27-1.55-.48-2.23-.48c-1.4,0-3.3.65-3.3,2.4c0,.79.3,1.49,1,2c.68.46,1.69.77,2,.9c1.18.5,1.93.84,1.84,1.89C35.56,24.1,34.75,24.75,33.77,24.75zM74.87,16.14c-.3-.09-.7-0-.87.4c-0,.1-2.56,7.1-2.56,7.1s-2.55-7.06-2.59-7.16c-.13-.3-.4-.47-.84-.37c-.46.13-.54.56-.48.74c.04,.1,3.1,8.48,3.15,8.59c.1.3,.38.5,.75.5c.5,0,.7-.35.75-.49c.04-.1,3.1-8.46,3.13-8.53C75.44,16.57,75.2,16.24,74.87,16.14zM67.68,25.6c.07-.13.1-.3.04-.47c-.06-.15-3.2-8.39-3.29-8.58c-.1-.3-.46-.46-.74-.46c-.26,0-.6.15-.74.46c-.08,.2-3.2,8.4-3.29,8.58c-.13.35,.14.6,.19.65c.17.13,.33.17,.47.17c.3,0,.56-.19.65-.4c.04-.1.87-2.27.87-2.27h3.7c0,0,.8,2.14.86,2.24c.1.3,.38.45,.66.45C67.34,26,67.57,25.8,67.68,25.6zM62.3,22.04l1.38-3.67l1.38,3.67H62.3zM77.56,16.1c-.38,0-.7.3-.7.65v8.57c0,.2.2,.64.7,.64c.5,0,.7-.43.7-.64v-8.57C78.26,16.53,78.05,16.1,77.56,16.1zM58.2,25.25v-8.49c0-.39-.37-.65-.7-.65c-.35,0-.7.26-.7.65v6.36c0,0-4.04-6.58-4.08-6.65c-.14-.23-.38-.36-.69-.36c-.4,0-.78.3-.78.7v8.5c0,.35.33,.64.7,.64c.4,0,.7-.3.7-.64v-6.36c0,0,4,6.55,4.08,6.63c.1.19,.34.36,.69.36C57.85,26,58.2,25.7,58.2,25.25z"/><path fill="#fff" d="M25.26,19.37c-.09-.16-.28-.3-.5-.3c-.1-0-1.1-.06-2-.08c-.2-0-.73-0-1-0c-.05,0-.09,0-.1-0c-0-0-.06-.04-.08-.09c-.09-.27-.27-.88-.5-1.3c-.2-.39-.47-.74-.66-1.1c-.19-.37-.35-.65-.37-.77c-0-.1.83,.27.9,.3c.07,0,.29.1,.4.1c.1,0,.2-0,.4-.2c.25-.2.28-.46.26-.68c-0-.16-.18-.39-.33-.6c-.15-.2-.3-.43-.37-.63c-.16-.45-.26-.9-.57-1.5c-.2-.4-.73-.7-1-.85c-.44-.23-.86-.36-.86-.36c-.48-2.08-1.19-2.96-3-3.47c-1.65-.47-2.5-.73-3.24-1.4c-.1-.1-.23-.14-.3-.09c-.1.06-.09,.18-0,.29c.43.83,1.56,1.5,3.1,2.07c1.15.4,1.79,1.08,1.93,2.08c-.3,0-.69-.18-.77-.2c-.1-0-.17-0-.2,0c-0,0-.06,.06-.04,.16c0,.1.13,.6.35,1.05c.23.43,.29.54,.37.66c-.05,.29-.2,1.45-.19,2.53c0,1.08-0,2.73-.09,3c0,0-.17.16-.57.5c-.4.35-2.69,2-3.66,2.6c-.84.5-3.36,1.94-5.3,2.47c-.77.2-.89.2-.9.34c-0,.07,.04,.13.17,.19c.17.06,1.17.43,1.16.6c-0,.48-.44,1-.7,1.76c-.13.45-.6.84-1.07,1.14c-.24.15-.47.28-.66.38c-.2.1-.33.17-.44.3c-.2.3-.27.67-.66,1.06c-.44.44-.88.94-1.2,1.28c-.37.39-.78,1.29-1.07,1.56c-.13.14-.33.24-.45.28c-.1.04-.38.08-.43.24c-.05,.16-.19.46-.1.84c.05,.2.2,.26.36,.27c.1,0,.17-.04,.24-.08c.08-.05,.6-.44,1.06-.94c1.05-1.19,2.17-2.8,3.04-3.45c.9-.67,3.5-1.58,4.67-2.33c.58-.38,1.2-1,1.73-1.49c.26-.25.48-.49.65-.66c.09-.08,.16-.15.2-.2c0-0,.04-0,.05-.05c.35-.05,2.96-.16,5.39-1c1.1-.38,1.8-1,2.3-1.56c.37-.4.85-1.16.93-1.2c.05-0,.28-.07,.34-.08c.57-.1,1.05-.1,1.44-.1c.09,0,.1,0,.14,0c0,0-.5.76-.7,1c-.2.27-.5.5-.74.66c-.2.16-.48.27-.6.5c-.13.24-.33.5-.78.7c-.68.3-.8.5-.77.7c0,.2.2,.7.4,.7c.13,0,.34-.1.57-.24c.66-.4,2.25-1.9,2.86-2.54c.6-.6,1.4-1.8,1.7-2.26C25.35,19.8,25.35,19.54,25.26,19.37z"/><path fill="#fff" d="M99.68,21.59h-1v2.04h1.08c.46,0,.79-.09,1-.26c.2-.17.33-.44.33-.8C101.07,21.9,100.6,21.59,99.68,21.59zM100.6,20.07c.2-.14.3-.37.3-.69c0-.3-.1-.5-.33-.64c-.2-.13-.57-.2-1.04-.2h-.87v1.74h.96C100.07,20.28,100.39,20.2,100.6,20.07zM124,15H96c-1.1,0-2,.9-2,2v8c0,1.1.9,2,2,2h28c1.1,0,2-.9,2-2v-8C126,15.9,125.1,15,124,15zM102,24.4c-.5.4-1.2.6-2.1.6H97v-7.8h2.43c1.1,0,1.9.16,2.4.47c.5.3,.75.8,.75,1.5c0,.47-.1.85-.33,1.15c-.2.3-.5.48-.87.54v.05c.5.1,.85.3,1.07,.6c.2.3,.33.7,.33,1.2C102.8,23.45,102.54,24,102,24.4zM108.93,18.54h-2.84v1.7h2.65v1.36h-2.65v2h2.84V25h-4.5v-7.8h4.5V18.54zM113.83,25h-1.66v-6.44h-2.1v-1.38h5.9v1.38h-2.1V25zM121.46,25l-.57-1.86h-2.85L117.48,25h-1.79l2.76-7.85h2l2.77,7.85H121.46zM119.47,18.36c-.1.46-.45,1.58-1,3.38h2.04c-.5-1.69-.8-2.64-.88-2.86S119.5,18.49,119.47,18.36z"/></svg>';
var beta=/*#__PURE__*/Object.freeze({__proto__:null,logo:logo$2});function ownKeys$1b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1b(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var themePrimary = Color$3('#0854A0');
var themeDanger = Color$3('#BB0000');
var background = '#EDEFF0';
var header = {
  primary: '#354A5F'
};
var primary = {
  base: themePrimary.hex(),
  dark: themePrimary.darken(0.3).hex(),
  light: themePrimary.alpha(0.12).string(),
  lighter: themePrimary.alpha(0.08).string()
};
var secondary = _objectSpread$1b({}, primary);
var danger = {
  base: themeDanger.hex(),
  dark: themeDanger.darken(0.3).hex(),
  light: themeDanger.alpha(0.12).string(),
  lighter: themeDanger.alpha(0.08).string()
};
var coloredText = {
  primary: primary.base,
  secondary: secondary.base,
  danger: danger.base
};
var active = {
  primary: primary.lighter,
  secondary: secondary.lighter,
  danger: danger.lighter
};
var activeHover = {
  primary: primary.light,
  secondary: secondary.light,
  danger: danger.light
};

// Status
var status = {
  info: '#0a6ed1',
  success: '#107e3e',
  warning: '#b3590a',
  danger: danger.base,
  light: {
    info: '#f5faff',
    success: '#f1fdf6',
    warning: '#fef7f1',
    danger: '#ffebeb'
  }
};

// Chart Palette Colors
// https://experience.sap.com/fiori-design-web/values-and-names/#qualitative-palette
var chart1 = {
  base: '#5899da',
  min: '#b2d4f5',
  max: '#1866b4'
};
var chart2 = {
  base: '#e8743b',
  min: '#fcc3a7',
  max: '#cc4300'
};
var chart3 = {
  base: '#19a979',
  min: '#8fd1bb',
  max: '#03734d'
};
var chart4 = {
  base: '#ed4a7b'
};
var chart5 = {
  base: '#945ecf'
};
var chart6 = {
  base: '#13a4b4'
};
var chart7 = {
  base: '#525df4'
};
var chart8 = {
  base: '#bf399e'
};
var chart9 = {
  base: '#6c8893'
};
var chart10 = {
  base: '#ee6868'
};
var chart11 = {
  base: '#2f6497'
};
var chartMono = {
  base: '#848f94',
  min: '#d5dadc',
  max: '#596468'
};var color$1=/*#__PURE__*/Object.freeze({__proto__:null,background:background,header:header,primary:primary,secondary:secondary,danger:danger,coloredText:coloredText,active:active,activeHover:activeHover,status:status,chart1:chart1,chart2:chart2,chart3:chart3,chart4:chart4,chart5:chart5,chart6:chart6,chart7:chart7,chart8:chart8,chart9:chart9,chart10:chart10,chart11:chart11,chartMono:chartMono});var logo = '<svg version="1.0" xmlns="http://www.w3.org/2000/svg" x="0" y="0" width="142px" height="40px" viewBox="0 0 142 40"><path fill="#fff" d="m.2 22.75 2.2-1.29a3.88 3.88 0 0 0 3.55 2.24c1.33 0 2.3-.5 2.3-1.51s-.95-1.41-2.68-1.9c-2.35-.66-4.82-1.26-4.82-4 0-2.46 1.92-3.93 4.75-3.93 2.1-.09 4.09.94 5.23 2.7l-2 1.53a3.92 3.92 0 0 0-3.23-1.85c-1.23 0-1.9.55-1.9 1.32 0 1.05.98 1.42 2.7 1.9 2.31.62 4.76 1.35 4.76 4.07 0 2.12-1.6 4-5.26 4C2.95 26 1.18 24.62.2 22.75zm11.4 2.97 4.66-13.21h2.75l4.66 13.21h-2.92l-1-2.92h-4.48l-1 2.92H11.6zm4.4-5.03h3.08l-1.51-4.48h-.03L16 20.69zm9.13 5.03V12.58h4.8c2.81 0 5.37.74 5.37 4.21s-2.75 4.27-5.41 4.27h-1.88v4.66h-2.88zM28 18.8h1.97c1.79 0 2.47-.69 2.47-1.95 0-1.27-.66-1.92-2.47-1.92H28v3.87zM.2 22.75l2.2-1.29a3.88 3.88 0 0 0 3.55 2.24c1.33 0 2.3-.5 2.3-1.51s-.95-1.41-2.68-1.9c-2.35-.66-4.82-1.26-4.82-4 0-2.46 1.92-3.93 4.75-3.93 2.1-.09 4.09.94 5.23 2.7l-2 1.53a3.92 3.92 0 0 0-3.23-1.85c-1.23 0-1.9.55-1.9 1.32 0 1.05.98 1.42 2.7 1.9 2.31.62 4.76 1.35 4.76 4.07 0 2.12-1.6 4-5.26 4C2.95 26 1.18 24.62.2 22.75zm11.4 2.97 4.66-13.21h2.75l4.66 13.21h-2.92l-1-2.92h-4.48l-1 2.92H11.6zm4.4-5.03h3.08l-1.51-4.48h-.03L16 20.69zm9.13 5.03V12.58h4.8c2.81 0 5.37.74 5.37 4.21s-2.75 4.27-5.41 4.27h-1.88v4.66h-2.88zM28 18.8h1.97c1.79 0 2.47-.69 2.47-1.95 0-1.27-.66-1.92-2.47-1.92H28v3.87zm12.19 3.95 2.2-1.3a3.92 3.92 0 0 0 3.56 2.25c1.33 0 2.29-.5 2.29-1.51s-.96-1.41-2.69-1.9c-2.35-.66-4.81-1.26-4.81-4 0-2.46 1.92-3.93 4.75-3.93 2.1-.09 4.09.94 5.23 2.7l-2 1.53a3.94 3.94 0 0 0-3.23-1.85c-1.23 0-1.9.55-1.9 1.32 0 1.05.98 1.42 2.7 1.9 2.31.62 4.77 1.35 4.77 4.07 0 2.12-1.6 4-5.26 4-2.86-.03-4.64-1.41-5.61-3.28zM53 12.67h2.88v2.29H53v-2.29zm0 3.59h2.85v9.46h-2.83L53 16.26zm3.97 10.9c0-.92.77-1.55 1.65-1.9-.4-.24-.64-.67-.64-1.14 0-.78.62-1.46 1.37-1.94a3.05 3.05 0 0 1-1.55-2.72c0-1.9 1.52-3.4 4.27-3.4 1.15-.06 2.29.3 3.18 1.03.7-.56 1.55-.9 2.44-.98v2.2c-.54 0-1.08.07-1.6.21.12.3.18.62.18.95 0 1.92-1.48 3.37-4.2 3.37-.49 0-.98-.05-1.46-.16-.2.16-.32.3-.32.48 0 .35.37.42 1.07.46l1.42.09c3.25.12 4.57.91 4.57 2.69 0 1.95-2.29 2.9-5.44 2.9-3.72 0-4.93-.83-4.93-2.15h-.01zm7.84-.28c0-.59-.29-.85-2.53-.96l-1.49-.07-.62-.05c-.32.17-.53.49-.55.85 0 .81.77 1.21 2.7 1.21 1.49 0 2.5-.35 2.5-.97l-.01-.01zm-2.71-8.93a1.62 1.62 0 1 0 0 3.24c.9 0 1.62-.69 1.62-1.62s-.72-1.62-1.62-1.62zm7.02-1.69h2.87v1.5a4.05 4.05 0 0 1 3.27-1.69c1.6 0 2.75.8 2.75 2.75v6.9h-2.85v-6c0-.85-.32-1.3-1.1-1.3-.78.05-1.51.39-2.06.95v6.35h-2.87l-.01-9.46zm10.36 7.07c0-2.2 1.85-3.4 6-3.74v-.23c0-.69-.36-1.13-1.28-1.13a5.05 5.05 0 0 0-3.11 1.17l-1.21-1.65a6.64 6.64 0 0 1 4.73-1.69c2.6 0 3.67 1.28 3.67 3.72v3.64c-.05.78.04 1.56.26 2.31H85.7a4.68 4.68 0 0 1-.21-1.39 4.15 4.15 0 0 1-3.3 1.53 2.54 2.54 0 0 1-2.71-2.54zm6.01-.42v-1.76c-2.26.23-3.22.8-3.22 1.65 0 .61.42.91 1.05.91.79.04 1.58-.25 2.17-.8zm3.57-6.65h2.95L94 22.58h.03l2-6.31h2.69l-3.38 9.5h-2.88l-3.4-9.51zm10.81-3.59h2.88v2.29h-2.89l.01-2.29zm0 3.59h2.85v9.46h-2.85v-9.46zm4.61 4.74c0-3.72 2.54-4.95 4.86-4.95s4.84 1.23 4.84 4.95-2.54 4.95-4.84 4.95-4.84-1.28-4.84-4.96l-.02.01zm6.83 0c0-1.62-.55-2.86-1.98-2.86s-2 1.16-2 2.86c0 1.58.55 2.9 2 2.9 1.37.03 1.98-1.27 1.98-2.9z"/><path fill="#f0ab00" d="M141.13 18.44a.71.71 0 0 0-.55-.35c-.29 0-2.42-.12-3.3-.09-.09.03-.19 0-.21-.1a10.3 10.3 0 0 0-.55-1.43c-.39-.69-.85-1.3-1.12-2.04 0-.12.9.29.98.33.36.1.55.23.9-.1.23-.22.32-.46.28-.74-.14-.5-.58-.84-.75-1.33-.16-.56-.37-1.1-.62-1.62-.47-.7-1.27-1.04-2.03-1.31-.55-2.25-1.29-3.2-3.24-3.75-1.78-.5-2.75-.79-3.51-1.51-.1-.15-.23-.15-.3-.15s-.1.19-.03.31c.46.9 1.68 1.65 3.35 2.24 1.24.45 1.93 1.16 2.09 2.24-.29-.03-.57-.1-.84-.22-.21-.06-.33 0-.28.18.06.54.42 1.26.78 1.84-.13.91-.2 1.83-.2 2.75.03 1.07 0 2.15-.1 3.22a29.84 29.84 0 0 1-10.31 6.07c-.83.23-.96.24-1 .37-.03.13.04.14.18.2.14.06 1.27.46 1.26.66 0 .52-.48 1.06-.76 1.9-.24.53-.64.96-1.16 1.23-.43.3-.84.4-1.18.75-.18.41-.42.8-.72 1.14-.48.47-.95 1-1.3 1.38s-.85 1.4-1.16 1.7c-.26.33-.78.28-.95.57-.13.28-.17.6-.12.91.04.19.21.31.4.29.57-.17 1-.7 1.4-1.1 1.14-1.28 2.35-3.05 3.3-3.73.96-.68 3.8-1.71 5.05-2.53 1.05-.7 1.97-1.75 2.85-2.59 1.98-.13 3.94-.5 5.84-1.1a5.96 5.96 0 0 0 2.48-1.68c.4-.46.92-1.26 1-1.29a7.24 7.24 0 0 1 2.08-.2s-.55.81-.77 1.1c-.37.56-1.05.76-1.46 1.27a1.7 1.7 0 0 1-.85.78c-.73.34-.86.55-.83.78.03.23.23.75.45.77.22-.03.44-.12.62-.25 1.1-.84 2.13-1.76 3.09-2.75.68-.76 1.29-1.58 1.83-2.44a.7.7 0 0 0-.01-.58z"/></svg>';
var logo$1 = logo;var index$1=/*#__PURE__*/Object.freeze({__proto__:null,color:color$1,logo:logo$1});function ownKeys$1a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1a(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styles = _objectSpread$1a(_objectSpread$1a({}, utils$1), {}, {
  media: media,
  header: header$3
});var _excluded$1t = ["children", "style", "className", "classNames", "icon", "onClick"];
function Button$7(_ref) {
  var children = _ref.children,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    icon = _ref.icon,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded$1t);
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$x(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {
    '&interactive': !rest.disabled,
    '&disabled': !!rest.disabled,
    '&active': !!rest.active
  });
  return /*#__PURE__*/React.createElement(Button$8, _extends({}, rest, {
    style: styles,
    frontChildren: _isString(icon) ? /*#__PURE__*/React.createElement(Glyph, null, icon) : icon || null,
    rearChildren: null,
    onClick: onClick
  }), children);
}
var defaultStyles$x = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return {
    borderColor: color.primary.base,
    color: color.coloredText.primary,
    borderRadius: border.button.borderRadius.regular,
    '&small': {
      borderRadius: border.button.borderRadius.small
    },
    '&interactive': {
      ':hover': {
        backgroundColor: color.hover.base
      },
      ':focus': {
        backgroundColor: color.hover.base
      },
      ':active': {
        backgroundColor: color.active.primary
      },
      ':active:hover': {
        backgroundColor: color.activeHover.primary
      },
      ':active:focus': {
        backgroundColor: color.activeHover.primary
      }
    },
    '&active': {
      backgroundColor: color.active.primary,
      ':hover': {
        backgroundColor: color.activeHover.primary
      },
      ':focus': {
        backgroundColor: color.activeHover.primary
      }
    },
    '&disabled': {
      backgroundColor: color.contrastText.base,
      color: color.text.disabled,
      borderColor: color.divider.base
    }
  };
};var _excluded$1s = ["children", "style", "icon", "onClick", "className", "classNames"];
function Button$6(_ref) {
  var children = _ref.children,
    style = _ref.style,
    icon = _ref.icon,
    onClick = _ref.onClick,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$1s);
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$w(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {
    '&interactive': !rest.disabled,
    '&disabled': !!rest.disabled
  });
  return /*#__PURE__*/React.createElement(Button$8, _extends({}, rest, {
    style: styles,
    frontChildren: icon ? /*#__PURE__*/React.createElement(Glyph, null, icon) : null,
    rearChildren: null,
    onClick: onClick
  }), children);
}
var defaultStyles$w = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return {
    backgroundColor: color.primary.base,
    color: Color$3(color.primary.base).isLight() ? color.text.base : color.contrastText.base,
    borderWidth: 0,
    borderRadius: border.button.borderRadius.regular,
    '&interactive': {
      ':hover': {
        backgroundColor: Color$3(color.primary.base).darken(0.08).hex()
      },
      ':focus': {
        backgroundColor: Color$3(color.primary.base).darken(0.08).hex()
      },
      ':active': {
        backgroundColor: Color$3(color.primary.base).lighten(0.12).hex()
      },
      ':active:hover': {
        backgroundColor: Color$3(color.primary.base).lighten(0.04).hex()
      },
      ':active:focus': {
        backgroundColor: Color$3(color.primary.base).lighten(0.04).hex()
      }
    },
    '&disabled': {
      backgroundColor: color.divider.base,
      color: color.text.disabled
    },
    '&small': {
      borderRadius: border.button.borderRadius.small
    }
  };
};var _excluded$1r = ["children", "style", "icon", "small", "disabled", "block", "onClick", "className", "classNames"];
function Button$5(_ref) {
  var children = _ref.children,
    style = _ref.style,
    icon = _ref.icon,
    small = _ref.small,
    disabled = _ref.disabled,
    block = _ref.block,
    onClick = _ref.onClick,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$1r);
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$v(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {
    '&interactive': !disabled,
    '&active': !!rest.active
  });
  return /*#__PURE__*/React.createElement(Button$8, _extends({}, rest, {
    block: !!block,
    disabled: !!disabled,
    small: !!small,
    style: styles,
    frontChildren: icon ? /*#__PURE__*/React.createElement(Glyph, null, icon) : null,
    rearChildren: null,
    onClick: onClick
  }), children);
}
var defaultStyles$v = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return {
    borderColor: color.contrastText.base,
    color: color.contrastText.base,
    borderRadius: border.button.borderRadius.regular,
    '&interactive': {
      ':hover': {
        backgroundColor: color.hover.contrast
      },
      ':focus': {
        backgroundColor: color.hover.contrast
      },
      ':active': {
        backgroundColor: color.active.contrast
      },
      ':active:hover': {
        backgroundColor: color.activeHover.contrast
      },
      ':active:focus': {
        backgroundColor: color.activeHover.contrast
      }
    },
    '&active': {
      backgroundColor: color.active.contrast,
      ':hover': {
        backgroundColor: color.activeHover.contrast
      },
      ':focus': {
        backgroundColor: color.activeHover.contrast
      }
    },
    '&disabled': {
      color: color.contrastText.disabled,
      borderColor: color.divider.contrast
    },
    '&small': {
      borderRadius: border.button.borderRadius.small
    }
  };
};var _excluded$1q = ["children", "icon", "disabled", "active", "small", "onClick", "style", "className", "classNames"];
function Button$4(_ref) {
  var children = _ref.children,
    icon = _ref.icon,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    onClick = _ref.onClick,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$1q);
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$u(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {
    '&interactive': !disabled,
    '&disabled': disabled,
    '&active': active
  });
  return /*#__PURE__*/React.createElement(Button$8, _extends({}, rest, {
    block: false,
    disabled: disabled,
    small: small,
    style: styles,
    frontChildren: icon ? /*#__PURE__*/React.createElement(Glyph, null, icon) : null,
    rearChildren: null,
    onClick: onClick
  }), children);
}
var defaultStyles$u = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return {
    color: color.coloredText.primary,
    borderWidth: 0,
    borderRadius: border.button.borderRadius.regular,
    '&interactive': {
      ':hover': {
        backgroundColor: color.hover.base
      },
      ':focus': {
        backgroundColor: color.hover.base
      },
      ':active': {
        backgroundColor: color.active.primary
      },
      ':active:hover': {
        backgroundColor: color.activeHover.primary
      },
      ':active:focus': {
        backgroundColor: color.activeHover.primary
      }
    },
    '&active': {
      backgroundColor: color.active.primary,
      ':hover': {
        backgroundColor: color.activeHover.primary
      },
      ':focus': {
        backgroundColor: color.activeHover.primary
      }
    },
    '&disabled': {
      color: color.text.disabled
    },
    '&small': {
      borderRadius: border.button.borderRadius.small
    }
  };
};var _excluded$1p = ["children", "style", "className", "classNames", "icon", "disabled", "onClick"];
function Button$3(_ref) {
  var children = _ref.children,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    icon = _ref.icon,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded$1p);
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$t(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {
    '&interactive': !disabled,
    '&active': !!rest.active
  });
  return /*#__PURE__*/React.createElement(Button$8, _extends({}, rest, {
    block: false,
    disabled: !!disabled,
    small: false,
    style: styles,
    frontChildren: icon ? /*#__PURE__*/React.createElement(Glyph, null, icon) : null,
    rearChildren: null,
    onClick: onClick
  }), children);
}
var defaultStyles$t = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return {
    color: color.contrastText.base,
    borderWidth: 0,
    borderRadius: border.button.borderRadius.regular,
    '&interactive': {
      ':hover': {
        backgroundColor: color.hover.contrast
      },
      ':focus': {
        backgroundColor: color.hover.contrast
      },
      ':active': {
        backgroundColor: color.active.contrast
      },
      ':active:hover': {
        backgroundColor: color.activeHover.contrast
      },
      ':active:focus': {
        backgroundColor: color.activeHover.contrast
      }
    },
    '&active': {
      backgroundColor: color.active.contrast,
      ':hover': {
        backgroundColor: color.activeHover.contrast
      },
      ':focus': {
        backgroundColor: color.activeHover.contrast
      }
    },
    '&disabled': {
      color: color.contrastText.disabled
    },
    '&small': {
      borderRadius: border.button.borderRadius.small
    }
  };
};var _excluded$1o = ["children", "style", "icon", "onClick", "className", "classNames"];
function DangerButton$3(_ref) {
  var children = _ref.children,
    style = _ref.style,
    icon = _ref.icon,
    onClick = _ref.onClick,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$1o);
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$s(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {
    '&interactive': !rest.disabled,
    '&disabled': !!rest.disabled
  });
  return /*#__PURE__*/React.createElement(Button$8, _extends({}, rest, {
    style: styles,
    frontChildren: icon ? /*#__PURE__*/React.createElement(Glyph, null, icon) : null,
    rearChildren: null,
    onClick: onClick
  }), children);
}
var defaultStyles$s = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return {
    backgroundColor: color.danger.base,
    color: Color$3(color.danger.base).isLight() ? color.text.base : color.contrastText.base,
    borderWidth: 0,
    borderRadius: border.button.borderRadius.regular,
    '&small': {
      borderRadius: border.button.borderRadius.small
    },
    '&interactive': {
      ':hover': {
        backgroundColor: Color$3(color.danger.base).darken(0.08).hex()
      },
      ':focus': {
        backgroundColor: Color$3(color.danger.base).darken(0.08).hex()
      },
      ':active': {
        backgroundColor: Color$3(color.danger.base).lighten(0.12).hex()
      },
      ':active:hover': {
        backgroundColor: Color$3(color.danger.base).lighten(0.04).hex()
      },
      ':active:focus': {
        backgroundColor: Color$3(color.danger.base).lighten(0.04).hex()
      }
    },
    '&disabled': {
      backgroundColor: color.text.disabled
    }
  };
};var _excluded$1n = ["children", "style", "icon", "disabled", "onClick", "small", "className", "classNames"];
function DangerButton$2(_ref) {
  var children = _ref.children,
    style = _ref.style,
    icon = _ref.icon,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    small = _ref.small,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$1n);
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$r(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {
    '&interactive': !disabled,
    '&disabled': !!disabled,
    '&active': !!rest.active
  });
  return /*#__PURE__*/React.createElement(Button$8, _extends({}, rest, {
    small: !!small,
    block: false,
    disabled: !!disabled,
    style: styles,
    frontChildren: icon ? /*#__PURE__*/React.createElement(Glyph, null, icon) : null,
    rearChildren: null,
    onClick: onClick
  }), children);
}
var defaultStyles$r = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return {
    color: color.coloredText.danger,
    borderWidth: 0,
    borderRadius: border.button.borderRadius.regular,
    '&interactive': {
      ':hover': {
        backgroundColor: color.hover.base
      },
      ':focus': {
        backgroundColor: color.hover.base
      },
      ':active': {
        backgroundColor: color.active.danger
      },
      ':active:hover': {
        backgroundColor: color.activeHover.danger
      },
      ':active:focus': {
        backgroundColor: color.activeHover.danger
      }
    },
    '&active': {
      backgroundColor: color.active.danger,
      ':hover': {
        backgroundColor: color.activeHover.danger
      },
      ':focus': {
        backgroundColor: color.activeHover.danger
      }
    },
    '&disabled': {
      color: color.text.disabled
    },
    '&small': {
      borderRadius: border.button.borderRadius.small
    }
  };
};var _excluded$1m = ["children", "style", "icon", "disabled", "small", "block", "onClick", "className", "classNames"];
function DangerButton$1(_ref) {
  var children = _ref.children,
    style = _ref.style,
    icon = _ref.icon,
    disabled = _ref.disabled,
    small = _ref.small,
    block = _ref.block,
    onClick = _ref.onClick,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$1m);
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$q(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {
    '&interactive': !disabled,
    '&disabled': !!disabled,
    '&active': !!rest.active
  });
  return /*#__PURE__*/React.createElement(Button$8, _extends({}, rest, {
    small: !!small,
    block: !!block,
    disabled: !!disabled,
    style: styles,
    frontChildren: icon ? /*#__PURE__*/React.createElement(Glyph, null, icon) : null,
    rearChildren: null,
    onClick: onClick
  }), children);
}
var defaultStyles$q = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return {
    borderColor: color.danger.base,
    color: color.coloredText.danger,
    borderRadius: border.button.borderRadius.regular,
    '&interactive': {
      ':hover': {
        backgroundColor: color.hover.base
      },
      ':focus': {
        backgroundColor: color.hover.base
      },
      ':active': {
        backgroundColor: color.active.danger
      },
      ':active:hover': {
        backgroundColor: color.activeHover.danger
      },
      ':active:focus': {
        backgroundColor: color.activeHover.danger
      }
    },
    '&active': {
      backgroundColor: color.active.danger,
      ':hover': {
        backgroundColor: color.activeHover.danger
      },
      ':focus': {
        backgroundColor: color.activeHover.danger
      }
    },
    '&disabled': {
      backgroundColor: color.contrastText.base,
      color: color.text.disabled,
      borderColor: color.text.disabled
    },
    '&small': {
      borderRadius: border.button.borderRadius.small
    }
  };
};var _excluded$1l = ["active", "style", "className", "classNames"];
function IconButton$3(_ref) {
  var active = _ref.active,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$1l);
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$p(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {
    '&disabled': !!rest.disabled,
    '&active': !!active,
    '&interactive': !rest.disabled
  });
  return /*#__PURE__*/React.createElement(IconButton$4, _extends({}, rest, {
    style: styles
  }));
}
var defaultStyles$p = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return {
    color: color.text.inactive,
    backgroundColor: 'transparent',
    '&interactive': {
      ':hover': {
        color: color.text.base,
        backgroundColor: color.hover.base,
        borderRadius: border.button.borderRadius.regular
      },
      ':focus': {
        color: color.text.base,
        backgroundColor: color.hover.base,
        borderRadius: border.button.borderRadius.regular
      },
      ':active': {
        color: color.coloredText.primary,
        backgroundColor: color.active.primary,
        borderRadius: border.button.borderRadius.regular
      },
      ':active:hover': {
        color: color.coloredText.primary,
        backgroundColor: color.activeHover.primary,
        borderRadius: border.button.borderRadius.regular
      },
      ':active:focus': {
        color: color.coloredText.primary,
        backgroundColor: color.activeHover.primary,
        borderRadius: border.button.borderRadius.regular
      }
    },
    '&active': {
      color: color.coloredText.primary,
      backgroundColor: color.active.primary,
      borderRadius: border.button.borderRadius.regular,
      ':hover': {
        color: color.coloredText.primary,
        backgroundColor: color.activeHover.primary,
        borderRadius: border.button.borderRadius.regular
      },
      ':focus': {
        color: color.coloredText.primary,
        backgroundColor: color.activeHover.primary,
        borderRadius: border.button.borderRadius.regular
      }
    },
    '&disabled': {
      color: color.text.disabled
    },
    '&small': {
      borderRadius: border.button.borderRadius.small
    }
  };
};var _excluded$1k = ["active", "style", "className", "classNames"];
function OnDarkIconButton$1(_ref) {
  var active = _ref.active,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    rest = _objectWithoutProperties(_ref, _excluded$1k);
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$o(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {
    '&disabled': !!rest.disabled,
    '&active': !!active,
    '&interactive': !rest.disabled
  });
  return /*#__PURE__*/React.createElement(IconButton$4, _extends({}, rest, {
    style: styles
  }));
}
var defaultStyles$o = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return {
    color: color.contrastText.inactive,
    backgroundColor: 'transparent',
    borderRadius: border.button.borderRadius.regular,
    '&interactive': {
      ':hover': {
        backgroundColor: color.hover.contrast
      },
      ':focus': {
        backgroundColor: color.hover.contrast
      },
      ':active': {
        backgroundColor: color.active.contrast
      },
      ':active:hover': {
        backgroundColor: color.activeHover.contrast
      },
      ':active:focus': {
        backgroundColor: color.activeHover.contrast
      }
    },
    '&active': {
      backgroundColor: color.active.contrast,
      ':hover': {
        backgroundColor: color.activeHover.contrast
      },
      ':focus': {
        backgroundColor: color.activeHover.contrast
      }
    },
    '&disabled': {
      color: color.contrastText.disabled
    },
    '&small': {
      borderRadius: border.button.borderRadius.small
    }
  };
};var _excluded$1j = ["style", "active"];
var ContainedIconButton$1 = function ContainedIconButton(_ref) {
  var style = _ref.style;
    _ref.active;
    var rest = _objectWithoutProperties(_ref, _excluded$1j);
  return /*#__PURE__*/React.createElement(IconButton$4, _extends({}, rest, {
    small: true,
    style: style
  }));
};
var styled$$ = createDefaultStyle(function (_ref2) {
  var color = _ref2.color;
  return {
    color: color.text.inactive,
    backgroundColor: 'transparent',
    '&interactive': {
      ':hover': {
        color: color.text.base,
        backgroundColor: color.hover.base
      },
      ':focus': {
        color: color.text.base,
        backgroundColor: color.hover.base
      },
      ':active': {
        color: color.coloredText.primary,
        backgroundColor: color.active.primary
      },
      ':active:hover': {
        color: color.coloredText.primary,
        backgroundColor: color.activeHover.primary
      },
      ':active:focus': {
        color: color.coloredText.primary,
        backgroundColor: color.activeHover.primary
      }
    },
    '&active': {
      color: color.coloredText.primary,
      backgroundColor: color.active.primary,
      ':hover': {
        color: color.coloredText.primary,
        backgroundColor: color.activeHover.primary
      },
      ':focus': {
        color: color.coloredText.primary,
        backgroundColor: color.activeHover.primary
      }
    },
    '&disabled': {
      color: color.text.disabled
    }
  };
}, function (props) {
  return {
    '&active': props.active,
    '&disabled': props.disabled,
    '&interactive': !props.disabled
  };
});
var ContainedIconButton$2 = styled$$(ContainedIconButton$1);function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CLOSE_DELAY$1 = 2000;
var withConfirmation$2 = function withConfirmation(WrappedComponent) {
  return /*#__PURE__*/function (_Component) {
    _inherits(WithConfirmation, _Component);
    var _super = _createSuper$8(WithConfirmation);
    function WithConfirmation(props) {
      var _this;
      _classCallCheck(this, WithConfirmation);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "requestConfirmation", function (ev) {
        ev.stopPropagation();
        _this.setState({
          confirm: true
        });
        _this.setTimer();
      });
      _defineProperty(_assertThisInitialized(_this), "cancel", function (ev) {
        ev.stopPropagation();
        _this.setState({
          confirm: false
        });
      });
      _defineProperty(_assertThisInitialized(_this), "confirm", function (ev) {
        ev.stopPropagation();
        _this.setState({
          confirm: false
        });
        if (_this.props.onClick) {
          _this.props.onClick(ev);
        }
      });
      _this.state = {
        confirm: false
      };
      return _this;
    }
    _createClass(WithConfirmation, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.timer) {
          window.clearTimeout(this.timer);
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
          confirm: this.state.confirm,
          onClick: this.requestConfirmation,
          onConfirm: this.confirm,
          onCancel: this.cancel
        }));
      }
    }, {
      key: "setTimer",
      value: function setTimer() {
        var _this2 = this;
        if (this.timer) {
          window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () {
          _this2.setState({
            confirm: false
          });
        }, CLOSE_DELAY$1);
      }
    }]);
    return WithConfirmation;
  }(Component);
};
var withConfirmation$3 = withConfirmation$2;function ownKeys$19(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$19(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$19(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$19(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ConfirmButton$3 = function ConfirmButton(_ref) {
  var confirm = _ref.confirm,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm,
    style = _ref.style,
    small = _ref.small,
    disabled = _ref.disabled,
    toLeft = _ref.toLeft,
    children = _ref.children,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", style, /*#__PURE__*/React.createElement(TransitionGroup, null, confirm && /*#__PURE__*/React.createElement(SlideAnimation, {
    left: toLeft,
    right: !toLeft,
    style: style('confirm')
  }, /*#__PURE__*/React.createElement(DangerButton$3, {
    small: small,
    onClick: onConfirm
  }, /*#__PURE__*/React.createElement(Glyph, null, "success"))), confirm && /*#__PURE__*/React.createElement(SlideAnimation, {
    left: !toLeft,
    right: toLeft,
    style: style('cancel')
  }, /*#__PURE__*/React.createElement(Button$6, {
    small: small,
    onClick: onCancel
  }, /*#__PURE__*/React.createElement(Glyph, null, "reset")))), /*#__PURE__*/React.createElement("div", style('button'), /*#__PURE__*/React.createElement(Button$7, {
    small: small,
    disabled: disabled || confirm,
    onClick: onClick
  }, children)));
};
var getModifiers$9 = function getModifiers(_ref2) {
  var toLeft = _ref2.toLeft,
    confirm = _ref2.confirm;
  return {
    '&toLeft': toLeft,
    '&confirm': confirm
  };
};
var ConfirmButtonUnsealed = compose(withConfirmation$3, createDefaultStyle(function (_ref3) {
  _ref3.padding;
    _ref3.lineHeight;
    _ref3.font;
  return {
    position: 'relative',
    display: 'inline-block',
    boxSizing: 'border-box',
    confirm: {
      position: 'absolute',
      left: '100%',
      zIndex: 1
    },
    cancel: {
      position: 'absolute',
      right: 1,
      zIndex: 1
    },
    button: _objectSpread$19({
      transform: 'scale(1.0)'
    }, styles.transition(['transform'], 'ease', '300ms')),
    '&confirm': {
      button: {
        transform: 'scale(0.8)'
      }
    },
    '&block': {
      display: 'block',
      width: '100%'
    },
    '&toLeft': {
      confirm: {
        left: null,
        right: '100%'
      },
      cancel: {
        right: null,
        left: 1
      }
    }
  };
}, getModifiers$9))(ConfirmButton$3);var _excluded$1i = ["dropdown", "position", "onOpen", "onClose"];
var uncontrolled$1 = dropdownEnhancers.uncontrolled,
  toggleOnClick$1 = dropdownEnhancers.toggleOnClick,
  closeOnClickNode$1 = dropdownEnhancers.closeOnClickNode;
var Dropdown$2 = compose(uncontrolled$1, toggleOnClick$1, closeOnClickNode$1)(Dropdown$3);
var DropdownButton$3 = function DropdownButton(_ref) {
  var dropdown = _ref.dropdown,
    position = _ref.position,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose;
    _objectWithoutProperties(_ref, _excluded$1i);
  return /*#__PURE__*/React.createElement(Dropdown$2, {
    node: dropdown,
    position: position,
    onOpen: onOpen,
    onClose: onClose
  }, function (isOpen) {
    return /*#__PURE__*/React.createElement(Button$7, {
      icon: isOpen ? 'dropdown-close' : 'dropdown-open'
    });
  });
};
var DropdownButtonUnsealed = DropdownButton$3;var CountIndicator$1 = function CountIndicator(_ref) {
  var style = _ref.style,
    value = _ref.value;
  return /*#__PURE__*/React.createElement("div", _extends({}, style, {
    title: value
  }), value <= 999 ? value : '•••');
};
var styled$_ = createDefaultStyle(function (_ref2) {
  var font = _ref2.font,
    spacing = _ref2.spacing,
    color = _ref2.color;
  return {
    borderRadius: font.indicator.normal,
    fontSize: font.indicator.normal,
    minWidth: font.indicator.normal + 2 * spacing.xxxsmall,
    paddingLeft: spacing.xxxsmall,
    paddingRight: spacing.xxxsmall,
    backgroundColor: color.surface,
    color: color.mono.ultradark,
    border: "1px solid ".concat(color.mono.ultradark),
    '&disabled': {
      color: color.text.disabled,
      borderColor: color.text.disabled
    },
    '&small': {
      borderRadius: font.indicator.small,
      fontSize: font.indicator.small,
      minWidth: font.indicator.small + 2 * spacing.xxxsmall
    }
  };
}, function (props) {
  return {
    '&disabled': props.disabled,
    '&small': props.small
  };
});
var CountIndicatorUnsealed = styled$_(CountIndicator$1);function NotificationIndicator$1(_ref) {
  var style = _ref.style,
    value = _ref.value;
  if (value == null) {
    return /*#__PURE__*/React.createElement("div", style);
  }
  return /*#__PURE__*/React.createElement("div", _extends({}, style, {
    title: value
  }), value <= 999 ? value : '•••');
}
var styled$Z = createDefaultStyle(function (_ref2) {
  var spacing = _ref2.spacing,
    font = _ref2.font,
    color = _ref2.color;
  return {
    borderRadius: font.indicator.normal,
    fontSize: font.indicator.normal,
    minWidth: font.indicator.normal + 2 * spacing.xxxsmall,
    paddingLeft: spacing.xxxsmall,
    paddingRight: spacing.xxxsmall,
    backgroundColor: color.primary.base,
    color: color.surface,
    border: '1px solid transparent',
    '&disabled': {
      backgroundColor: color.mono.lighter
    },
    '&blank': {
      width: 10,
      height: 10,
      borderRadius: 10,
      minWidth: null,
      paddingLeft: null,
      paddingRight: null,
      marginTop: spacing.xxxsmall,
      marginRight: spacing.xxxsmall
    },
    '&small': {
      borderRadius: font.indicator.small,
      fontSize: font.indicator.small,
      minWidth: font.indicator.small + 2 * spacing.xxxsmall,
      '&blank': {
        minWidth: null,
        marginTop: spacing.xxxsmall / 2,
        marginRight: spacing.xxxsmall / 2
      }
    }
  };
}, function (props) {
  return {
    '&disabled': props.disabled,
    '&blank': props.value == null,
    '&small': props.small
  };
});
var NotificationIndicatorUnsealed = styled$Z(NotificationIndicator$1);var _excluded$1h = ["title", "style"];
function Divider$1(_ref) {
  var title = _ref.title,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$1h);
  return /*#__PURE__*/React.createElement("div", _extends({}, _omit(rest, 'padding'), style), /*#__PURE__*/React.createElement("div", style('border')), title && /*#__PURE__*/React.createElement("span", style('title'), title));
}
var styled$Y = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    padding = _ref2.padding,
    font = _ref2.font;
  return {
    position: 'relative',
    '&padding-small': {
      paddingTop: padding.small,
      paddingBottom: padding.small
    },
    '&padding-normal': {
      paddingTop: padding.normal,
      paddingBottom: padding.normal
    },
    '&padding-large': {
      paddingTop: padding.large,
      paddingBottom: padding.large
    },
    border: {
      position: 'absolute',
      top: '50%',
      width: '100%',
      height: 1,
      backgroundColor: color.mono.light
    },
    title: {
      position: 'relative',
      marginLeft: padding.normal,
      fontSize: font.size.small,
      color: Color$3(color.mono.light).darken(0.2).rgb().string(),
      backgroundColor: 'white',
      paddingLeft: padding.small,
      paddingRight: padding.small
    }
  };
}, function (_ref3) {
  var _ref3$padding = _ref3.padding,
    padding = _ref3$padding === void 0 ? 'small' : _ref3$padding;
  return _defineProperty({}, "&padding-".concat(padding), true);
});
var DividerUnsealed = styled$Y(Divider$1);var _excluded$1g = ["children", "style"];
var List$1 = function List(props) {
  var children = props.children,
    style = props.style,
    rest = _objectWithoutProperties(props, _excluded$1g);
  if (!children) {
    return null;
  }
  var isFirst = true;
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "list",
    "data-testid": "list-component"
  }, _omit(rest, 'direction', 'equalWidths', 'alignBottom'), style), Children.toArray(children).map(function (child) {
    if (!child) {
      return null;
    }
    var entryStyle = style('entry')({
      '&first': isFirst
    });
    isFirst = false;
    return /*#__PURE__*/React.createElement("div", _extends({
      role: "listitem",
      key: child.key
    }, entryStyle), child);
  }));
};
var styled$X = createDefaultStyle({
  '&vertical': {
    entry: {
      marginTop: 1,
      '&first': {
        marginTop: 0
      }
    }
  },
  '&horizontal': {
    display: 'flex',
    entry: {
      paddingLeft: 1,
      '&first': {
        paddingLeft: 0
      }
    },
    '&alignBottom': {
      entry: {
        alignSelf: 'flex-end'
      }
    },
    '&equalWidths': {
      entry: {
        flexGrow: 1,
        flexBasis: 0
      }
    }
  }
}, function (_ref) {
  var _ref2;
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
    equalWidths = _ref.equalWidths,
    alignBottom = _ref.alignBottom;
  return _ref2 = {}, _defineProperty(_ref2, "&".concat(direction), true), _defineProperty(_ref2, '&equalWidths', equalWidths), _defineProperty(_ref2, '&alignBottom', alignBottom), _ref2;
});
var ListUnsealed = styled$X(List$1);var _excluded$1f = ["children", "style", "noPadding", "accent", "theme"];
function ownKeys$18(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$18(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$18(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$18(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Card$1 = function Card(_ref) {
  var children = _ref.children,
    style = _ref.style,
    noPadding = _ref.noPadding,
    _ref$accent = _ref.accent,
    accent = _ref$accent === void 0 ? 'transparent' : _ref$accent,
    theme = _ref.theme,
    rest = _objectWithoutProperties(_ref, _excluded$1f);
  var borderColor;
  switch (accent) {
    case 'primary':
      borderColor = theme.color.primary.base;
      break;
    case 'secondary':
      borderColor = theme.color.secondary.base;
      break;
    default:
      borderColor = accent;
  }
  var fioriStyles = useFioriStyles();
  var borderTopWidth = fioriStyles ? 2 : 4;
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, styles.merge(style, _objectSpread$18({
    borderTopColor: borderColor,
    borderRadius: fioriStyles ? accent === 'transparent' ? '12px' : '0 0 12px 12px' : 0,
    paddingTop: noPadding ? 0 : theme.spacing.small - borderTopWidth
  }, theme.shadow.card))), children);
};
var enhance$z = compose(createDefaultStyle(function (_ref2) {
  var spacing = _ref2.spacing;
  return {
    background: 'white',
    borderTopStyle: 'solid',
    paddingBottom: spacing.small,
    paddingLeft: spacing.small,
    paddingRight: spacing.small,
    '&noPadding': {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    },
    '&removeBorder': {
      borderTopWidth: 0
    }
  };
}, function (_ref3) {
  var noPadding = _ref3.noPadding,
    accent = _ref3.accent;
  return {
    '&noPadding': noPadding,
    '&removeBorder': noPadding && !accent
  };
}), getTheme$1);
var CardUnsealed = enhance$z(Card$1);var omitProps = compose(mapProps, _omit$1);var _excluded$1e = ["innerRef"];
function ownKeys$17(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$17(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$17(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$17(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var resolveInnerRef = mapProps(function (_ref) {
  var innerRef = _ref.innerRef,
    rest = _objectWithoutProperties(_ref, _excluded$1e);
  return _objectSpread$17({
    ref: innerRef
  }, rest);
});var _excluded$1d = ["icon", "style"];
var Icon$1 = function Icon(_ref) {
  var icon = _ref.icon,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$1d);
  return /*#__PURE__*/React.createElement(Glyph, _extends({
    style: style
  }, rest), icon);
};
var getModifiers$8 = function getModifiers(_ref2) {
  var inline = _ref2.inline,
    block = _ref2.block,
    small = _ref2.small,
    warning = _ref2.warning,
    error = _ref2.error,
    info = _ref2.info,
    primary = _ref2.primary,
    white = _ref2.white,
    inheritSize = _ref2.inheritSize;
  return {
    '&inline': inline,
    '&block': block,
    '&small': small,
    '&warning': warning,
    '&error': error,
    '&info': info,
    '&primary': primary,
    '&white': white,
    '&inheritSize': inheritSize
  };
};
var enhance$y = compose(createDefaultStyle(function (theme) {
  return {
    lineHeight: theme.lineHeight,
    fontSize: theme.font.size.normal,
    display: 'inline-block',
    paddingTop: theme.padding.small,
    paddingBottom: theme.padding.small,
    width: styles.calculateIconSize(theme),
    textAlign: 'center',
    '&inheritSize': {
      fontSize: null
    },
    '&block': {
      display: 'block'
    },
    '&small': {
      width: styles.calculateSmallIconSize(theme),
      paddingTop: theme.padding.xsmall,
      paddingBottom: theme.padding.xsmall,
      fontSize: theme.font.size.small
    },
    '&info': {
      color: theme.color.status.info
    },
    '&success': {
      color: theme.color.status.success
    },
    '&warning': {
      color: theme.color.status.warning
    },
    '&error': {
      color: theme.color.status.danger
    },
    '&white': {
      color: 'white'
    },
    '&primary': {
      color: theme.color.primary.base
    },
    '&inline': {
      width: 'auto',
      marginLeft: theme.padding.small,
      marginRight: theme.padding.small,
      paddingTop: 0,
      paddingBottom: 0
    }
  };
}, getModifiers$8), omitProps(['inline', 'block', 'small', 'warning', 'error', 'info', 'primary', 'white', 'inheritSize']));
var Icon$2 = enhance$y(Icon$1);var _excluded$1c = ["style"];
function Spinner$1(_ref) {
  var style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$1c);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, style), /*#__PURE__*/React.createElement("div", style('spinner')));
}
var diameter = {
  normal: 14,
  small: 10
};
var borderWidth = 2;
var enhance$x = compose(createDefaultStyle(function (theme) {
  var size = styles.calculateIconSize(theme);
  var sizeSmall = styles.calculateSmallIconSize(theme);
  return {
    position: 'relative',
    width: size,
    height: size,
    spinner: {
      width: diameter.normal,
      height: diameter.normal,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -(diameter.normal + 2 * borderWidth) / 2,
      marginLeft: -(diameter.normal + 2 * borderWidth) / 2,
      borderWidth: borderWidth,
      borderStyle: 'solid',
      borderColor: 'transparent',
      borderTopColor: theme.color.primary.base,
      borderLeftColor: theme.color.primary.base,
      borderRadius: '50%',
      animation: 'signavio-ui-spinner 400ms linear infinite'
    },
    '&small': {
      width: sizeSmall,
      height: sizeSmall,
      spinner: {
        width: diameter.small,
        height: diameter.small,
        marginTop: -(diameter.small + 2 * borderWidth) / 2,
        marginLeft: -(diameter.small + 2 * borderWidth) / 2
      }
    },
    '&inline': {
      display: 'inline-block',
      width: size - 2 * theme.padding.small,
      height: size - 2 * theme.padding.small,
      '&small': {
        width: sizeSmall - 2 * theme.padding.xsmall,
        height: sizeSmall - 2 * theme.padding.xsmall
      }
    },
    '&onDark': {
      spinner: {
        borderTopColor: theme.color.surface,
        borderLeftColor: theme.color.surface
      }
    }
  };
}, function (props) {
  return {
    '&small': props.small,
    '&inline': props.inline,
    '&onDark': props.onDark
  };
}), omitProps(['small', 'inline', 'onDark']));
var SpinnerUnsealed = enhance$x(Spinner$1);function ownKeys$16(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$16(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$16(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$16(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DragHandle$1 = function DragHandle(props) {
  return /*#__PURE__*/React.createElement(Icon$2, _extends({}, props, {
    icon: "drag-sort"
  }));
};
var styled$W = createDefaultStyle(function (_ref) {
  var font = _ref.font,
    lineHeight = _ref.lineHeight;
  return _objectSpread$16(_objectSpread$16({
    opacity: 0.25,
    cursor: 'grab'
  }, styles.transition('opacity')), {}, {
    ':hover': {
      opacity: 1
    },
    '&dragging': {
      cursor: 'grabbing'
    },
    '&small': {
      fontSize: font.size.normal,
      lineHeight: "".concat(styles.calculateAbsoluteLineHeight(font.size.small, lineHeight), "px")
    }
  });
}, function (_ref2) {
  var dragging = _ref2.dragging,
    small = _ref2.small;
  return {
    '&dragging': dragging,
    '&small': small
  };
});
var enhance$w = compose(styled$W, omitProps(['dragging']));
var DragHandleUnsealed = enhance$w(DragHandle$1);var _excluded$1b = ["toolbar", "tooltip", "header", "icon", "children", "style", "small"];
function Tile$1(props) {
  var toolbar = props.toolbar,
    tooltip = props.tooltip,
    header = props.header,
    icon = props.icon,
    children = props.children,
    style = props.style,
    small = props.small,
    rest = _objectWithoutProperties(props, _excluded$1b);
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "tile-component"
  }, rest, style, {
    title: tooltip
  }), (header || icon) && /*#__PURE__*/React.createElement("div", style('header'), icon && /*#__PURE__*/React.createElement(Icon$2, {
    style: style('icon'),
    icon: icon,
    small: small,
    block: true
  }), header), /*#__PURE__*/React.createElement("div", style('main'), children), toolbar && /*#__PURE__*/React.createElement("div", style('toolbar'), toolbar));
}
var getModifiers$7 = function getModifiers(_ref) {
  var small = _ref.small,
    inline = _ref.inline,
    transparent = _ref.transparent,
    alignBottom = _ref.alignBottom,
    alignTop = _ref.alignTop;
  return {
    '&small': small,
    '&inline': inline,
    '&transparent': transparent,
    '&alignBottom': alignBottom,
    '&alignTop': alignTop
  };
};
var enhance$v = compose(pure, createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    font = _ref2.font;
  return {
    backgroundColor: color.mono.ultralight,
    display: 'flex',
    alignItems: 'center',
    header: {},
    main: {
      flexGrow: 1,
      overflow: 'hidden'
    },
    icon: {
      backgroundColor: color.mono.light,
      color: styles.textColor(color.mono.light),
      marginRight: padding.xsmall
    },
    '&small': {
      fontSize: font.size.button
    },
    '&inline': {
      alignItems: 'flex-start'
    },
    '&transparent': {
      backgroundColor: 'transparent'
    },
    '&alignBottom': {
      alignItems: 'flex-end'
    },
    '&alignTop': {
      alignItems: 'flex-start'
    }
  };
}, getModifiers$7), omitProps(['alignBottom', 'alignTop', 'inline', 'transparent']));
var Tile$2 = enhance$v(Tile$1);var _excluded$1a = ["subtitle", "children", "tooltip", "small", "style"];
function ownKeys$15(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$15(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$15(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$15(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TextTile$1 = function TextTile(_ref) {
  var subtitle = _ref.subtitle,
    children = _ref.children,
    tooltip = _ref.tooltip,
    small = _ref.small,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$1a);
  return /*#__PURE__*/React.createElement(Tile$2, _extends({}, rest, {
    style: style,
    small: small,
    tooltip: getTooltip({
      tooltip: tooltip,
      small: small,
      subtitle: subtitle,
      children: children
    })
  }), /*#__PURE__*/React.createElement("div", style('content'), /*#__PURE__*/React.createElement("div", style('title'), children), !!subtitle && !small && /*#__PURE__*/React.createElement("div", style('subtitle'), subtitle)));
};
var getTooltip = function getTooltip(_ref2) {
  var tooltip = _ref2.tooltip,
    small = _ref2.small,
    subtitle = _ref2.subtitle,
    children = _ref2.children;
  if (tooltip) {
    return tooltip;
  }
  if (small && subtitle) {
    return subtitle;
  }
  if (_isString(children)) {
    return children;
  }
  return '';
};
var getModifiers$6 = function getModifiers(_ref3) {
  var small = _ref3.small,
    transparent = _ref3.transparent,
    subtitle = _ref3.subtitle;
  return {
    '&small': small,
    '&transparent': transparent,
    '&double-spaced': !!subtitle && !small
  };
};
var styled$V = createDefaultStyle(function (_ref4) {
  var color = _ref4.color,
    padding = _ref4.padding,
    lineHeight = _ref4.lineHeight,
    font = _ref4.font;
  var height = styles.calculateHeight(font.size.normal, lineHeight, padding.small);
  var smallHeight = styles.calculateHeight(font.size.small, lineHeight, padding.xsmall);
  return {
    content: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: height,
      paddingLeft: padding.normal,
      paddingRight: padding.normal
    },
    title: _objectSpread$15({}, styles.ellipsis()),
    subtitle: _objectSpread$15(_objectSpread$15({}, styles.ellipsis()), {}, {
      // make sure the text is not cut off at the bottom and move it a bit up
      marginTop: -2,
      paddingBottom: 2,
      color: color.mono.middle,
      fontSize: font.size.small
    }),
    '&small': {
      content: {
        height: smallHeight,
        paddingLeft: padding.small,
        paddingRight: padding.small
      }
    },
    '&doubleSpaced': {
      title: {
        height: "".concat(2 / 3 * 100, "%")
      }
    }
  };
}, getModifiers$6);
var TextTileUnsealed = styled$V(TextTile$1);var PlaceholderTile$1 = function PlaceholderTile(_ref) {
  var style = _ref.style,
    withHeader = _ref.withHeader,
    header = _ref.header,
    subtitle = _ref.subtitle,
    withSubtitle = _ref.withSubtitle,
    icon = _ref.icon,
    small = _ref.small,
    transparent = _ref.transparent,
    toolbar = _ref.toolbar;
  return /*#__PURE__*/React.createElement(TextTileUnsealed, {
    small: small,
    transparent: transparent,
    toolbar: toolbar,
    icon: icon,
    header: header || !icon && withHeader && /*#__PURE__*/React.createElement("div", style('headerPlaceholder'), /*#__PURE__*/React.createElement("div", _extends({}, style('flare'), {
      className: "hide-in-percy"
    }))),
    subtitle: subtitle || withSubtitle && /*#__PURE__*/React.createElement("div", style('textPlaceholderContainer'), /*#__PURE__*/React.createElement("div", style(['textPlaceholder', 'subtitlePlaceholder']), /*#__PURE__*/React.createElement("div", _extends({}, style('flare'), {
      className: "hide-in-percy"
    }))), "\xA0")
  }, /*#__PURE__*/React.createElement("div", style('textPlaceholderContainer'), /*#__PURE__*/React.createElement("div", style(['textPlaceholder', 'bodyPlaceholder']), /*#__PURE__*/React.createElement("div", _extends({}, style('flare'), {
    className: "hide-in-percy"
  }))), "\xA0"));
};
var randomizeWidth = function randomizeWidth() {
  return 33 + Math.random() * 66;
};
var size$1 = 500;
var styled$U = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    font = _ref2.font,
    padding = _ref2.padding,
    lineHeight = _ref2.lineHeight;
  var height = styles.calculateHeight(font.size.normal, lineHeight, 0);
  var smallHeight = styles.calculateHeight(font.size.small, lineHeight, 0);
  return {
    headerPlaceholder: {
      backgroundColor: color.mono.light,
      marginTop: padding.small,
      marginBottom: padding.small,
      marginLeft: padding.small,
      height: height,
      width: height,
      borderRadius: '50%',
      overflow: 'hidden'
    },
    textPlaceholderContainer: {
      position: 'relative',
      width: '100%',
      maxWidth: size$1
    },
    textPlaceholder: {
      position: 'absolute',
      top: '50%',
      backgroundColor: color.mono.light
    },
    flare: {
      width: '100%',
      height: '100%',
      background: "linear-gradient(to right, ".concat(color.mono.light, " 8%, ").concat(color.hover.base, " 18%, ").concat(color.hover.base, " 28%, ").concat(color.mono.light, " 48%)"),
      backgroundRepeat: 'no-repeat',
      backgroundSize: "".concat(size$1, "px 100%"),
      animationName: 'signavio-ui-placeholder',
      animationDuration: '1s',
      animationFillMode: 'forwards',
      animationTimingFunction: 'linear',
      animationIterationCount: 'infinite'
    },
    bodyPlaceholder: {
      height: font.size.normal,
      marginTop: -parseInt(font.size.normal, 10) / 2,
      width: "".concat(randomizeWidth(), "%")
    },
    subtitlePlaceholder: {
      height: font.size.small,
      marginTop: -parseInt(font.size.small, 10) / 2,
      width: "".concat(randomizeWidth(), "%")
    },
    '&small': {
      headerPlaceholder: {
        height: smallHeight,
        width: smallHeight,
        marginTop: null,
        marginBottom: null
      },
      bodyPlaceholder: {
        height: font.size.small,
        marginTop: -parseInt(font.size.small, 10) / 2,
        width: "".concat(randomizeWidth(), "%")
      }
    }
  };
}, function (_ref3) {
  var small = _ref3.small;
  return {
    '&small': small
  };
});
var PlaceholderTileUnsealed = styled$U(PlaceholderTile$1);function ownKeys$14(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$14(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$14(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$14(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function makeInteractive(WrappedComponent) {
  var styled = createDefaultStyle(function (_ref) {
    var color = _ref.color;
    return _objectSpread$14(_objectSpread$14({
      backgroundColor: 'transparent',
      cursor: 'pointer'
    }, styles.transition('background-color')), {}, {
      ':hover': {
        backgroundColor: color.mono.ultralight
      },
      '&focused': {
        backgroundColor: color.mono.ultralight
      },
      '&selected': {
        backgroundColor: color.mono.ultralight
      },
      '&disabled': {
        cursor: 'default',
        ':hover': {
          backgroundColor: 'transparent'
        }
      }
    });
  }, function (_ref2) {
    var isFocused = _ref2.isFocused,
      isSelected = _ref2.isSelected,
      disabled = _ref2.disabled;
    return {
      '&focused': isFocused,
      '&selected': isSelected,
      '&disabled': disabled
    };
  });
  return styled(WrappedComponent);
}var workflowAccelerator = 'data:image/svg+xml;base64,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';
var workflowAccelerator$1 = workflowAccelerator;var processIntelligence = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPjxwYXRoIGlkPSJwcm9wZXJ0eS1wcm9jZXNzLWludGVsbGlnZW5jZSIgZD0iTTI4LjUgOWgtMS44NmExLjE1IDEuMTUgMCAwIDAtLjc2LS42N0E2LjY1IDYuNjUgMCAwIDAgMTkuMjUgM2MtMi44OSAwLTYuODIuNjEtMTEuNiA1LjQtLjIxLjItLjM5LjQtLjU3LjZIMi41QzEuNjcgOSAxIDkuNjcgMSAxMC41djRjMCAuODMuNjcgMS41IDEuNSAxLjVoLjcyQzMgMTcuMSAzIDE3Ljk2IDMgMTguNWMwIDQuMTMgMi42NCA2LjUgNy4yNSA2LjVoMS41NGwtMS40IDEuNGEuNS41IDAgMCAwIDAgLjcxYy4yNC4yLjQ3LjIuNzEgMGwyLjI1LTIuMjVjLjItLjI0LjItLjQ3IDAtLjcxTDExLjEgMjEuOWEuNS41IDAgMCAwLS43MSAwIC41LjUgMCAwIDAgMCAuNzFsMS40IDEuNGgtMS41NEM2LjE2IDI0IDQgMjIuMSA0IDE4LjVjMC0uNTcgMC0xLjQyLjIzLTIuNUg5LjVjLjgzIDAgMS41LS42NyAxLjUtMS41di00YzAtLjgzLS42Ny0xLjUtMS41LTEuNUg4LjQ2YzQuNDctNC40MiA4LjExLTUgMTAuNzktNWE1LjY2IDUuNjYgMCAwIDEgNS42MyA0LjQ0Ljk2Ljk2IDAgMCAwLS41Mi41NkgyMS41Yy0uODMgMC0xLjUuNjctMS41IDEuNXY0YzAgLjgzLjY3IDEuNSAxLjUgMS41aDdjLjgzIDAgMS41LS42NyAxLjUtMS41di00YzAtLjgzLS42Ny0xLjUtMS41LTEuNXpNMy40NyAxNUgyLjVhLjUuNSAwIDAgMS0uNS0uNXYtNGMwLS4yOC4yMi0uNS41LS41aDMuN2ExNC41MyAxNC41MyAwIDAgMC0yLjczIDV6bTYuMDMtNWMuMjggMCAuNS4yMi41LjV2NGEuNS41IDAgMCAxLS41LjVoLTVhMTMuOTcgMTMuOTcgMCAwIDEgMy4wMS01SDkuNXpNMjkgMTQuNWEuNS41IDAgMCAxLS41LjVoLTdhLjUuNSAwIDAgMS0uNS0uNXYtNGMwLS4yOC4yMi0uNS41LS41aDIuODZjLjIuNDUuNjUuNzUgMS4xNC43NS40OSAwIC45NC0uMyAxLjE0LS43NWgxLjg2Yy4yOCAwIC41LjIyLjUuNXY0em0tMTYuNS0yYzAgLjI4LjIyLjUuNS41aDMuNzlsLTEuMTUgMS4xNWEuNS41IDAgMCAwIDAgLjcxYy4yNC4yLjQ3LjIuNzEgMGwyLTJjLjItLjI0LjItLjQ3IDAtLjcxbC0yLTJhLjUuNSAwIDAgMC0uNzEgMCAuNS41IDAgMCAwIDAgLjcxTDE2Ljc5IDEySDEzYS41LjUgMCAwIDAtLjUuNXptMTEgOC41aC03Yy0uODMgMC0xLjUuNjctMS41IDEuNXY0YzAgLjgzLjY3IDEuNSAxLjUgMS41aDdjLjgzIDAgMS41LS42NyAxLjUtMS41di00YzAtLjgzLS42Ny0xLjUtMS41LTEuNXptLjUgNS41YS41LjUgMCAwIDEtLjUuNWgtN2EuNS41IDAgMCAxLS41LS41di00YzAtLjI4LjIyLS41LjUtLjVoN2MuMjggMCAuNS4yMi41LjV2NHoiIGZpbGw9IndoaXRlIi8+PC9zdmc+';
var processIntelligence$1 = processIntelligence;var userManagement = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPjxwYXRoIGlkPSJwcm9wZXJ0eS1hY2Nlc3MtcmlnaHRzIiBkPSJNMjEuNSAxNWMuOTYgMCAxLjc1LS43OCAxLjc1LTEuNzUgMC0uNzktLjUzLTEuNDUtMS4yNS0xLjY3di0uODNjMC0uMjgtLjIyLS41LS41LS41cy0uNS4yMi0uNS41di44M2MtLjcyLjIyLTEuMjUuODgtMS4yNSAxLjY3IDAgLjk3Ljc5IDEuNzUgMS43NSAxLjc1em0wLTIuNWMuNDEgMCAuNzUuMzQuNzUuNzVzLS4zNC43NS0uNzUuNzUtLjc1LS4zNC0uNzUtLjc1LjM0LS43NS43NS0uNzV6bTMuMjUgNi43NWgtNS41Yy0uMjggMC0uNS4yMi0uNS41cy4yMi41LjUuNWg1LjVjLjI4IDAgLjUtLjIyLjUtLjVzLS4yMi0uNS0uNS0uNXptMCAyLjVoLTUuNWMtLjI4IDAtLjUuMjItLjUuNXMuMjIuNS41LjVoNS41Yy4yOCAwIC41LS4yMi41LS41cy0uMjItLjUtLjUtLjV6bS0xMC45MS0uNTljLjA3LS41MS4yNi0uNzcuNS0xLjA4LjM1LS40Ny43OS0xLjA2Ljc5LTIuNDQgMC0xLjk3LTEuMTctMy4xNC0zLjEzLTMuMTRzLTMuMTMgMS4xNy0zLjEzIDMuMTRjMCAxLjM4LjQ0IDEuOTcuNzkgMi40NC4yMy4zMS40My41Ny41IDEuMDktMi4yNy4zOC0zLjY2IDEuNjMtMy42NiAzLjMzIDAgLjI4LjIyLjUuNS41aDEwLjAyYS41LjUgMCAwIDAgLjUtLjVjMC0xLjctMS4zNS0yLjk3LTMuNjgtMy4zNHpNNy41NyAyNGMuMjktMSAxLjQ1LTEuNzEgMy4xNy0xLjkxYS41LjUgMCAwIDAgLjQ0LS41YzAtMS4xNS0uMzgtMS42Ny0uNzItMi4xMi0uMzItLjQyLS41OS0uNzktLjU5LTEuODQgMC0uOTguMzctMi4xNCAyLjEzLTIuMTQgMS43NiAwIDIuMTMgMS4xNiAyLjEzIDIuMTQgMCAxLjA1LS4yNyAxLjQyLS41OSAxLjg0LS4zNC40NS0uNzIuOTYtLjcyIDIuMTIgMCAuMjUuMTkuNDcuNDQuNSAxLjA5LjEyIDIuODQuNTMgMy4xOCAxLjkxSDcuNTd6TTI3IDExaC0xdi0xYTIgMiAwIDAgMC0yLTJWNi4yNWEzIDMgMCAwIDAtMy0zIDMgMyAwIDAgMC0zIDNjMCAuMjguMjIuNS41LjVzLjUtLjIyLjUtLjVjMC0xLjEuOS0yIDItMmEyIDIgMCAwIDEgMiAyVjhoLTRhMiAyIDAgMCAwLTIgMnYxSDZhMiAyIDAgMCAwLTIgMnYxM2MwIDEuMS45IDIgMiAyaDIxYTIgMiAwIDAgMCAyLTJWMTNhMiAyIDAgMCAwLTItMnptLTktMWExIDEgMCAwIDEgMS0xaDVhMSAxIDAgMCAxIDEgMXY1YTEgMSAwIDAgMS0xIDFoLTVhMSAxIDAgMCAxLTEtMXYtNXptMTAgMTZhMSAxIDAgMCAxLTEgMUg2YTEgMSAwIDAgMS0xLTFWMTNhMSAxIDAgMCAxIDEtMWgxMXYzYzAgMS4xLjkgMiAyIDJoNWEyIDIgMCAwIDAgMi0ydi0zaDFhMSAxIDAgMCAxIDEgMXYxM3oiIGZpbGw9IndoaXRlIiAvPjwvc3ZnPg==';
var userManagement$1 = userManagement;var collaborationHub = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPjxwYXRoIGlkPSJwcm9wZXJ0eS1jb2xsYWJvcmF0aW9uLXBvcnRhbCIgZD0iTTE5LjQxIDIwLjYzYTQuODEgNC44MSAwIDAgMSAxLjI1LTMuMThjLjc2LS45OCAxLjYzLTIuMDkgMS42My00Ljk1QzIyLjI5IDguNDMgMTkuOTQgNiAxNiA2cy02LjI5IDIuNDMtNi4yOSA2LjVjMCAyLjg3Ljg3IDMuOTcgMS42MyA0Ljk1LjYzLjggMS4xNyAxLjUgMS4yNSAzLjE4LTUgLjU1LTguMDkgMy4xNS04LjA5IDYuODcgMCAuMjguMjIuNS41LjVoMjIuMDJhLjUuNSAwIDAgMCAuNS0uNWwtLjAyLS4xNWMtLjA4LTMuNjQtMy4xNS02LjE4LTguMDktNi43MnpNNS41MiAyN2MuMjktMyAzLjE1LTUuMDUgNy42Mi01LjQyYS41LjUgMCAwIDAgLjQ2LS41YzAtMi4zNS0uNzUtMy4zMi0xLjQ4LTQuMjUtLjczLS45My0xLjQyLTEuODItMS40Mi00LjM0QzEwLjcxIDkgMTIuNjQgNyAxNiA3czUuMjkgMiA1LjI5IDUuNWMwIDIuNTItLjY5IDMuNC0xLjQyIDQuMzRhNS44NSA1Ljg1IDAgMCAwLTEuNDggNC4yNWMwIC4yNi4yLjQ4LjQ2LjUgNC40Ny4zNiA3LjM0IDIuNDIgNy42MiA1LjQySDUuNTJ6TTMgMjVIMS41MmMuMi0yLjc5IDIuMS00LjQgNS44LTQuOTJhLjUuNSAwIDAgMCAuNDMtLjUgNC4xIDQuMSAwIDAgMC0xLjE5LTIuOTMgNC45NSA0Ljk1IDAgMCAxLTEuMzEtMy43MkM1LjI1IDEwLjI5IDYuNDggOSA5IDljLjI4IDAgLjUtLjIyLjUtLjVTOS4yOCA4IDkgOGMtMy4wNiAwLTQuNzUgMS43NS00Ljc1IDQuOTMgMCAyLjQ3Ljg1IDMuNTEgMS41NCA0LjM1LjQ2LjU3Ljg1IDEuMDMuOTQgMS44OEMyLjYgMTkuODYuNSAyMS45OS41IDI1LjVjMCAuMjguMjIuNS41LjVoMmMuMjggMCAuNS0uMjIuNS0uNVMzLjI4IDI1IDMgMjV6bTIyLjI3LTUuODRjLjA5LS44NC40Ny0xLjMxLjk0LTEuODhhNS45MiA1LjkyIDAgMCAwIDEuNTQtNC4zNUMyNy43NSA5Ljc1IDI2LjA2IDggMjMgOGMtLjI4IDAtLjUuMjItLjUuNXMuMjIuNS41LjVjMi41MiAwIDMuNzUgMS4yOSAzLjc1IDMuOTMgMCAyLjExLS42NyAyLjkzLTEuMzEgMy43Mi0uNTguNzEtMS4xOSAxLjQ1LTEuMTkgMi45MyAwIC4yNS4xOC40Ni40My41IDMuNy41MiA1LjYgMi4xMyA1LjggNC45MkgyOWMtLjI4IDAtLjUuMjItLjUuNXMuMjIuNS41LjVoMmEuNS41IDAgMCAwIC41LS41YzAtMy41MS0yLjA5LTUuNjQtNi4yMy02LjM0eiIgZmlsbD0id2hpdGUiIC8+PC9zdmc+';
var collaborationHub$1 = collaborationHub;var comparator = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggaWQ9InByb3BlcnR5LWNvbXBhcmF0b3IiIGQ9Ik0yMywxNS43OFYxNC41YzAtMi40OC0yLTQuNS00LjUtNC41SDE3VjUuNUMxNyw1LjIsMTYuNzgsNSwxNi41LDVoLTEzQzMuMiw1LDMsNS4yLDMsNS41djEzQzMsMTguNzgsMy4yLDE5LDMuNSwxOUg5di41YzAsMi40OCwyLDQuNSw0LjUsNC41aDIuNGMuNjksMywzLjM3LDUuMjUsNi41OCw1LjI1YzMuNywwLDYuNzUtMyw2Ljc1LTYuNzVDMjkuMjUsMTguOTQsMjYuNDksMTYsMjMsMTUuNzh6TTQsMThWNmgxMnY0aC0yLjVDMTEsMTAsOSwxMiw5LDE0LjVWMThINHpNMTMuNSwyM2MtMS45MywwLTMuNS0xLjU3LTMuNS0zLjV2LTVjMC0xLjkzLDEuNTctMy41LDMuNS0zLjVoNWMxLjkzLDAsMy41LDEuNTcsMy41LDMuNXYxLjI4Yy0zLjQ5LC4yNi02LjI1LDMuMTctNi4yNSw2LjdjMCwuMTcsMCwuMzQsMCwuNUgxMy41ek0yMi41LDI4LjI1Yy0zLjE3LDAtNS43NS0yLjU4LTUuNzUtNS43NWMwLTMuMTcsMi41OC01Ljc1LDUuNzUtNS43NWMzLjE3LDAsNS43NSwyLjU4LDUuNzUsNS43NUMyOC4yNSwyNS42NywyNS42NywyOC4yNSwyMi41LDI4LjI1eiIgZmlsbD0id2hpdGUiLz48L3N2Zz4=';
var comparator$1 = comparator;var dictionary = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggaWQ9InByb3BlcnR5LWRpY3Rpb25hcnkiIGQ9Ik0yNSwyMi41di0xN0MyNSw0LjY3LDI0LjMzLDQsMjMuNSw0aC0xNUM3LjEsNCw2LDUuMSw2LDYuNXYxOUM2LDI2Ljg4LDcuMSwyOCw4LjUsMjhoMTZjLjI4LDAsLjUtLjIuNS0uNVMyNC43OCwyNywyNC41LDI3aC0xNkM3LjY3LDI3LDcsMjYuMzMsNywyNS41UzcuNjcsMjQsOC41LDI0aDE1QzI0LjMzLDI0LDI1LDIzLjMzLDI1LDIyLjV6TTI0LDIyLjVjMCwuMjgtLjIuNS0uNS41aC0xNWMtLjU2LDAtMS4wOCwuMi0xLjUuNVY2LjVDNyw1LjY3LDcuNjcsNSw4LjUsNWgxNUMyMy43OCw1LDI0LDUuMiwyNCw1LjVWMjIuNXpNOSwyNWMtLjI4LDAtLjUuMi0uNS41UzguNywyNiw5LDI2aDE0LjVjLjI4LDAsLjUtLjIuNS0uNVMyMy43OCwyNSwyMy41LDI1SDl6TTIwLjUsN2gtOUMxMS4yLDcsMTEsNy4yLDExLDcuNXY2YzAsLjI4LjIsLjUuNSwuNWg5Yy4yOCwwLC41LS4yLjUtLjV2LTZDMjEsNy4yLDIwLjc4LDcsMjAuNSw3ek0yMCwxM2gtOFY4aDhWMTN6IiBmaWxsPSJ3aGl0ZSIvPjwvc3ZnPg==';
var dictionary$1 = dictionary;var explorer = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggaWQ9InByb3BlcnR5LWV4cGxvcmVyIiBkPSJNMzEuNSwxNGMtLjMsMC0yLjUsMC0yLjUsMFY4LjVDMjksNy42NywyOC4zMyw3LDI3LjUsN2gtMjFDNS42Nyw3LDUsNy42Nyw1LDguNVY5SDMuNUMyLjY3LDksMiw5LjY3LDIsMTAuNWMwLDAsMCwxNS41NCwwLDE2LjI1UzIuNzMsMjgsMy41LDI4UzI3LDI4LDI3LDI4Yy4yLDAsLjM4LS4xNSwuNDctLjM0YzAsMCw0LjM5LTEyLjczLDQuNS0xM1MzMS44LDE0LDMxLjUsMTR6TTYsOC41QzYsOC4yLDYuMiw4LDYuNSw4aDIxQzI3Ljc4LDgsMjgsOC4yLDI4LDguNVYxNGgtNXYtMy41YzAtLjI4LS4yLS41LS41LS41UzIyLDEwLjIsMjIsMTAuNXYzLjUzYy0xLjA1LC4xLTEuNTYsLjYtMiwxLjA1VjEwLjVjMC0uMjgtLjItLjUtLjUtLjVTMTksMTAuMiwxOSwxMC41djUuMzRjLS4yNiwuMS0uNTcsLjE2LTEsLjE2aC0zdi01LjVjMC0uMjgtLjItLjUtLjUtLjVoLTVDOS4yLDEwLDksMTAuMiw5LDEwLjVWMTZjMCwwLTIuMjMsMC0yLjUsMFM2LjA2LDE2LjE5LDYsMTYuNFY4LjV6TTE0LDE2aC00di01aDRWMTZ6TTMsMTAuNUMzLDEwLjIsMy4yLDEwLDMuNSwxMEg1djljMCwwLDAsMCwwLDBsLTIsNS4yNlYxMC41ek0zLjEsMjYuOEw2Ljg0LDE3SDE4YzEuNSwwLDIuMTQtLjY0LDIuNjUtMS4xNkMyMS4xLDE1LjM3LDIxLjQ3LDE1LDIyLjUsMTVoOC4zbC00LjE1LDEySDMuNUMzLjM0LDI3LDMuMiwyNi45LDMuMSwyNi44eiIgZmlsbD0id2hpdGUiLz48L3N2Zz4=';
var explorer$1 = explorer;var processManager = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggaWQ9InByb3BlcnR5LXByb2Nlc3MtZWRpdG9yIiBkPSJNMTYuNjUsMTIuODVjLjI0LjIsLjQ3LjIsLjcxLDBsMi0yYy4xOS0uMTkuMTktLjUyLDAtLjcxbC0yLTJjLS4yLS4yLS41MS0uMi0uNzEsMHMtLjIuNTEsMCwuNzFMMTcuNzksMTBoLTMuNDJsLTIuNjMtMi42M2MtLjItLjItLjUxLS4yLS43MSwwbC0yLjc1LDIuNzVjLS4yLjItLjIuNTEsMCwuNzFsMi42MywyLjY0YzAsMCwwLDkuMDQsMCw5LjA0YzAsLjI4LjIyLC41LjUsLjVoNi4zOGwtMS4xNSwxLjE1Yy0uMi4yLS4yLjUxLDAsLjcxYy4yNC4yLC40Ny4yLC43MSwwbDItMmMuMTktLjE5LjE5LS41MiwwLS43MWwtMi0yYy0uMi0uMi0uNTEtLjItLjcxLDBzLS4yLjUxLDAsLjcxTDE3Ljc5LDIyaC01Ljg4YzAsMCwwLTguNTUsMC04LjU4bDIuNC0yLjQyaDMuNDhsLTEuMTUsMS4xNUMxNi40NSwxMi4zNCwxNi40NSwxMi42NiwxNi42NSwxMi44NXpNMTEuMzksMTIuNTFsLTIuMDQtMi4wNGwyLjA0LTIuMDRsMi4wNCwyLjA0TDExLjM5LDEyLjUxek02LjM1LDEwLjE1bC0yLTJjLS4yLS4yLS41MS0uMi0uNzEsMHMtLjIuNTEsMCwuNzFMNC43OSwxMEguNUMuMjIsMTAsMCwxMC4yMiwwLDEwLjVTLjIyLDExLC41LDExaDQuMjlsLTEuMTUsMS4xNWMtLjIuMi0uMi41MSwwLC43MWMuMjQuMiwuNDcuMiwuNzEsMGwyLTJDNi41NCwxMC42Niw2LjU0LDEwLjM0LDYuMzUsMTAuMTV6TTI5LjU3LDYuOTdoLTdjLS44MywwLTEuNS42Ny0xLjUsMS41djRjMCwuODMuNjcsMS41LDEuNSwxLjVoN2MuODMsMCwxLjUtLjY3LDEuNS0xLjV2LTRDMzEuMDcsNy42NCwzMC40LDYuOTcsMjkuNTcsNi45N3pNMzAuMDcsMTIuNDdjMCwuMjgtLjIyLjUtLjUuNWgtN2MtLjI4LDAtLjUtLjIyLS41LS41di00YzAtLjI4LjIyLS41LjUtLjVoN2MuMjgsMCwuNS4yMiwuNS41VjEyLjQ3ek0yOS41NywxOWgtN2MtLjgzLDAtMS41LjY3LTEuNSwxLjV2NGMwLC44My42NywxLjUsMS41LDEuNWg3Yy44MywwLDEuNS0uNjcsMS41LTEuNXYtNEMzMS4wNywxOS42NywzMC40LDE5LDI5LjU3LDE5ek0zMC4wNywyNC41YzAsLjI4LS4yMi41LS41LjVoLTdjLS4yOCwwLS41LS4yMi0uNS0uNXYtNGMwLS4yOC4yMi0uNS41LS41aDdjLjI4LDAsLjUuMjIsLjUuNVYyNC41eiIgZmlsbD0id2hpdGUiLz48L3N2Zz4=';
var processManager$1 = processManager;var quickModel = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggaWQ9InByb3BlcnR5LXF1aWNrbW9kZWwiIGQ9Ik0xNi42LDIzLjE1Yy0uMi0uMi0uNS0uMi0uNywwcy0uMi41LDAsLjdMMTcuMDQsMjVoLTMuNTlsLTIuNi0yLjZjLS4yLS4yLS41LS4yLS43LDBMNy40LDI1LjE1Yy0uMi4yLS4yLjUsMCwuN2wyLjc1LDIuNzVjLjI0LjIsLjQ3LjIsLjcsMGwyLjYtMi42aDMuNTlsLTEuMTUsMS4xNWMtLjIuMi0uMi41LDAsLjdjLjI0LjIsLjQ3LjIsLjcsMGwyLTJjLjItLjIuMi0uNSwwLS43TDE2LjYsMjMuMTV6TTEyLjUsMjUuNTRsLTIsMkw4LjQ2LDI1LjVsMi4wNC0yLjA0bDIsMmMwLDAtMCwwLTAsLjA0UzEyLjUsMjUuNSwxMi41LDI1LjU0ek0zLjYsMjMuMTVjLS4yLS4yLS41LS4yLS43LDBzLS4yLjUsMCwuN0w0LjA0LDI1SC41Qy4yLDI1LDAsMjUuMiwwLDI1LjVTLjIsMjYsLjUsMjZoMy41NEwyLjksMjcuMTVjLS4yLjItLjIuNSwwLC43Yy4yNC4yLC40Ny4yLC43LDBsMi0yYy4yLS4yLjItLjUsMC0uN0wzLjYsMjMuMTV6TTI4LjUsMjJoLTdjLS44MywwLTEuNS42Ny0xLjUsMS41djRjMCwuODMuNjcsMS41LDEuNSwxLjVoN2MuODMsMCwxLjUtLjY3LDEuNS0xLjV2LTRDMzAsMjIuNjcsMjkuMzMsMjIsMjguNSwyMnpNMjksMjcuNWMwLC4yOC0uMi41LS41LjVoLTdjLS4yOCwwLS41LS4yLS41LS41di00YzAtLjI4LjItLjUuNS0uNWg3Yy4yOCwwLC41LjIsLjUuNVYyNy41ek01LjUsMTZoMTQuOTZjLS41OSwxLjM2LTEuNTcsMi40NC0yLjQ2LDMuM3YtMS41NmMwLS4yOC0uMi0uNS0uNS0uNXMtLjUuMi0uNS41djIuNzVjMCwuMjcuMjMsLjUuNSwuNWgyLjc1Yy4yOCwwLC41LS4yLjUtLjVzLS4yLS41LS41LS41aC0xLjUzYzEtMSwyLjE4LTIuMjgsMi44LTRoMi45NmMuODMsMCwxLjUtLjY3LDEuNS0xLjV2LThDMjYsNS42NywyNS4zMyw1LDI0LjUsNWgtMTlDNC42Nyw1LDQsNS42Nyw0LDYuNXY4QzQsMTUuMzMsNC42NywxNiw1LjUsMTZ6TTE1LDExaDIuNWMuMjgsMCwuNS0uMi41LS41UzE3Ljc4LDEwLDE3LjUsMTBIMTVWNmg5LjVDMjQuNzgsNiwyNSw2LjIsMjUsNi41VjEwaC0yYy0uMjgsMC0uNS4yLS41LjVTMjIuNywxMSwyMywxMWgydjMuNWMwLC4yOC0uMi41LS41LjVoLTIuNjdjLjUzLTIuNDktLjMtNS41LTIuNTYtNi45M0MxOSw3LjkzLDE4LjcsOCwxOC41Nyw4LjI0Yy0uMTQuMjQtLjA3LC41NC4xNiwuNjljMiwxLjIsMi41OCw0LDIuMDYsNi4wN0gxNVYxMXpNNSw2LjVDNSw2LjIsNS4yLDYsNS41LDZIMTR2NEg1VjYuNXpNNSwxMWg5djRINS41QzUuMiwxNSw1LDE0Ljc4LDUsMTQuNVYxMXoiIGZpbGw9IndoaXRlIi8+PC9zdmc+';
var quickModel$1 = quickModel;var simulation = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggaWQ9InByb3BlcnR5LXNpbXVsYXRpb24iIGQ9Ik0yNy41LDI2SDRWNS41QzQsNS4yLDMuNzgsNSwzLjUsNVMzLDUuMiwzLDUuNXYyMUMzLDI2Ljc4LDMuMiwyNywzLjUsMjdoMjRjLjI4LDAsLjUtLjIuNS0uNVMyNy43OCwyNiwyNy41LDI2ek03LjA0LDE2LjE2bDcuNDctNS4zbDEyLjQ3LDguMDdjLjA4LC4wNSwuMTguMDgsLjI3LjA4Yy4xNiwwLC4zLS4wOCwuNC0uMjNjLjE1LS4yMy4wOC0uNTQtLjE1LS42OUwxNC43Nyw5LjgzYy0uMTctLjEtLjM5LS4xLS41NiwwbC03Ljc1LDUuNWMtLjIzLjE2LS4yOC40Ny0uMS43QzYuNSwxNi4yNiw2LjgsMTYuMyw3LjA0LDE2LjE2ek0yMy4zLDEzLjY0Yy4yNy0uMTksMy41LTIuNzUsMy41LTIuNzVjLjItLjE3LjI1LS40OS4wOC0uN2MtLjE3LS4yLS40OS0uMjUtLjctLjA4bC0zLjUsMi43NWMtLjIuMTctLjI4LjUtLjA4LC43UzIzLjA0LDEzLjgzLDIzLjMsMTMuNjR6TTYuNzUsMjJoNi4wOGMuMSwwLC4yLS4wNCwuMjgtLjFjMC0wLDAsMCwwLTBsNi42Ny01LjI1Yy4yLS4xNy4yNS0uNDkuMDgtLjdjLS4xNy0uMi0uNDktLjI1LS43LS4wOEwxMi42NiwyMUg2Ljc1Yy0uMjgsMC0uNS4yLS41LjVTNi40NywyMiw2Ljc1LDIyeiIgZmlsbD0id2hpdGUiLz48L3N2Zz4=';
var simulation$1 = simulation;var appIcons=/*#__PURE__*/Object.freeze({__proto__:null,workflowAccelerator:workflowAccelerator$1,processIntelligence:processIntelligence$1,userManagement:userManagement$1,collaborationHub:collaborationHub$1,comparator:comparator$1,dictionary:dictionary$1,explorer:explorer$1,processManager:processManager$1,quickModel:quickModel$1,simulation:simulation$1});var _excluded$19 = ["style", "app"];
var AppIcon$1 = function AppIcon(_ref) {
  var style = _ref.style,
    app = _ref.app,
    rest = _objectWithoutProperties(_ref, _excluded$19);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, style), /*#__PURE__*/React.createElement("div", styles.merge(style('icon'), {
    backgroundImage: "url(".concat(appIcons[app], ")")
  })));
};
var ICON_PADDING = 12;
var styled$T = createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding,
    color = _ref2.color,
    font = _ref2.font,
    lineHeight = _ref2.lineHeight;
  var size = styles.calculateHeight(font.size.normal, lineHeight, padding.normal);
  return {
    paddingTop: ICON_PADDING,
    paddingRight: ICON_PADDING,
    paddingBottom: ICON_PADDING,
    paddingLeft: ICON_PADDING,
    backgroundColor: color.mono.ultradark,
    icon: {
      width: size - 2 * ICON_PADDING,
      height: size - 2 * ICON_PADDING,
      backgroundPosition: 'center center',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat'
    }
  };
});
var AppIconUnsealed = compose(setDisplayName('AppIcon'), styled$T)(AppIcon$1);function ownKeys$13(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$13(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$13(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$13(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function DebugWarning(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/React.createElement("div", style, "Dev");
}
var styled$S = createDefaultStyle(function (theme) {
  return _objectSpread$13(_objectSpread$13({
    color: 'red',
    fontFamily: theme.font.family.mono,
    fontWeight: 'bold',
    fontSize: theme.font.size.small,
    lineHeight: theme.lineHeight,
    textTransform: 'uppercase',
    marginTop: 14,
    padding: "".concat(theme.padding.xsmall, "px ").concat(theme.padding.small, "px"),
    transform: 'rotate(-10deg)',
    background: 'white'
  }, styles.border('1px', 'solid', theme.color.mono.light)), styles.boxShadow());
});
var DevBadge = styled$S(DebugWarning);var _excluded$18 = ["style", "theme"];
var Logo$1 = function Logo(_ref) {
  var style = _ref.style,
    logo = _ref.theme.logo,
    rest = _objectWithoutProperties(_ref, _excluded$18);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, style, {
    dangerouslySetInnerHTML: {
      __html: logo
    }
  }));
};
var styled$R = createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding,
    font = _ref2.font,
    lineHeight = _ref2.lineHeight;
  return {
    height: styles.calculateHeight(font.size.normal, lineHeight, padding.small),
    marginTop: padding.normal - padding.small,
    marginBottom: padding.normal - padding.small,
    marginLeft: padding.normal,
    marginRight: padding.normal,
    textShadow: 'none'
  };
});
var LogoUnsealed = compose(setDisplayName('Logo'), styled$R, getTheme$1)(Logo$1);function ownKeys$12(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$12(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$12(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$12(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Header$1(_ref) {
  var app = _ref.app,
    logo = _ref.logo,
    children = _ref.children,
    userMenu = _ref.userMenu,
    metaMenu = _ref.metaMenu,
    development = _ref.development,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("div", style, /*#__PURE__*/React.createElement(ListUnsealed, {
    style: style('logos'),
    direction: "horizontal"
  }, !!app && /*#__PURE__*/React.createElement(AppIconUnsealed, _extends({}, style('appIcon'), {
    app: app
  })), /*#__PURE__*/React.createElement("div", style('logo'), logo), development ? /*#__PURE__*/React.createElement(DevBadge, null) : null), /*#__PURE__*/React.createElement(ListUnsealed, {
    style: style('menus'),
    direction: "horizontal"
  }, metaMenu && /*#__PURE__*/React.createElement(ListUnsealed, {
    style: style('metaMenu'),
    direction: "horizontal"
  }, metaMenu), !!userMenu && /*#__PURE__*/React.createElement("div", style('userMenu'), userMenu)), /*#__PURE__*/React.createElement(ListUnsealed, {
    style: style('navigation'),
    direction: "horizontal"
  }, children));
}
var styled$Q = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    padding = _ref2.padding,
    font = _ref2.font,
    lineHeight = _ref2.lineHeight,
    shadow = _ref2.shadow;
  return _objectSpread$12(_objectSpread$12(_objectSpread$12({
    position: 'relative',
    backgroundColor: styles.header.backgroundColor(color, {
      primary: true
    }),
    height: styles.calculateHeight(font.size.normal, lineHeight, padding.normal),
    textAlign: 'center'
  }, shadow.header), styles.media.xs({
    textAlign: 'left'
  })), {}, {
    navigation: {
      display: 'inline-flex'
    },
    logo: _objectSpread$12({}, styles.media.xs({
      display: 'none'
    })),
    logos: _objectSpread$12({
      position: 'absolute',
      top: 0,
      left: 0
    }, styles.media.xs({
      position: 'relative',
      float: 'left'
    })),
    menus: _objectSpread$12({
      position: 'absolute',
      top: 0,
      right: padding.normal
    }, styles.media.xs({
      right: 0
    })),
    metaMenu: _objectSpread$12({
      marginTop: padding.small,
      marginBottom: padding.small
    }, styles.borderRight(1, 'solid', Color$3(styles.header.color(color, {
      primary: true
    })).fade(0.5).rgb().string()))
  });
});
var enhance$u = compose(setDisplayName('Header'), defaultProps({
  logo: /*#__PURE__*/React.createElement("a", {
    href: "/",
    style: {
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement(LogoUnsealed, null))
}), styled$Q);
var HeaderUnsealed = enhance$u(Header$1);var _excluded$17 = ["children", "style"];
function ownKeys$11(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$11(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$11(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$11(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function HeaderTab$1(_ref) {
  var children = _ref.children,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$17);
  return /*#__PURE__*/React.createElement("div", _extends({}, _omit(rest, 'active'), style), /*#__PURE__*/React.createElement("div", style('flap')), /*#__PURE__*/React.createElement("div", style('body'), children));
}
var styled$P = createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding,
    color = _ref2.color;
  return {
    cursor: 'pointer',
    display: 'inline-block',
    position: 'relative',
    paddingRight: padding.normal,
    paddingLeft: padding.normal,
    paddingTop: padding.normal,
    paddingBottom: padding.normal,
    color: styles.header.color(color, {
      primary: true
    }),
    flap: _objectSpread$11({
      position: 'absolute',
      display: 'block',
      top: 0,
      left: 0,
      right: 0,
      height: '100%',
      width: '100%',
      zIndex: 0,
      backgroundColor: styles.header.backdropColor(color, {
        primary: true
      }),
      transform: 'perspective(200px) rotate3d(1, 0, 0, 90deg)',
      transformOrigin: '50% 100%',
      perspectiveOrigin: '50% 100%'
    }, styles.transition('transform')),
    body: {
      position: 'relative',
      zIndex: 1
    },
    '&active': {
      flap: {
        transform: 'perspective(200px) rotate3d(1, 0, 0, 0deg)'
      }
    }
  };
}, function (props) {
  return {
    '&active': props.active
  };
});
var HeaderTabUnsealed = styled$P(HeaderTab$1);function ownKeys$10(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$10(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$10(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$10(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var isComponentMaxWidthDefined = function isComponentMaxWidthDefined(componentMaxWidth) {
  if (componentMaxWidth && componentMaxWidth.hasOwnProperty('normal') && componentMaxWidth.hasOwnProperty('medium') && componentMaxWidth.hasOwnProperty('small')) {
    return true;
  }
  return false;
};
var UserInfo = function UserInfo(_ref) {
  var style = _ref.style,
    user = _ref.user,
    organization = _ref.organization,
    _ref$componentMaxWidt = _ref.componentMaxWidth,
    componentMaxWidth = _ref$componentMaxWidt === void 0 ? {} : _ref$componentMaxWidt;
  var enhancedStyle = useMemo(function () {
    if (isComponentMaxWidthDefined(componentMaxWidth)) {
      var normal = componentMaxWidth.normal,
        medium = componentMaxWidth.medium,
        small = componentMaxWidth.small;
      return _objectSpread$10(_objectSpread$10(_objectSpread$10({}, style), {}, {
        maxWidth: normal
      }, styles.media.md({
        maxWidth: medium
      })), styles.media.sm({
        maxWidth: small
      }));
    }
    return style;
  }, [componentMaxWidth, style]);
  var userInfoStyle = useStyles$1(defaultStyle$5,
  // $FlowExpectedError
  {
    style: enhancedStyle
  }, {
    '&withOrganization': !!organization
  });
  return /*#__PURE__*/React.createElement("div", userInfoStyle, /*#__PURE__*/React.createElement("p", _extends({}, userInfoStyle('user'), {
    title: user
  }), user), !!organization && /*#__PURE__*/React.createElement("p", _extends({}, userInfoStyle('organization'), {
    title: organization
  }), organization));
};
var defaultStyle$5 = function defaultStyle(_ref2) {
  var padding = _ref2.padding,
    font = _ref2.font,
    color = _ref2.color,
    lineHeight = _ref2.lineHeight;
  var headerHeight = styles.calculateHeight(font.size.normal, lineHeight, padding.normal);
  var verticalPadding = styles.calculateVerticalPadding(headerHeight, font.size.small, lineHeight);
  var verticalPaddingWithOrg = styles.calculateVerticalPadding(headerHeight, font.size.small, 2 * lineHeight);
  var backgroundColor = color.header.primary || color.primary.base;
  return _objectSpread$10(_objectSpread$10(_objectSpread$10(_objectSpread$10(_objectSpread$10({
    whiteSpace: 'nowrap',
    maxWidth: 350,
    color: styles.color(backgroundColor),
    fontSize: font.size.small,
    textAlign: 'left'
  }, styles.transition('backgroundColor')), {}, {
    paddingRight: padding.normal,
    paddingTop: verticalPadding,
    paddingBottom: verticalPadding
  }, styles.media.md({
    maxWidth: 220
  })), styles.media.sm({
    maxWidth: 135
  })), styles.media.xs({
    display: 'none'
  })), {}, {
    user: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      margin: 0
    },
    organization: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      margin: 0,
      color: Color$3(styles.color(backgroundColor)).fade(0.2).rgb().string()
    },
    '&withOrganization': {
      paddingTop: verticalPaddingWithOrg,
      paddingBottom: verticalPaddingWithOrg
    }
  });
};
var UserInfo$1 = UserInfo;var _excluded$16 = ["children", "user", "organization", "style", "isOpen", "componentMaxWidth"];
function ownKeys$$(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$$(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$$(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$$(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Dropdown$1 = compose(
// $FlowFixMe
dropdownEnhancers.toggleOnClick, dropdownEnhancers.closeOnClickNode)(Dropdown$3);
var UserMenuDropdown = function UserMenuDropdown(_ref) {
  var children = _ref.children,
    user = _ref.user,
    organization = _ref.organization,
    style = _ref.style,
    isOpen = _ref.isOpen,
    componentMaxWidth = _ref.componentMaxWidth,
    rest = _objectWithoutProperties(_ref, _excluded$16);
  var _useTheme = useTheme(),
    shadow = _useTheme.shadow,
    border = _useTheme.border;
  return /*#__PURE__*/React.createElement(Dropdown$1, _extends({
    position: "bottom right",
    align: "top right",
    node: /*#__PURE__*/React.createElement("div", styles.merge(style('dropdown'), _objectSpread$$(_objectSpread$$({}, shadow.modal), border.chipDropDown)), children)
  }, rest, {
    isOpen: isOpen,
    style: style
  }), /*#__PURE__*/React.createElement(ListUnsealed, {
    direction: "horizontal",
    role: "menu",
    "aria-label": "User menu"
  }, /*#__PURE__*/React.createElement("div", style('icon'), /*#__PURE__*/React.createElement(Icon$2, {
    icon: isOpen ? 'dropdown-close' : 'dropdown-open'
  })), /*#__PURE__*/React.createElement(UserInfo$1, {
    style: style,
    componentMaxWidth: componentMaxWidth,
    user: user,
    organization: organization
  })));
};
var styled$O = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    padding = _ref2.padding,
    zIndex = _ref2.zIndex;
  var backgroundColor = color.header.primary || color.primary.base;
  var isLight = Color$3(backgroundColor).isLight();
  return {
    cursor: 'pointer',
    node: {
      zIndex: zIndex.popover
    },
    dropdown: _objectSpread$$({
      minWidth: 200,
      // subtract page header height and a bit so that the menu is not clipped at the end of the page
      maxHeight: 'calc(100vh - 56px - 18px)',
      overflowY: 'auto',
      backgroundColor: 'white',
      paddingTop: padding.small,
      paddingBottom: padding.small
    }, styles.popover(color)),
    icon: {
      color: styles.color(backgroundColor),
      marginTop: padding.small,
      marginBottom: padding.small
    },
    ':hover': {
      backgroundColor: isLight ? Color$3(backgroundColor).darken(0.1).toString() : Color$3(backgroundColor).lighten(0.1).toString()
    }
  };
});
// $FlowFixMe
var enhance$t = compose(dropdownEnhancers.uncontrolled, styled$O);
var UserInfoDropdown = enhance$t(UserMenuDropdown);var _excluded$15 = ["children"];
var UserMenu$1 = function UserMenu(props) {
  if (props.children) {
    var children = props.children,
      rest = _objectWithoutProperties(props, _excluded$15);
    return /*#__PURE__*/React.createElement(UserInfoDropdown, rest, children);
  }
  return /*#__PURE__*/React.createElement(UserInfo$1, props);
};
var UserMenuUnsealed = UserMenu$1;var _excluded$14 = ["icon", "children", "style"];
var MenuItem$1 = function MenuItem(_ref) {
  var icon = _ref.icon,
    children = _ref.children,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$14);
  return /*#__PURE__*/React.createElement(TextTileUnsealed, _extends({}, rest, {
    small: true,
    transparent: true,
    header: _isString(icon) ? /*#__PURE__*/React.createElement(Icon$2, {
      small: true,
      icon: icon
    }) : icon,
    style: style
  }), children);
};
var MenuItemUnsealed = makeInteractive(MenuItem$1);var iconColor = function iconColor(color) {
  var _color$header;
  return styles.color(((_color$header = color.header) === null || _color$header === void 0 ? void 0 : _color$header.primary) || color.primary.base, color.text.base, color.contrastText.base) || color.text.base;
};
var defaultStyles$n = function defaultStyles(_ref) {
  var color = _ref.color;
  return {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    '&expanded': {
      borderWidth: '0 4.165px 4.17px 4.165px',
      borderColor: "transparent transparent ".concat(iconColor(color), " transparent")
    },
    '&collapsed': {
      borderWidth: '4.17px 4.165px 0 4.165px',
      borderColor: "".concat(iconColor(color), " transparent transparent transparent")
    }
  };
};
var TriangleIcon = function TriangleIcon(_ref2) {
  var expanded = _ref2.expanded;
  var styles = useStyles$1(defaultStyles$n, {}, _defineProperty({}, "".concat(expanded ? '&expanded' : '&collapsed'), true));
  return /*#__PURE__*/React.createElement("span", styles);
};
var TriangleIcon$1 = TriangleIcon;var buttonWidth = 40;
var defaultStyles$m = function defaultStyles(_ref) {
  var _color$header, _color$header2, _color$header3;
  var color = _ref.color,
    zIndex = _ref.zIndex,
    font = _ref.font,
    lineHeight = _ref.lineHeight,
    padding = _ref.padding;
  return {
    zIndex: zIndex.header,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center!important',
    borderRadius: '0 0 8px 8px!important',
    boxShadow: '0px 3px 4px -1px rgba(0, 0, 0, 0.16)',
    transition: "".concat(styles.transition('top', 'ease', '0.3s').transition, ", ").concat(styles.transition('height', 'linear', '0.125s').transition),
    backgroundColor: "".concat(((_color$header = color.header) === null || _color$header === void 0 ? void 0 : _color$header.primary) || color.primary.base, "!important"),
    ':hover': {
      backgroundColor: "".concat(((_color$header2 = color.header) === null || _color$header2 === void 0 ? void 0 : _color$header2.primary) || color.primary.base, "!important")
    },
    borderColor: "".concat(((_color$header3 = color.header) === null || _color$header3 === void 0 ? void 0 : _color$header3.primary) || color.primary.base, "!important"),
    width: "".concat(buttonWidth, "px"),
    position: 'absolute',
    top: styles.calculateHeight(font.size.normal, lineHeight, padding.normal) - 10,
    left: "calc(50% - ".concat(buttonWidth, "px)"),
    '&expanded': {
      height: '16px!important'
    },
    '&collapsed': {
      height: '10px!important',
      top: '0px',
      ':hover': {
        height: '12px!important'
      }
    }
  };
};
var ExpandCollapseButton = function ExpandCollapseButton(_ref2) {
  var toggleExpandCollapse = _ref2.toggleExpandCollapse,
    expanded = _ref2.expanded;
  var styles = useStyles$1(defaultStyles$m, {}, _defineProperty({}, "".concat(expanded ? '&expanded' : '&collapsed'), true));
  return /*#__PURE__*/React.createElement(Button$7, {
    small: true,
    style: styles,
    "data-uie": "toggleShowHide",
    onClick: toggleExpandCollapse
  }, /*#__PURE__*/React.createElement(TriangleIcon$1, {
    expanded: expanded
  }));
};
var ExpandCollapseButton$1 = ExpandCollapseButton;function ownKeys$_(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$_(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$_(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$_(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var HorizontalBar = function HorizontalBar(_ref) {
  var expanded = _ref.expanded;
  var _useTheme = useTheme(),
    shadow = _useTheme.shadow;
  var defaultStyles = function defaultStyles(_ref2) {
    var _color$header;
    var color = _ref2.color;
    return _objectSpread$_(_objectSpread$_({
      backgroundColor: ((_color$header = color.header) === null || _color$header === void 0 ? void 0 : _color$header.primary) || color.primary.base
    }, shadow.header), {}, {
      '&expanded': {
        display: 'none'
      },
      '&collapsed': {
        height: '4px'
      }
    });
  };
  var styles = useStyles$1(defaultStyles, {}, _defineProperty({}, "".concat(expanded ? '&expanded' : '&collapsed'), true));
  return /*#__PURE__*/React.createElement("div", styles);
};
var HorizontalBar$1 = HorizontalBar;var _excluded$13 = ["expanded", "autoCollapse"];
var defaultStyles$l = function defaultStyles() {
  return {
    height: '4px',
    position: 'relative'
  };
};
function CollapsibleHeader(_ref) {
  var _ref$expanded = _ref.expanded,
    expanded = _ref$expanded === void 0 ? false : _ref$expanded,
    _ref$autoCollapse = _ref.autoCollapse,
    autoCollapse = _ref$autoCollapse === void 0 ? false : _ref$autoCollapse,
    headerProps = _objectWithoutProperties(_ref, _excluded$13);
  var _useState = useState(expanded),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setExpanded = _useState2[1];
  var headerRef = useRef(null);
  var toggleExpandCollapse = function toggleExpandCollapse() {
    return setExpanded(!isExpanded);
  };
  useEffect(function () {
    setExpanded(expanded);
  }, [expanded]);
  useEffect(function () {
    if (isExpanded && autoCollapse) {
      var delay = 1000;
      var header = headerRef.current;
      var timeout;
      var handleMouseLeave = function handleMouseLeave() {
        timeout = setTimeout(function () {
          setExpanded(false);
        }, delay);
      };
      var handleMouseEnter = function handleMouseEnter() {
        clearTimeout(timeout);
      };
      header === null || header === void 0 ? void 0 : header.addEventListener('mouseleave', handleMouseLeave);
      header === null || header === void 0 ? void 0 : header.addEventListener('mouseenter', handleMouseEnter);
      return function () {
        header === null || header === void 0 ? void 0 : header.removeEventListener('mouseleave', handleMouseLeave);
        header === null || header === void 0 ? void 0 : header.removeEventListener('mouseenter', handleMouseEnter);
      };
    }
  }, [isExpanded, autoCollapse]);
  var styles = useStyles$1(defaultStyles$l, {});
  return /*#__PURE__*/React.createElement("div", _extends({}, styles, {
    ref: headerRef,
    "data-testid": "collapsible-header-container"
  }), /*#__PURE__*/React.createElement(SlideAnimation, {
    in: isExpanded,
    appear: true,
    down: true
  }, /*#__PURE__*/React.createElement(HeaderUnsealed, headerProps)), /*#__PURE__*/React.createElement(HorizontalBar$1, {
    expanded: isExpanded
  }), /*#__PURE__*/React.createElement(ExpandCollapseButton$1, {
    toggleExpandCollapse: toggleExpandCollapse,
    expanded: isExpanded
  }));
}var defaultStyles$k = function defaultStyles(_ref) {
  var color = _ref.color,
    font = _ref.font,
    spacing = _ref.spacing;
  return {
    display: 'flex',
    alignItems: 'centre',
    listStyle: 'none',
    breadcrumb: {
      overflow: 'hidden',
      display: 'flex',
      color: color.text.inactive,
      alignItems: 'centre',
      fontWeight: font.weight.normal,
      fontSize: font.size.small,
      lineHeight: font.size.normal
    },
    icon: {
      fontSize: 'inherit',
      padding: "0px ".concat(spacing.xxxsmall, "px")
    },
    '&onContrast': {
      breadcrumb: {
        color: color.surface
      },
      icon: {
        color: color.surface
      }
    },
    '&large': {
      breadcrumb: {
        fontSize: font.size.large,
        fontWeight: font.weight.bold
      }
    }
  };
};
var Breadcrumb$1 = function Breadcrumb(_ref2) {
  var children = _ref2.children,
    showTrailingDivider = _ref2.showTrailingDivider,
    _ref2$onContrast = _ref2.onContrast,
    onContrast = _ref2$onContrast === void 0 ? false : _ref2$onContrast,
    size = _ref2.size;
  var styles = useStyles$1(defaultStyles$k, {}, {
    '&onContrast': onContrast,
    '&large': size === 'large'
  });
  var breadcrumbCount = Children.count(children);
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": "breadcrumb"
  }, /*#__PURE__*/React.createElement("ol", styles, Children.map(children, function (child, index) {
    var showCrumbDivider = breadcrumbCount !== index + 1 || showTrailingDivider;
    return /*#__PURE__*/React.createElement("li", styles('breadcrumb'), child, showCrumbDivider && /*#__PURE__*/React.createElement("span", styles('icon'), /*#__PURE__*/React.createElement(Glyph, {
      role: "presentational"
    }, "breadcrumb-separator")));
  })));
};
var BreadcrumbUnsealed = Breadcrumb$1;function ownKeys$Z(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$Z(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$Z(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$Z(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var breadcrumbStyles = {
  color: "inherit !important",
  fontSize: "inherit !important",
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden'
};
var defaultStyles$j = function defaultStyles(_ref) {
  _ref.color;
    _ref.font;
    _ref.spacing;
  return {
    link: _objectSpread$Z(_objectSpread$Z({}, breadcrumbStyles), {}, {
      ':hover': {
        textDecoration: 'underline'
      },
      ':focus': {
        textDecoration: 'underline'
      }
    }),
    text: breadcrumbStyles
  };
};
var BreadcrumbItem$1 = function BreadcrumbItem(_ref2) {
  var children = _ref2.children;
  var styles = useStyles$1(defaultStyles$j, {});
  if (children.type === 'a') {
    return /*#__PURE__*/React.cloneElement(children, _objectSpread$Z({}, styles('link')));
  }
  return /*#__PURE__*/React.cloneElement(children, _objectSpread$Z({}, styles('text')));
};
var BreadcrumbItemUnsealed = BreadcrumbItem$1;var isClear = function isClear(value) {
  return _isNil(value) || value === '';
};
var isClear$1 = isClear;function ownKeys$Y(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$Y(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$Y(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$Y(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Bar = function Bar(_ref) {
  var style = _ref.style;
  var baseColor = useBaseColor();
  return /*#__PURE__*/React.createElement("div", style, /*#__PURE__*/React.createElement("div", style('base')), /*#__PURE__*/React.createElement("div", merge$2(style('highlight'), {
    backgroundColor: baseColor
  })));
};
var styled$N = createDefaultStyle(function (_ref2) {
  var color = _ref2.color;
  return {
    position: 'relative',
    base: {
      height: 1,
      marginBottom: -1,
      backgroundColor: color.mono.lighter
    },
    highlight: _objectSpread$Y({
      margin: '0 auto',
      width: 0,
      height: 2
    }, styles.transition(['width'], 'ease', '0.2s')),
    '&hasFocus': {
      highlight: {
        width: '100%'
      }
    },
    '&disabled': {
      base: {
        backgroundColor: 'transparent',
        backgroundImage: 'linear-gradient(90deg,rgba(0,0,0,0.38) 0,rgba(0,0,0,0.38) 33%,transparent 0)',
        backgroundPosition: 'bottom 0 left 0',
        backgroundSize: '4px 1px',
        backgroundRepeat: 'repeat-x'
      }
    },
    '&error': {
      base: {
        height: 2,
        marginBottom: -2,
        backgroundColor: color.status.danger
      }
    }
  };
}, function (_ref3) {
  var hasFocus = _ref3.hasFocus,
    disabled = _ref3.disabled,
    error = _ref3.error,
    required = _ref3.required;
  return {
    '&hasFocus': hasFocus,
    '&disabled': disabled,
    '&error': error,
    '&required': required
  };
});
var Bar$1 = styled$N(Bar);function ownKeys$X(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$X(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$X(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$X(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Modal$4 = function Modal(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    cancelLabel = _ref.cancelLabel,
    onCancel = _ref.onCancel,
    confirmLabel = _ref.confirmLabel,
    onConfirm = _ref.onConfirm,
    disableConfirm = _ref.disableConfirm,
    children = _ref.children,
    onRequestClose = _ref.onRequestClose,
    style = _ref.style,
    fullscreen = _ref.fullscreen,
    fullheight = _ref.fullheight,
    open = _ref.open,
    onClosed = _ref.onClosed,
    className = _ref.className,
    classNames = _ref.classNames,
    dataPendoAttributeConfirm = _ref.dataPendoAttributeConfirm,
    dataPendoAttributeCancel = _ref.dataPendoAttributeCancel,
    _ref$fitToBody = _ref.fitToBody,
    fitToBody = _ref$fitToBody === void 0 ? true : _ref$fitToBody;
  var _useTheme = useTheme(),
    shadow = _useTheme.shadow,
    border = _useTheme.border;
  var styles = useStyles$1(_objectSpread$X(_objectSpread$X({}, shadow.modal), border.modal), {
    style: style,
    className: className,
    classNames: classNames
  }, {});
  var fioriStyles = useFioriStyles();
  var confirmButton = /*#__PURE__*/React.createElement(Button$6, {
    "data-testid": "action-buttons",
    "data-pa": dataPendoAttributeConfirm,
    onClick: function onClick() {
      invariant(onConfirm, 'You must specify an "onConfirm" handler when you set the "confirmLabel" prop.');
      onConfirm();
    },
    disabled: disableConfirm
  }, confirmLabel);
  return /*#__PURE__*/React.createElement(Modal$5, {
    fitToBody: fitToBody,
    open: open,
    fullscreen: fullscreen,
    fullheight: fullheight,
    onRequestClose: onRequestClose,
    onClosed: onClosed,
    style: styles,
    header: /*#__PURE__*/React.createElement("div", styles('headerContainer'), /*#__PURE__*/React.createElement("div", styles('titleContainer'), icon && /*#__PURE__*/React.createElement(Glyph, styles('icon'), icon), /*#__PURE__*/React.createElement(Title3$2, null, title)), /*#__PURE__*/React.createElement("div", styles('xButtonContainer'), /*#__PURE__*/React.createElement(IconButton$3, {
      large: true,
      icon: "reset",
      onClick: function onClick() {
        return onRequestClose();
      }
    }))),
    footer: (cancelLabel || confirmLabel) && /*#__PURE__*/React.createElement(Stack, {
      direction: "horizontal",
      spacing: "small"
    }, confirmLabel && fioriStyles && confirmButton, cancelLabel && /*#__PURE__*/React.createElement(Button$4, {
      "data-testid": "action-buttons",
      "data-pa": dataPendoAttributeCancel,
      onClick: function onClick() {
        invariant(onCancel, 'You must specify an "onCancel" handler when you set the "cancelLabel" prop.');
        onCancel();
      }
    }, cancelLabel), confirmLabel && !fioriStyles && confirmButton)
  }, children);
};
var enhance$s = compose(setDisplayName('Modal'), createDefaultStyle(function (_ref2) {
  var color = _ref2.color;
    _ref2.padding;
    var font = _ref2.font,
    spacing = _ref2.spacing;
  return {
    justifyContent: 'flex-start',
    header: _objectSpread$X({}, styles.borderBottom('1px', 'solid', color.mono.light)),
    headerContainer: {
      display: 'flex',
      flex: 1,
      overflow: 'hidden',
      justifyContent: 'space-between'
    },
    titleContainer: {
      display: 'flex',
      alignItems: 'baseline',
      overflow: 'hidden',
      minHeight: 40
    },
    xButtonContainer: {
      minWidth: 40,
      marginLeft: spacing.xsmall
    },
    icon: {
      fontSize: font.size.xxlarge,
      padding: 0,
      width: spacing.large,
      marginRight: spacing.xsmall,
      height: 40
    },
    footer: _objectSpread$X({}, styles.borderTop('1px', 'solid', color.mono.light)),
    '&noContentPadding': {
      content: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      }
    }
  };
}, function (_ref3) {
  var noContentPadding = _ref3.noContentPadding;
  return {
    '&noContentPadding': noContentPadding
  };
}));
var ModalUnsealed = enhance$s(Modal$4);function ownKeys$W(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$W(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$W(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$W(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Dialog$2 = function Dialog(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    cancelLabel = _ref.cancelLabel,
    onCancel = _ref.onCancel,
    confirmLabel = _ref.confirmLabel,
    onConfirm = _ref.onConfirm,
    children = _ref.children,
    disableConfirm = _ref.disableConfirm,
    style = _ref.style,
    fullscreen = _ref.fullscreen,
    fullheight = _ref.fullheight,
    open = _ref.open,
    onClosed = _ref.onClosed,
    className = _ref.className,
    classNames = _ref.classNames;
  var _useTheme = useTheme(),
    shadow = _useTheme.shadow,
    border = _useTheme.border;
  var styles = useStyles$1(_objectSpread$W(_objectSpread$W({}, shadow.modal), border.modal), {
    style: style,
    className: className,
    classNames: classNames
  }, {});
  var fioriStyles = useFioriStyles();
  var confirmButton = /*#__PURE__*/React.createElement(Button$6, {
    "data-testid": "action-buttons",
    onClick: function onClick() {
      return onConfirm();
    },
    disabled: disableConfirm
  }, confirmLabel);
  return /*#__PURE__*/React.createElement(Dialog$3, {
    open: open,
    fullscreen: fullscreen,
    fullheight: fullheight,
    style: styles,
    header: title && /*#__PURE__*/React.createElement("div", styles('titleContainer'), icon && /*#__PURE__*/React.createElement(Glyph, styles('icon'), icon), /*#__PURE__*/React.createElement(Title3$2, null, title)),
    footer: /*#__PURE__*/React.createElement(Stack, {
      direction: "horizontal",
      spacing: "small"
    }, fioriStyles && confirmButton, cancelLabel && /*#__PURE__*/React.createElement(Button$4, {
      "data-testid": "action-buttons",
      onClick: function onClick() {
        invariant(onCancel, 'You must specify an "onCancel" handler when you set the "cancelLabel" prop.');
        onCancel();
      }
    }, cancelLabel), !fioriStyles && confirmButton),
    onClosed: onClosed
  }, children);
};
var enhance$r = compose(setDisplayName('Dialog'), createDefaultStyle(function (_ref2) {
  var font = _ref2.font,
    spacing = _ref2.spacing;
  return {
    titleContainer: {
      display: 'flex',
      overflow: 'hidden',
      alignItems: 'baseline',
      minHeight: 40
    },
    icon: {
      fontSize: font.size.xxlarge,
      padding: 0,
      width: spacing.large,
      marginRight: spacing.xsmall,
      height: 40
    },
    '&hasTitle': {
      content: {
        paddingTop: 0
      }
    }
  };
}, function (props) {
  return {
    '&hasTitle': !!props.title
  };
}));
var DialogUnsealed = enhance$r(Dialog$2);function ownKeys$V(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$V(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$V(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$V(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Dialog$1 = function Dialog(_ref) {
  var title = _ref.title;
    _ref.icon;
    var cancelLabel = _ref.cancelLabel,
    onCancel = _ref.onCancel,
    confirmLabel = _ref.confirmLabel,
    onConfirm = _ref.onConfirm,
    children = _ref.children,
    disableConfirm = _ref.disableConfirm,
    style = _ref.style,
    fullscreen = _ref.fullscreen,
    open = _ref.open,
    onClosed = _ref.onClosed,
    className = _ref.className,
    classNames = _ref.classNames;
  var _useTheme = useTheme(),
    shadow = _useTheme.shadow,
    border = _useTheme.border;
  var styles = useStyles$1(_objectSpread$V(_objectSpread$V({}, shadow.modal), border.modal), {
    style: style,
    className: className,
    classNames: classNames
  }, {});
  var fioriStyles = useFioriStyles();
  var confirmButton = /*#__PURE__*/React.createElement(DangerButton$3, {
    "data-testid": "action-buttons",
    onClick: function onClick() {
      return onConfirm();
    },
    disabled: disableConfirm
  }, confirmLabel);
  return /*#__PURE__*/React.createElement(Dialog$3, {
    open: open,
    fullscreen: fullscreen,
    style: styles,
    header: title && /*#__PURE__*/React.createElement("div", styles('titleContainer'), /*#__PURE__*/React.createElement(Glyph, styles('icon'), "warning"), /*#__PURE__*/React.createElement(Title3$2, null, title)),
    footer: /*#__PURE__*/React.createElement(Fragment, null, fioriStyles && confirmButton, cancelLabel && /*#__PURE__*/React.createElement("div", styles('cancelButton'), /*#__PURE__*/React.createElement(DangerButton$2, {
      "data-testid": "action-buttons",
      onClick: function onClick() {
        invariant(onCancel, 'You must specify an "onCancel" handler when you set the "cancelLabel" prop.');
        onCancel();
      }
    }, cancelLabel)), !fioriStyles && confirmButton),
    onClosed: onClosed
  }, children);
};
var enhance$q = compose(setDisplayName('DangerDialog'), createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    font = _ref2.font,
    spacing = _ref2.spacing;
  return {
    titleContainer: {
      display: 'flex',
      overflow: 'hidden',
      alignItems: 'baseline',
      minHeight: 40
    },
    icon: {
      fontSize: font.size.xxlarge,
      padding: 0,
      width: spacing.large,
      marginRight: spacing.xsmall,
      color: color.status.danger,
      height: 40
    },
    cancelButton: {
      marginRight: spacing.small
    },
    '&hasTitle': {
      content: {
        paddingTop: 0
      }
    }
  };
}, function (props) {
  return {
    '&hasTitle': !!props.title
  };
}));
var DangerDialogUnsealed = enhance$q(Dialog$1);function ownKeys$U(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$U(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$U(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$U(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var RegularHint = function RegularHint(_ref) {
  var style = _ref.style,
    children = _ref.children,
    title = _ref.title,
    className = _ref.className,
    classNames = _ref.classNames;
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$i(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {});
  return /*#__PURE__*/React.createElement(Hint$3, {
    style: styles,
    icon: "info",
    title: title
  }, children);
};
var defaultStyles$i = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return _objectSpread$U({
    border: "1px solid ".concat(color.text.inactive)
  }, border.hint);
};
var HintUnsealed = RegularHint;function ownKeys$T(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$T(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$T(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$T(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ContrastHint$1 = function ContrastHint(_ref) {
  var style = _ref.style,
    children = _ref.children,
    title = _ref.title,
    className = _ref.className,
    classNames = _ref.classNames;
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$h(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {});
  return /*#__PURE__*/React.createElement(Hint$3, {
    style: styles,
    icon: "info",
    title: title
  }, children);
};
var defaultStyles$h = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return _objectSpread$T({
    border: "1px solid ".concat(color.contrast),
    color: color.contrastText.base,
    backgroundColor: color.contrast,
    icon: {
      color: color.contrastText.base
    }
  }, border.hint);
};
var ContrastHintUnsealed = ContrastHint$1;function ownKeys$S(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$S(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$S(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$S(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DangerHint$1 = function DangerHint(_ref) {
  var style = _ref.style,
    children = _ref.children,
    title = _ref.title,
    className = _ref.className,
    classNames = _ref.classNames;
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$g(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {});
  return /*#__PURE__*/React.createElement(Hint$3, {
    style: styles,
    icon: "error",
    title: title
  }, children);
};
var defaultStyles$g = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return _objectSpread$S({
    border: "1px solid ".concat(color.danger.base),
    color: color.danger.base,
    icon: {
      color: color.danger.base
    }
  }, border.hint);
};
var DangerHintUnsealed = DangerHint$1;function ownKeys$R(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$R(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$R(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$R(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DangerContrastHint$1 = function DangerContrastHint(_ref) {
  var style = _ref.style,
    children = _ref.children,
    title = _ref.title,
    className = _ref.className,
    classNames = _ref.classNames;
  var theme = useTheme();
  var styles = useStyles$1(defaultStyles$f(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {});
  return /*#__PURE__*/React.createElement(Hint$3, {
    style: styles,
    icon: "error",
    title: title
  }, children);
};
var defaultStyles$f = function defaultStyles(_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return _objectSpread$R({
    border: "1px solid ".concat(color.danger.base),
    backgroundColor: color.danger.base,
    color: color.contrastText.base,
    icon: {
      color: color.contrastText.base
    }
  }, border.hint);
};
var DangerContrastHintUnsealed = DangerContrastHint$1;var Empty$1 = function Empty(_ref) {
  var children = _ref.children,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("div", style, children || '—');
};
var styled$M = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    padding = _ref2.padding;
  return {
    color: styles.textColor(color.mono.light),
    paddingLeft: padding.normal,
    paddingRight: padding.normal,
    '&inline': {
      display: 'inline',
      paddingLeft: 0,
      paddingRight: 0
    }
  };
}, function (_ref3) {
  var inline = _ref3.inline;
  return {
    '&inline': inline
  };
});
var Empty$2 = styled$M(Empty$1);function ownKeys$Q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$Q(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$Q(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$Q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var PopoverNode = function PopoverNode(_ref) {
  var title = _ref.title,
    popover = _ref.popover,
    style = _ref.style;
  var _useTheme = useTheme(),
    shadow = _useTheme.shadow,
    border = _useTheme.border;
  return /*#__PURE__*/React.createElement("div", styles.merge(style, _objectSpread$Q(_objectSpread$Q({}, shadow.modal), border.modal)), /*#__PURE__*/React.createElement("div", style(['arrowLayer', 'arrowBackground'])), /*#__PURE__*/React.createElement("div", style(['arrowLayer', 'arrowForeground'])), !!title && /*#__PURE__*/React.createElement("h6", style('title'), title), /*#__PURE__*/React.createElement("div", style('content'), popover));
};
var ARROW_SIZE = 16;
var styled$L = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    padding = _ref2.padding,
    font = _ref2.font,
    zIndex = _ref2.zIndex;
  return {
    position: 'relative',
    display: 'inline-block',
    background: 'white',
    padding: padding.small,
    zIndex: zIndex.popover,
    fontSize: font.size.small,
    title: {
      fontSize: font.size.small,
      fontWeight: 'bold',
      backgroundColor: color.mono.ultralight,
      marginTop: -padding.small,
      marginRight: -padding.small,
      marginBottom: padding.small,
      marginLeft: -padding.small,
      padding: padding.small,
      borderBottom: "1px solid ".concat(color.mono.lighter)
    },
    arrowLayer: {
      position: 'absolute',
      borderStyle: 'solid',
      borderTopColor: 'transparent',
      borderLeftColor: 'transparent',
      borderBottomColor: 'transparent',
      borderRightColor: 'transparent',
      borderWidth: ARROW_SIZE / 2,
      zIndex: zIndex.popover - 1,
      pointerEvents: 'none'
    },
    '&top': {
      bottom: ARROW_SIZE / 2,
      arrowLayer: {
        left: '50%',
        transform: 'translateX(-50%)'
      },
      arrowForeground: {
        borderTopColor: 'white',
        top: 'calc(100% - 1px)'
      },
      arrowBackground: {
        borderTopColor: 'rgba(0, 0, 0, 0.15)',
        top: '100%'
      }
    },
    '&right': {
      left: ARROW_SIZE / 2,
      marginRight: ARROW_SIZE / 2,
      arrowLayer: {
        top: '50%',
        transform: 'translateY(-50%)'
      },
      arrowForeground: {
        borderRightColor: 'white',
        right: 'calc(100% - 1px)'
      },
      arrowBackground: {
        borderRightColor: 'rgba(0, 0, 0, 0.15)',
        right: '100%'
      }
    },
    '&bottom': {
      top: ARROW_SIZE / 2,
      arrowLayer: {
        left: '50%',
        transform: 'translateX(-50%)'
      },
      arrowForeground: {
        borderBottomColor: 'white',
        bottom: 'calc(100% - 1px)'
      },
      arrowBackground: {
        borderBottomColor: 'rgba(0, 0, 0, 0.15)',
        bottom: '100%'
      }
    },
    '&left': {
      right: ARROW_SIZE / 2,
      marginLeft: ARROW_SIZE / 2,
      arrowLayer: {
        top: '50%',
        transform: 'translateY(-50%)'
      },
      arrowForeground: {
        borderLeftColor: 'white',
        left: 'calc(100% - 1px)'
      },
      arrowBackground: {
        borderLeftColor: 'rgba(0, 0, 0, 0.15)',
        left: '100%'
      }
    }
  };
}, function (_ref3) {
  var _ref3$position = _ref3.position,
    position = _ref3$position === void 0 ? 'top' : _ref3$position;
  return _defineProperty({}, "&".concat(position), true);
});
var PopoverNode$1 = styled$L(PopoverNode);var _excluded$12 = ["trigger", "position", "delayOpen", "delayClose", "isOpen", "inline", "children", "keepOpenOnHover", "style"];
var composeDropdownEnhancer = function composeDropdownEnhancer(trigger, delayOpen, delayClose, keepOpenOnHover) {
  var delayEnhancers = _compact([delayOpen && dropdownEnhancers.delayOpen(delayOpen), delayClose && dropdownEnhancers.delayClose(delayClose)]);
  switch (trigger) {
    case 'hover':
      // $FlowFixMe
      return compose.apply(void 0, [dropdownEnhancers.uncontrolled].concat(_toConsumableArray(delayEnhancers), [dropdownEnhancers.toggleOnHover, keepOpenOnHover ? _identity : dropdownEnhancers.closeOnMouseEnterNode]));
    case 'click':
      // $FlowFixMe
      return compose.apply(void 0, [dropdownEnhancers.uncontrolled].concat(_toConsumableArray(delayEnhancers), [dropdownEnhancers.toggleOnClick]));
    default:
      return _identity;
  }
};
var enhanceDropdown = function enhanceDropdown() {
  return composeDropdownEnhancer.apply(void 0, arguments)(Dropdown$3);
};
var concatArgs = function concatArgs() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.join('_');
};
var enhanceDropdownMemoized = _memoize(enhanceDropdown, concatArgs);
var transformToDropdownPosition = function transformToDropdownPosition(position) {
  return {
    top: 'top center',
    right: 'middle right',
    bottom: 'bottom center',
    left: 'middle left'
  }[position];
};
var Popover$1 = function Popover(_ref) {
  var _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'top' : _ref$position,
    delayOpen = _ref.delayOpen,
    delayClose = _ref.delayClose,
    isOpen = _ref.isOpen,
    inline = _ref.inline,
    children = _ref.children,
    keepOpenOnHover = _ref.keepOpenOnHover,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$12);
  // use the memoized result to make sure that the Dropdown component class
  // does not change on each rerender, causing the element to be re-mounted
  // each time
  var Dropdown = enhanceDropdownMemoized(trigger, delayOpen, delayClose, keepOpenOnHover);
  return (
    /*#__PURE__*/
    // $FlowFixMe
    React.createElement(Dropdown, {
      node: /*#__PURE__*/React.createElement(PopoverNode$1, _extends({}, rest, {
        position: position,
        style: style('popover')
      })),
      position: transformToDropdownPosition(position),
      isOpen: isOpen,
      inline: inline,
      style: style
    }, children)
  );
};
var styled$K = createDefaultStyle(function (_ref2) {
  var zIndex = _ref2.zIndex;
  return {
    node: {
      zIndex: zIndex.popover
    }
  };
});
var PopoverUnsealed = styled$K(Popover$1);var _excluded$11 = ["style", "children", "actionIcon", "actionLabel", "onAction"];
function ToastBase(_ref) {
  var style = _ref.style,
    children = _ref.children,
    actionIcon = _ref.actionIcon,
    actionLabel = _ref.actionLabel,
    onAction = _ref.onAction,
    rest = _objectWithoutProperties(_ref, _excluded$11);
  if (actionLabel) {
    invariant(actionIcon, 'Labeled toast actions require an icon.');
    invariant(onAction, 'You need to specify an "onAction" handler when you set "actionLabel".');
    return /*#__PURE__*/React.createElement(Toast$1, _extends({}, rest, {
      style: style,
      action: function action(closeToast) {
        return /*#__PURE__*/React.createElement(Button$3, {
          icon: actionIcon,
          onClick: function onClick(event) {
            return onAction(closeToast, event);
          }
        }, actionLabel);
      }
    }), children);
  }
  if (actionIcon) {
    invariant(onAction, 'You need to specify an "onAction" handler when you set "actionIcon".');
    return /*#__PURE__*/React.createElement(Toast$1, _extends({}, rest, {
      style: style,
      action: function action(closeToast) {
        return /*#__PURE__*/React.createElement("div", _extends({
          "data-testid": "toast-base-dark-icon-button"
        }, style('iconButton')), /*#__PURE__*/React.createElement(OnDarkIconButton$1, {
          small: true,
          icon: actionIcon,
          onClick: function onClick(event) {
            return onAction(closeToast, event);
          }
        }));
      }
    }), children);
  }
  return /*#__PURE__*/React.createElement(Toast$1, _extends({}, rest, {
    style: style,
    action: function action(closeToast) {
      return /*#__PURE__*/React.createElement("div", _extends({
        "data-testid": "toast-base-dark-icon-button"
      }, style('iconButton')), /*#__PURE__*/React.createElement(OnDarkIconButton$1, {
        small: true,
        icon: "reset",
        onClick: closeToast
      }));
    }
  }), children);
}
var styled$J = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    spacing = _ref2.spacing;
  return {
    backgroundColor: color.contrast,
    color: color.contrastText.base,
    iconButton: {
      marginRight: spacing.xxsmall,
      marginTop: spacing.xxsmall
    }
  };
});
var ToastBase$1 = styled$J(ToastBase);function ownKeys$P(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$P(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$P(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$P(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function InfoToast$1(_ref) {
  var children = _ref.children,
    actionIcon = _ref.actionIcon,
    actionLabel = _ref.actionLabel,
    onAction = _ref.onAction,
    onClose = _ref.onClose;
  var theme = useTheme();
  var style = defaultStyles$e(theme);
  return /*#__PURE__*/React.createElement(ToastBase$1, {
    style: style,
    icon: "info",
    autoCloseAfter: 3000,
    actionIcon: actionIcon,
    actionLabel: actionLabel,
    onAction: onAction,
    onClose: onClose
  }, children);
}
var defaultStyles$e = function defaultStyles(_ref2) {
  var border = _ref2.border,
    shadow = _ref2.shadow;
  return _objectSpread$P(_objectSpread$P({}, border.hint), shadow.menu);
};function ownKeys$O(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$O(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$O(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$O(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function SuccessToast$1(_ref) {
  var children = _ref.children,
    actionIcon = _ref.actionIcon,
    actionLabel = _ref.actionLabel,
    onAction = _ref.onAction,
    onClose = _ref.onClose;
  var theme = useTheme();
  var style = defaultStyles$d(theme);
  return /*#__PURE__*/React.createElement(ToastBase$1, {
    style: style,
    icon: "checked-tick",
    autoCloseAfter: 3000,
    actionIcon: actionIcon,
    actionLabel: actionLabel,
    onAction: onAction,
    onClose: onClose
  }, children);
}
var defaultStyles$d = function defaultStyles(_ref2) {
  var border = _ref2.border,
    shadow = _ref2.shadow;
  return _objectSpread$O(_objectSpread$O({}, border.hint), shadow.menu);
};function ownKeys$N(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$N(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$N(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$N(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function WarningToast$1(_ref) {
  var children = _ref.children,
    actionIcon = _ref.actionIcon,
    actionLabel = _ref.actionLabel,
    onAction = _ref.onAction,
    onClose = _ref.onClose;
  var theme = useTheme();
  var style = defaultStyles$c(theme);
  return /*#__PURE__*/React.createElement(ToastBase$1, {
    style: style,
    icon: "warning",
    autoCloseAfter: 3000,
    actionIcon: actionIcon,
    actionLabel: actionLabel,
    onAction: onAction,
    onClose: onClose
  }, children);
}
var defaultStyles$c = function defaultStyles(_ref2) {
  var border = _ref2.border,
    shadow = _ref2.shadow;
  return _objectSpread$N(_objectSpread$N({}, border.hint), shadow.menu);
};function ownKeys$M(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$M(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$M(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$M(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function Danger(_ref) {
  var style = _ref.style,
    children = _ref.children,
    actionIcon = _ref.actionIcon,
    actionLabel = _ref.actionLabel,
    onAction = _ref.onAction,
    onClose = _ref.onClose,
    className = _ref.className,
    classNames = _ref.classNames;
  var _useTheme = useTheme(),
    shadow = _useTheme.shadow,
    border = _useTheme.border;
  var styles = useStyles$1(_objectSpread$M(_objectSpread$M({}, shadow.modal), border.modal), {
    style: style,
    className: className,
    classNames: classNames
  }, {});
  if (actionLabel) {
    invariant(actionIcon, 'Labeled toast actions require an icon.');
    invariant(onAction, 'You need to specify an "onAction" handler when you set "actionLabel".');
    return /*#__PURE__*/React.createElement(Toast$1, {
      style: styles,
      icon: "checked-cross",
      action: function action(closeToast) {
        return /*#__PURE__*/React.createElement(Button$3, {
          icon: actionIcon,
          onClick: function onClick(event) {
            return onAction(closeToast, event);
          }
        }, actionLabel);
      },
      onClose: onClose
    }, children);
  }
  if (actionIcon) {
    invariant(onAction, 'You need to specify an "onAction" handler when you set "actionIcon".');
    return /*#__PURE__*/React.createElement(Toast$1, {
      style: styles,
      icon: "checked-cross",
      action: function action(closeToast) {
        return /*#__PURE__*/React.createElement("div", _extends({
          "data-testid": "dark-icon-button"
        }, styles('iconButton')), /*#__PURE__*/React.createElement(OnDarkIconButton$1, {
          small: true,
          icon: actionIcon,
          onClick: function onClick(event) {
            return onAction(closeToast, event);
          }
        }));
      },
      onClose: onClose
    }, children);
  }
  return /*#__PURE__*/React.createElement(Toast$1, {
    style: styles,
    icon: "checked-cross",
    action: function action(closeToast) {
      return /*#__PURE__*/React.createElement("div", _extends({
        "data-testid": "dark-icon-button"
      }, styles('iconButton')), /*#__PURE__*/React.createElement(OnDarkIconButton$1, {
        small: true,
        icon: "reset",
        onClick: closeToast
      }));
    },
    onClose: onClose
  }, children);
}
var styled$I = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    spacing = _ref2.spacing;
  return {
    backgroundColor: color.danger.base,
    color: color.contrastText.base,
    iconButton: {
      marginRight: spacing.xxsmall,
      marginTop: spacing.xxsmall
    }
  };
});
var DangerToastUnsealed = styled$I(Danger);var _excluded$10 = ["children", "style"];
function Title1$1(_ref) {
  var children = _ref.children,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$10);
  return /*#__PURE__*/React.createElement(Title1$2, _extends({
    style: style
  }, rest), children);
}
var enhance$p = createDefaultStyle(function (_ref2) {
  var spacing = _ref2.spacing;
  return {
    marginBottom: spacing.large
  };
});
var Title1Unsealed = enhance$p(Title1$1);var _excluded$$ = ["children", "style"];
function Title2$1(_ref) {
  var children = _ref.children,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$$);
  return /*#__PURE__*/React.createElement(Title2$2, _extends({}, rest, {
    style: style
  }), children);
}
var styled$H = createDefaultStyle(function (_ref2) {
  _ref2.color;
    var spacing = _ref2.spacing;
  return {
    marginBottom: spacing.small
  };
});
var Title2Unsealed = styled$H(Title2$1);var _excluded$_ = ["children", "style"];
function Title3$1(_ref) {
  var children = _ref.children,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$_);
  return /*#__PURE__*/React.createElement(Title3$2, _extends({}, rest, {
    style: style
  }), children);
}
var styled$G = createDefaultStyle(function (_ref2) {
  var spacing = _ref2.spacing;
  return {
    marginBottom: spacing.xsmall
  };
});
var Title3Unsealed = styled$G(Title3$1);var _excluded$Z = ["children", "style"];
function Title4$1(_ref) {
  var children = _ref.children,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$Z);
  return /*#__PURE__*/React.createElement(Title4$2, _extends({}, rest, {
    style: style
  }), children);
}
var styled$F = createDefaultStyle(function (_ref2) {
  var spacing = _ref2.spacing;
    _ref2.color;
  return {
    marginBottom: spacing.xxsmall
  };
});
var Title4Unsealed = styled$F(Title4$1);function Article$1(_ref) {
  var children = _ref.children,
    style = _ref.style,
    title = _ref.title,
    ellipsis = _ref.ellipsis;
  return /*#__PURE__*/React.createElement(Article$2, {
    title: title,
    style: style,
    ellipsis: ellipsis
  }, children);
}
var styled$E = createDefaultStyle(function (_ref2) {
  var spacing = _ref2.spacing;
  return {
    marginBottom: spacing.xsmall
  };
});
var ArticleUnsealed = styled$E(Article$1);function Body$1(_ref) {
  var children = _ref.children,
    style = _ref.style,
    title = _ref.title,
    ellipsis = _ref.ellipsis;
  return /*#__PURE__*/React.createElement(Body$2, {
    title: title,
    style: style,
    ellipsis: ellipsis
  }, children);
}
var styled$D = createDefaultStyle(function (_ref2) {
  var spacing = _ref2.spacing;
  return {
    marginBottom: spacing.xxsmall
  };
});
var BodyUnsealed = styled$D(Body$1);var OhSnap$1 = function OhSnap(_ref) {
  var title = _ref.title,
    meta = _ref.meta,
    children = _ref.children,
    showDate = _ref.showDate,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("div", style, /*#__PURE__*/React.createElement("div", style('textBox'), /*#__PURE__*/React.createElement(Title3Unsealed, style('title'), title), /*#__PURE__*/React.createElement(Caption$1, null, meta && /*#__PURE__*/React.createElement("span", style('meta'), meta, " "), showDate && /*#__PURE__*/React.createElement("span", style('date'), new Date().toISOString())), /*#__PURE__*/React.createElement("div", style('bodyText'), children)), /*#__PURE__*/React.createElement("div", style('imgBox'), /*#__PURE__*/React.createElement("div", {
    className: "signavio-ui-img-oh-snap",
    "aria-label": "Oh snap!"
  })));
};
var styled$C = createDefaultStyle(function (_ref2) {
  var spacing = _ref2.spacing;
  return {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    paddingTop: spacing.xlarge,
    paddingBottom: spacing.xlarge,
    textBox: {
      paddingTop: spacing.large,
      paddingBottom: spacing.large,
      paddingLeft: spacing.small,
      paddingRight: spacing.small,
      flex: '550px 0 0'
    },
    bodyText: {
      paddingTop: spacing.medium,
      paddingBottom: spacing.medium
    },
    title: {
      marginBottom: 0
    },
    meta: {
      display: 'inline-block',
      paddingRight: spacing.xxsmall
    },
    date: {
      display: 'inline-block',
      whiteSpace: 'nowrap'
    },
    imgBox: {
      textAlign: 'center',
      flex: '512px 0 0'
    }
  };
});
var OhSnapUnsealed = styled$C(OhSnap$1);function ProgressIndicator$1(_ref) {
  var children = _ref.children,
    actionIcon = _ref.actionIcon,
    actionLabel = _ref.actionLabel,
    onAction = _ref.onAction,
    onClose = _ref.onClose;
  var styles = useStyles$1(defaultStyles$b, {}, {});
  var spinnerStyles = useStyles$1(spinnerDefaultStyles, {}, {});
  if (actionLabel) {
    invariant(actionIcon, 'Labeled toast actions require an icon.');
    invariant(onAction, 'You need to specify an "onAction" handler when you set "actionLabel".');
    return /*#__PURE__*/React.createElement(Toast$1, {
      style: styles,
      action: function action(closeToast) {
        return /*#__PURE__*/React.createElement(Button$3, {
          icon: actionIcon,
          onClick: function onClick(event) {
            return onAction(closeToast, event);
          }
        }, actionLabel);
      },
      onClose: onClose
    }, /*#__PURE__*/React.createElement(SpinnerUnsealed, {
      onDark: true,
      inline: true,
      style: spinnerStyles
    }), children);
  }
  if (actionIcon) {
    invariant(onAction, 'You need to specify an "onAction" handler when you set "actionIcon".');
    return /*#__PURE__*/React.createElement(Toast$1, {
      style: styles,
      action: function action(closeToast) {
        return /*#__PURE__*/React.createElement("div", _extends({
          "data-testid": "dark-icon-button"
        }, styles('iconButton')), /*#__PURE__*/React.createElement(OnDarkIconButton$1, {
          small: true,
          icon: actionIcon,
          onClick: function onClick(event) {
            return onAction(closeToast, event);
          }
        }));
      },
      onClose: onClose
    }, /*#__PURE__*/React.createElement(SpinnerUnsealed, {
      onDark: true,
      inline: true,
      style: spinnerStyles
    }), children);
  }
  return /*#__PURE__*/React.createElement(Toast$1, {
    style: styles,
    action: function action(closeToast) {
      return /*#__PURE__*/React.createElement("div", _extends({
        "data-testid": "dark-icon-button"
      }, styles('iconButton')), /*#__PURE__*/React.createElement(OnDarkIconButton$1, {
        small: true,
        icon: "reset",
        onClick: closeToast
      }));
    },
    onClose: onClose
  }, /*#__PURE__*/React.createElement(SpinnerUnsealed, {
    onDark: true,
    inline: true,
    style: spinnerStyles
  }), children);
}
var defaultStyles$b = function defaultStyles(_ref2) {
  var color = _ref2.color,
    spacing = _ref2.spacing;
  return {
    backgroundColor: color.contrast,
    color: color.contrastText.base,
    content: {
      display: 'flex',
      alignItems: 'center'
    },
    iconButton: {
      marginRight: spacing.xxsmall,
      marginTop: spacing.xxsmall
    }
  };
};
var spinnerDefaultStyles = function spinnerDefaultStyles(_ref3) {
  var spacing = _ref3.spacing;
  return {
    height: 14,
    width: 14,
    marginRight: spacing.small,
    marginTop: spacing.xxxsmall / 2
  };
};var DEFAULT_DELAY = 200;
function Description(_ref) {
  var children = _ref.children;
  var styles = useStyles$1(defaultStyles$a, {});
  return /*#__PURE__*/React.createElement("div", styles, /*#__PURE__*/React.createElement(PopoverUnsealed, {
    popover: children,
    delayClose: DEFAULT_DELAY,
    keepOpenOnHover: true
  }, /*#__PURE__*/React.createElement(Glyph, {
    "data-testid": "inline-description",
    style: styles('icon')
  }, "info")));
}
var defaultStyles$a = function defaultStyles(_ref2) {
  _ref2.color;
    var spacing = _ref2.spacing;
  return {
    cursor: 'help',
    display: 'inline-block',
    marginLeft: spacing.xxsmall,
    icon: {
      lineHeight: 1
    }
  };
};function Label$2(_ref) {
  var children = _ref.children,
    required = _ref.required,
    style = _ref.style;
  return /*#__PURE__*/React.createElement(Fragment, null, children, required ? /*#__PURE__*/React.createElement("span", style('asterisk'), " *") : null);
}
var styled$B = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    font = _ref2.font;
  return {
    asterisk: {
      fontSize: font.size.small,
      position: 'relative',
      top: -3
    },
    '&hasFocus': {
      asterisk: {
        color: color.status.danger
      }
    },
    '&floating': {
      asterisk: {
        top: 0
      }
    }
  };
}, function (_ref3) {
  var hasFocus = _ref3.hasFocus,
    floating = _ref3.floating;
  return {
    '&hasFocus': hasFocus,
    '&floating': floating
  };
});
var Label$3 = styled$B(Label$2);function Messages(_ref) {
  var error = _ref.error,
    hint = _ref.hint,
    style = _ref.style;
  return /*#__PURE__*/React.createElement(Fragment, null, error && /*#__PURE__*/React.createElement("div", style('error'), error), hint && /*#__PURE__*/React.createElement("div", style('hint'), hint));
}
var styled$A = createDefaultStyle(function (_ref2) {
  var font = _ref2.font,
    color = _ref2.color;
  return {
    hint: {
      fontSize: font.size.small,
      color: color.mono.middle
    },
    error: {
      fontSize: font.size.small,
      color: color.status.danger
    }
  };
});
var Messages$1 = styled$A(Messages);function ownKeys$L(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$L(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$L(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$L(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var FieldLayout = function FieldLayout(_ref) {
  var children = _ref.children,
    label = _ref.label,
    description = _ref.description,
    hint = _ref.hint,
    error = _ref.error,
    hasFocus = _ref.hasFocus,
    required = _ref.required,
    disabled = _ref.disabled,
    floating = _ref.floating,
    bar = _ref.bar,
    controls = _ref.controls,
    htmlFor = _ref.htmlFor,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("div", style, /*#__PURE__*/React.createElement("label", _extends({
    htmlFor: htmlFor
  }, style('label')), /*#__PURE__*/React.createElement(Label$3, {
    hasFocus: hasFocus,
    floating: floating,
    required: required
  }, label), description && /*#__PURE__*/React.createElement("span", style('description'), /*#__PURE__*/React.createElement(Description, null, description))), /*#__PURE__*/React.createElement(Tile$2, {
    transparent: true,
    alignBottom: true,
    toolbar: controls && /*#__PURE__*/React.createElement(ListUnsealed, {
      direction: "horizontal",
      style: style('controls')
    }, controls)
  }, /*#__PURE__*/React.createElement("div", style('inputWrapper'), children)), bar === undefined ? /*#__PURE__*/React.createElement(Bar$1, {
    hasFocus: hasFocus,
    error: error,
    disabled: disabled,
    required: required
  }) : bar, /*#__PURE__*/React.createElement(Messages$1, {
    error: error,
    hint: hint
  }));
};
var styled$z = createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding,
    font = _ref2.font,
    lineHeight = _ref2.lineHeight,
    color = _ref2.color,
    spacing = _ref2.spacing;
  var floatingLabelHeight = styles.calculateAbsoluteLineHeight(font.size.small, lineHeight);
  return {
    position: 'relative',
    paddingTop: padding.small,
    paddingBottom: padding.small,
    label: _objectSpread$L(_objectSpread$L({
      display: 'block',
      width: '100%',
      position: 'absolute',
      top: padding.small + floatingLabelHeight,
      lineHeight: lineHeight,
      color: color.mono.middle,
      fontSize: font.size.normal,
      // give some extra padding to make clickable area larger
      // add negative margin to keep the right position
      paddingTop: padding.small,
      paddingBottom: padding.small,
      paddingRight: spacing.large,
      marginTop: -padding.small + styles.inputPadding
    }, styles.transition(['fontSize', 'top', 'color'], 'ease', '0.2s')), styles.ellipsis()),
    description: {
      position: 'absolute',
      zIndex: 1,
      // we have to slightly fix the description position in a rather random way :S
      marginTop: -1
    },
    inputWrapper: {
      paddingTop: floatingLabelHeight
    },
    '&floating': {
      label: {
        color: color.mono.ultradark,
        top: padding.small,
        fontSize: font.size.small,
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: 0,
        marginTop: 0
      },
      '&disabled': {
        label: {
          color: color.mono.middle
        }
      }
    },
    '&disabled': {
      label: {
        color: Color$3(color.mono.middle).lighten(0.2).hex()
      }
    },
    '&dontFloatLabel': {
      // clear reserved spacing for floatingLabelHeight on all elements
      label: {
        top: padding.small
      },
      inputWrapper: {
        paddingTop: 0
      },
      controls: {
        top: 0,
        marginTop: styles.inputPadding - padding.small
      },
      '&floating': {
        label: {
          display: 'none',
          transition: 'none'
        }
      }
    }
  };
}, function (_ref3) {
  var floating = _ref3.floating,
    dontFloatLabel = _ref3.dontFloatLabel,
    disabled = _ref3.disabled;
  return {
    '&floating': floating,
    '&dontFloatLabel': dontFloatLabel,
    '&disabled': disabled
  };
});
var Field = styled$z(FieldLayout);function ownKeys$K(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$K(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$K(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$K(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var InTile = function InTile(_ref) {
  var children = _ref.children,
    label = _ref.label,
    description = _ref.description,
    hint = _ref.hint,
    error = _ref.error,
    hasFocus = _ref.hasFocus,
    required = _ref.required,
    disabled = _ref.disabled,
    bar = _ref.bar,
    controls = _ref.controls,
    htmlFor = _ref.htmlFor,
    floating = _ref.floating,
    style = _ref.style;
  var content = /*#__PURE__*/React.createElement(Fragment, null, !floating && /*#__PURE__*/React.createElement("label", _extends({
    htmlFor: htmlFor
  }, style('label')), /*#__PURE__*/React.createElement(Label$3, {
    required: required
  }, label), description && /*#__PURE__*/React.createElement("span", style('description'), /*#__PURE__*/React.createElement(Description, null, description))), /*#__PURE__*/React.createElement(Tile$2, {
    transparent: true,
    toolbar: controls && /*#__PURE__*/React.createElement(ListUnsealed, {
      direction: "horizontal",
      style: style('controls')
    }, controls)
  }, /*#__PURE__*/React.createElement("div", style('inputWrapper'), children)), bar === undefined ? /*#__PURE__*/React.createElement(Bar$1, {
    hasFocus: hasFocus,
    error: error,
    disabled: disabled,
    required: required
  }) : bar);
  return error || hint ? /*#__PURE__*/React.createElement(PopoverUnsealed, {
    style: style,
    position: "bottom",
    popover: /*#__PURE__*/React.createElement(Messages$1, {
      error: error,
      hint: hint
    })
  }, content) : /*#__PURE__*/React.createElement("div", style, content);
};
var styled$y = createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding,
    font = _ref2.font,
    lineHeight = _ref2.lineHeight,
    color = _ref2.color;
  return {
    position: 'relative',
    paddingLeft: padding.normal,
    paddingRight: padding.normal,
    paddingTop: padding.small - styles.inputPadding,
    paddingBottom: padding.small - styles.inputPadding - 2,
    // -2 for bar
    backgroundColor: 'white',
    label: _objectSpread$K({
      display: 'block',
      position: 'absolute',
      lineHeight: lineHeight,
      color: color.mono.middle,
      fontSize: font.size.normal,
      top: 0,
      left: 0,
      paddingTop: padding.small,
      paddingBottom: padding.small,
      paddingLeft: padding.normal,
      paddingRight: padding.normal
    }, styles.transition(['fontSize', 'top', 'color'], 'ease', '0.2s')),
    description: {
      position: 'absolute',
      zIndex: 1,
      // we have to slightly fix the description position in a rather random way :S
      marginTop: -1
    },
    controls: {
      marginTop: styles.inputPadding - padding.small,
      marginBottom: styles.inputPadding - padding.small
    },
    popover: {
      marginTop: -padding.small // position popover directly below the bar
    },

    '&disabled': {
      label: {
        color: Color$3(color.mono.middle).lighten(0.2).hex()
      }
    }
  };
}, function (_ref3) {
  var disabled = _ref3.disabled,
    error = _ref3.error;
  return {
    '&disabled': disabled,
    '&error': error
  };
});
var InTile$1 = styled$y(InTile);var _excluded$Y = ["label", "description", "hint", "error", "required", "disabled", "floatingLabelFixed", "dontFloatLabel", "value", "defaultValue", "placeholder", "bar", "controls", "inTile"];
function labeled$2(WrappedComponent) {
  function Labeled(_ref) {
    var label = _ref.label,
      description = _ref.description,
      hint = _ref.hint,
      error = _ref.error,
      required = _ref.required,
      disabled = _ref.disabled,
      floatingLabelFixed = _ref.floatingLabelFixed,
      dontFloatLabel = _ref.dontFloatLabel,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      actualPlaceholder = _ref.placeholder,
      bar = _ref.bar,
      controls = _ref.controls,
      inTile = _ref.inTile,
      rest = _objectWithoutProperties(_ref, _excluded$Y);
    var _useState = useState(function () {
        return _uniqueId('ui_input');
      }),
      _useState2 = _slicedToArray(_useState, 1),
      fieldId = _useState2[0];
    var _useState3 = useState(!isClear$1(defaultValue)),
      _useState4 = _slicedToArray(_useState3, 2),
      hasValue = _useState4[0],
      setHasValue = _useState4[1];
    var _useState5 = useState(!!rest.autoFocus),
      _useState6 = _slicedToArray(_useState5, 2),
      hasFocus = _useState6[0],
      setHasFocus = _useState6[1];
    useEffect(function () {
      setHasValue(!isClear$1(value) || !isClear$1(defaultValue));
    }, [value, defaultValue]);
    var floating = floatingLabelFixed || !isClear$1(value) || hasValue || hasFocus;
    var placeholder = floating ? actualPlaceholder : '';
    var Layout = inTile ? InTile$1 : Field;
    return /*#__PURE__*/React.createElement(Layout, {
      label: label,
      description: description,
      hint: hint,
      error: error,
      required: required,
      disabled: disabled,
      htmlFor: fieldId,
      floating: floating,
      dontFloatLabel: dontFloatLabel,
      hasFocus: hasFocus,
      bar: bar,
      controls: controls
    }, /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      id: fieldId
    }, rest, _omitBy({
      value: value,
      defaultValue: defaultValue,
      required: required,
      disabled: disabled,
      placeholder: placeholder
    }, _isUndefined), {
      onChange: function onChange(newValue) {
        setHasValue(!isClear$1(newValue));
        if (rest.onChange) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          rest.onChange.apply(rest, [newValue].concat(args));
        }
      },
      onFocus: function onFocus(event) {
        setHasFocus(true);
        if (rest.onFocus) {
          rest.onFocus(event);
        }
      },
      onBlur: function onBlur(event) {
        setHasFocus(false);
        if (rest.onBlur) {
          rest.onBlur(event);
        }
      },
      "aria-invalid": !!error
    })));
  }
  Labeled.displayName = wrapDisplayName(WrappedComponent, 'labeled');
  return Labeled;
}var styledAsInput$1 = createDefaultStyle(function (theme) {
  return styles.input(theme);
}, function (_ref) {
  var disabled = _ref.disabled,
    required = _ref.required,
    ariaInvalid = _ref['aria-invalid'];
  return {
    '&disabled': disabled,
    '&required': required,
    '&error': !!ariaInvalid
  };
});var NavigationHeader = function NavigationHeader(_ref) {
  var children = _ref.children,
    onPrev = _ref.onPrev,
    onNext = _ref.onNext,
    disablePrev = _ref.disablePrev,
    disableNext = _ref.disableNext,
    style = _ref.style;
  var styles = useStyles$1(defaultStyle$4, {
    style: style
  }, {});
  return /*#__PURE__*/React.createElement("header", styles, /*#__PURE__*/React.createElement(Button$4, {
    "data-testid": "date-picker-navigation-prev",
    onClick: onPrev,
    disabled: disablePrev
  }, /*#__PURE__*/React.createElement(Glyph, {
    style: styles('icon')
  }, "nav-prev")), /*#__PURE__*/React.createElement("div", null, children), /*#__PURE__*/React.createElement(Button$4, {
    "data-testid": "date-picker-navigation-next",
    onClick: onNext,
    disabled: disableNext
  }, /*#__PURE__*/React.createElement(Glyph, {
    style: styles('icon')
  }, "nav-next")));
};
var defaultStyle$4 = function defaultStyle(_ref2) {
  _ref2.color;
    var font = _ref2.font;
  return {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    icon: {
      fontSize: font.size.normal
    }
  };
};
var NavigationHeader$1 = NavigationHeader;var CALENDAR_VIEW = {
  DATE: 'date',
  MONTH: 'month',
  YEAR: 'year'
};
var DEFAULT_LOCALE = 'en_US';
var DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
var getValidDate = function getValidDate(date, format) {
  if (!date) return undefined;
  if (isValid(parseISO(date))) return parseISO(date);
  if (isValid(new Date(date))) return new Date(date);
  return undefined;
};
var getDateLocale = function getDateLocale(locale) {
  var _locale$split = locale.split(/[-_]/g),
    _locale$split2 = _slicedToArray(_locale$split, 2),
    lang = _locale$split2[0],
    country = _locale$split2[1];
  var langConfig = dateLocales[lang];
  var countryConfig = dateLocales[lang + (country === null || country === void 0 ? void 0 : country.toUpperCase())];
  return countryConfig || langConfig || dateLocales['enGB'];
};
var getWeekDays = function getWeekDays(weekStartsOn) {
  var week = [0, 1, 2, 3, 4, 5, 6];
  for (var i = 0; i < weekStartsOn; i++) {
    week.push(week[0]);
    week.splice(0, 1);
  }
  return week;
};
var getAbbreviatedWeekDays = function getAbbreviatedWeekDays(locale) {
  var dateLocale = getDateLocale(locale);
  return getWeekDays(dateLocale.options.weekStartsOn || 0).map(function (day) {
    return dateLocale.localize.day(day, {
      width: 'abbreviated'
    });
  });
};
var fillInDaysForFirstWeekOfMonth = function fillInDaysForFirstWeekOfMonth(weeks) {
  var result = _toConsumableArray(weeks);
  if (weeks[0].days.length < 7) {
    var daysToFill = 7 - weeks[0].days.length;
    var currentDay = subDays(weeks[0].days[0].date, 1);
    for (var day = daysToFill - 1; day >= 0; day--) {
      result[0].days.unshift({
        number: getDate(currentDay),
        date: currentDay,
        inCurrentMonth: false,
        isToday: false
      });
      currentDay = subDays(currentDay, 1);
    }
  }
  return result;
};
var fillInDaysForLastWeekOfMonth = function fillInDaysForLastWeekOfMonth(weeks) {
  var result = _toConsumableArray(weeks);
  var lastWeekIndex = weeks.length - 1;
  if (weeks[lastWeekIndex].days.length < 7) {
    var daysToFill = 7 - weeks[lastWeekIndex].days.length;
    var lastDayIndex = weeks[lastWeekIndex].days.length - 1;
    var currentDay = addDays(weeks[lastWeekIndex].days[lastDayIndex].date, 1);
    for (var day = 0; day < daysToFill; day++) {
      result[lastWeekIndex].days.push({
        number: getDate(currentDay),
        date: currentDay,
        inCurrentMonth: false,
        isToday: false
      });
      currentDay = addDays(currentDay, 1);
    }
  }
  return result;
};
var getMonthWeeks = function getMonthWeeks(currentDate, locale) {
  var date = new Date(currentDate);
  var dateLocale = getDateLocale(locale);
  var weeks = [];
  var daysInMonth = getDaysInMonth(date);
  var month = getMonth(date);
  var currentDay = startOfMonth(date);
  var weekIndex = 0;
  for (var i = 0; i < daysInMonth; i++) {
    if (getDay(currentDay) === dateLocale.options.weekStartsOn && !!weeks[weekIndex]) {
      weekIndex = weekIndex + 1;
    }
    if (!weeks[weekIndex]) {
      weeks.push({
        number: "".concat(month + 1, "-").concat(weekIndex + 1),
        days: []
      });
    }
    weeks[weekIndex].days.push({
      date: currentDay,
      number: i + 1,
      inCurrentMonth: true,
      isToday: isToday(currentDay)
    });
    currentDay = addDays(currentDay, 1);
  }
  weeks = fillInDaysForFirstWeekOfMonth(weeks);
  weeks = fillInDaysForLastWeekOfMonth(weeks);
  return weeks;
};
var getMonthName = function getMonthName(month, locale) {
  var dateLocale = getDateLocale(locale);
  return dateLocale.localize.month(month);
};
var getYearPage = function getYearPage(year) {
  var currentYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date().getFullYear();
  var lastYearInFirstPage = currentYear + 1;
  var blockIndex = Math.ceil(Math.abs((lastYearInFirstPage - year) / 16));
  var to, from;
  if (year >= lastYearInFirstPage) {
    to = lastYearInFirstPage + blockIndex * 16;
    from = to - 16 + 1;
  } else {
    from = lastYearInFirstPage + 1 - blockIndex * 16;
    to = from + 16 - 1;
  }
  return {
    from: from,
    to: to
  };
};
var isDateOutOfRange = function isDateOutOfRange(date) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [],
    _ref2 = _slicedToArray(_ref, 2),
    minDate = _ref2[0],
    maxDate = _ref2[1];
  var isMinOutOfRange = minDate && date < minDate;
  var isMaxOutOfRange = maxDate && date > maxDate;
  return !!isMinOutOfRange || !!isMaxOutOfRange;
};function ownKeys$J(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$J(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$J(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$J(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var CalendarDateView = function CalendarDateView(_ref) {
  var value = _ref.value,
    month = _ref.month,
    year = _ref.year,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    locale = _ref.locale,
    disabled = _ref.disabled,
    hideNavigation = _ref.hideNavigation,
    onChange = _ref.onChange,
    onPrev = _ref.onPrev,
    onNext = _ref.onNext,
    onMonthClick = _ref.onMonthClick,
    onYearClick = _ref.onYearClick,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames;
  var styles = useStyles$1(defaultStyle$3, {
    style: style,
    className: className,
    classNames: classNames
  }, {});
  var values = normalizeValues(value, [minDate, maxDate]);
  var currentDate = getValidDate(values === null || values === void 0 ? void 0 : values[0]) || new Date(Date.now());
  var selectedYear = year || currentDate.getFullYear();
  var selectedMonth = typeof month === 'number' && !isNaN(month) ? month : currentDate.getMonth();
  var displayDate = new Date(selectedYear, selectedMonth, 1);
  var weekDays = useMemo(function () {
    return getAbbreviatedWeekDays(locale);
  }, [locale]);
  var weeks = getMonthWeeks(displayDate, locale);
  return /*#__PURE__*/React.createElement("div", styles, hideNavigation ? null : /*#__PURE__*/React.createElement(NavigationHeader$1, {
    onNext: onNext,
    onPrev: onPrev,
    disableNext: disabled || isDateOutOfRange(new Date(selectedYear, selectedMonth + 1, 0), [null, maxDate]),
    disablePrev: disabled || isDateOutOfRange(new Date(selectedYear, selectedMonth), [minDate, null])
  }, /*#__PURE__*/React.createElement(Button$4, {
    "data-testid": "date-picker-navigation-month",
    onClick: onMonthClick,
    disabled: disabled
  }, getMonthName(displayDate.getMonth(), locale)), /*#__PURE__*/React.createElement(Button$4, {
    "data-testid": "date-picker-navigation-year",
    onClick: onYearClick,
    disabled: disabled
  }, displayDate.getFullYear())), /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "date-view"
  }, styles('calendar')), /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "date-weekdays"
  }, styles('weekDays')), weekDays.map(function (weekDay) {
    return /*#__PURE__*/React.createElement("div", _extends({
      key: weekDay
    }, styles('weekDay')), weekDay);
  })), weeks.map(function (week) {
    return /*#__PURE__*/React.createElement("div", _extends({
      key: week.number
    }, styles('week')), week.days.map(function (day) {
      var _day$date;
      return /*#__PURE__*/React.createElement(CalendarDateOption, {
        key: (_day$date = day.date) === null || _day$date === void 0 ? void 0 : _day$date.toDateString(),
        value: values,
        day: day,
        minDate: minDate,
        maxDate: maxDate,
        disabled: disabled,
        onChange: onChange,
        style: style
      });
    }));
  })));
};
var CalendarDateOption = function CalendarDateOption(_ref2) {
  var day = _ref2.day,
    minDate = _ref2.minDate,
    maxDate = _ref2.maxDate,
    value = _ref2.value,
    disabled = _ref2.disabled,
    onChange = _ref2.onChange,
    style = _ref2.style;
  var modifiers = getStyleModifiers(_objectSpread$J(_objectSpread$J({}, day), {}, {
    minDate: minDate,
    maxDate: maxDate,
    value: value,
    disabled: disabled
  }));
  var baseColor = useBaseColor();
  var defaultDateStyle = function defaultDateStyle(_ref3) {
    var color = _ref3.color,
      font = _ref3.font;
    return {
      width: 40,
      height: 40,
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'none',
      borderWidth: 0,
      fontSize: font.size.normal,
      fontWeight: font.weight.normal,
      color: color.text.base,
      '&selectable': {
        cursor: 'pointer',
        transition: 'all 0.3s ease-out',
        borderRadius: '50%',
        ':hover': {
          background: color.activeHover.secondary,
          transition: 'all 0.3s ease'
        },
        ':active': {
          background: color.active.secondary
        },
        ':focus-visible': {
          background: color.activeHover.secondary
        }
      },
      '&selected': {
        background: baseColor,
        borderRadius: '50%',
        color: color.contrastText.base,
        ':hover': {
          background: baseColor
        },
        ':focus-visible': {
          background: baseColor
        }
      },
      '&selectedFrom': {
        ':after': {
          content: ' ',
          display: 'block',
          width: '100%',
          height: '100%',
          borderRadius: '50% 0 0 50%',
          position: 'absolute',
          right: '0',
          background: color.active.secondary
        }
      },
      '&selectedTo': {
        ':after': {
          content: ' ',
          display: 'block',
          width: '100%',
          height: '100%',
          borderRadius: '0 50% 50% 0',
          position: 'absolute',
          left: '0',
          background: color.active.secondary
        }
      },
      '&highlighted': {
        color: color.text.base,
        background: color.active.secondary,
        borderRadius: 0,
        ':hover': {
          borderRadius: 0
        }
      },
      '&today': {
        ':before': {
          content: ' ',
          display: 'block',
          width: 5,
          height: 5,
          borderRadius: '50%',
          background: baseColor,
          position: 'absolute',
          top: 5,
          left: 'calc(50% - 2.5px)'
        }
      },
      '&disabled': {
        color: color.text.disabled,
        cursor: 'default'
      }
    };
  };
  var styles = useStyles$1(defaultDateStyle, {
    style: style
  }, {
    '&selectable': modifiers.selectable,
    '&highlighted': modifiers.highlighted,
    '&selected': modifiers.selected,
    '&selectedFrom': modifiers.selectedFrom,
    '&selectedTo': modifiers.selectedTo,
    '&today': modifiers.today,
    '&disabled': modifiers.disabled
  });
  var date = day.date,
    number = day.number,
    inCurrentMonth = day.inCurrentMonth;
  var isDisabled = modifiers.disabled;
  var isClickable = onChange && inCurrentMonth && !isDisabled;
  return /*#__PURE__*/React.createElement(Button$8, {
    disabled: isDisabled,
    tabIndex: inCurrentMonth ? 0 : -1,
    onClick: function onClick() {
      return isClickable && onChange(format(date, DEFAULT_DATE_FORMAT));
    },
    "data-testid": inCurrentMonth ? "calendar-day-".concat(number) : undefined,
    style: styles
  }, inCurrentMonth && number);
};
var getStyleModifiers = function getStyleModifiers(_ref4) {
  var value = _ref4.value,
    date = _ref4.date,
    isToday = _ref4.isToday,
    inCurrentMonth = _ref4.inCurrentMonth,
    minDate = _ref4.minDate,
    maxDate = _ref4.maxDate,
    disabled = _ref4.disabled;
  var isDisabled = disabled || isDateOutOfRange(date, [minDate, maxDate]);
  var validStartDate = getValidDate(value === null || value === void 0 ? void 0 : value[0]);
  var validEndDate = getValidDate(value === null || value === void 0 ? void 0 : value[1]);
  var isSelected = !!validStartDate && isSameDay(date, validStartDate) || !!validEndDate && isSameDay(date, validEndDate);
  var isRangeSelected = !!validStartDate && !!validEndDate && !isSameDay(validStartDate, validEndDate);
  var isInBetweenRange = !isDateOutOfRange(date, [validStartDate, validEndDate]);
  var baseModifiers = {
    today: isToday,
    selectable: false,
    selected: false,
    selectedFrom: false,
    selectedTo: false,
    highlighted: false,
    disabled: false
  };
  if (inCurrentMonth && !isDisabled) {
    return _objectSpread$J(_objectSpread$J({}, baseModifiers), {}, {
      selectable: true,
      selected: isSelected,
      selectedFrom: isRangeSelected && !!validStartDate && isSameDay(date, validStartDate),
      selectedTo: isRangeSelected && !!validEndDate && isSameDay(date, validEndDate),
      highlighted: !isSelected && isRangeSelected && isInBetweenRange
    });
  } else {
    return _objectSpread$J(_objectSpread$J({}, baseModifiers), {}, {
      disabled: true
    });
  }
};
var normalizeValues = function normalizeValues(values, _ref5) {
  var _fromDate, _toDate;
  var _ref6 = _slicedToArray(_ref5, 2),
    minDate = _ref6[0],
    maxDate = _ref6[1];
  var fromDate = getValidDate(values === null || values === void 0 ? void 0 : values[0]);
  var toDate = getValidDate(values === null || values === void 0 ? void 0 : values[1]);
  if (fromDate && isDateOutOfRange(fromDate, [minDate, maxDate])) {
    fromDate = minDate;
  }
  if (toDate && isDateOutOfRange(toDate, [minDate, maxDate])) {
    toDate = maxDate;
  }
  return [(_fromDate = fromDate) === null || _fromDate === void 0 ? void 0 : _fromDate.toISOString(), (_toDate = toDate) === null || _toDate === void 0 ? void 0 : _toDate.toISOString()];
};
var defaultStyle$3 = function defaultStyle(_ref7) {
  var color = _ref7.color,
    padding = _ref7.padding,
    border = _ref7.border;
  return _objectSpread$J(_objectSpread$J({
    background: color.surface,
    display: 'inline-block',
    padding: padding.normal,
    width: '100%'
  }, border.hint), {}, {
    week: {
      display: 'flex'
    },
    calendar: {
      display: 'block'
    },
    weekDays: {
      display: 'flex',
      padding: "".concat(padding.small, "px 0")
    },
    weekDay: {
      width: 40,
      textAlign: 'center',
      fontWeight: 600
    }
  });
};
var CalendarDateView$1 = CalendarDateView;function ownKeys$I(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$I(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$I(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$I(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var NavigationViewBase = function NavigationViewBase(_ref) {
  var children = _ref.children,
    header = _ref.header,
    style = _ref.style;
  var styles = useStyles$1(defaultStyle$2, {
    style: style
  }, {});
  return /*#__PURE__*/React.createElement("div", styles, header, /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "options-view"
  }, styles('options')), children));
};
var NavigationViewOption = function NavigationViewOption(_ref2) {
  var value = _ref2.value,
    label = _ref2.label,
    _onClick = _ref2.onClick,
    disabled = _ref2.disabled,
    active = _ref2.active,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? 'auto' : _ref2$width,
    style = _ref2.style;
  var labelRef = useRef();
  var theme = useTheme();
  var styles = useStyles$1(defaultOptionStyle(_objectSpread$I(_objectSpread$I({}, theme), {}, {
    width: width
  })), {
    style: style
  }, {
    '&disabled': !!disabled,
    '&active': !!active
  });
  useEffect(function () {
    var _labelRef$current;
    var buttonElement = (_labelRef$current = labelRef.current) === null || _labelRef$current === void 0 ? void 0 : _labelRef$current.parentElement;
    if (active && buttonElement) {
      buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.focus();
    }
  }, [active]);
  return /*#__PURE__*/React.createElement(Button$8, {
    "data-testid": "date-picker-option-".concat(value),
    onClick: function onClick() {
      return _onClick(value);
    },
    disabled: disabled,
    style: styles
  }, /*#__PURE__*/React.createElement("span", {
    ref: labelRef
  }, label));
};
var defaultStyle$2 = function defaultStyle(_ref3) {
  var color = _ref3.color,
    padding = _ref3.padding,
    border = _ref3.border;
  return _objectSpread$I(_objectSpread$I({
    background: color.surface,
    display: 'inline-block',
    padding: padding.normal,
    width: '100%'
  }, border.hint), {}, {
    options: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'center'
    }
  });
};
var defaultOptionStyle = function defaultOptionStyle(_ref4) {
  var color = _ref4.color;
    _ref4.padding;
    var width = _ref4.width;
  return {
    color: color.coloredText.secondary,
    borderWidth: 0,
    justifyContent: 'center',
    width: width,
    ':hover': {
      backgroundColor: color.hover.base
    },
    ':focus': {
      backgroundColor: color.hover.base
    },
    ':active': {
      backgroundColor: color.active.secondary
    },
    ':active:hover': {
      backgroundColor: color.activeHover.secondary
    },
    ':active:focus': {
      backgroundColor: color.activeHover.secondary
    },
    '&active': {
      backgroundColor: color.active.secondary,
      ':hover': {
        backgroundColor: color.activeHover.secondary
      },
      ':focus': {
        backgroundColor: color.activeHover.secondary
      }
    },
    '&disabled': {
      color: color.text.disabled
    }
  };
};
var NavigationViewBase$1 = NavigationViewBase;var MonthNavigationView = function MonthNavigationView(_ref) {
  var selectedMonth = _ref.month,
    selectedYear = _ref.year,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    locale = _ref.locale,
    hideNavigation = _ref.hideNavigation,
    onChange = _ref.onChange,
    onNext = _ref.onNext,
    onPrev = _ref.onPrev,
    onYearClick = _ref.onYearClick,
    style = _ref.style;
  var months = useMemo(function () {
    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (monthIndex) {
      return {
        number: monthIndex,
        name: getMonthName(monthIndex, locale)
      };
    });
  }, [locale]);
  var isDisabled = function isDisabled(month) {
    var currentDate = new Date(selectedYear, month);
    var minRange = minDate && new Date(minDate.getFullYear(), minDate.getMonth(), 1);
    var maxRange = maxDate && new Date(maxDate.getFullYear(), maxDate.getMonth() + 1, 0);
    return isDateOutOfRange(currentDate, [minRange, maxRange]);
  };
  return /*#__PURE__*/React.createElement(NavigationViewBase$1, {
    header: hideNavigation ? null : /*#__PURE__*/React.createElement(NavigationHeader$1, {
      onNext: onNext,
      onPrev: onPrev,
      disablePrev: minDate ? selectedYear <= (minDate === null || minDate === void 0 ? void 0 : minDate.getFullYear()) : false,
      disableNext: maxDate ? selectedYear >= (maxDate === null || maxDate === void 0 ? void 0 : maxDate.getFullYear()) : false
    }, /*#__PURE__*/React.createElement(Button$4, {
      "data-testid": "date-picker-navigation-year",
      onClick: onYearClick
    }, selectedYear)),
    style: style
  }, months.map(function (_ref2) {
    var name = _ref2.name,
      number = _ref2.number;
    return /*#__PURE__*/React.createElement(NavigationViewOption, {
      key: name,
      value: number,
      label: name,
      disabled: isDisabled(number),
      active: number === selectedMonth,
      onClick: function onClick() {
        return onChange(number);
      },
      width: "30%"
    }, name);
  }));
};
var MonthNavigationView$1 = MonthNavigationView;var generateYearsList = function generateYearsList(from, to) {
  var years = [];
  for (var i = from; i <= to; i++) {
    years.push(i);
  }
  return years;
};
var YearNavigationView = function YearNavigationView(_ref) {
  var selectedYear = _ref.year,
    onChange = _ref.onChange,
    minYear = _ref.minYear,
    maxYear = _ref.maxYear,
    hideNavigation = _ref.hideNavigation,
    style = _ref.style;
  var page = getYearPage(selectedYear);
  var _useState = useState(page.from),
    _useState2 = _slicedToArray(_useState, 2),
    from = _useState2[0],
    setFrom = _useState2[1];
  var _useState3 = useState(page.to),
    _useState4 = _slicedToArray(_useState3, 2),
    to = _useState4[0],
    setTo = _useState4[1];
  var _useState5 = useState(generateYearsList(page.from, page.to)),
    _useState6 = _slicedToArray(_useState5, 2),
    years = _useState6[0],
    setYears = _useState6[1];
  useEffect(function () {
    var newPage = getYearPage(selectedYear);
    setFrom(newPage.from);
    setTo(newPage.to);
    setYears(generateYearsList(newPage.from, newPage.to));
  }, [selectedYear]);
  var onNext = function onNext() {
    var newFrom = to + 1;
    var newTo = to + 16;
    setFrom(newFrom);
    setTo(newTo);
    setYears(generateYearsList(newFrom, newTo));
  };
  var onPrev = function onPrev() {
    var newFrom = from - 16;
    var newTo = from - 1;
    setFrom(newFrom);
    setTo(newTo);
    setYears(generateYearsList(newFrom, newTo));
  };
  var isDisabled = function isDisabled(selectedYear) {
    return isDateOutOfRange(selectedYear, [minYear, maxYear]);
  };
  var onSelect = function onSelect(selectedYear) {
    if (!isDisabled(selectedYear)) {
      onChange(selectedYear);
    }
  };
  return /*#__PURE__*/React.createElement(NavigationViewBase$1, {
    header: hideNavigation ? null : /*#__PURE__*/React.createElement(NavigationHeader$1, {
      onNext: onNext,
      onPrev: onPrev,
      disablePrev: minYear ? from <= minYear : false,
      disableNext: maxYear ? to >= maxYear : false
    }, /*#__PURE__*/React.createElement(Button$4, {
      "data-testid": "date-picker-navigation-year",
      onClick: function onClick() {
        return onChange(selectedYear);
      }
    }, selectedYear)),
    style: style
  }, years.map(function (year) {
    return /*#__PURE__*/React.createElement(NavigationViewOption, {
      key: year,
      value: year,
      label: String(year),
      disabled: isDisabled(year),
      active: selectedYear === year,
      onClick: function onClick() {
        return onSelect(year);
      }
    }, year);
  }));
};
var YearNavigationView$1 = YearNavigationView;function ownKeys$H(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$H(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$H(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$H(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DatePicker$3 = function DatePicker(_ref) {
  var _getValidDate, _getValidDate2;
  var value = _ref.value,
    onChange = _ref.onChange,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? DEFAULT_LOCALE : _ref$locale;
    _ref.format;
    var minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$hideNavigation = _ref.hideNavigation,
    hideNavigation = _ref$hideNavigation === void 0 ? false : _ref$hideNavigation,
    _ref$autofocus = _ref.autofocus,
    autofocus = _ref$autofocus === void 0 ? true : _ref$autofocus,
    datePickerRef = _ref.datePickerRef,
    onRequestHideWidget = _ref.onRequestHideWidget,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames;
  var ref = useRef();
  var theme = useTheme();
  var styles = useStyles$1(defaultStyle$1(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {});
  var values = getTupleFromValue(value);
  var initialDate = getValidDate(values[0]) || new Date();
  var _useState = useState([CALENDAR_VIEW.DATE]),
    _useState2 = _slicedToArray(_useState, 2),
    viewHistory = _useState2[0],
    setViewHistory = _useState2[1];
  var _useState3 = useState(initialDate.getMonth()),
    _useState4 = _slicedToArray(_useState3, 2),
    month = _useState4[0],
    setMonth = _useState4[1];
  var _useState5 = useState(initialDate.getFullYear()),
    _useState6 = _slicedToArray(_useState5, 2),
    year = _useState6[0],
    setYear = _useState6[1];
  var goToPrevMonth = function goToPrevMonth() {
    if (month === 0) {
      setMonth(11);
      setYear(year - 1);
    } else {
      setMonth(month - 1);
    }
  };
  var goToNextMonth = function goToNextMonth() {
    if (month === 11) {
      setMonth(0);
      setYear(year + 1);
    } else {
      setMonth(month + 1);
    }
  };
  var historyPush = function historyPush(value) {
    setViewHistory([].concat(_toConsumableArray(viewHistory), [value]));
  };
  var historyPop = function historyPop() {
    var newHistory = _toConsumableArray(viewHistory);
    newHistory.pop();
    setViewHistory(newHistory);
  };
  var onDateSelection = function onDateSelection(selectedDate) {
    if (onChange) onChange(selectedDate);
    if (onRequestHideWidget) onRequestHideWidget();
  };
  var onMonthSelection = function onMonthSelection(selectedMonth) {
    setMonth(selectedMonth);
    historyPop();
  };
  var onYearSelection = function onYearSelection(selectedYear) {
    setYear(selectedYear);
    historyPop();
  };
  var view = viewHistory.length ? viewHistory[viewHistory.length - 1] : CALENDAR_VIEW.DATE;
  useEffect(function () {
    if (autofocus) {
      var _ref$current;
      var buttonElement = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector('button:not([disabled])');
      if (buttonElement) buttonElement.focus();
    }
  }, [autofocus]);
  return /*#__PURE__*/React.createElement("div", _extends({}, styles, {
    ref: datePickerRef
  }), /*#__PURE__*/React.createElement(TransitionGroup, null, view === CALENDAR_VIEW.DATE ? /*#__PURE__*/React.createElement(SlideAnimation, {
    right: true,
    timeout: 0,
    exit: false
  }, /*#__PURE__*/React.createElement("div", _extends({}, styles('viewContainer'), {
    ref: ref
  }), /*#__PURE__*/React.createElement(CalendarDateView$1, {
    locale: locale,
    value: values,
    onChange: onDateSelection,
    month: month,
    year: year,
    minDate: getValidDate(minDate),
    maxDate: getValidDate(maxDate),
    onPrev: goToPrevMonth,
    onNext: goToNextMonth,
    onMonthClick: function onMonthClick() {
      return historyPush(CALENDAR_VIEW.MONTH);
    },
    onYearClick: function onYearClick() {
      return historyPush(CALENDAR_VIEW.YEAR);
    },
    disabled: disabled,
    hideNavigation: hideNavigation
  }))) : null, view === CALENDAR_VIEW.MONTH ? /*#__PURE__*/React.createElement(SlideAnimation, {
    left: true,
    timeout: 0,
    exit: false
  }, /*#__PURE__*/React.createElement("div", styles('viewContainer'), /*#__PURE__*/React.createElement(MonthNavigationView$1, {
    locale: locale,
    month: month,
    year: year,
    minDate: getValidDate(minDate),
    maxDate: getValidDate(maxDate),
    onNext: function onNext() {
      return setYear(year + 1);
    },
    onPrev: function onPrev() {
      return setYear(year - 1);
    },
    onYearClick: function onYearClick() {
      return historyPush(CALENDAR_VIEW.YEAR);
    },
    onChange: onMonthSelection,
    hideNavigation: hideNavigation
  }))) : null, view === CALENDAR_VIEW.YEAR ? /*#__PURE__*/React.createElement(SlideAnimation, {
    left: true,
    timeout: 0,
    exit: false
  }, /*#__PURE__*/React.createElement("div", styles('viewContainer'), /*#__PURE__*/React.createElement(YearNavigationView$1, {
    year: year,
    minYear: (_getValidDate = getValidDate(minDate)) === null || _getValidDate === void 0 ? void 0 : _getValidDate.getFullYear(),
    maxYear: (_getValidDate2 = getValidDate(maxDate)) === null || _getValidDate2 === void 0 ? void 0 : _getValidDate2.getFullYear(),
    onChange: onYearSelection,
    hideNavigation: hideNavigation
  }))) : null));
};
var getTupleFromValue = function getTupleFromValue(value) {
  var values = Array.isArray(value) ? [value[0], value[1]] : [value, null];
  if (!values[0] || !values[1]) {
    return [values[0] || values[1], null];
  } else if (new Date(values[0]) > new Date(values[1])) {
    return [values[1], values[0]];
  }
  return values;
};
var CONTAINER_WIDTH = 320;
var defaultStyle$1 = function defaultStyle(theme) {
  return _objectSpread$H(_objectSpread$H({
    width: CONTAINER_WIDTH,
    background: theme.color.surface
  }, theme.border.hint), {}, {
    viewContainer: {
      width: CONTAINER_WIDTH
    }
  });
};
var DatePickerUnsealed = DatePicker$3;var hideValueIfNotNeeded = compose(withStateHandlers(function (_ref) {
  var autoFocus = _ref.autoFocus;
  return {
    hasFocus: autoFocus ? true : false
  };
}, {
  onFocus: function onFocus(_, _ref2) {
    var _onFocus = _ref2.onFocus;
    return function (event) {
      if (_onFocus) {
        _onFocus(event);
      }
      return {
        hasFocus: true
      };
    };
  },
  onBlur: function onBlur(_, _ref3) {
    var _onBlur = _ref3.onBlur;
    return function (event) {
      if (_onBlur) {
        _onBlur(event);
      }
      return {
        hasFocus: false
      };
    };
  }
}), createDefaultStyle({
  color: 'transparent',
  '&showNativeValue': {
    color: null
  }
}, function (_ref4) {
  var hasFocus = _ref4.hasFocus,
    value = _ref4.value;
  return {
    '&showNativeValue': hasFocus || !_isNil(value)
  };
}), omitProps(['hasFocus']));
var hideValueIfNotNeeded$1 = hideValueIfNotNeeded;var _excluded$X = ["locale"];
function ownKeys$G(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$G(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$G(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$G(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var mapLocaleToCulture = mapProps(function (_ref) {
  var locale = _ref.locale,
    rest = _objectWithoutProperties(_ref, _excluded$X);
  return _objectSpread$G(_objectSpread$G({}, rest), {}, {
    culture: locale
  });
});var _excluded$W = ["style"];
function ownKeys$F(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$F(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$F(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$F(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styled$x = createDefaultStyle(function (_ref) {
  var color = _ref.color;
    _ref.border;
  return _objectSpread$F(_objectSpread$F({}, styles.border(1, 'solid', color.mono.light)), styles.boxShadow());
});
var DatePicker$2 = styled$x(function (_ref2) {
  var style = _ref2.style,
    rest = _objectWithoutProperties(_ref2, _excluded$W);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement("div", merge$2(style, theme.border.hint), /*#__PURE__*/React.createElement(DatePickerUnsealed, rest));
});
var EnhancedDatePicker$1 = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(DatePicker$2, _extends({}, props, {
    datePickerRef: ref
  }));
});
var enhance$o = compose(labeled$2, styledAsInput$1, hideValueIfNotNeeded$1, mapLocaleToCulture, defaultProps({
  stickInline: true
}), omitProps(['isExpanded']));
var DateInputUnsealed = stickWidgetToInput(EnhancedDatePicker$1, enhance$o(Date$1));var enhance$n = compose(labeled$2, styledAsInput$1, hideValueIfNotNeeded$1, mapLocaleToCulture);
var TimeInputUnsealed = enhance$n(Time);var _excluded$V = ["style"];
function ownKeys$E(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$E(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$E(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$E(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styled$w = createDefaultStyle(function (_ref) {
  var color = _ref.color;
  return _objectSpread$E(_objectSpread$E({}, styles.border(1, 'solid', color.mono.light)), styles.boxShadow());
});
var DatePicker$1 = styled$w(function (_ref2) {
  var style = _ref2.style,
    rest = _objectWithoutProperties(_ref2, _excluded$V);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement("div", merge$2(style, theme.border.hint), /*#__PURE__*/React.createElement(DatePickerUnsealed, rest));
});
var EnhancedDatePicker = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(DatePicker$1, _extends({}, props, {
    datePickerRef: ref
  }));
});
var enhance$m = compose(labeled$2, styledAsInput$1, hideValueIfNotNeeded$1, mapLocaleToCulture, defaultProps({
  stickInline: true
}), omitProps(['isExpanded']));
var DateTimeInputUnsealed = stickWidgetToInput(EnhancedDatePicker, enhance$m(DateTime));var _excluded$U = ["icon", "children", "disabled", "ellipsis", "indeterminate", "inTile", "style", "className", "classNames", "onChange", "checked", "onBlur", "onFocus"];
function ownKeys$D(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$D(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$D(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$D(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SwitchBase = function SwitchBase(_ref) {
  var icon = _ref.icon,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    disabled = _ref.disabled,
    ellipsis = _ref.ellipsis,
    indeterminate = _ref.indeterminate,
    inTile = _ref.inTile,
    style = _ref.style,
    className = _ref.className,
    classNames = _ref.classNames,
    _onChange = _ref.onChange,
    checked = _ref.checked,
    _onBlur = _ref.onBlur,
    _onFocus = _ref.onFocus,
    rest = _objectWithoutProperties(_ref, _excluded$U);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var theme = useTheme();
  var styles = useStylesBase(defaultStyle(theme), {
    style: style,
    className: className,
    classNames: classNames
  }, {
    '&isFocused': !!isFocused,
    '&checked': !!checked,
    '&disabled': !!disabled,
    '&inTile': !!inTile,
    '&indeterminate': !!indeterminate
  });
  return /*#__PURE__*/React.createElement("label", styles, /*#__PURE__*/React.createElement(Glyph, _extends({}, styles('icon'), {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }), icon), /*#__PURE__*/React.createElement("input", _extends({}, rest, styles('input'), {
    checked: checked,
    disabled: disabled,
    indeterminate: indeterminate ? 'true' : 'false',
    onChange: function onChange(event) {
      if (!_onChange) {
        return;
      }
      _onChange(event.target.checked, event);
    },
    onFocus: function onFocus(event) {
      if (_onFocus) {
        _onFocus(event);
      }
      setIsFocused(true);
    },
    onBlur: function onBlur(event) {
      if (_onBlur) {
        _onBlur(event);
      }
      setIsFocused(false);
    }
  })), /*#__PURE__*/React.createElement(Body$2, {
    ellipsis: ellipsis,
    style: styles('label')
  }, children));
};
var defaultStyle = function defaultStyle(_ref2) {
  var spacing = _ref2.spacing,
    color = _ref2.color,
    border = _ref2.border;
  return {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    position: 'relative',
    input: {
      clip: 'rect(1px, 1px, 1px, 1px)',
      clipPath: 'inset(50%)',
      width: '100%',
      opacity: 0,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute'
    },
    icon: _objectSpread$D(_objectSpread$D({
      marginRight: spacing.xxsmall,
      paddingTop: spacing.xxxsmall,
      paddingRight: spacing.xxxsmall,
      paddingBottom: spacing.xxxsmall,
      paddingLeft: spacing.xxxsmall
    }, border.hint), {}, {
      lineHeight: 1,
      transition: 'background 150ms ease-in'
    }),
    ':hover': {
      '& i': {
        background: color.hover.base
      }
    },
    ':active': {
      '& i': {
        background: color.hover.base
      }
    },
    '&indeterminate': {
      icon: {
        color: color.primary.base
      }
    },
    '&isFocused': {
      icon: {
        background: color.hover.base
      }
    },
    '&disabled': {
      cursor: 'not-allowed',
      label: {
        color: color.text.disabled
      },
      icon: {
        color: color.text.disabled
      },
      '&checked': {
        icon: {
          color: color.text.disabled
        }
      },
      ':hover': {
        '& i': {
          background: 'none'
        }
      }
    },
    '&inTile': {
      width: 40,
      icon: {
        marginLeft: spacing.xxsmall
      }
    },
    '&checked': {
      icon: {
        color: color.primary.base
      },
      '& i': {
        background: 'red !important'
      }
    }
  };
};
var SwitchBase$1 = SwitchBase;var _excluded$T = ["checked", "indeterminate", "children"];
var getIcon$3 = function getIcon(checked, indeterminate) {
  if (!checked && indeterminate) {
    return 'checkbox-indeterminate';
  }
  if (checked) {
    return 'checkbox-true';
  }
  return 'checkbox-false';
};
var Checkbox$3 = function Checkbox(_ref) {
  var checked = _ref.checked,
    indeterminate = _ref.indeterminate,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$T);
  return /*#__PURE__*/React.createElement(SwitchBase$1, _extends({}, rest, {
    checked: checked,
    icon: getIcon$3(checked, indeterminate),
    type: "checkbox",
    indeterminate: indeterminate
  }), children);
};
var CheckboxUnsealed = Checkbox$3;var _excluded$S = ["children", "label", "hint", "description", "error", "required", "controls", "style", "hasFocus", "onFocus", "onBlur", "direction"];
var Group$3 = function Group(_ref) {
  var children = _ref.children,
    label = _ref.label,
    hint = _ref.hint,
    description = _ref.description,
    error = _ref.error,
    required = _ref.required,
    controls = _ref.controls,
    style = _ref.style,
    hasFocus = _ref.hasFocus,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    direction = _ref.direction;
    _objectWithoutProperties(_ref, _excluded$S);
  return /*#__PURE__*/React.createElement("fieldset", _extends({}, style, {
    onFocus: onFocus,
    onBlur: onBlur
  }), /*#__PURE__*/React.createElement("div", style('label'), /*#__PURE__*/React.createElement("legend", style('legend'), /*#__PURE__*/React.createElement(Label$3, {
    hasFocus: hasFocus,
    required: required
  }, label), description && /*#__PURE__*/React.createElement(Description, null, description)), controls && /*#__PURE__*/React.createElement("div", style('controls'), /*#__PURE__*/React.createElement(ListUnsealed, {
    direction: "horizontal"
  }, controls))), /*#__PURE__*/React.createElement(Stack, {
    direction: direction,
    spacing: "xxsmall",
    style: style('childrenList')
  }, children), /*#__PURE__*/React.createElement("div", style('messages'), /*#__PURE__*/React.createElement(Messages$1, {
    error: error,
    hint: hint
  })));
};
var enhance$l = compose(withStateHandlers({
  hasFocus: false
}, {
  onFocus: function onFocus() {
    return function () {
      return {
        hasFocus: true
      };
    };
  },
  onBlur: function onBlur() {
    return function () {
      return {
        hasFocus: false
      };
    };
  }
}), createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding,
    font = _ref2.font,
    lineHeight = _ref2.lineHeight,
    color = _ref2.color,
    spacing = _ref2.spacing;
  return {
    position: 'relative',
    paddingTop: padding.small,
    paddingBottom: padding.small,
    paddingLeft: 0,
    paddingRight: 0,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    borderWidth: 0,
    minWidth: 0,
    label: {},
    legend: {
      display: 'block',
      lineHeight: lineHeight,
      color: color.mono.ultradark,
      fontSize: font.size.button,
      padding: 0,
      margin: 0,
      marginBottom: spacing.xsmall
    },
    controls: {
      position: 'absolute',
      right: 0,
      marginTop: styles.inputPadding - padding.small,
      marginBottom: styles.inputPadding - padding.small
    },
    messages: {
      marginTop: spacing.xxxsmall
    },
    '&horizontal': {
      childrenList: {
        justifyContent: 'flex-start',
        flexWrap: 'wrap'
      }
    },
    '&disabled': {
      cursor: 'not-allowed',
      legend: {
        color: color.text.disabled
      }
    },
    '&labelIsLarge': {
      legend: {
        fontSize: font.size.large,
        fontWeight: font.weight.bold,
        marginBottom: spacing.small
      }
    }
  };
}, function (_ref3) {
  var required = _ref3.required,
    _ref3$direction = _ref3.direction,
    direction = _ref3$direction === void 0 ? 'vertical' : _ref3$direction,
    disabled = _ref3.disabled,
    labelIsLarge = _ref3.labelIsLarge;
  return _defineProperty({
    '&required': required,
    '&disabled': disabled,
    '&labelIsLarge': labelIsLarge
  }, "&".concat(direction), true);
}));
var SwitchGroupBase = enhance$l(Group$3);var _excluded$R = ["direction", "children", "value", "disabled", "onChange"];
function CheckboxGroup$1(_ref) {
  var direction = _ref.direction,
    children = _ref.children,
    value = _ref.value,
    disabled = _ref.disabled,
    _onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$R);
  var isControlled = !_isNil(value) || !_isNil(_onChange);
  return /*#__PURE__*/React.createElement(SwitchGroupBase, _extends({}, rest, {
    disabled: disabled,
    direction: direction
  }), Children.map(children, function (checkbox) {
    var isControlledCheckbox = !_isNil(checkbox.props.checked) || !_isNil(checkbox.props.onChange);
    if (isControlled && isControlledCheckbox) {
      warn('You are using <CheckboxGroup /> in a controlled manner but are also', 'passing value and/or onChange handlers to the individual <Checkbox />.', 'components. This can lead to undesired side-effects.');
    }
    return /*#__PURE__*/cloneElement(checkbox, {
      checked: checkbox.props.checked || _includes(value, checkbox.props.value),
      disabled: disabled ? disabled : checkbox.props.disabled,
      indeterminate: checkbox.props.indeterminate,
      ellipsis: checkbox.props.ellipsis,
      onChange: function onChange(checked, event) {
        if (checkbox.props.onChange) {
          checkbox.props.onChange(checked, event);
        }
        if (!_onChange) {
          return;
        }
        if (_includes(value, checkbox.props.value)) {
          _onChange(_without(value, checkbox.props.value), event);
        } else {
          _onChange([].concat(_toConsumableArray(value || []), [checkbox.props.value]), event);
        }
      }
    });
  }));
}var _excluded$Q = ["checked", "children"];
var RadioButton$1 = function RadioButton(_ref) {
  var checked = _ref.checked,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$Q);
  return /*#__PURE__*/React.createElement(SwitchBase$1, _extends({}, rest, {
    checked: checked,
    icon: "radio-button-".concat(checked ? 'true' : 'false'),
    type: "radio"
  }), children);
};
var RadioButtonUnsealed = RadioButton$1;var _excluded$P = ["direction", "children", "value", "disabled", "name", "uniqueName", "onChange", "style"];
var RadioGroup$1 = function RadioGroup(_ref) {
  var direction = _ref.direction,
    children = _ref.children,
    value = _ref.value,
    disabled = _ref.disabled,
    name = _ref.name,
    uniqueName = _ref.uniqueName,
    _onChange = _ref.onChange;
    _ref.style;
    var rest = _objectWithoutProperties(_ref, _excluded$P);
  return /*#__PURE__*/React.createElement(SwitchGroupBase, _extends({}, rest, {
    disabled: disabled,
    direction: direction
  }), Children.map(children, function (child) {
    return /*#__PURE__*/cloneElement(child, {
      name: name || uniqueName,
      checked: value === child.props.value,
      disabled: disabled ? disabled : child.props.disabled,
      ellipsis: child.props.ellipsis,
      onChange: function onChange(checked, event) {
        return checked && _onChange && _onChange(child.props.value, event);
      }
    });
  }));
};
var enhance$k = compose(withState('uniqueName', 'setUniqueName', function () {
  return _uniqueId('radio-group-');
}), omitProps(['setUniqueName']));
var RadioGroupUnsealed = enhance$k(RadioGroup$1);var _excluded$O = ["style", "progress", "active"];
function ownKeys$C(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$C(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$C(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$C(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ProgressBar$1 = function ProgressBar(_ref) {
  var style = _ref.style,
    progress = _ref.progress,
    active = _ref.active,
    rest = _objectWithoutProperties(_ref, _excluded$O);
  return /*#__PURE__*/React.createElement("div", _extends({}, style, {
    title: "".concat(Math.round(progress), "%")
  }, rest), /*#__PURE__*/React.createElement("div", styles.merge(style('bar'), {
    width: "".concat(progress, "%"),
    backgroundColor: useBaseColor()
  }), active && /*#__PURE__*/React.createElement("div", style('stripes'))));
};
var styled$v = createDefaultStyle(function (_ref2) {
  var font = _ref2.font,
    padding = _ref2.padding,
    lineHeight = _ref2.lineHeight;
    _ref2.color;
  return {
    position: 'relative',
    height: styles.calculateHeight(font.size.normal, lineHeight, padding.small),
    bar: _objectSpread$C({
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%'
    }, styles.transition('width')),
    stripes: {
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      backgroundImage: 'linear-gradient(45deg, ' + 'rgba(255, 255, 255, 0.15) 25%, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0) 50%, ' + 'rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, rgba(0, 0, 0, 0) 75%, ' + 'rgba(0, 0, 0, 0))',
      backgroundSize: '40px 40px',
      animationName: 'signavio-ui-progress-bar-stripes',
      animationDuration: '1s',
      animationIterationCount: 'infinite',
      animationDirection: 'none',
      animationTimingFunction: 'linear',
      position: 'absolute'
    }
  };
});
var ProgressBarUnsealed = styled$v(ProgressBar$1);var _excluded$N = ["children", "style", "activeChildren"];
function ownKeys$B(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$B(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$B(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$B(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DropZone$1 = function DropZone(_ref) {
  var children = _ref.children,
    style = _ref.style,
    activeChildren = _ref.activeChildren,
    rest = _objectWithoutProperties(_ref, _excluded$N);
  return /*#__PURE__*/React.createElement(DropZone$2, _extends({
    style: style
  }, rest, {
    activeChildren: /*#__PURE__*/React.createElement("div", style('activeChildrenWrapper'), /*#__PURE__*/React.createElement("div", style('activeArea')), activeChildren)
  }), children);
};
var styled$u = createDefaultStyle(function (_ref2) {
  var color = _ref2.color;
  return {
    position: 'relative',
    activeArea: _objectSpread$B({
      zIndex: -1,
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    }, styles.border(3, 'dashed', color.primary.light))
  };
});
var DropZoneUnsealed = styled$u(DropZone$1);function Avatar$1(props) {
  var style = props.style,
    small = props.small;
  if (props.color) {
    return /*#__PURE__*/React.createElement("div", _extends({}, _omit(props, 'style', 'small', 'color'), styles.merge(style, {
      color: styles.color(props.color),
      backgroundColor: props.color
    })), props.children);
  }
  if (props.pictureUrl) {
    return /*#__PURE__*/React.createElement("div", _extends({}, _omit(props, 'style', 'small', 'pictureUrl'), style), /*#__PURE__*/React.createElement("img", _extends({}, style('content'), {
      width: small ? size.small : size.normal,
      alt: "",
      src: props.pictureUrl
    })));
  }
  throw new Error('To show an avatar you must either specify a color to use or link to an image.');
}
var size = {
  small: 26,
  normal: 40
};
var enhance$j = createDefaultStyle(function (_ref) {
  var font = _ref.font;
  return {
    position: 'relative',
    display: 'block',
    overflow: 'hidden',
    zIndex: 0,
    width: size.normal,
    height: size.normal,
    borderRadius: '50%',
    '&text': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: font.size.normal,
      userSelect: 'none',
      overflow: 'hidden'
    },
    '&small': {
      width: size.small,
      height: size.small,
      '&text': {
        fontSize: font.size.small
      }
    }
  };
}, function (props) {
  return {
    '&text': props.color ? true : false,
    '&small': props.small
  };
});
var AvatarUnsealed = enhance$j(Avatar$1);var _excluded$M = ["children"];
function FileSelectDropZone(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$M);
  if (rest.multiple) {
    var _value = rest.value,
      _onChange = rest.onChange;
    return /*#__PURE__*/React.createElement(DropZoneUnsealed, {
      onDrop: function onDrop(files) {
        var newValue = _uniqBy([].concat(_toConsumableArray(_value || []), _toConsumableArray(files)), function (file) {
          return "".concat(file.name, "_").concat(file.size, "_").concat(file.lastModified);
        });
        _onChange(newValue);
      }
    }, children);
  }
  var onChange = rest.onChange;
  return /*#__PURE__*/React.createElement(DropZoneUnsealed, {
    onDrop: function onDrop(files) {
      onChange(files[0]);
    }
  }, children);
}var _excluded$L = ["value", "multiple", "onChange"];
function ownKeys$A(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$A(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$A(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$A(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var wrapOnChangeToAppendToValue = function wrapOnChangeToAppendToValue(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  return function (newFiles) {
    onChange(_uniqBy([].concat(_toConsumableArray(value || []), _toConsumableArray(newFiles || [])), function (file) {
      return "".concat(file.name, "_").concat(file.size, "_").concat(file.lastModified);
    }));
  };
};
var FileSelectOpener = compose(mapProps(function (_ref2) {
  var value = _ref2.value,
    multiple = _ref2.multiple,
    onChange = _ref2.onChange,
    rest = _objectWithoutProperties(_ref2, _excluded$L);
  return _objectSpread$A(_objectSpread$A({}, rest), {}, {
    value: value,
    multiple: multiple,
    onChange: multiple ? wrapOnChangeToAppendToValue({
      value: value,
      onChange: onChange
    }) : onChange
  });
}))(File);var readFile = function readFile(file, done) {
  var reader = new FileReader();
  reader.onload = function (event) {
    invariant(event.target instanceof FileReader, 'The target of the load event must be a FileReader.');
    invariant(typeof event.target.result === 'string', "Expected FileReader result to be a \"string\" but was \"".concat(_typeof(event.target.result), "\""));
    done(event.target.result);
  };
  reader.readAsDataURL(file);
};
var determineDimensions = function determineDimensions(src, done) {
  var img = new Image();
  img.onload = function () {
    done({
      width: img.width,
      height: img.height
    });
  };
  img.src = src;
};
var ImagePreview = function ImagePreview(_ref) {
  var file = _ref.file,
    src = _ref.src,
    small = _ref.small,
    style = _ref.style;
  return /*#__PURE__*/React.createElement(PopoverUnsealed, {
    popover: src ? /*#__PURE__*/React.createElement("img", _extends({
      src: src,
      alt: file.name
    }, style('imgLarge'))) : /*#__PURE__*/React.createElement(SpinnerUnsealed, null),
    style: style
  }, src ? /*#__PURE__*/React.createElement("img", _extends({
    src: src,
    alt: file.name
  }, style('img'))) : /*#__PURE__*/React.createElement(SpinnerUnsealed, {
    small: small
  }));
};
var ImagePreview$1 = compose(setDisplayName('ImagePreview'), withState('src', 'setSrc'), withState('dimensions', 'setDimensions', {}), lifecycle({
  componentDidMount: function componentDidMount() {
    readFile(this.props.file, this.props.setSrc);
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (prevProps.file !== this.props.file) {
      this.props.setSrc(null);
      this.props.setDimensions({});
      readFile(this.props.file, this.props.setSrc);
    }
    if (prevProps.src !== this.props.src) {
      determineDimensions(this.props.src, this.props.setDimensions);
    }
  }
}), createDefaultStyle(function (theme) {
  var size = styles.calculateIconSize(theme);
  var smallSize = styles.calculateSmallIconSize(theme);
  return {
    overflow: 'hidden',
    width: size,
    height: size,
    cursor: 'zoom-in',
    img: {
      display: 'block',
      position: 'relative',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    '&small': {
      width: smallSize,
      height: smallSize
    },
    '&landscape': {
      img: {
        width: 'auto',
        maxHeight: '100%'
      },
      imgLarge: {
        display: 'block',
        maxWidth: 320,
        height: 'auto'
      }
    },
    '&portrait': {
      img: {
        maxWidth: '100%',
        height: 'auto'
      },
      imgLarge: {
        display: 'block',
        maxHeight: 320,
        width: 'auto'
      }
    }
  };
}, function (_ref2) {
  var small = _ref2.small,
    _ref2$dimensions = _ref2.dimensions,
    width = _ref2$dimensions.width,
    height = _ref2$dimensions.height;
  return {
    '&small': small,
    '&landscape': width >= height,
    '&portrait': height > width
  };
}))(ImagePreview);var getExtension = function getExtension(fileName) {
  if (!fileName) {
    return null;
  }
  var i = fileName.lastIndexOf('.');
  if (i === -1) {
    return null;
  }
  return fileName.substring(i + 1) || null;
};
var getReadableSize$1 = function getReadableSize(size) {
  if (!size) {
    return '';
  }
  if (size < 1024 * 1024) {
    return "".concat(Math.round(size / 1024), " kb");
  }
  return "".concat(Math.round(size / (1024 * 1024)), " mb");
};
var isImage$1 = function isImage() {
  var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return startsWith(contentType, 'image');
};
var isText = function isText() {
  var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return startsWith(contentType, 'text');
};
var isVideo = function isVideo() {
  var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return startsWith(contentType, 'video');
};
var isAudio = function isAudio() {
  var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return startsWith(contentType, 'audio');
};
var isPdf = function isPdf() {
  var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return startsWith(contentType, 'application/pdf');
};
var isWord = function isWord() {
  var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return startsWith(contentType, 'application/msword') || startsWith(contentType, 'application/vnd.ms-word') || startsWith(contentType, 'application/vnd.openxmlformats-officedocument.wordprocessingml');
};
var isExcel = function isExcel() {
  var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return startsWith(contentType, 'application/vnd.ms-excel') || startsWith(contentType, 'application/vnd.openxmlformats-officedocument.spreadsheetml');
};
var isGoogleSpreadsheet = function isGoogleSpreadsheet() {
  var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return startsWith(contentType, 'application/vnd.google-apps.spreadsheet');
};
var isSpreadsheet = function isSpreadsheet() {
  var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return isExcel(contentType) || isGoogleSpreadsheet(contentType);
};
var isPowerPoint = function isPowerPoint() {
  var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return startsWith(contentType, 'application/vnd.ms-powerpoint') || startsWith(contentType, 'application/vnd.openxmlformats-officedocument.presentationml');
};
var isXml = function isXml() {
  var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return !!contentType.match(/(text|application)\/(.*\+)?xml/) || _includes(['xml', 'html', 'xhtml', 'wsdl'], getExtension(name));
};
var isArchive = function isArchive(contentType) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return _includes(['zip', 'rar', 'gz', 'tgz', 'tar', 'ace', '7z', 'bz2'], getExtension(name));
};
var isFolder = function isFolder() {
  var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return startsWith(contentType, 'application/vnd.google-apps.folder') || startsWith(contentType, 'application/vnd.box.folder');
};
var getIcon$2 = function getIcon() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    type = _ref.type,
    name = _ref.name;
  if (isImage$1(type, name)) {
    return 'file-picture';
  }

  // if (isVideo(type, name)) {
  //   return 'file-video'
  // }

  // if (isAudio(type, name)) {
  //   return 'file-audio'
  // }

  if (isPdf(type, name)) {
    return 'adobe-pdf';
  }
  if (isWord(type, name)) {
    return 'microsoft-word';
  }
  if (isSpreadsheet(type, name)) {
    return 'microsoft-excel';
  }
  if (isPowerPoint(type, name)) {
    return 'microsoft-powerpoint';
  }

  // if (isXml(type, name)) {
  //   return 'file-code'
  // }

  if (isArchive(type, name)) {
    return 'file-archive';
  }

  // text should be checked after XML as text/xml will also be positive for text
  // if (isText(type, name)) {
  //   return 'file-text'
  // }

  if (isFolder(type, name)) {
    return 'folder';
  }
  return 'file';
};var fileUtils=/*#__PURE__*/Object.freeze({__proto__:null,getReadableSize:getReadableSize$1,isImage:isImage$1,isText:isText,isVideo:isVideo,isAudio:isAudio,isPdf:isPdf,isWord:isWord,isExcel:isExcel,isGoogleSpreadsheet:isGoogleSpreadsheet,isSpreadsheet:isSpreadsheet,isPowerPoint:isPowerPoint,isXml:isXml,isArchive:isArchive,isFolder:isFolder,getIcon:getIcon$2});var FileTile$4 = function FileTile(_ref) {
  var file = _ref.file,
    style = _ref.style,
    toolbar = _ref.toolbar;
  return /*#__PURE__*/React.createElement(TextTileUnsealed, {
    small: true,
    transparent: true,
    toolbar: toolbar && /*#__PURE__*/React.createElement("div", style('toolbar'), toolbar),
    header: isImage$1(file.type) ? /*#__PURE__*/React.createElement(ImagePreview$1, {
      file: file,
      small: true
    }) : /*#__PURE__*/React.createElement(Glyph, null, getIcon$2(file))
  }, file.name, /*#__PURE__*/React.createElement("span", style('fileSize'), getReadableSize$1(file.size)));
};
var styled$t = createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding,
    font = _ref2.font,
    color = _ref2.color;
  return {
    toolbar: {
      paddingLeft: padding.normal
    },
    fileSize: {
      fontSize: font.size.small,
      color: color.mono.middle,
      paddingLeft: padding.small
    }
  };
});
var FileTile$5 = styled$t(FileTile$4);var Placeholder = function Placeholder(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(TextTileUnsealed, {
    small: true,
    transparent: true,
    header: /*#__PURE__*/React.createElement(Glyph, null, "file-attachment")
  }, children);
};
var Placeholder$1 = Placeholder;var _excluded$K = ["floatingLabelFixed"];
function ownKeys$z(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$z(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$z(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$z(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function FileInput$1(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    style = _ref.style,
    inputRef = _ref.inputRef,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  if (disabled) {
    return /*#__PURE__*/React.createElement("div", style, value ? /*#__PURE__*/React.createElement(FileTile$5, {
      file: value
    }) : /*#__PURE__*/React.createElement(Placeholder$1, null, placeholder || ''));
  }
  invariant(onChange, 'A non-disabled file input must specify an onChange handler.');
  return /*#__PURE__*/React.createElement(FileSelectDropZone, {
    onChange: onChange
  }, /*#__PURE__*/React.createElement(FileSelectOpener, {
    disabled: disabled,
    value: value,
    onChange: onChange,
    inputRef: inputRef
  }, /*#__PURE__*/React.createElement("div", style, value ? /*#__PURE__*/React.createElement(FileTile$5, {
    file: value
  }) : /*#__PURE__*/React.createElement(Placeholder$1, null, placeholder || ''))));
}
var enhance$i = compose(mapProps(function (_ref2) {
  var floatingLabelFixed = _ref2.floatingLabelFixed,
    rest = _objectWithoutProperties(_ref2, _excluded$K);
  return _objectSpread$z(_objectSpread$z({}, rest), {}, {
    floatingLabelFixed: floatingLabelFixed === undefined ? true : floatingLabelFixed
  });
}), labeled$2, createDefaultStyle({
  cursor: 'pointer',
  '&disabled': {
    opacity: 0.8,
    cursor: 'default'
  }
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return {
    '&disabled': disabled
  };
}));
var FileInputUnsealed = enhance$i(FileInput$1);function ownKeys$y(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$y(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$y(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$y(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SortableDragHandle = SortableHandle(DragHandleUnsealed);
function Item$2(_ref) {
  var style = _ref.style,
    sortable = _ref.sortable,
    renderItem = _ref.renderItem,
    asRow = _ref.asRow,
    value = _ref.value,
    transparent = _ref.transparent,
    onRemove = _ref.onRemove;
  return /*#__PURE__*/React.createElement("div", style, /*#__PURE__*/React.createElement("div", style('wrapper'), /*#__PURE__*/React.createElement(Tile$2, {
    transparent: transparent || !asRow,
    small: !asRow,
    header: sortable ? /*#__PURE__*/React.createElement(SortableDragHandle, {
      small: !asRow,
      dragging: false
    }) : null,
    toolbar: /*#__PURE__*/React.createElement(ContainedIconButton$2, {
      tabIndex: -1,
      icon: "reset",
      onClick: function onClick(ev) {
        // prevent open of file select
        ev.stopPropagation();
        ev.preventDefault();
        onRemove();
      }
    })
  }, renderItem ? renderItem({
    value: value
  }) : /*#__PURE__*/React.createElement("div", style('valueWrapper'), value))));
}
var enhance$h = compose(branch(function (_ref2) {
  var sortable = _ref2.sortable;
  return !!sortable;
}, SortableElement), createDefaultStyle(function (_ref3) {
  var padding = _ref3.padding,
    color = _ref3.color;
  return {
    paddingTop: padding.small / 2,
    paddingBottom: padding.small / 2,
    paddingLeft: padding.small / 2,
    paddingRight: padding.small / 2,
    maxWidth: '100%',
    '&asRow': {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      marginBottom: 1
    },
    '&notAsRow': {
      wrapper: _objectSpread$y(_objectSpread$y({
        backgroundColor: 'white'
      }, styles.boxShadow()), styles.border(1, 'solid', color.mono.light)),
      valueWrapper: {
        whiteSpace: 'nowrap'
      }
    }
  };
}, function (_ref4) {
  var asRow = _ref4.asRow;
  return {
    '&asRow': asRow,
    '&notAsRow': !asRow
  };
}));
var Item$3 = enhance$h(Item$2);var Items = function Items(_ref) {
  var style = _ref.style,
    onChange = _ref.onChange,
    value = _ref.value,
    sortable = _ref.sortable,
    asRows = _ref.asRows,
    renderItem = _ref.renderItem,
    getItemKey = _ref.getItemKey,
    allowDuplicates = _ref.allowDuplicates;
  return /*#__PURE__*/React.createElement("div", style, value.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Item$3, {
      asRow: asRows,
      key: getItemKey ? getItemKey(item, index) : "".concat(JSON.stringify(item), "_").concat(allowDuplicates ? index : ''),
      sortable: sortable,
      value: item,
      index: index,
      renderItem: renderItem,
      onRemove: function onRemove() {
        onChange([].concat(_toConsumableArray(value.slice(0, index)), _toConsumableArray(value.slice(index + 1))));
      }
    });
  }), !asRows ? /*#__PURE__*/React.createElement("div", {
    style: {
      clear: 'left'
    }
  }) : null);
};
var enhanceAsSortable = compose(withProps(function (_ref2) {
  var asRows = _ref2.asRows,
    sortableHelperContainer = _ref2.sortableHelperContainer;
  return {
    axis: asRows ? 'y' : 'xy',
    lockAxis: asRows ? 'y' : 'xy',
    useDragHandle: true,
    helperContainer: sortableHelperContainer
  };
}), withHandlers({
  onSortEnd: function onSortEnd(_ref3) {
    var value = _ref3.value,
      onChange = _ref3.onChange;
    return function (_ref4) {
      var oldIndex = _ref4.oldIndex,
        newIndex = _ref4.newIndex;
      onChange(arrayMove(value, oldIndex, newIndex));
    };
  }
}), SortableContainer);
var enhance$g = compose(branch(function (_ref5) {
  var sortable = _ref5.sortable;
  return !!sortable;
}, enhanceAsSortable), createDefaultStyle(function (_ref6) {
  var padding = _ref6.padding;
    _ref6.font;
    _ref6.lineHeight;
  return {
    display: 'flex',
    flexWrap: 'wrap',
    paddingTop: styles.inputPadding,
    paddingBottom: styles.inputPadding,
    marginLeft: -padding.small / 2,
    marginRight: -padding.small / 2,
    marginBottom: -padding.small / 2,
    '&asRows': {
      display: null,
      flexWrap: null,
      marginLeft: 0,
      marginRight: 0,
      marginBottom: 0
    }
  };
}, function (_ref7) {
  var asRows = _ref7.asRows;
  return {
    '&asRows': asRows
  };
}));
var Items$1 = enhance$g(Items);var _excluded$J = ["value", "onChange", "placeholder", "nextLabel", "allowDuplicates", "autoFocus", "style"],
  _excluded2$5 = ["value"];
function ownKeys$x(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$x(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$x(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$x(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var resolveConfig = function resolveConfig(config, props) {
  return typeof config === 'function' ? config(props) : config || {};
};
var multiValue = function multiValue(config) {
  return function (WrappedInput) {
    var MultiValueInput = /*#__PURE__*/function (_Component) {
      _inherits(MultiValueInput, _Component);
      var _super = _createSuper$7(MultiValueInput);
      function MultiValueInput() {
        var _this;
        _classCallCheck(this, MultiValueInput);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "nextItemValue", void 0);
        _defineProperty(_assertThisInitialized(_this), "state", {
          nextItemValue: null,
          autoFocusNextInput: false,
          nextInputKey: 0,
          sortableHelperContainer: null
        });
        _defineProperty(_assertThisInitialized(_this), "setSortableHelperContainer", function (element) {
          _this.setState({
            sortableHelperContainer: element
          });
        });
        _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (ev) {
          if (ev.keyCode === 13) {
            // Enter pressed
            _this.handleAdd();
          }
        });
        _defineProperty(_assertThisInitialized(_this), "handleAdd", function () {
          var _this$props = _this.props,
            value = _this$props.value,
            allowDuplicates = _this$props.allowDuplicates,
            onChange = _this$props.onChange;
          var _resolveConfig = resolveConfig(config, _this.props),
            flatten = _resolveConfig.flatten,
            dontRefocus = _resolveConfig.dontRefocus;
          if (isClear$1(_this.nextItemValue) || !allowDuplicates && value && value.indexOf(_this.nextItemValue) >= 0) {
            return;
          }
          if (onChange) {
            onChange(flatten ? [].concat(_toConsumableArray(value || []), _toConsumableArray(_this.nextItemValue.filter(function (item) {
              return allowDuplicates || !value || value.indexOf(item) === -1;
            }))) : [].concat(_toConsumableArray(value || []), [_this.nextItemValue]));
          }
          _this.nextItemValue = null;
          _this.setState({
            nextItemValue: null,
            autoFocusNextInput: !dontRefocus,
            nextInputKey: _this.state.nextInputKey + 1
          });
        });
        _defineProperty(_assertThisInitialized(_this), "handleChange", function (nextItemValue) {
          // Store as instance member so that we will have the latest value available in handleAdd ...
          _this.nextItemValue = nextItemValue;
          // ... and also in state to trigger re-render.
          _this.setState({
            nextItemValue: nextItemValue
          });
          var _resolveConfig2 = resolveConfig(config, _this.props),
            addOnChange = _resolveConfig2.addOnChange;
          if (addOnChange) {
            _this.handleAdd();
          }
        });
        return _this;
      }
      _createClass(MultiValueInput, [{
        key: "render",
        value: function render() {
          var _resolveConfig3 = resolveConfig(config, this.props),
            addOnEnter = _resolveConfig3.addOnEnter,
            addOnChange = _resolveConfig3.addOnChange,
            sortable = _resolveConfig3.sortable,
            itemsAsRows = _resolveConfig3.itemsAsRows,
            renderItem = _resolveConfig3.renderItem,
            getItemKey = _resolveConfig3.getItemKey;
          var _this$props2 = this.props,
            value = _this$props2.value,
            onChange = _this$props2.onChange,
            placeholder = _this$props2.placeholder,
            nextLabel = _this$props2.nextLabel,
            allowDuplicates = _this$props2.allowDuplicates,
            autoFocus = _this$props2.autoFocus,
            style = _this$props2.style,
            rest = _objectWithoutProperties(_this$props2, _excluded$J);
          return /*#__PURE__*/React.createElement("div", _extends({}, style, {
            ref: this.setSortableHelperContainer
          }), value && this.state.sortableHelperContainer && /*#__PURE__*/React.createElement(Items$1, {
            allowDuplicates: allowDuplicates,
            sortable: sortable,
            value: value,
            asRows: itemsAsRows,
            renderItem: renderItem,
            getItemKey: getItemKey,
            onChange: onChange,
            sortableHelperContainer: this.state.sortableHelperContainer
          }), /*#__PURE__*/React.createElement("div", style('inputWrapper'), /*#__PURE__*/React.createElement(WrappedInput, _extends({
            dontFloatLabel: true,
            key: this.state.nextInputKey // force remount after adding items
            // Please fix me
            // eslint-disable-next-line jsx-a11y/no-autofocus
            ,
            autoFocus: autoFocus || this.state.autoFocusNextInput,
            value: this.state.nextItemValue,
            onChange: this.handleChange,
            onKeyDown: addOnEnter ? this.handleKeyDown : null,
            label: !isClear$1(value) ? nextLabel : undefined,
            placeholder: placeholder,
            controls: !addOnChange ? /*#__PURE__*/React.createElement(ContainedIconButton$2, {
              disabled: isClear$1(this.state.nextItemValue),
              icon: "add",
              onClick: this.handleAdd
            }) : null
          }, rest))));
        }
      }]);
      return MultiValueInput;
    }(Component);
    var enhance = compose(mapProps(function (_ref) {
      var value = _ref.value,
        rest = _objectWithoutProperties(_ref, _excluded2$5);
      return _objectSpread$x({
        // map empty arry to null so that the label does not float in that case
        value: value && value.length === 0 ? null : value,
        // don't show own bar, as there's already the one of the WrappedInput
        bar: null
      }, rest);
    }), labeled$2, createDefaultStyle(function (_ref2) {
      var padding = _ref2.padding;
        _ref2.font;
        _ref2.lineHeight;
        _ref2.color;
      return {
        inputWrapper: {
          // negative margin to cancel out the wrapped input's Field element
          marginBottom: -padding.small,
          marginTop: -padding.small
        }
      };
    }));
    return enhance(MultiValueInput);
  };
};
var multiValue$1 = multiValue;var FileMultiInput$1 = function FileMultiInput(_ref) {
  var placeholder = _ref.placeholder;
    _ref.style;
    var value = _ref.value,
    onChange = _ref.onChange;
    _ref.accept;
  return /*#__PURE__*/React.createElement(FileSelectDropZone, {
    multiple: true,
    value: value,
    onChange: onChange
  }, /*#__PURE__*/React.createElement(FileSelectOpener, {
    value: value,
    onChange: onChange,
    multiple: true
  }, /*#__PURE__*/React.createElement(Placeholder$1, null, placeholder)));
};
var FileMultiInputUnsealed = compose(withProps({
  floatingLabelFixed: true
}), multiValue$1(function (_ref2) {
  _ref2.children;
  return {
    addOnChange: true,
    flatten: true,
    dontRefocus: true,
    renderItem: function renderItem(_ref3) {
      var value = _ref3.value;
      return /*#__PURE__*/React.createElement(FileTile$5, {
        file: value
      });
    },
    getItemKey: function getItemKey(item, index) {
      return "".concat(item.name, "_").concat(item.size, "_").concat(index);
    }
  };
}), withProps({
  floatingLabelFixed: true
}), labeled$2)(FileMultiInput$1);var FileTile$2 = function FileTile(_ref) {
  var file = _ref.file,
    small = _ref.small,
    noPreview = _ref.noPreview,
    toolbar = _ref.toolbar;
  return /*#__PURE__*/React.createElement(TextTileUnsealed, {
    small: small,
    header: isImage$1(file.type) && !noPreview ? /*#__PURE__*/React.createElement(ImagePreview$1, {
      file: file,
      small: small
    }) : /*#__PURE__*/React.createElement(Icon$2, {
      icon: getIcon$2(file),
      small: small,
      block: true
    }),
    subtitle: getReadableSize$1(file.size),
    toolbar: toolbar
  }, file.name);
};
var FileTile$3 = FileTile$2;var FileSelectMulti$2 = function FileSelectMulti(_ref) {
  var children = _ref.children,
    value = _ref.value,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Fragment, null, value && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 1
    }
  }, /*#__PURE__*/React.createElement(ListUnsealed, null, value.map(function (item, index) {
    return /*#__PURE__*/React.createElement(FileTile$3, {
      key: "".concat(item.name, "_").concat(item.size, "_").concat(index),
      file: item,
      toolbar: /*#__PURE__*/React.createElement(ContainedIconButton$2, {
        icon: "reset",
        onClick: function onClick(ev) {
          // prevent open of file select
          ev.stopPropagation();
          ev.preventDefault();
          onChange([].concat(_toConsumableArray(value.slice(0, index)), _toConsumableArray(value.slice(index + 1))), ev);
        }
      })
    });
  }))), /*#__PURE__*/React.createElement(FileSelectOpener, {
    value: value,
    onChange: onChange,
    multiple: true
  }, children));
};
var FileSelectMulti$3 = FileSelectMulti$2;var FileSelectSingle$2 = function FileSelectSingle(_ref) {
  var children = _ref.children,
    value = _ref.value,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(FileSelectOpener, {
    value: value,
    onChange: onChange
  }, value ? /*#__PURE__*/React.createElement(FileTile$3, {
    file: value
  }) : children);
};
var FileSelectSingle$3 = FileSelectSingle$2;var _excluded$I = ["primary", "children", "small"];
var FileSelect$3 = function FileSelect(_ref) {
  var primary = _ref.primary,
    children = _ref.children,
    small = _ref.small,
    rest = _objectWithoutProperties(_ref, _excluded$I);
  var ButtonComponent = primary ? Button$6 : Button$7;
  var button = !children || _isString(children) ? /*#__PURE__*/React.createElement(ButtonComponent, {
    block: true,
    icon: "file-upload",
    small: small,
    onClick: noop
  }, children) : children;
  if (rest.multiple) {
    var _value = rest.value,
      _onChange = rest.onChange;
    return /*#__PURE__*/React.createElement(FileSelectDropZone, {
      multiple: true,
      value: _value || [],
      onChange: _onChange
    }, /*#__PURE__*/React.createElement(FileSelectMulti$3, rest, button));
  }
  var onChange = rest.onChange;
  return /*#__PURE__*/React.createElement(FileSelectDropZone, {
    onChange: onChange
  }, /*#__PURE__*/React.createElement(FileSelectSingle$3, rest, button));
};
var noop = function noop() {};
var FileSelectUnsealed = FileSelect$3;function ownKeys$w(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$w(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$w(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$w(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Color$1 = function Color(_ref) {
  var color = _ref.color,
    onClick = _ref.onClick,
    style = _ref.style;
  return (
    /*#__PURE__*/
    // Please fix me
    // jsx-a11y/click-events-have-key-events jsx-a11y/interactive-supports-focus
    // eslint-disable-next-line
    React.createElement("div", _extends({}, style, {
      role: "button",
      onClick: onClick,
      title: color
    }))
  );
};
var styled$s = createDefaultStyle(function (theme, _ref2) {
  var color = _ref2.color,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? 25 : _ref2$width,
    _ref2$height = _ref2.height,
    height = _ref2$height === void 0 ? 25 : _ref2$height;
  return {
    background: color,
    cursor: 'pointer',
    float: 'left',
    height: height,
    width: width,
    ':active': _objectSpread$w({
      outline: 'none'
    }, styles.boxShadowInset()),
    ':focus': {
      outline: 'none'
    },
    ':hover': _objectSpread$w({
      position: 'relative',
      zIndex: theme.zIndex.dropdown,
      outline: '2px solid #fff'
    }, styles.boxShadowInset())
  };
});
var enhance$f = compose(withHandlers({
  onClick: function onClick(_ref3) {
    var color = _ref3.color,
      onSelect = _ref3.onSelect;
    return function () {
      return _isFunction(onSelect) && onSelect(color);
    };
  }
}), styled$s);
var Color$2 = enhance$f(Color$1);var _excluded$H = ["style", "value"];
function ownKeys$v(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$v(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$v(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$v(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SimpleColorInput$2 = function SimpleColorInput(_ref) {
  var style = _ref.style,
    value = _ref.value,
    rest = _objectWithoutProperties(_ref, _excluded$H);
  return /*#__PURE__*/React.createElement("div", style, value && /*#__PURE__*/React.createElement(Color$2, {
    color: value,
    style: style('preview')
  }), /*#__PURE__*/React.createElement(TextInput, _extends({}, _omit(rest, 'isExpanded'), {
    style: style('input'),
    readOnly: true
  })));
};
var styled$r = createDefaultStyle(function (theme, _ref2) {
  var value = _ref2.value;
  var previewHeight = styles.calculateAbsoluteLineHeight(theme.font.size.normal, theme.lineHeight) - 1;
  return {
    cursor: 'pointer',
    display: 'block',
    position: 'relative',
    input: _objectSpread$v(_objectSpread$v({}, styles.input(theme)), {}, {
      opacity: 0
    }),
    preview: _objectSpread$v(_objectSpread$v({}, styles.border(1, 'solid', Color$3(value).darken(0.2).rgb().string())), {}, {
      position: 'absolute',
      height: previewHeight,
      width: '100%',
      bottom: 1,
      left: 0,
      ':hover': {
        position: 'absolute',
        outline: 'none',
        boxShadow: 'none'
      }
    })
  };
});
var SimpleColorInput$3 = styled$r(SimpleColorInput$2);function ownKeys$u(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$u(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$u(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$u(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var COLOR_TILE_DEFAULT_WIDTH = 25;
var MAX_TILES_ON_ONE_ROW = 8;
var defaultPalette$1 = ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'];
var ColorPicker$2 = function ColorPicker(_ref) {
  var onSelectColor = _ref.onSelectColor,
    style = _ref.style;
    _ref.onRequestHideWidget;
    var _ref$palette = _ref.palette,
    palette = _ref$palette === void 0 ? defaultPalette$1 : _ref$palette,
    width = _ref.width,
    colorPickerRef = _ref.colorPickerRef;
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: colorPickerRef,
    tabIndex: "-1"
  }, style), /*#__PURE__*/React.createElement("div", styles.merge(style('palette'), {
    width: width
  }), palette.map(function (color) {
    return /*#__PURE__*/React.createElement(Color$2, {
      key: color,
      color: color,
      width: COLOR_TILE_DEFAULT_WIDTH,
      onSelect: onSelectColor,
      style: style('color')
    });
  })));
};
var styled$q = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    padding = _ref2.padding;
  return {
    display: 'block',
    ':focus': {
      outline: 'none'
    },
    ':active': _objectSpread$u({
      outline: 'none'
    }, styles.boxShadowInset()),
    palette: _objectSpread$u({
      background: '#fff',
      boxSizing: 'content-box',
      overflow: 'auto',
      padding: padding.xsmall,
      position: 'relative'
    }, styles.border(1, 'solid', color.mono.lighter))
  };
});
var calculateWidthForPalette = function calculateWidthForPalette(_ref3) {
  var _ref3$palette = _ref3.palette,
    palette = _ref3$palette === void 0 ? defaultPalette$1 : _ref3$palette;
  var paletteSize = palette.length;
  var maxRowSize = COLOR_TILE_DEFAULT_WIDTH * MAX_TILES_ON_ONE_ROW;
  var rowSize = COLOR_TILE_DEFAULT_WIDTH * (Math.floor(paletteSize / 2) + paletteSize % 2);
  return {
    width: paletteSize > MAX_TILES_ON_ONE_ROW ? Math.min(maxRowSize, rowSize) : paletteSize * COLOR_TILE_DEFAULT_WIDTH
  };
};
var enhance$e = compose(withProps(calculateWidthForPalette), withHandlers({
  onSelectColor: function onSelectColor(_ref4) {
    var onRequestHideWidget = _ref4.onRequestHideWidget,
      onChange = _ref4.onChange;
    return function (color) {
      if (onRequestHideWidget) {
        onRequestHideWidget();
      }
      onChange(color);
    };
  }
}), styled$q);
var EnhancedComponent$1 = enhance$e(ColorPicker$2);
var ColorPicker$3 = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(EnhancedComponent$1, _extends({}, props, {
    colorPickerRef: ref
  }));
});var ColorInputUnsealed = compose(labeled$2, createDefaultStyle(function (theme) {
  return {
    widget: {
      marginTop: 2
    },
    node: {
      zIndex: theme.zIndex.dropdown
    }
  };
}))(stickWidgetToInput(ColorPicker$3, SimpleColorInput$3));var _excluded$G = ["type"];
var Input$2 = function Input(_ref) {
  var type = _ref.type,
    rest = _objectWithoutProperties(_ref, _excluded$G);
  return /*#__PURE__*/React.createElement(TextInput, _extends({
    type: type || 'text'
  }, rest));
};
var enhance$d = compose(labeled$2, styledAsInput$1);
var InputBase = enhance$d(Input$2);var _excluded$F = ["buttonLabel", "icon", "defaultValue", "validate", "onChange", "onKeyDown", "clearOnSubmit", "onSubmit", "style"];
function InputWithButton$2(_ref) {
  var buttonLabel = _ref.buttonLabel,
    icon = _ref.icon,
    defaultValue = _ref.defaultValue,
    validate = _ref.validate,
    _onChange = _ref.onChange,
    _onKeyDown = _ref.onKeyDown,
    clearOnSubmit = _ref.clearOnSubmit,
    onSubmit = _ref.onSubmit,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$F);
  var _useState = useState(defaultValue || ''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  function handleSubmit(value) {
    if (isValidValue$1(value, validate)) {
      onSubmit(value);
      if (clearOnSubmit) {
        setValue('');
      }
    }
  }
  return /*#__PURE__*/React.createElement(Tile$2, {
    transparent: true,
    toolbar: /*#__PURE__*/React.createElement("div", style('toolbar'), /*#__PURE__*/React.createElement(Button$7, {
      icon: icon,
      disabled: !isValidValue$1(value, validate),
      onClick: function onClick() {
        return handleSubmit(value);
      }
    }, buttonLabel))
  }, /*#__PURE__*/React.createElement(InputBase, _extends({}, rest, {
    value: value,
    onChange: function onChange(value) {
      setValue(value || '');
      if (_onChange) {
        _onChange(value);
      }
    },
    onKeyDown: function onKeyDown(event) {
      if (keycode(event) === 'enter') {
        handleSubmit(value);
      }
      if (_onKeyDown) {
        _onKeyDown(event);
      }
    }
  })));
}
var isValidValue$1 = function isValidValue(value, validator) {
  if (!validator) {
    return value && value.trim().length > 0;
  }
  return validator(value);
};
var enhance$c = createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding,
    font = _ref2.font,
    lineHeight = _ref2.lineHeight;
  var floatingLabelHeight = styles.calculateAbsoluteLineHeight(font.size.small, lineHeight);
  return {
    toolbar: {
      marginTop: floatingLabelHeight,
      marginLeft: padding.normal
    },
    '&inTile': {
      toolbar: {
        marginTop: 0,
        // don't reserve space for label
        marginLeft: 0 // <Input inTile /> already adds horizontal margin
      }
    }
  };
}, function (_ref3) {
  var inTile = _ref3.inTile;
  return {
    '&inTile': inTile
  };
});
var InputWithButtonUnsealed = enhance$c(InputWithButton$2);var _excluded$E = ["emptyMessage", "maxDropdownHeight"],
  _excluded2$4 = ["placeholder", "label", "searchPlaceholder"];
function ownKeys$t(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$t(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$t(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$t(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DropdownSelect$3 = function DropdownSelect(_ref) {
  var emptyMessage = _ref.emptyMessage,
    maxDropdownHeight = _ref.maxDropdownHeight,
    rest = _objectWithoutProperties(_ref, _excluded$E);
  return /*#__PURE__*/React.createElement(DropdownSelect$4, _extends({}, rest, {
    height: maxDropdownHeight,
    emptyMessage: emptyMessage && /*#__PURE__*/React.createElement(Empty$2, null, emptyMessage)
  }));
};
var readOnlyPlaceholder = /*#__PURE__*/React.createElement("span", null, "\xA0");
var enhance$b = compose(labeled$2, mapProps(function (_ref2) {
  var placeholder = _ref2.placeholder,
    label = _ref2.label,
    searchPlaceholder = _ref2.searchPlaceholder,
    rest = _objectWithoutProperties(_ref2, _excluded2$4);
  return _objectSpread$t({
    // use placeholder as search placeholder if a label is present
    searchPlaceholder: searchPlaceholder || placeholder,
    placeholder: !placeholder || label ? readOnlyPlaceholder : placeholder
  }, rest);
}), defaultProps({
  maxDropdownHeight: 250
}), createDefaultStyle(function (theme, _ref3) {
  var maxDropdownWidth = _ref3.maxDropdownWidth;
  return {
    display: 'block',
    fontSize: theme.font.size.normal,
    input: {
      cursor: 'text',
      display: 'block',
      borderWidth: 0,
      placeholder: _objectSpread$t(_objectSpread$t({}, styles.input(theme)), styles.ellipsis()),
      value: {
        // negative margins to subtract default option (tile) padding
        marginLeft: -theme.padding.normal,
        marginRight: -theme.padding.normal,
        marginTop: styles.inputPadding - theme.padding.small,
        marginBottom: styles.inputPadding - theme.padding.small,
        option: {
          cursor: 'text',
          marginBottom: 0,
          ':hover': {
            backgroundColor: 'transparent'
          }
        }
      },
      search: _objectSpread$t({}, styles.input(theme))
    },
    widget: _objectSpread$t(_objectSpread$t(_objectSpread$t({
      outline: 'none',
      fontSize: theme.font.size.normal,
      marginTop: 2
    }, styles.popover(theme.color)), theme.border.hint), theme.shadow.menu),
    nodeContent: {
      minWidth: '100%'
    },
    '&maxDropdownWidth': {
      nodeContent: {
        maxWidth: maxDropdownWidth === true ? '100%' : maxDropdownWidth
      }
    },
    '&disabled': {
      input: {
        color: theme.color.mono.middle,
        cursor: 'not-allowed',
        value: {
          option: {
            cursor: 'not-allowed'
          }
        }
      }
    }
  };
}, function (_ref4) {
  var maxDropdownWidth = _ref4.maxDropdownWidth,
    disabled = _ref4.disabled;
  return {
    '&maxDropdownWidth': !_isNil(maxDropdownWidth),
    '&disabled': disabled
  };
}), withProps(function (_ref5) {
  var style = _ref5.style,
    disabled = _ref5.disabled;
  return {
    wrapTrigger: function wrapTrigger(trigger, _ref6) {
      var isExpanded = _ref6.isExpanded,
        onClick = _ref6.onClick;
      return /*#__PURE__*/React.createElement(Tile$2, {
        transparent: true,
        alignBottom: true,
        toolbar: /*#__PURE__*/React.createElement("div", style('expand'), /*#__PURE__*/React.createElement(ContainedIconButton$2, {
          tabIndex: -1,
          disabled: disabled,
          icon: isExpanded ? 'dropdown-close' : 'dropdown-open',
          onClick: onClick
        }))
      }, trigger);
    }
  };
}), omitProps(['maxDropdownWidth', 'isOpen', 'setIsOpen']));
var DropdownSelectUnsealed = enhance$b(DropdownSelect$3);var _excluded$D = ["children", "_allowDuplicates", "_value"];
function ownKeys$s(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$s(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$s(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$s(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Item$1 = createDefaultStyle({
  cursor: 'text',
  marginBottom: 0,
  ':hover': {
    backgroundColor: 'transparent'
  }
})(function (_ref) {
  var style = _ref.style,
    options = _ref.options,
    value = _ref.value;
  var option = options.find(function (child) {
    return child.props.value === value;
  });
  return option ? /*#__PURE__*/cloneElement(option, {
    style: style
  }) : /*#__PURE__*/React.createElement(TextTileUnsealed, null, value);
});
var enhance$a = compose(withProps(function (_ref2) {
  var value = _ref2.value,
    allowDuplicates = _ref2.allowDuplicates;
  return {
    value: value,
    allowDuplicates: allowDuplicates,
    // rescue props which would otherwise be consumed by multiValue
    _value: value,
    _allowDuplicates: allowDuplicates
  };
}), multiValue$1(function (_ref3) {
  var sortable = _ref3.sortable,
    children = _ref3.children;
  return {
    sortable: sortable,
    addOnChange: true,
    itemsAsRows: true,
    renderItem: function renderItem(_ref4) {
      var value = _ref4.value;
      return /*#__PURE__*/React.createElement(Item$1, {
        value: value,
        options: Children.toArray(children)
      });
    }
  };
}), mapProps(function (_ref5) {
  var children = _ref5.children,
    _allowDuplicates = _ref5._allowDuplicates,
    _value = _ref5._value,
    rest = _objectWithoutProperties(_ref5, _excluded$D);
  return _objectSpread$s({
    // implement behaviour when `allowDuplicates` is true and get rid of internal props
    children: _allowDuplicates ? children : Children.toArray(children).filter(function (option) {
      return !_value || _value.indexOf(option.props.value) === -1;
    })
  }, rest);
}), createDefaultStyle(function (_ref6) {
  var padding = _ref6.padding;
  return {
    marginTop: padding.small
  };
}));
var DropdownMultiSelectUnsealed = enhance$a(DropdownSelectUnsealed);var _excluded$C = ["value", "name", "highlightedName", "children", "isFocused", "isSelected", "style", "search"];
var Option$2 = function Option(_ref) {
  var value = _ref.value,
    name = _ref.name,
    highlightedName = _ref.highlightedName,
    children = _ref.children,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected,
    style = _ref.style,
    search = _ref.search,
    rest = _objectWithoutProperties(_ref, _excluded$C);
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "option",
    "aria-selected": isSelected
  }, rest, style), children && typeof children === 'function' ? children({
    highlightedName: highlightedName,
    search: search,
    isFocused: isFocused,
    isSelected: isSelected
  }) : children || highlightedName || name || value);
};
// $FlowFixMe
var enhance$9 = compose(makeInteractive, createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding;
  return {
    marginBottom: 1,
    '&textContent': {
      paddingLeft: padding.normal,
      paddingRight: padding.normal,
      paddingTop: padding.small,
      paddingBottom: padding.small
    },
    '&disabled': {
      opacity: 0.5
    }
  };
}, function (_ref3) {
  var disabled = _ref3.disabled,
    children = _ref3.children;
  return {
    '&disabled': disabled,
    '&textContent': !children
  };
}));
var Option$3 = enhance$9(Option$2);var EmailInputUnsealed = compose(labeled$2, styledAsInput$1)(EmailInput$1);var _excluded$B = ["locale"];
function ownKeys$r(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$r(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$r(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$r(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var enhance$8 = compose(labeled$2, styledAsInput$1, mapProps(function (_ref) {
  var locale = _ref.locale,
    rest = _objectWithoutProperties(_ref, _excluded$B);
  return _objectSpread$r(_objectSpread$r({}, rest), {}, {
    culture: locale ? locale.split('_')[0] : undefined
  });
}));
var NumberInputUnsealed = enhance$8(NumberInput$1);var _excluded$A = ["value", "disabled", "units", "unitLabel", "unitHint", "unitError", "unitDescription", "style", "controls", "onChange"];
function NumberUnitInput$1(_ref) {
  var value = _ref.value,
    disabled = _ref.disabled,
    units = _ref.units,
    unitLabel = _ref.unitLabel,
    unitHint = _ref.unitHint,
    unitError = _ref.unitError,
    unitDescription = _ref.unitDescription,
    style = _ref.style,
    controls = _ref.controls,
    _onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$A);
  var harmonizedUnits = harmonizeUnits(units);
  return /*#__PURE__*/React.createElement("div", style, /*#__PURE__*/React.createElement("div", style('amount'), /*#__PURE__*/React.createElement(NumberInputUnsealed, _extends({}, rest, {
    disabled: disabled,
    value: value === null || value === void 0 ? void 0 : value.amount,
    onChange: function onChange(amount) {
      if (!_onChange) {
        return;
      }
      _onChange({
        amount: amount,
        unit: (value === null || value === void 0 ? void 0 : value.unit) || harmonizedUnits[0].id
      });
    }
  }))), /*#__PURE__*/React.createElement("div", style('unit'), /*#__PURE__*/React.createElement(DropdownSelectUnsealed, {
    disabled: disabled,
    label: unitLabel,
    hint: unitHint,
    error: unitError,
    description: unitDescription,
    value: (value === null || value === void 0 ? void 0 : value.unit) || harmonizedUnits[0].id,
    controls: controls,
    onChange: function onChange(unit) {
      if (!_onChange) {
        return;
      }
      _onChange({
        amount: value === null || value === void 0 ? void 0 : value.amount,
        unit: unit
      });
    }
  }, harmonizedUnits.map(function (unit) {
    return /*#__PURE__*/React.createElement(Option$3, {
      key: unit.id,
      value: unit.id,
      name: unit.name
    });
  }))));
}
var harmonizeUnits = function harmonizeUnits(units) {
  if (Array.isArray(units)) {
    return units.map(function (value) {
      return {
        id: value,
        name: value
      };
    });
  }
  return Object.keys(units).map(function (key) {
    return {
      id: key,
      name: units[key]
    };
  });
};
var styled$p = createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding;
  return {
    display: 'flex',
    amount: {
      flexGrow: 1,
      flexShrink: 0,
      flexBasis: 'auto'
    },
    unit: {
      flexGrow: 0,
      flexShrink: 1,
      flexBasis: 'auto',
      marginLeft: padding.small
    }
  };
});
var NumberUnitInputUnsealed = styled$p(NumberUnitInput$1);var _excluded$z = ["controls", "value"];
var LabeledUrl = labeled$2(styledAsInput$1(Url));
var UrlInput$1 = function UrlInput(_ref) {
  var controls = _ref.controls,
    value = _ref.value,
    rest = _objectWithoutProperties(_ref, _excluded$z);
  return /*#__PURE__*/React.createElement(LabeledUrl, _extends({}, rest, {
    value: value,
    controls: /*#__PURE__*/React.createElement(ListUnsealed, {
      direction: "horizontal"
    }, /*#__PURE__*/React.createElement(ContainedIconButton$2, {
      disabled: !value,
      onClick: function onClick() {
        return window.open(value);
      },
      icon: "link"
    }), controls)
  }));
};
var UrlInputUnsealed = UrlInput$1;var Group$2 = function Group(_ref) {
  var children = _ref.children,
    label = _ref.label,
    hint = _ref.hint,
    description = _ref.description,
    error = _ref.error,
    required = _ref.required,
    controls = _ref.controls,
    setHasFocus = _ref.setHasFocus,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("fieldset", _extends({}, style, {
    onFocus: function onFocus() {
      return setHasFocus(true);
    },
    onBlur: function onBlur() {
      return setHasFocus(false);
    }
  }), /*#__PURE__*/React.createElement("div", style('label'), /*#__PURE__*/React.createElement("legend", style('legend'), label, required ? /*#__PURE__*/React.createElement("span", style('asterisk'), " *") : null, description && /*#__PURE__*/React.createElement(PopoverUnsealed, {
    popover: description,
    style: style('description')
  }, /*#__PURE__*/React.createElement(Icon$2, {
    inline: true,
    primary: true,
    block: true,
    icon: "quick-info",
    style: style('descriptionIcon')
  }))), controls && /*#__PURE__*/React.createElement(ListUnsealed, {
    direction: "horizontal",
    style: style('controls')
  }, controls)), (error || hint) && /*#__PURE__*/React.createElement("div", style('hint'), error || hint), /*#__PURE__*/React.createElement("div", style('body'), children));
};
var enhance$7 = compose(withState('hasFocus', 'setHasFocus', false), createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding,
    font = _ref2.font,
    lineHeight = _ref2.lineHeight,
    color = _ref2.color;
  return {
    position: 'relative',
    marginTop: padding.large,
    marginBottom: padding.large,
    marginLeft: 0,
    marginRight: 0,
    paddingTop: padding.normal,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    borderWidth: 0,
    description: {
      cursor: 'help',
      display: 'inline-block',
      position: 'relative',
      top: -1 // random correction for visual pleasure
    },

    label: {
      position: 'relative'
    },
    legend: {
      display: 'block',
      lineHeight: lineHeight,
      color: color.mono.ultradark,
      fontSize: font.size.xlarge,
      padding: 0,
      margin: 0
    },
    asterisk: {
      fontSize: font.size.small,
      position: 'relative',
      top: -5
    },
    controls: {
      position: 'absolute',
      top: -padding.xsmall,
      right: 0
    },
    hint: {
      color: color.mono.middle,
      fontSize: font.size.small
    },
    '&isFirst': {
      marginTop: 0,
      paddingTop: padding.small
    },
    '&isLast': {
      marginBottom: 0
    },
    '&error': {
      border: "1px solid ".concat(color.status.danger),
      hint: {
        color: color.status.danger
      }
    },
    '&hasFocus': {
      asterisk: {
        color: color.status.danger
      }
    }
  };
}, function (_ref3) {
  var error = _ref3.error;
    _ref3.hint;
    var required = _ref3.required,
    hasFocus = _ref3.hasFocus,
    isFirst = _ref3.isFirst,
    isLast = _ref3.isLast;
  return {
    '&error': error,
    '&required': required,
    '&hasFocus': hasFocus,
    '&isFirst': isFirst,
    '&isLast': isLast
  };
}));
var GroupUnsealed = enhance$7(Group$2);var _excluded$y = ["value", "style"];
function Textarea$1(_ref) {
  var value = _ref.value,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$y);
  return /*#__PURE__*/React.createElement(TextareaBase, _extends({}, style, rest, {
    value: _isNil(value) ? '' : value
  }));
}
var enhance$6 = compose(labeled$2, styledAsInput$1, withHandlers({
  onChange: function onChange(_ref2) {
    var _onChange = _ref2.onChange;
    return function (event) {
      if (!_onChange) {
        return;
      }
      _onChange(event.target.value);
    };
  }
}), createDefaultStyle({
  resize: 'none'
}));
var TextareaUnsealed = enhance$6(Textarea$1);function ownKeys$q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$q(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$q(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// renders the given value into the DOM invisible to the user
// and calculates the width it would use.
function ShrinkInputHelper(_ref) {
  var value = _ref.value,
    style = _ref.style,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    fontSize = _ref.fontSize;
  var newValue = (value || placeholder || '').replace(/ /g, "\xA0");
  var helper = useRef();
  useEffect(function () {
    if (!helper.current) {
      return;
    }
    onChange(helper.current.offsetWidth + 1);
  });
  var mountPoint = useExternalNode$1();
  if (!mountPoint) {
    return null;
  }
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      zIndex: -1
    }
  }, /*#__PURE__*/React.createElement("span", _extends({
    ref: helper
  }, style, {
    style: _objectSpread$q(_objectSpread$q({}, style.style), {}, {
      fontSize: fontSize,
      width: 'auto',
      maxWidth: 'auto',
      whiteSpace: 'nowrap',
      visibility: 'hidden'
    })
  }), newValue)), mountPoint);
}
var useExternalNode$1 = function useExternalNode() {
  var node = useRef();
  useEffect(function () {
    var currentNode = document.createElement('div');
    node.current = currentNode;
    invariant(document.body, 'Expected body to be defined');
    document.body.appendChild(currentNode);
    return function () {
      invariant(document.body, 'Expected body to be defined');
      document.body.removeChild(currentNode);
    };
  }, []);
  return node.current;
};
var styled$o = createDefaultStyle();
var ShrinkInputHelper$1 = styled$o(ShrinkInputHelper);var _excluded$x = ["minFontSize", "maxFontSize", "style", "defaultValue", "value", "placeholder", "onBlur", "onFocus", "onChange"];
function ownKeys$p(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$p(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$p(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$p(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function ShrinkInput(_ref) {
  var minFontSize = _ref.minFontSize,
    maxFontSize = _ref.maxFontSize,
    style = _ref.style,
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    placeholder = _ref.placeholder,
    _onBlur = _ref.onBlur,
    _onFocus = _ref.onFocus,
    _onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$x);
  var theme = useTheme();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setFocused = _useState4[1];
  var _useWidthDependentFon = useWidthDependentFontSize(minFontSize, maxFontSize, width),
    _useWidthDependentFon2 = _slicedToArray(_useWidthDependentFon, 2),
    fontSize = _useWidthDependentFon2[0],
    inputRef = _useWidthDependentFon2[1];
  var _useInternalValue = useInternalValue$1(value, defaultValue),
    _useInternalValue2 = _slicedToArray(_useInternalValue, 2),
    internalValue = _useInternalValue2[0],
    setInternalValue = _useInternalValue2[1];
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("input", _extends({
    type: "text"
  }, rest, style, {
    style: _objectSpread$p(_objectSpread$p({}, style.style), {}, {
      maxWidth: '100%',
      fontSize: fontSize,
      // we add some extra padding when the user enters input
      // to avoid a wobbling of the text due to resizing
      width: isFocused ? width + theme.padding.normal : width
    }),
    placeholder: placeholder,
    onFocus: function onFocus(event) {
      setFocused(true);
      if (_onFocus) {
        _onFocus(event);
      }
    },
    onBlur: function onBlur(event) {
      setFocused(false);
      if (_onBlur) {
        _onBlur(event);
      }
    },
    value: internalValue,
    onChange: function onChange(ev) {
      setInternalValue(ev.target.value);
      if (_onChange) {
        _onChange(ev);
      }
    },
    ref: inputRef
  })), /*#__PURE__*/React.createElement(ShrinkInputHelper$1, {
    style: style,
    value: internalValue,
    placeholder: placeholder,
    fontSize: maxFontSize,
    onChange: function onChange(newWidth) {
      if (newWidth === width) {
        return;
      }
      setWidth(newWidth);
    }
  }));
}
var useInternalValue$1 = function useInternalValue(value, defaultValue) {
  // we're starting at an empty value so that at least one re-render
  // is done after the component has mounted. this is currently
  // needed so that the helper which measures the text width can
  // determine the correct value.
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    internalValue = _useState6[0],
    setInternalValue = _useState6[1];
  useEffect(function () {
    if (value == null) {
      setInternalValue(defaultValue);
    } else {
      setInternalValue(value);
    }
  }, [value, defaultValue]);
  return [internalValue, setInternalValue];
};

// selects a font size between minFontSize and maxFontSize based
// on how wide the component would need to be and how much space
// is actually available.
var useWidthDependentFontSize = function useWidthDependentFontSize(minFontSize, maxFontSize, width) {
  var _useState7 = useState(maxFontSize),
    _useState8 = _slicedToArray(_useState7, 2),
    fontSize = _useState8[0],
    setFontSize = _useState8[1];
  var elementRef = useRef();
  useEffect(function () {
    if (elementRef.current && width) {
      var inputWidth = elementRef.current.offsetWidth;
      var factor = Math.min(1, inputWidth / width);
      var newFontSize = Math.max(Math.floor(maxFontSize * factor), minFontSize);
      if (newFontSize !== fontSize) {
        setFontSize(newFontSize);
      }
    }
  }, [width, minFontSize, maxFontSize, fontSize]);
  return [fontSize, elementRef];
};
var styled$n = createDefaultStyle();
var ShrinkInput$1 = styled$n(ShrinkInput);var _excluded$w = ["hint", "error", "style"];
function ownKeys$o(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$o(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$o(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$o(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function TitleInput$1(_ref) {
  var hint = _ref.hint,
    error = _ref.error;
    _ref.style;
    var rest = _objectWithoutProperties(_ref, _excluded$w);
  var theme = useTheme();
  var _useTheme = useTheme(),
    border = _useTheme.border;
  var borderRadius = border.tab.borderRadius;
  var baseColor = useBaseColor();
  var defaultStyles = function defaultStyles(_ref2) {
    var color = _ref2.color,
      font = _ref2.font,
      spacing = _ref2.spacing;
    return {
      input: _objectSpread$o(_objectSpread$o(_objectSpread$o(_objectSpread$o({
        margin: 0
      }, styles.border(0)), {}, {
        borderRadius: borderRadius.regular
      }, font.title1), {}, {
        marginBottom: spacing.large
      }, styles.borderBottom(1, 'solid', color.mono.ultradark)), {}, {
        height: '72px',
        minWidth: '336px',
        paddingTop: spacing.xxsmall,
        paddingBottom: spacing.xxsmall,
        paddingRight: spacing.small,
        paddingLeft: spacing.small,
        backgroundColor: color.shading.onLight,
        transition: 'all ease .2s',
        ':hover': {
          backgroundColor: color.hover.base
        },
        ':focus': _objectSpread$o({
          backgroundColor: color.activeHover.secondary
        }, styles.borderBottom(2, 'solid', baseColor))
      }),
      '&withHint': {
        hint: {
          paddingTop: spacing.xxsmall,
          paddingRight: spacing.small,
          paddingLeft: spacing.small,
          color: color.text.inactive,
          marginTop: 0
        }
      },
      '&asError': {
        hint: {
          color: color.status.danger
        },
        input: _objectSpread$o(_objectSpread$o({}, styles.borderBottom(1, 'solid', color.status.danger)), {}, {
          backgroundColor: activeHover$2.danger
        })
      }
    };
  };
  var commonStyle = useStyles$1(defaultStyles, {}, {
    '&withHint': !!(hint || error),
    '&asError': !!error
  });
  return /*#__PURE__*/React.createElement("div", commonStyle, /*#__PURE__*/React.createElement(ShrinkInput$1, _extends({}, rest, {
    style: commonStyle('input'),
    minFontSize: theme.font.title3.fontSize,
    maxFontSize: theme.font.title1.fontSize
  })), hint && !error && /*#__PURE__*/React.createElement("div", commonStyle('hint'), hint), error && /*#__PURE__*/React.createElement("div", commonStyle('hint'), error));
}var clearable = withPropsOnChange(['value', 'onChange', 'controls', 'disabled'], function provideProps(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    controls = _ref.controls,
    disabled = _ref.disabled;
  return {
    controls: /*#__PURE__*/React.createElement(ListUnsealed, {
      direction: "horizontal"
    }, controls, /*#__PURE__*/React.createElement(ContainedIconButton$2, {
      tabIndex: -1,
      icon: "reset",
      key: "clearable-clear-button",
      disabled: disabled || value === null || value === undefined,
      onClick: function onClick() {
        if (onChange) {
          onChange(null);
        }
      }
    }))
  };
});
var clearable$1 = clearable;function TabBar$1(_ref) {
  var children = _ref.children,
    style = _ref.style;
  return /*#__PURE__*/React.createElement(ListUnsealed, {
    style: style,
    direction: "horizontal",
    role: "tablist"
  }, children);
}
var styled$m = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    spacing = _ref2.spacing;
  return {
    borderBottom: "1px solid ".concat(color.divider.base),
    paddingLeft: spacing.xsmall
  };
});
var TabBarUnsealed = styled$m(TabBar$1);function ownKeys$n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$n(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var merge = function merge(substyle, inlineStyle) {
  return _objectSpread$n(_objectSpread$n({}, substyle), {}, {
    style: _objectSpread$n(_objectSpread$n({}, substyle.style), inlineStyle)
  });
};
var merge$1 = merge;var _excluded$v = ["icon", "children", "style", "onClick", "disabled", "active"];
function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$m(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Tab$1 = function Tab(_ref) {
  var icon = _ref.icon,
    children = _ref.children,
    style = _ref.style,
    _onClick = _ref.onClick,
    disabled = _ref.disabled,
    active = _ref.active,
    rest = _objectWithoutProperties(_ref, _excluded$v);
  var _useTheme = useTheme(),
    border = _useTheme.border;
  var borderRadius = border.tab.borderRadius;
  var hasFioriStyles = useFioriStyles();
  var borderBottom = {
    borderBottomWidth: hasFioriStyles ? '2px' : '4px'
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "tab-component"
  }, _omit(rest, 'small'), merge$1(style, _objectSpread$m({
    borderRadius: rest.small ? borderRadius.small : borderRadius.regular
  }, borderBottom)), {
    onClick: function onClick(event) {
      if (disabled || !_onClick) {
        return;
      }
      _onClick(event);
    },
    "aria-selected": !!active,
    tabIndex: _onClick && !disabled ? '0' : '',
    onKeyDown: function onKeyDown(event) {
      if (disabled || !_onClick) {
        return;
      }
      if (event.key === 'Enter') {
        _onClick(event);
      }
      if (event.key === ' ') {
        event.preventDefault();
        _onClick(event);
      }
    },
    role: _onClick ? 'tab' : ''
  }), /*#__PURE__*/React.createElement("span", style('iconWrapper'), icon && /*#__PURE__*/React.createElement(Icon$2, _extends({}, style('icon'), {
    inline: true,
    icon: icon
  })), children));
};
var styled$l = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    font = _ref2.font,
    spacing = _ref2.spacing;
  return _objectSpread$m(_objectSpread$m(_objectSpread$m({
    cursor: 'pointer',
    height: '100%',
    padding: "".concat(spacing.xxsmall, "px ").concat(spacing.large, "px ").concat(spacing.xxxsmall, "px"),
    margin: "0 ".concat(spacing.xxxsmall, "px"),
    fontWeight: 'bold',
    fontSize: font.size.button,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: color.text.inactive
  }, styles.borderBottom(0, 'solid', 'transparent')), styles.transition(['border'], 'ease', ".4s")), {}, {
    ':hover': {
      background: color.hover.base
    },
    ':focus': {
      outline: 0,
      background: color.activeHover.primary
    },
    '&active': {
      borderBottomColor: color.primary.base,
      marginBottom: -1,
      color: color.primary.base,
      ':hover': {
        borderRadius: 0,
        background: 'transparent'
      }
    },
    '&disabled': {
      color: color.text.disabled,
      cursor: 'not-allowed',
      ':hover': {
        borderRadius: 0,
        background: 'transparent'
      },
      '&active': {
        borderBottomColor: color.primary.light
      }
    },
    iconWrapper: {
      display: 'flex'
    },
    icon: {
      marginLeft: '0 !important'
    },
    '&small': {
      fontSize: font.size.small,
      paddingRight: spacing.small,
      paddingLeft: spacing.small,
      paddingTop: spacing.xxsmall,
      paddingBottom: spacing.xxxsmall,
      borderBottomWidth: '2px',
      icon: {
        lineHeight: 1.1
      }
    }
  });
}, function (props) {
  return {
    '&active': props.active,
    '&small': props.small,
    '&disabled': props.disabled
  };
});
var TabUnsealed = styled$l(Tab$1);function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$l(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var isPositiveInteger = function isPositiveInteger(n) {
  return Number.isInteger(n) && n >= 0;
};
function Sidebar$1(_ref) {
  var children = _ref.children,
    style = _ref.style,
    _ref$wideningFactor = _ref.wideningFactor,
    wideningFactor = _ref$wideningFactor === void 0 ? 0 : _ref$wideningFactor;
  invariant(isPositiveInteger(wideningFactor), "The wideningFactor must be an positive integer, but is ".concat(wideningFactor));
  return /*#__PURE__*/React.createElement(ListUnsealed, _extends({}, style, {
    style: _objectSpread$l(_objectSpread$l({}, style.style), {}, {
      width: 224 + wideningFactor * 56
    })
  }), children);
}
var styled$k = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    spacing = _ref2.spacing;
  return {
    borderLeft: "1px solid ".concat(color.divider.base),
    padding: "".concat(spacing.small, "px 0 ").concat(spacing.xxsmall, "px"),
    marginRight: spacing.xxsmall
  };
});
var SidebarUnsealed = styled$k(Sidebar$1);function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$k(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SidebarItem$1 = function SidebarItem(_ref) {
  var icon = _ref.icon,
    children = _ref.children,
    style = _ref.style,
    onClick = _ref.onClick;
  var onKeyDown = useCallback(function (e) {
    if (!onClick) {
      return;
    }
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(e);
    }
  }, [onClick]);
  var _useTheme = useTheme(),
    border = _useTheme.border;
  var hasFioriStyles = useFioriStyles();
  var borderLeft = {
    borderLeftWidth: hasFioriStyles ? '2px' : '4px'
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "sidebarItem-component"
  }, merge$2(style, _objectSpread$k(_objectSpread$k({}, border.sidebarItem), borderLeft)), {
    onClick: onClick,
    tabIndex: onClick ? '0' : undefined,
    role: onClick ? 'button' : undefined,
    onKeyDown: onClick ? onKeyDown : undefined
  }), /*#__PURE__*/React.createElement("span", style('iconWrapper'), icon && /*#__PURE__*/React.createElement(Icon$2, _extends({}, style('icon'), {
    inline: true,
    icon: icon
  })), /*#__PURE__*/React.createElement("span", style('itemContent'), children)));
};
var styled$j = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    font = _ref2.font,
    spacing = _ref2.spacing;
  return _objectSpread$k(_objectSpread$k(_objectSpread$k({
    cursor: 'pointer',
    height: '100%',
    padding: "".concat(spacing.xxsmall, "px ").concat(spacing.xlarge, "px ").concat(spacing.xxsmall, "px ").concat(spacing.xlarge - spacing.xxxsmall, "px "),
    marginLeft: -1,
    marginBottom: spacing.xxsmall,
    fontWeight: 'bold',
    fontSize: font.size.button,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    color: color.text.inactive
  }, styles.borderLeft(0, 'solid', 'transparent')), styles.transition(['border'], 'ease', ".4s")), {}, {
    ':hover': {
      backgroundColor: color.hover.base
    },
    ':focus': {
      outline: 0,
      backgroundColor: color.hover.base
    },
    '&active': {
      borderLeftColor: color.primary.base,
      color: color.primary.base,
      backgroundColor: color.active.primary,
      ':hover': {
        backgroundColor: color.activeHover.primary
      },
      ':focus': {
        backgroundColor: color.activeHover.primary
      }
    },
    iconWrapper: {
      display: 'flex',
      alignItems: 'flex-start'
    },
    itemContent: {
      marginTop: 2
    },
    icon: {
      marginLeft: '0 !important'
    }
  });
}, function (props) {
  return {
    '&active': props.active,
    '&small': props.small,
    '&disabled': props.disabled
  };
});
var SidebarItemUnsealed = styled$j(SidebarItem$1);var ActionBarLargeContext = /*#__PURE__*/createContext(false);
var ProvideActionBarLarge = ActionBarLargeContext.Provider;
var useActionBarLarge = function useActionBarLarge() {
  return useContext(ActionBarLargeContext);
};
var ActionBarVerticalContext = /*#__PURE__*/createContext(false);
var ProvideActionBarVertical = ActionBarVerticalContext.Provider;
var useActionBarVertical = function useActionBarVertical() {
  return useContext(ActionBarVerticalContext);
};var ActionBarItem = function ActionBarItem(_ref) {
  var children = _ref.children;
  var vertical = useActionBarVertical();
  var styles = useStyles$1(style$2, {}, {
    '&vertical': vertical,
    '&horizontal': !vertical
  });
  return /*#__PURE__*/React.createElement("div", styles, children);
};
var Item = ActionBarItem;
var ITEM_SPACING = 2;
var style$2 = {
  '&horizontal': {
    marginTop: 0,
    marginBottom: 0,
    marginLeft: ITEM_SPACING,
    marginRight: ITEM_SPACING
  },
  '&vertical': {
    marginLeft: 0,
    marginRight: 0,
    marginTop: ITEM_SPACING,
    marginBottom: ITEM_SPACING
  }
};var ActionBarButton = function ActionBarButton(_ref) {
  var icon = _ref.icon,
    active = _ref.active,
    disabled = _ref.disabled,
    label = _ref.label,
    onClick = _ref.onClick;
  var large = useActionBarLarge();
  var vertical = useActionBarVertical();
  var buttonProps = {
    'aria-label': label,
    onClick: onClick,
    icon: icon,
    active: active,
    disabled: disabled
  };
  var button = large ? /*#__PURE__*/React.createElement(IconButton$3, _extends({
    large: true
  }, buttonProps)) : /*#__PURE__*/React.createElement(ContainedIconButton$2, buttonProps);
  return /*#__PURE__*/React.createElement(Item, null, disabled || !label ? button : /*#__PURE__*/React.createElement(PopoverUnsealed, {
    popover: label,
    position: vertical ? 'left' : 'top'
  }, button));
};
var Button$2 = ActionBarButton;var ActionBarGroup = function ActionBarGroup(_ref) {
  var children = _ref.children;
  var vertical = useActionBarVertical();
  var styles = useStyles$1(style$1, {}, {
    '&vertical': vertical,
    '&horizontal': !vertical
  });
  return /*#__PURE__*/React.createElement("div", styles, children);
};
var style$1 = function style(_ref2) {
  var color = _ref2.color,
    spacing = _ref2.spacing;
  return {
    display: 'flex',
    alignItems: 'center',
    ':empty': {
      display: 'none'
    },
    '&horizontal': {
      borderRight: "1px solid ".concat(color.divider.base),
      paddingLeft: spacing.xxxsmall - ITEM_SPACING,
      paddingRight: spacing.xxxsmall - ITEM_SPACING
    },
    '&vertical': {
      flexDirection: 'column',
      borderBottom: "1px solid ".concat(color.divider.base),
      paddingTop: spacing.xxxsmall - ITEM_SPACING,
      paddingBottom: spacing.xxxsmall - ITEM_SPACING
    }
  };
};
var Group$1 = ActionBarGroup;function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$j(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ActionBar = function ActionBar(_ref) {
  var children = _ref.children,
    _ref$large = _ref.large,
    large = _ref$large === void 0 ? false : _ref$large,
    _ref$vertical = _ref.vertical,
    vertical = _ref$vertical === void 0 ? false : _ref$vertical;
  var theme = useTheme();
  var styles = useStyles$1(style(theme), {}, {
    '&vertical': vertical,
    '&horizontal': !vertical
  });
  return /*#__PURE__*/React.createElement(ProvideActionBarLarge, {
    value: large
  }, /*#__PURE__*/React.createElement(ProvideActionBarVertical, {
    value: vertical
  }, /*#__PURE__*/React.createElement("div", styles, children, /*#__PURE__*/React.createElement("div", styles('hideLastBorder')))));
};
ActionBar.Button = Button$2;
ActionBar.Group = Group$1;
ActionBar.Item = Item;
var ActionBar$1 = ActionBar;
var style = function style(_ref2) {
  var color = _ref2.color,
    spacing = _ref2.spacing,
    border = _ref2.border;
  return _objectSpread$j(_objectSpread$j({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: color.surface
  }, border.hint), {}, {
    border: "1px solid ".concat(color.divider.base),
    // This element renders a white box to hide the last group's border
    hideLastBorder: {
      position: 'absolute',
      backgroundColor: color.surface,
      borderRadius: 8
    },
    '&horizontal': {
      paddingTop: spacing.xxsmall,
      paddingBottom: spacing.xxsmall,
      paddingLeft: spacing.xxsmall - spacing.xxxsmall,
      paddingRight: spacing.xxsmall - spacing.xxxsmall - 1,
      // -1 is for the border of the last Group

      hideLastBorder: {
        right: 2,
        top: 1,
        bottom: 1,
        width: spacing.xxsmall - 1 // - 1 is just to keep a bit of safety distance and not run in danger of overlaying the last button
      }
    },

    '&vertical': {
      flexDirection: 'column',
      paddingLeft: spacing.xxsmall,
      paddingRight: spacing.xxsmall,
      paddingTop: spacing.xxsmall - spacing.xxxsmall,
      paddingBottom: spacing.xxsmall - spacing.xxxsmall - 1,
      // -1 is for the border of the last Group

      hideLastBorder: {
        bottom: 2,
        left: 1,
        right: 1,
        height: spacing.xxsmall - 1 // - 1 is just to keep a bit of safety distance and not run in danger of overlaying the last button
      }
    }
  });
};var printMediaQuery = window.matchMedia('print');
function useMatchMedia(query) {
  var _useState = useState(function () {
      return window.matchMedia(query).matches;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    matches = _useState2[0],
    setMatches = _useState2[1];
  useEffect(function () {
    var handleResize = function handleResize() {
      setMatches(window.matchMedia(query).matches);
    };
    window.addEventListener('resize', handleResize);
    printMediaQuery.addListener(handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
      printMediaQuery.removeListener(handleResize);
    };
  }, [query]);
  return matches;
}var _excluded$u = ["children"];
function Visible$1(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$u);
  var matches = useMatchMedia(styles.media.getSizeMediaQuery(rest));
  if (!matches) {
    return null;
  }
  return children;
}var _excluded$t = ["children"];
function Hidden$1(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$t);
  var matches = useMatchMedia(styles.media.getSizeMediaQuery(rest));
  if (matches) {
    return null;
  }
  return children;
}function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$i(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DetailsPanel$1 = function DetailsPanel(_ref) {
  var header = _ref.header,
    children = _ref.children,
    footer = _ref.footer,
    onRequestClose = _ref.onRequestClose,
    style = _ref.style;
  var _useTheme = useTheme(),
    shadow = _useTheme.shadow,
    padding = _useTheme.padding;
  var fioriPadding = {
    paddingLeft: padding.normal,
    paddingRight: padding.normal,
    paddingBottom: padding.normal
  };
  var fioriStyles = useFioriStyles();
  return /*#__PURE__*/React.createElement("div", styles.merge(style, _objectSpread$i({}, shadow.modal)), /*#__PURE__*/React.createElement("div", style('header'), header, /*#__PURE__*/React.createElement("div", style('close'), /*#__PURE__*/React.createElement(OnDarkIconButton$1, {
    icon: "reset",
    large: true,
    onClick: onRequestClose,
    "aria-label": "close"
  }))), /*#__PURE__*/React.createElement("div", style('content'), children), footer && /*#__PURE__*/React.createElement("div", merge$2(style('footer'), fioriStyles ? fioriPadding : {}), footer));
};
var styled$i = createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding,
    color = _ref2.color;
  return {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    background: color.surface,
    // if we'd use a border instead of outline here, it would look too bright in overlay mode
    outline: '1px solid rgba(0,0,0,0.15)',
    header: {
      flexShrink: 0,
      padding: padding.normal,
      background: color.contrast,
      color: 'white',
      position: 'relative',
      overflow: 'hidden'
    },
    close: {
      position: 'absolute',
      top: 0,
      right: 0,
      paddingTop: padding.small,
      paddingRight: padding.small
    },
    content: {
      flexGrow: 1,
      overflowY: 'auto',
      overflowX: 'hidden'
    },
    footer: {
      flexShrink: 0
    }
  };
});
var DetailsPanelUnsealed = styled$i(DetailsPanel$1);var _excluded$s = ["children"];
function Table$1(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$s);
  return /*#__PURE__*/React.createElement(Table$2, rest, children);
}var _excluded$r = ["children", "style", "borderTopStyle", "borderRightStyle", "borderBottomStyle", "borderLeftStyle"];
function Cell$1(_ref) {
  var children = _ref.children,
    style = _ref.style;
    _ref.borderTopStyle;
    _ref.borderRightStyle;
    _ref.borderBottomStyle;
    _ref.borderLeftStyle;
    var rest = _objectWithoutProperties(_ref, _excluded$r);
  return /*#__PURE__*/React.createElement(Cell$2, _extends({}, rest, {
    style: style
  }), children);
}
var styled$h = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    spacing = _ref2.spacing;
  return {
    position: 'relative',
    borderColor: color.hover.base,
    paddingTop: 10,
    paddingBottom: 10,
    lineHeight: '20px',
    '&compact': {
      paddingTop: spacing.xxsmall,
      paddingBottom: spacing.xxsmall
    },
    '&borderTop-dashed': {
      borderTopStyle: 'dashed',
      borderTopWidth: 1
    },
    '&borderTop-bold': {
      borderTopWidth: 2
    },
    '&borderTop-regular': {
      borderTopWidth: 1
    },
    '&borderTop-none': {
      borderTopWidth: 0
    },
    '&borderRight-dashed': {
      borderRightStyle: 'dashed',
      borderRightWidth: 1
    },
    '&borderRight-bold': {
      borderRightWidth: 2
    },
    '&borderRight-regular': {
      borderRightWidth: 1
    },
    '&borderRight-none': {
      borderRightWidth: 0
    },
    '&borderBottom-dashed': {
      borderBottomStyle: 'dashed',
      borderBottomWidth: 1
    },
    '&borderBottom-bold': {
      borderBottomWidth: 2
    },
    '&borderBottom-regular': {
      borderBottomWidth: 1
    },
    '&borderBottom-none': {
      borderBottomWidth: 0
    },
    '&borderLeft-dashed': {
      borderLeftStyle: 'dashed',
      borderLeftWidth: 1
    },
    '&borderLeft-bold': {
      borderLeftWidth: 2
    },
    '&borderLeft-regular': {
      borderLeftWidth: 1
    },
    '&borderLeft-none': {
      borderLeftWidth: 0
    }
  };
}, function (_ref3) {
  var _ref4;
  var compact = _ref3.compact,
    borderTopStyle = _ref3.borderTopStyle,
    borderRightStyle = _ref3.borderRightStyle,
    borderBottomStyle = _ref3.borderBottomStyle,
    borderLeftStyle = _ref3.borderLeftStyle;
  return _ref4 = {
    '&compact': compact
  }, _defineProperty(_ref4, "&borderTop-".concat(borderTopStyle), !!borderTopStyle), _defineProperty(_ref4, "&borderRight-".concat(borderRightStyle), !!borderRightStyle), _defineProperty(_ref4, "&borderBottom-".concat(borderBottomStyle), !!borderBottomStyle), _defineProperty(_ref4, "&borderLeft-".concat(borderLeftStyle), !!borderLeftStyle), _ref4;
});
var enhance$5 = compose(withTableContext, styled$h);
var CellUnsealed = enhance$5(Cell$1);var _excluded$q = ["children", "locale", "style"];
function NumberCell$1(_ref) {
  var children = _ref.children,
    locale = _ref.locale,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$q);
  var number = children == null ? '' : Number(children);
  return /*#__PURE__*/React.createElement(CellUnsealed, _extends({}, rest, {
    style: style,
    align: "right"
  }), !_isNaN(number) && number.toLocaleString(locale));
}var _excluded$p = ["children", "style"];
function HeaderCell$1(_ref) {
  var children = _ref.children,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$p);
  return /*#__PURE__*/React.createElement(HeaderCell$2, _extends({}, rest, {
    style: style
  }), children);
}
var styled$g = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    spacing = _ref2.spacing;
  return {
    borderColor: color.hover.base,
    borderBottomColor: color.divider.base,
    paddingTop: spacing.xsmall,
    lineHeight: '20px'
  };
});
var HeaderCellUnsealed = styled$g(HeaderCell$1);function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$h(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * This method renders the given value into the DOM invisible to the user
 * and calculates the width it would use.
 *
 * @param {object<PageTitleHelperT>}
 * @returns {object<ReactElement>}
 */
function PageTitleHelper(_ref) {
  var value = _ref.value,
    style = _ref.style,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    fontSize = _ref.fontSize;
  var newValue = (value || placeholder || '').replace(/ /g, "\xA0");
  var helper = useRef();
  useEffect(function () {
    if (!helper.current) {
      return;
    }
    onChange(helper.current.offsetWidth + 1);
  });
  var mountPoint = useExternalNode();
  if (!mountPoint) {
    return null;
  }
  return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      zIndex: -1
    }
  }, /*#__PURE__*/React.createElement("span", _extends({
    ref: helper
  }, style, {
    style: _objectSpread$h(_objectSpread$h({}, style.style), {}, {
      fontSize: fontSize,
      width: 'auto',
      maxWidth: 'auto',
      whiteSpace: 'nowrap',
      visibility: 'hidden'
    })
  }), newValue)), mountPoint);
}
var useExternalNode = function useExternalNode() {
  var node = useRef();
  useEffect(function () {
    var currentNode = document.createElement('div');
    node.current = currentNode;
    invariant(document.body, 'Expected body to be defined');
    document.body.appendChild(currentNode);
    return function () {
      invariant(document.body, 'Expected body to be defined');
      document.body.removeChild(currentNode);
    };
  }, []);
  return node.current;
};var _excluded$o = ["error", "value", "defaultValue", "interactive", "placeholder", "onBlur", "onFocus", "onChange", "onMouseOver", "onMouseLeave"];
function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$g(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var PageTitle$1 = function PageTitle(_ref) {
  var _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? false : _ref$interactive,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Document name' : _ref$placeholder,
    _onBlur = _ref.onBlur,
    _onFocus = _ref.onFocus,
    _onChange = _ref.onChange,
    _onMouseOver = _ref.onMouseOver,
    _onMouseLeave = _ref.onMouseLeave,
    rest = _objectWithoutProperties(_ref, _excluded$o);
  var theme = useTheme();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setFocused = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isHovered = _useState6[0],
    setHovered = _useState6[1];
  var _useInternalValue = useInternalValue(value, defaultValue),
    _useInternalValue2 = _slicedToArray(_useInternalValue, 2),
    internalValue = _useInternalValue2[0],
    setInternalValue = _useInternalValue2[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isInputChanged = _useState8[0],
    setIsInputChanged = _useState8[1];
  var baseColor = useBaseColor();
  var fioriStyles = useFioriStyles();

  /**
   * The memoized value checks if the page title has a value defined.
   * This checks if the default value is defined and if the component has not been edited.
   * This is necessary to apply the correct substyle modifiers when the component state changes.
   */
  var hasValue = useMemo(function () {
    var componentHasDefaultValueAndNotEdited = !!defaultValue && !isInputChanged;
    var nonEmptyTitle = !!(internalValue !== null && internalValue !== void 0 && internalValue.trim());
    return componentHasDefaultValueAndNotEdited || nonEmptyTitle;
  }, [defaultValue, internalValue, isInputChanged]);

  /**
   * The memoized value holds the width with an additional spacing added
   * to the width that is needed to achieve the effect on hover whenever
   * the page title has a value if the component is not in an error state.
   * @returns {number} width
   */
  var calculatedWidth = useMemo(function () {
    var isAdditionalWidthNeeded = !error && (isHovered || isFocused) && internalValue;
    if (isAdditionalWidthNeeded) {
      return width + theme.spacing.xsmall;
    }
    return width;
  }, [error, isHovered, isFocused, theme, width, internalValue]);
  var defaultStyles = function defaultStyles(_ref2) {
    var color = _ref2.color,
      font = _ref2.font,
      spacing = _ref2.spacing,
      border = _ref2.border;
    var pageTitleDefaultStyle = _objectSpread$g(_objectSpread$g(_objectSpread$g(_objectSpread$g({}, font.title3), {}, {
      margin: 0,
      color: color.text.base,
      height: 40,
      minWidth: 240
    }, styles.border(0)), styles.borderBottom(1, 'solid', color.mono.ultradark)), {}, {
      borderTopLeftRadius: border.modal.borderRadius,
      borderTopRightRadius: border.modal.borderRadius,
      paddingTop: spacing.xxxsmall,
      paddingBottom: spacing.xxxsmall,
      paddingRight: spacing.xsmall,
      paddingLeft: spacing.xsmall,
      backgroundColor: color.shading.onLight,
      transition: 'padding-left 0.2s ease 0.1s, padding-right 0.2s ease 0.1s, width 0.2s ease 0.1s, background-color 0.2s ease 0.1s, border-bottom 0.2s ease 0.1s',
      ':hover': {
        transition: 'padding-left 0.2s ease 0.1s, padding-right 0.2s ease 0.1s, width 0.2s ease 0.1s, background-color 0.2s ease 0.1s, border-bottom 0.2s ease 0.1s',
        backgroundColor: color.hover.base
      },
      ':focus': _objectSpread$g({
        backgroundColor: color.activeHover.secondary,
        transition: 'none'
      }, styles.borderBottom(2, 'solid', baseColor))
    });
    return {
      input: pageTitleDefaultStyle,
      '&defaultInteractiveState': pageTitleDefaultStyle,
      '&interactiveErrorState': {
        input: _objectSpread$g(_objectSpread$g({
          minWidth: 240,
          transition: 'none',
          backgroundColor: color.activeHover.danger
        }, styles.borderBottom(1, 'solid', color.danger.base)), {}, {
          ':hover': _objectSpread$g({}, styles.borderBottom(1, 'solid', color.danger.base))
        })
      },
      '&interactiveFilledState': {
        input: _objectSpread$g(_objectSpread$g(_objectSpread$g({}, styles.border(0)), styles.borderBottom(1, 'solid', 'transparent')), {}, {
          minWidth: 'none',
          backgroundColor: 'none',
          paddingLeft: '0px',
          ':hover': _objectSpread$g(_objectSpread$g({}, styles.borderBottom(1, 'solid', color.mono.ultradark)), {}, {
            backgroundColor: color.hover.base,
            paddingLeft: spacing.xsmall
          }),
          ':focus': _objectSpread$g({
            backgroundColor: color.activeHover.secondary,
            transition: 'none'
          }, styles.borderBottom(2, 'solid', baseColor))
        })
      },
      '&interactiveFilledErrorState': {
        input: _objectSpread$g(_objectSpread$g(_objectSpread$g({}, styles.border(0)), styles.borderBottom(1, 'solid', color.danger.base)), {}, {
          minWidth: 'none',
          paddingLeft: spacing.xsmall,
          backgroundColor: color.danger.light,
          ':hover': _objectSpread$g({}, styles.borderBottom(1, 'solid', fioriStyles ? color.danger.base : color.shading.onLight))
        })
      },
      '&readOnlyState': {
        input: _objectSpread$g(_objectSpread$g(_objectSpread$g({}, styles.border(0)), styles.borderBottom(1, 'solid', 'transparent')), {}, {
          backgroundColor: 'none',
          paddingLeft: '0px',
          transition: 'none',
          ':hover': {
            backgroundColor: 'none'
          },
          ':focus': _objectSpread$g({
            backgroundColor: 'none'
          }, styles.borderBottom(1, 'solid', 'transparent'))
        })
      },
      '&readOnlyErrorState': {
        input: _objectSpread$g(_objectSpread$g({}, styles.borderBottom(1, 'solid', color.danger.base)), {}, {
          backgroundColor: 'none',
          transition: 'none',
          paddingLeft: spacing.xsmall,
          ':hover': {
            backgroundColor: 'none'
          },
          ':focus': _objectSpread$g({
            backgroundColor: 'none'
          }, styles.borderBottom(1, 'solid', color.danger.base))
        })
      }
    };
  };
  var pageTitleStyles = useStyles$1(defaultStyles(theme), {}, {
    '&readOnlyState': !interactive,
    '&readOnlyErrorState': error && !interactive,
    '&interactiveFilledState': hasValue && interactive,
    '&interactiveErrorState': error && interactive,
    '&interactiveFilledErrorState': hasValue && error && interactive,
    '&defaultInteractiveState': !internalValue && interactive
  });
  if (!interactive && !hasValue) {
    throw new Error('PageTitle takes the readOnly mode as default. Either use the component with a defaultValue or a value or set the interactive mode on the component');
  }
  var handleEvent = function handleEvent(event, eventName, callBacks) {
    callBacks.forEach(function (fn) {
      if (fn) {
        fn();
      }
    });
    if (eventName) {
      eventName(event);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    role: "main",
    "aria-labelledby": "page-title",
    "data-testid": "page-title"
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "text"
  }, rest, pageTitleStyles('input'), {
    style: {
      maxWidth: '100%',
      width: calculatedWidth
    },
    readOnly: !interactive,
    placeholder: placeholder,
    value: internalValue
    // Event handlers
    ,
    onFocus: function onFocus(event) {
      return handleEvent(event, _onFocus, [setFocused(true)]);
    },
    onBlur: function onBlur(event) {
      return handleEvent(event, _onBlur, [setFocused(false), setHovered(false)]);
    },
    onMouseOver: function onMouseOver(event) {
      return handleEvent(event, _onMouseOver, [setHovered(true)]);
    },
    onMouseLeave: function onMouseLeave(event) {
      return handleEvent(event, _onMouseLeave, [setHovered(false)]);
    },
    onChange: function onChange(event) {
      var _event$target;
      return handleEvent(event, _onChange, [setIsInputChanged(true), setInternalValue(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value)]);
    }
  })), /*#__PURE__*/React.createElement(PageTitleHelper, {
    style: pageTitleStyles('input'),
    value: internalValue,
    placeholder: placeholder,
    fontSize: theme.font.title3.fontSize,
    onChange: function onChange(newWidth) {
      var paddingOffset = 0;
      if (newWidth === width) {
        return;
      }

      // The paddingOffset is the padding value which is removed whenever the page title is in filled state.
      // When the page title value is completely deleted it falls back to the placeholder and this offset has to be
      // added back to the width.
      if (isInputChanged) {
        paddingOffset = theme.spacing.xsmall;
      }
      setWidth(newWidth + paddingOffset);
    }
  }));
};

/**
 * This hook returns the value to be rendered on the component based on the value and defaultValue
 * that is passed.
 * @param {string} value
 * @param {string} defaultValue
 * @returns {Array}
 */
var useInternalValue = function useInternalValue(value, defaultValue) {
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    internalValue = _useState10[0],
    setInternalValue = _useState10[1];
  useEffect(function () {
    if (value == null) {
      setInternalValue(defaultValue);
    } else {
      setInternalValue(value);
    }
  }, [value, defaultValue]);
  return [internalValue, setInternalValue];
};
var PageTitleUnsealed = PageTitle$1;var TRANSPARENT = 'rgba(0, 0, 0, 0)';
function useDotColor(dotColor) {
  var contrast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var theme = useTheme();
  var themeColor = dotColor === 'none' ? TRANSPARENT : _get(theme.color, dotColor);
  var color;
  try {
    color = Color$3(themeColor || dotColor);
  } catch (e) {
    warn("dotColor=\"".concat(dotColor, "\" is not a valid color value"));
    color = Color$3(TRANSPARENT);
  }
  var borderColor = color.string() === TRANSPARENT ? theme.color.divider.base : color.darken(0.5).string();
  return {
    dotBackgroundColor: color.string(),
    dotBorderColor: contrast ? theme.color.contrastText.inactive : borderColor
  };
}function FilledTag(_ref) {
  var children = _ref.children,
    _ref$dotColor = _ref.dotColor,
    dotColor = _ref$dotColor === void 0 ? 'none' : _ref$dotColor,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    title = _ref.title,
    icon = _ref.icon,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? false : _ref$interactive,
    onDismiss = _ref.onDismiss,
    onClick = _ref.onClick;
  var dotColorProps = useDotColor(disabled ? 'none' : dotColor);
  var hasFioriStyles = useFioriStyles();
  var defaultStyles = function defaultStyles(_ref2) {
    var color = _ref2.color;
    var colorToken = hasFioriStyles ? color.primary : color.secondary;
    var textColor = hasFioriStyles ? color.coloredText.primary : color.coloredText.secondary;
    return {
      backgroundColor: colorToken.lighter,
      borderColor: colorToken.light,
      color: textColor,
      action: {
        ':hover': {
          backgroundColor: color.hover.base
        },
        ':focus': {
          backgroundColor: color.hover.base
        }
      },
      '&active': {
        backgroundColor: 'transparent',
        borderColor: colorToken.base
      },
      '&disabled': {
        backgroundColor: 'transparent',
        borderColor: color.hover.base,
        color: color.text.disabled
      },
      '&interactive': {
        ':hover': {
          backgroundColor: colorToken.light
        },
        ':focus': {
          backgroundColor: colorToken.light
        },
        ':active': {
          backgroundColor: 'transparent',
          borderColor: colorToken.base
        }
      }
    };
  };
  var styles = useStyles$1(defaultStyles, {}, {
    '&active': active,
    '&disabled': disabled,
    '&interactive': interactive && !disabled
  });
  return /*#__PURE__*/React.createElement(Tag$1, _extends({
    showDot: dotColor !== 'none',
    style: styles,
    active: active,
    disabled: disabled,
    small: small,
    interactive: interactive,
    title: title,
    icon: icon,
    onDismiss: onDismiss,
    onClick: onClick
  }, dotColorProps), children);
}function Tag(_ref) {
  var children = _ref.children,
    _ref$dotColor = _ref.dotColor,
    dotColor = _ref$dotColor === void 0 ? 'none' : _ref$dotColor,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? false : _ref$interactive,
    title = _ref.title,
    icon = _ref.icon,
    onDismiss = _ref.onDismiss,
    onClick = _ref.onClick;
  var dotColorProps = useDotColor(disabled ? 'none' : dotColor);
  var styles = useStyles$1(defaultStyles$9, {}, {
    '&disabled': disabled,
    '&active': active,
    '&interactive': interactive && !disabled
  });
  return /*#__PURE__*/React.createElement(Tag$1, _extends({
    title: title,
    icon: icon,
    showDot: dotColor !== 'none',
    style: styles,
    active: active,
    disabled: disabled,
    small: small,
    interactive: interactive,
    onDismiss: onDismiss,
    onClick: onClick
  }, dotColorProps), children);
}
var defaultStyles$9 = function defaultStyles(_ref2) {
  var color = _ref2.color;
  return {
    backgroundColor: 'transparent',
    borderColor: color.divider.base,
    color: color.text.inactive,
    action: {
      ':hover': {
        backgroundColor: color.hover.base
      },
      ':focus': {
        backgroundColor: color.hover.base
      }
    },
    '&active': {
      borderColor: color.primary.base,
      color: color.coloredText.primary
    },
    '&disabled': {
      borderColor: color.hover.base,
      color: color.text.disabled
    },
    '&interactive': {
      ':hover': {
        backgroundColor: color.hover.base
      },
      ':focus': {
        backgroundColor: color.hover.base
      },
      ':active': {
        borderColor: color.primary.base,
        color: color.coloredText.primary
      }
    }
  };
};function DangerTag(_ref) {
  var children = _ref.children,
    _ref$dotColor = _ref.dotColor,
    dotColor = _ref$dotColor === void 0 ? 'none' : _ref$dotColor,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? false : _ref$interactive,
    title = _ref.title,
    icon = _ref.icon,
    onDismiss = _ref.onDismiss,
    onClick = _ref.onClick;
  var dotColorProps = useDotColor(disabled ? 'none' : dotColor);
  var styles = useStyles$1(defaultStyles$8, {}, {
    '&active': active,
    '&disabled': disabled,
    '&interactive': interactive
  });
  return /*#__PURE__*/React.createElement(Tag$1, _extends({
    showDot: dotColor !== 'none',
    small: small,
    interactive: interactive,
    title: title,
    icon: icon,
    style: styles,
    active: active,
    disabled: disabled,
    onDismiss: onDismiss,
    onClick: onClick
  }, dotColorProps), children);
}
var defaultStyles$8 = function defaultStyles(_ref2) {
  var color = _ref2.color;
  return {
    backgroundColor: color.active.danger,
    borderColor: color.activeHover.danger,
    color: color.coloredText.danger,
    action: {
      ':hover': {
        backgroundColor: color.hover.base
      },
      ':focus': {
        backgroundColor: color.hover.base
      }
    },
    '&active': {
      backgroundColor: color.active.danger,
      borderColor: color.danger.base
    },
    '&disabled': {
      backgroundColor: 'transparent',
      borderColor: color.hover.base,
      color: color.text.disabled
    },
    '&interactive': {
      ':hover': {
        backgroundColor: color.activeHover.danger
      },
      ':focus': {
        backgroundColor: color.activeHover.danger
      },
      ':active': {
        backgroundColor: color.active.danger,
        borderColor: color.danger.base
      },
      '&active': {
        ':hover': {
          backgroundColor: color.activeHover.danger
        }
      }
    }
  };
};function HighlightTag(_ref) {
  var children = _ref.children,
    _ref$dotColor = _ref.dotColor,
    dotColor = _ref$dotColor === void 0 ? 'none' : _ref$dotColor,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? false : _ref$interactive,
    title = _ref.title,
    icon = _ref.icon,
    onDismiss = _ref.onDismiss,
    onClick = _ref.onClick;
  var dotColorProps = useDotColor(disabled ? 'none' : dotColor);
  var styles = useStyles$1(defaultStyles$7, {}, {
    '&active': active,
    '&disabled': disabled,
    '&interactive': interactive
  });
  return /*#__PURE__*/React.createElement(Tag$1, _extends({
    showDot: dotColor !== 'none',
    small: small,
    interactive: interactive,
    title: title,
    icon: icon,
    style: styles,
    active: active,
    disabled: disabled,
    onDismiss: onDismiss,
    onClick: onClick
  }, dotColorProps), children);
}
var defaultStyles$7 = function defaultStyles(_ref2) {
  var color = _ref2.color;
  return {
    backgroundColor: color.active.primary,
    borderColor: color.activeHover.primary,
    color: color.coloredText.primary,
    action: {
      ':hover': {
        backgroundColor: color.hover.base
      },
      ':focus': {
        backgroundColor: color.hover.base
      }
    },
    '&active': {
      backgroundColor: color.active.primary,
      borderColor: color.primary.base
    },
    '&disabled': {
      backgroundColor: 'transparent',
      borderColor: color.hover.base,
      color: color.text.disabled
    },
    '&interactive': {
      ':hover': {
        backgroundColor: color.activeHover.primary
      },
      ':focus': {
        backgroundColor: color.activeHover.primary
      },
      ':active': {
        backgroundColor: color.active.primary,
        borderColor: color.primary.base
      },
      '&active': {
        ':hover': {
          backgroundColor: color.activeHover.primary
        }
      }
    }
  };
};function ContrastTag(_ref) {
  var children = _ref.children,
    _ref$dotColor = _ref.dotColor,
    dotColor = _ref$dotColor === void 0 ? 'none' : _ref$dotColor,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? false : _ref$interactive,
    title = _ref.title,
    icon = _ref.icon,
    onDismiss = _ref.onDismiss,
    onClick = _ref.onClick;
  var dotColorProps = useDotColor(disabled ? 'none' : dotColor, true);
  var styles = useStyles$1(defaultStyles$6, {}, {
    '&active': active,
    '&disabled': disabled,
    '&interactive': interactive && !disabled
  });
  return /*#__PURE__*/React.createElement(Tag$1, _extends({
    showDot: dotColor !== 'none',
    style: styles,
    active: active,
    title: title,
    icon: icon,
    disabled: disabled,
    small: small,
    interactive: interactive,
    onDismiss: onDismiss,
    onClick: onClick
  }, dotColorProps), children);
}
var defaultStyles$6 = function defaultStyles(_ref2) {
  var color = _ref2.color;
  return {
    backgroundColor: 'transparent',
    borderColor: color.contrastText.inactive,
    color: color.contrastText.inactive,
    action: {
      ':hover': {
        backgroundColor: color.hover.contrast
      },
      ':focus': {
        backgroundColor: color.hover.contrast
      }
    },
    '&active': {
      backgroundColor: color.active.contrast,
      borderColor: color.contrastText.base,
      color: color.contrastText.base
    },
    '&disabled': {
      borderColor: color.divider.contrast,
      color: color.contrastText.disabled
    },
    '&interactive': {
      ':hover': {
        backgroundColor: color.hover.contrast,
        borderColor: color.contrastText.base,
        color: color.contrastText.base
      },
      ':focus': {
        backgroundColor: color.hover.contrast,
        borderColor: color.contrastText.base,
        color: color.contrastText.base
      },
      ':active': {
        backgroundColor: color.active.contrast,
        borderColor: color.contrastText.base,
        color: color.contrastText.base
      },
      '&active': {
        ':hover': {
          backgroundColor: color.activeHover.contrast
        }
      }
    }
  };
};var _excluded$n = ["children", "title", "disabled", "inline", "small", "dotColor", "defaultValue", "applyOnEnter", "disableApply", "clearLabel", "applyLabel", "valueRenderer", "popoverRenderer", "onDismiss", "onApply", "onBeforeApply"];
function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ChipDropdown = function ChipDropdown(_ref) {
  var children = _ref.children,
    title = _ref.title,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$dotColor = _ref.dotColor,
    dotColor = _ref$dotColor === void 0 ? 'none' : _ref$dotColor,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
    _ref$applyOnEnter = _ref.applyOnEnter,
    applyOnEnter = _ref$applyOnEnter === void 0 ? true : _ref$applyOnEnter,
    _ref$disableApply = _ref.disableApply,
    disableApply = _ref$disableApply === void 0 ? false : _ref$disableApply,
    clearLabel = _ref.clearLabel,
    applyLabel = _ref.applyLabel,
    valueRenderer = _ref.valueRenderer,
    popoverRenderer = _ref.popoverRenderer,
    onDismiss = _ref.onDismiss,
    onApply = _ref.onApply,
    _ref$onBeforeApply = _ref.onBeforeApply,
    onBeforeApply = _ref$onBeforeApply === void 0 ? function () {
      return true;
    } : _ref$onBeforeApply,
    rest = _objectWithoutProperties(_ref, _excluded$n);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(defaultValue),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedValues = _useState4[0],
    setSelectedValues = _useState4[1];
  var _useState5 = useState(defaultValue),
    _useState6 = _slicedToArray(_useState5, 2),
    proposedValues = _useState6[0],
    setProposedValues = _useState6[1];
  var theme = useTheme();
  var tagStyles = function tagStyles(_ref2) {
    var color = _ref2.color;
      _ref2.spacing;
    return {
      backgroundColor: 'transparent',
      borderColor: color.divider.base,
      color: color.text.inactive,
      action: {
        ':hover': {
          backgroundColor: color.hover.base
        },
        ':focus': {
          backgroundColor: color.hover.base
        }
      },
      label: {
        display: 'flex'
      },
      '&active': {
        borderColor: color.primary.base,
        color: color.primary.base
      },
      '&disabled': {
        borderColor: color.hover.base,
        color: color.text.disabled
      },
      '&interactive': {
        label: {
          cursor: 'pointer'
        },
        ':hover': {
          backgroundColor: color.hover.base
        },
        ':focus': {
          backgroundColor: color.hover.base
        },
        ':active': {
          borderColor: color.primary.base,
          color: color.primary.base
        }
      }
    };
  };
  var dotColorProps = useDotColor(disabled ? 'none' : dotColor);
  var styles = useStyles$1(defaultStyles$5(theme), {}, {
    '&disabled': disabled
  });
  var coreTagStyles = useStyles$1(tagStyles, {}, {
    '&disabled': disabled,
    '&active': isOpen,
    '&interactive': !disabled
  });
  var handleApply = function handleApply() {
    var continueToApply = onBeforeApply(proposedValues);
    if (continueToApply !== false && !disableApply) {
      setSelectedValues(proposedValues);
      setIsOpen(false);
      if (onApply) {
        onApply(proposedValues);
      }
    }
  };
  var onClear = function onClear() {
    setIsOpen(false);
    setSelectedValues(null);
    setProposedValues(null);
    onBeforeApply(null);
    if (onApply) {
      onApply(null);
    }
  };
  var values = valueRenderer ? valueRenderer(selectedValues) : defaultValueRenderer(selectedValues);
  var popover = popoverRenderer ? popoverRenderer(selectedValues) : /*#__PURE__*/React.createElement(DefaultPopover, {
    title: title,
    value: selectedValues
  });
  var handleKeyDown = function handleKeyDown(event) {
    switch (event.key) {
      case 'Enter':
        if (applyOnEnter) handleApply();
        break;
      case 'Escape':
        setIsOpen(false);
        break;
    }
  };
  useEffect(function () {
    if (defaultValue === null) {
      setSelectedValues(null);
      setProposedValues(null);
    }
  }, [defaultValue]);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, styles), /*#__PURE__*/React.createElement(Dropdown$3, {
    isOpen: disabled ? false : isOpen,
    node: /*#__PURE__*/React.createElement("div", _extends({}, styles('node'), {
      onKeyDown: handleKeyDown,
      role: "button",
      tabIndex: 0
    }), children(setProposedValues), !!clearLabel || !!applyLabel ? /*#__PURE__*/React.createElement("div", styles('footer'), clearLabel ? /*#__PURE__*/React.createElement(Button$4, {
      onClick: onClear
    }, clearLabel) : /*#__PURE__*/React.createElement("span", null), applyLabel ? /*#__PURE__*/React.createElement("div", styles('applyButton'), /*#__PURE__*/React.createElement(Button$6, {
      disabled: disableApply,
      onClick: handleApply
    }, applyLabel)) : null) : null),
    onClickOutside: function onClickOutside() {
      return setIsOpen(false);
    },
    inline: inline
  }, /*#__PURE__*/React.createElement(PopoverUnsealed, {
    popover: popover,
    trigger: popover ? 'hover' : 'controlled'
  }, /*#__PURE__*/React.createElement(Tag$1, _extends({
    title: title,
    showDot: dotColor !== 'none',
    style: coreTagStyles,
    disabled: disabled,
    small: small,
    interactive: true,
    onDismiss: onDismiss,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, dotColorProps), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", styles('values'), values), /*#__PURE__*/React.createElement(Glyph, {
    style: styles('icon')
  }, !isOpen || disabled ? 'dropdown-open' : 'dropdown-close'))))));
};
var defaultStyles$5 = function defaultStyles(_ref3) {
  var color = _ref3.color,
    padding = _ref3.padding,
    spacing = _ref3.spacing,
    shadow = _ref3.shadow,
    border = _ref3.border;
  return {
    display: 'inline-block',
    maxWidth: 300,
    values: _objectSpread$f(_objectSpread$f({}, styles.ellipsis()), {}, {
      color: color.text.inactive
    }),
    node: _objectSpread$f(_objectSpread$f(_objectSpread$f({}, styles.popover(color)), {}, {
      background: 'white',
      margin: '0 10px'
    }, border.chipDropDown), shadow.modal),
    icon: {
      display: 'inline-block',
      marginLeft: spacing.xxxsmall
    },
    footer: {
      borderTop: "1px solid ".concat(color.divider.base),
      display: 'flex',
      justifyContent: 'space-between',
      padding: padding.normal
    },
    applyButton: {
      display: 'inline-block',
      marginLeft: spacing.xxsmall
    },
    '&disabled': {
      values: {
        color: color.text.disabled
      }
    }
  };
};
var DefaultPopover = function DefaultPopover(_ref4) {
  var title = _ref4.title,
    _ref4$value = _ref4.value,
    value = _ref4$value === void 0 ? null : _ref4$value;
  var styles = useStyles$1(popoverStyles, {}, {});
  var result = value;
  if (Array.isArray(value) && value.length > 1) {
    result = value.join(', ');
  }
  return /*#__PURE__*/React.createElement("div", styles('popover'), title ? /*#__PURE__*/React.createElement("div", styles('popoverTitle'), title) : null, result);
};
var defaultValueRenderer = function defaultValueRenderer(value) {
  var result = value;
  if (Array.isArray(value) && value.length) {
    result = value[0];
    if (value.length > 1) {
      result = "".concat(String(value[0]), " +").concat(value.length - 1);
    }
  }
  return result ? String(result) : null;
};
var popoverStyles = function popoverStyles(_ref5) {
  var color = _ref5.color;
  return {
    popover: {
      color: color.text.inactive
    },
    popoverTitle: {
      fontWeight: 600
    }
  };
};
ChipDropdown.DefaultPopover = DefaultPopover;
ChipDropdown.defaultValueRenderer = defaultValueRenderer;
var ChipDropdown$1 = ChipDropdown;var _excluded$m = ["title", "value", "filterLabel", "emptyLabel", "shouldDisplayLabelValue", "loading", "disabled", "children"];
function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MAX_LIST_HEIGHT = 272;
var MIN_LIST_HEIGHT = 72;
var ITEM_HEIGHT = 40;
var ChipMultiSelect = function ChipMultiSelect(_ref) {
  var title = _ref.title,
    value = _ref.value,
    filterLabel = _ref.filterLabel,
    emptyLabel = _ref.emptyLabel,
    _ref$shouldDisplayLab = _ref.shouldDisplayLabelValue,
    shouldDisplayLabelValue = _ref$shouldDisplayLab === void 0 ? false : _ref$shouldDisplayLab,
    loading = _ref.loading,
    disabled = _ref.disabled,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$m);
  var style = useStyles$1(defaultStyles$4, {}, {});
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchQuery = _useState2[0],
    setSearchQuery = _useState2[1];
  var optionsData = Children.toArray(children).map(function (_ref2) {
    var props = _ref2.props;
    return props;
  });
  var findOptionByValue = function findOptionByValue(value) {
    return optionsData.find(function (option) {
      return JSON.stringify(option === null || option === void 0 ? void 0 : option.value) === JSON.stringify(value);
    });
  };
  var initialValues = value === null || value === void 0 ? void 0 : value.filter(findOptionByValue);
  var selectedEntries = initialValues || [];
  var selectedOptions = [];
  var unselectedOptions = [];
  var onSelectionChange = function onSelectionChange(data, setValue) {
    var selection = _toConsumableArray(selectedEntries);
    var selectionIndex = selection.indexOf(data.value);
    if (selectionIndex !== -1) {
      selection.splice(selectionIndex, 1);
    } else {
      selection.push(data.value);
    }
    selectedEntries = selection;
    setValue === null || setValue === void 0 ? void 0 : setValue(selection);
  };
  Children.forEach(children, function (child, i) {
    var _child$props, _child$props2;
    if (nameIncludesQuery((_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.label, searchQuery) || nameIncludesQuery((_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.caption, searchQuery)) {
      var _child$props3;
      if (value !== null && value !== void 0 && value.includes((_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : _child$props3.value)) {
        selectedOptions.push(child);
      } else {
        unselectedOptions.push(child);
      }
    }
  });
  var mapCheckboxPropsToChild = function mapCheckboxPropsToChild(child, setValue) {
    if (!(child !== null && child !== void 0 && child.props)) return child;
    var checked = selectedEntries.some(function (entry) {
      return JSON.stringify(entry) === JSON.stringify(child.props.value);
    });
    var onChange = function onChange() {
      return onSelectionChange(child.props, setValue);
    };
    return _objectSpread$e(_objectSpread$e({}, child), {}, {
      props: _objectSpread$e(_objectSpread$e({}, child.props), {}, {
        checked: checked,
        onChange: onChange
      })
    });
  };
  var getDisplayValue = function getDisplayValue(value) {
    var _findOptionByValue;
    return (_findOptionByValue = findOptionByValue(value)) === null || _findOptionByValue === void 0 ? void 0 : _findOptionByValue.label;
  };
  var options = !!optionsData.length ? [].concat(selectedOptions, [selectedOptions.length && unselectedOptions.length ? /*#__PURE__*/React.createElement(DividerUnsealed, null) : null], unselectedOptions).filter(Boolean) : [/*#__PURE__*/React.createElement("div", style('emptyContainer'), emptyLabel)];
  return /*#__PURE__*/React.createElement(ChipDropdown$1, _extends({}, rest, {
    title: title,
    defaultValue: initialValues,
    disabled: disabled,
    valueRenderer: shouldDisplayLabelValue ? function (selectedValues) {
      return ChipDropdown$1.defaultValueRenderer(selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(getDisplayValue)) || null;
    } : undefined,
    popoverRenderer: function popoverRenderer(selectedValues) {
      return !disabled && /*#__PURE__*/React.createElement(ChipDropdown$1.DefaultPopover, {
        title: title,
        value: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(getDisplayValue)
      });
    }
  }), function (setValue) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, (optionsData === null || optionsData === void 0 ? void 0 : optionsData.length) > 20 ? /*#__PURE__*/React.createElement("div", style('input'), /*#__PURE__*/React.createElement(InputBase, {
      label: filterLabel,
      value: searchQuery,
      onChange: function onChange(value) {
        return setSearchQuery(value);
      }
    })) : null, /*#__PURE__*/React.createElement("div", style('list'), loading ? /*#__PURE__*/React.createElement("div", style('emptyContainer'), /*#__PURE__*/React.createElement(SpinnerUnsealed, null)) : /*#__PURE__*/React.createElement(VirtualList, _extends({}, style('virtualList'), {
      height: getListHeight(options.length),
      itemCount: options.length,
      itemSize: optionsData !== null && optionsData !== void 0 && optionsData.length ? ITEM_HEIGHT : MIN_LIST_HEIGHT,
      overscanCount: 30,
      renderItem: function renderItem(_ref3) {
        var index = _ref3.index,
          style = _ref3.style;
        return /*#__PURE__*/React.createElement("div", {
          style: style
        }, mapCheckboxPropsToChild(options[index], setValue));
      }
    }))));
  });
};
function ChipMultiSelectOption(_ref4) {
  _ref4.id;
    var label = _ref4.label,
    caption = _ref4.caption,
    identifier = _ref4.identifier,
    checked = _ref4.checked,
    onChange = _ref4.onChange;
  var styles = useStyles$1(defaultOptionStyles, {}, {});
  var showPopover = label.length > 28 || caption && caption.length > 28;
  return /*#__PURE__*/React.createElement(PopoverUnsealed, {
    position: "right",
    keepOpenOnHover: true,
    style: styles('popover'),
    trigger: showPopover ? 'hover' : 'controlled',
    popover: caption ? /*#__PURE__*/React.createElement(ChipDropdown$1.DefaultPopover, {
      title: label,
      value: caption
    }) : label
  }, /*#__PURE__*/React.createElement(CheckboxUnsealed, {
    style: styles('checkbox'),
    checked: checked,
    "aria-checked": checked,
    onChange: onChange,
    "aria-label": label
  }, /*#__PURE__*/React.createElement("div", styles('content'), identifier ? identifier : null, /*#__PURE__*/React.createElement("div", styles('labelContainer'), label && /*#__PURE__*/React.createElement("span", _extends({
    "data-testid": "list-item-label"
  }, styles('label')), label), caption && /*#__PURE__*/React.createElement("span", styles(['label', 'caption']), caption)))));
}
var nameIncludesQuery = function nameIncludesQuery(name, query) {
  return !query || !!(name !== null && name !== void 0 && name.toLowerCase().includes(query.toLowerCase()));
};
var getListHeight = function getListHeight(count) {
  var calculatedHeight = ITEM_HEIGHT * count;
  if (calculatedHeight > MAX_LIST_HEIGHT) {
    return MAX_LIST_HEIGHT;
  } else if (calculatedHeight < MIN_LIST_HEIGHT) {
    return MIN_LIST_HEIGHT;
  }
  return calculatedHeight;
};
var defaultStyles$4 = function defaultStyles(_ref5) {
  var padding = _ref5.padding,
    spacing = _ref5.spacing,
    color = _ref5.color;
  return {
    list: {
      maxHeight: MAX_LIST_HEIGHT,
      minHeight: MIN_LIST_HEIGHT,
      width: 300,
      overflow: 'hidden',
      padding: "".concat(padding.xsmall, "px 0")
    },
    virtualList: {
      overflowX: 'hidden !important'
    },
    input: {
      padding: "0 ".concat(spacing.xsmall, "px")
    },
    emptyContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      color: color.text.disabled,
      padding: padding.normal,
      textAlign: 'center'
    }
  };
};
var defaultOptionStyles = function defaultOptionStyles(_ref6) {
  var spacing = _ref6.spacing,
    color = _ref6.color,
    font = _ref6.font;
  return {
    popover: {
      width: '100%'
    },
    checkbox: {
      padding: "0 ".concat(spacing.xsmall, "px"),
      height: ITEM_HEIGHT,
      ':hover': {
        backgroundColor: color.hover.base,
        '& i': {
          background: 'none'
        }
      }
    },
    content: {
      display: 'flex',
      alignItems: 'center'
    },
    labelContainer: {
      width: 200,
      marginLeft: spacing.xxsmall
    },
    label: _objectSpread$e({
      display: 'block'
    }, styles.ellipsis()),
    caption: {
      fontSize: font.size.small,
      color: color.text.inactive
    }
  };
};
ChipMultiSelect.Option = ChipMultiSelectOption;
var ChipMultiSelect$1 = ChipMultiSelect;var InputErrorMessage = function InputErrorMessage(_ref) {
  var error = _ref.error;
  var style = useStyles$1(defaultStyles$3, {}, {});
  return _typeof(error) === 'object' && error !== null && error !== void 0 && error.message ? /*#__PURE__*/React.createElement("span", style, error.message) : null;
};
var defaultStyles$3 = function defaultStyles(_ref2) {
  var color = _ref2.color;
  return {
    display: 'block',
    color: color.coloredText.danger
  };
};
var InputErrorMessage$1 = InputErrorMessage;var _excluded$l = ["title", "value", "min", "max", "minPlaceholder", "maxPlaceholder", "minLabel", "maxLabel", "valueSeparator", "onChange", "error", "disabled"];
var ChipNumberRangeInput = function ChipNumberRangeInput(_ref) {
  var title = _ref.title,
    value = _ref.value,
    min = _ref.min,
    max = _ref.max,
    minPlaceholder = _ref.minPlaceholder,
    maxPlaceholder = _ref.maxPlaceholder,
    minLabel = _ref.minLabel,
    maxLabel = _ref.maxLabel,
    _ref$valueSeparator = _ref.valueSeparator,
    valueSeparator = _ref$valueSeparator === void 0 ? '-' : _ref$valueSeparator,
    _onChange = _ref.onChange,
    error = _ref.error,
    disabled = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded$l);
  var styles = useStyles$1(defaultStyles$2, {}, {});
  var _useState = useState((value === null || value === void 0 ? void 0 : value[0]) || null),
    _useState2 = _slicedToArray(_useState, 2),
    minInput = _useState2[0],
    setMinInput = _useState2[1];
  var _useState3 = useState((value === null || value === void 0 ? void 0 : value[1]) || null),
    _useState4 = _slicedToArray(_useState3, 2),
    maxInput = _useState4[0],
    setMaxInput = _useState4[1];
  if (min && isNaN(min)) {
    throw new Error("min prop value of ".concat(String(min), " can only be a number, null or undefined"));
  }
  if (max && isNaN(max)) {
    throw new Error("max prop value of ".concat(String(max), " can only be a number, null or undefined"));
  }
  return /*#__PURE__*/React.createElement(ChipDropdown$1, _extends({}, rest, {
    title: title,
    defaultValue: value,
    disabled: disabled,
    disableApply: !!error,
    valueRenderer: function valueRenderer(selectedValues) {
      return ChipDropdown$1.defaultValueRenderer(selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.join(" ".concat(valueSeparator, " "))) || null;
    },
    popoverRenderer: function popoverRenderer(selectedValues) {
      return !disabled && /*#__PURE__*/React.createElement(ChipDropdown$1.DefaultPopover, {
        title: title,
        value: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.join(" ".concat(valueSeparator, " "))
      });
    }
  }), function (setValue) {
    return /*#__PURE__*/React.createElement("div", styles, /*#__PURE__*/React.createElement("div", styles('range'), /*#__PURE__*/React.createElement(NumberInputUnsealed, {
      autoFocus: true,
      floatingLabelFixed: true,
      min: min,
      max: max,
      value: minInput,
      label: minLabel,
      placeholder: minPlaceholder,
      onChange: function onChange(minNumber) {
        setMinInput(minNumber);
        var range = [Number(minNumber), Number(maxInput) || null];
        _onChange && _onChange(range);
        setValue(range);
      }
    }), /*#__PURE__*/React.createElement("span", styles('spacer'), valueSeparator), /*#__PURE__*/React.createElement(NumberInputUnsealed, {
      floatingLabelFixed: true,
      min: min,
      max: max,
      value: maxInput,
      label: maxLabel,
      placeholder: maxPlaceholder,
      onChange: function onChange(maxNumber) {
        setMaxInput(maxNumber);
        var range = [Number(minInput) || null, Number(maxNumber)];
        _onChange && _onChange(range);
        setValue(range);
      }
    })), /*#__PURE__*/React.createElement(InputErrorMessage$1, {
      error: error
    }));
  });
};
var defaultStyles$2 = function defaultStyles(_ref2) {
  var color = _ref2.color,
    padding = _ref2.padding;
  return {
    padding: "0 ".concat(padding.normal, "px"),
    width: 300,
    range: {
      display: 'flex',
      alignItems: 'baseline'
    },
    spacer: {
      padding: "0 ".concat(padding.normal, "px")
    },
    error: {
      color: color.coloredText.danger
    }
  };
};
var ChipNumberRangeInput$1 = ChipNumberRangeInput;var _excluded$k = ["title", "value", "children", "displayFormat", "minDate", "maxDate", "fromLabel", "toLabel", "onChange", "error", "locale", "disabled"];
function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var FOCUSABLE_INPUTS = Object.freeze({
  FROM: 'FROM',
  TO: 'TO'
});
var VALUE_FORMAT = 'yyyy-MM-dd';
var ChipDateRangePicker = function ChipDateRangePicker(_ref) {
  var title = _ref.title,
    value = _ref.value,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? [] : _ref$children,
    _ref$displayFormat = _ref.displayFormat,
    displayFormat = _ref$displayFormat === void 0 ? 'dd/MM/yyyy' : _ref$displayFormat,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    fromLabel = _ref.fromLabel,
    toLabel = _ref.toLabel,
    onChange = _ref.onChange,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? null : _ref$error,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? window.navigator.userLanguage || window.navigator.language : _ref$locale,
    disabled = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded$k);
  var parsedMinDate = useMemo(function () {
    return minDate ? parse(minDate, VALUE_FORMAT, new Date()) : new Date('1970-01-01');
  }, [minDate]);
  var parsedMaxDate = useMemo(function () {
    return maxDate ? parse(maxDate, VALUE_FORMAT, new Date()) : null;
  }, [maxDate]);
  var parseDate = useCallback(function (date) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : VALUE_FORMAT;
    if (!date) return null;
    var parsedDate = parse(date, format, new Date());
    var isDateValid = isValid(parsedDate);
    var isAfterMin = isAfter(parsedDate, parsedMinDate) || isEqual(parsedDate, parsedMinDate);
    var isBeforeMax = !parsedMaxDate || isAfter(parsedMaxDate, parsedDate) || isEqual(parsedMaxDate, parsedDate);
    return isDateValid && isAfterMin && isBeforeMax ? parsedDate : null;
  }, [parsedMaxDate, parsedMinDate]);
  var formatValueDateToDisplay = useCallback(function (date) {
    var parsedDate = parseDate(date);
    return parsedDate ? format(parsedDate, displayFormat) : null;
  }, [displayFormat, parseDate]);
  var formatDisplayDateToValue = useCallback(function (date) {
    var parsedDate = parseDate(date, displayFormat);
    return parsedDate ? format(parsedDate, VALUE_FORMAT) : null;
  }, [displayFormat, parseDate]);
  var inputsRef = useRef();
  var optionsData = Children.toArray(children).map(function (_ref2) {
    var props = _ref2.props;
    return props;
  });
  var _useState = useState(value || [null, null]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedValues = _useState2[0],
    setSelectedValues = _useState2[1];
  var _useState3 = useState(value && !!(optionsData !== null && optionsData !== void 0 && optionsData.find(function (option) {
      return option.isCustomEntry;
    })) && !(optionsData !== null && optionsData !== void 0 && optionsData.find(function (option) {
      return JSON.stringify(option.value) === JSON.stringify(value);
    }))),
    _useState4 = _slicedToArray(_useState3, 2),
    isCustomEntrySelected = _useState4[0],
    setIsCustomEntrySelected = _useState4[1];
  var _useState5 = useState(formatValueDateToDisplay(value === null || value === void 0 ? void 0 : value[0])),
    _useState6 = _slicedToArray(_useState5, 2),
    fromInput = _useState6[0],
    setFromInput = _useState6[1];
  var _useState7 = useState(formatValueDateToDisplay(value === null || value === void 0 ? void 0 : value[1])),
    _useState8 = _slicedToArray(_useState7, 2),
    toInput = _useState8[0],
    setToInput = _useState8[1];
  var _useState9 = useState(FOCUSABLE_INPUTS.FROM),
    _useState10 = _slicedToArray(_useState9, 2),
    focusedInput = _useState10[0],
    setFocusedInput = _useState10[1];
  var selectedValuesAreValid = !!(selectedValues !== null && selectedValues !== void 0 && selectedValues.every(validateValueFormat));
  var hasOptions = !!(optionsData !== null && optionsData !== void 0 && optionsData.length);
  var style = useStyles$1(defaultStyles$1, {}, {
    '&isCalendarOpen': !!isCustomEntrySelected
  });
  var transformValueToDisplay = function transformValueToDisplay(value) {
    return (value === null || value === void 0 ? void 0 : value.filter(function (date, index) {
      return value && value.indexOf(date) === index;
    }).map(function (date) {
      return formatValueDateToDisplay(date);
    }).join(' - ')) || null;
  };
  var getNextDateValues = function getNextDateValues(formattedDate) {
    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : focusedInput;
    return location === FOCUSABLE_INPUTS.FROM ? [formattedDate, (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues[1]) || null] : [(selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues[0]) || null, formattedDate];
  };
  var toggleInputFocus = function toggleInputFocus(dateValues, setValue) {
    var _inputsRef$current;
    var _ref3 = ((_inputsRef$current = inputsRef.current) === null || _inputsRef$current === void 0 ? void 0 : _inputsRef$current.querySelectorAll('input')) || [],
      _ref4 = _slicedToArray(_ref3, 2),
      firstInput = _ref4[0],
      secondInput = _ref4[1];
    var _ref5 = dateValues || [],
      _ref6 = _slicedToArray(_ref5, 2),
      firstDate = _ref6[0],
      secondDate = _ref6[1];
    if (focusedInput === FOCUSABLE_INPUTS.FROM) {
      if (firstDate && secondDate && isAfter(new Date(firstDate), new Date(secondDate))) {
        setSelectedValues([firstDate, null]);
        setValue([firstDate, null]);
      }
      secondInput.focus();
      setFocusedInput(FOCUSABLE_INPUTS.TO);
    } else if (focusedInput === FOCUSABLE_INPUTS.TO) {
      if (firstDate && secondDate && isAfter(new Date(firstDate), new Date(secondDate))) {
        setSelectedValues([null, secondDate]);
        setValue([null, secondDate]);
        firstInput.focus();
        setFocusedInput(FOCUSABLE_INPUTS.FROM);
      }
    }
  };
  var isChecked = function isChecked(_ref7) {
    var value = _ref7.value,
      isCustomEntry = _ref7.isCustomEntry;
    if (isCustomEntrySelected) {
      return !!isCustomEntry;
    } else {
      return JSON.stringify(value) === JSON.stringify(selectedValues);
    }
  };
  var onRadioButtonSelect = function onRadioButtonSelect(_ref8) {
    var value = _ref8.value,
      isCustomEntry = _ref8.isCustomEntry,
      setValue = _ref8.setValue;
    setIsCustomEntrySelected(isCustomEntry);
    !isCustomEntry && (onChange === null || onChange === void 0 ? void 0 : onChange(value));
    setSelectedValues(value);
    setValue(value);
  };
  var onDateChange = function onDateChange(formattedDate, location) {
    var nextDateValues = getNextDateValues(formattedDate, location);
    onChange === null || onChange === void 0 ? void 0 : onChange(nextDateValues);
    setSelectedValues(nextDateValues);
    return nextDateValues;
  };
  var renderOptions = function renderOptions(setValue) {
    return Children.map(children, function (child) {
      var props = child.props;
      var checked = isChecked(props);
      var onClick = function onClick() {
        return onRadioButtonSelect(_objectSpread$d(_objectSpread$d({}, props), {}, {
          setValue: setValue
        }));
      };
      return _objectSpread$d(_objectSpread$d({}, child), {}, {
        props: _objectSpread$d(_objectSpread$d({}, props), {}, {
          checked: checked,
          onClick: onClick
        })
      });
    });
  };
  return /*#__PURE__*/React.createElement(ChipDropdown$1, _extends({}, rest, {
    title: title,
    defaultValue: value,
    valueRenderer: transformValueToDisplay,
    popoverRenderer: function popoverRenderer(value) {
      return !disabled && /*#__PURE__*/React.createElement(ChipDropdown$1.DefaultPopover, {
        title: title,
        value: transformValueToDisplay(value)
      });
    },
    disableApply: !!error || (isCustomEntrySelected ? !selectedValuesAreValid : false),
    disabled: disabled
  }), function (setValue) {
    return /*#__PURE__*/React.createElement("div", style('container'), hasOptions ? /*#__PURE__*/React.createElement("div", style('radioGroup'), renderOptions(setValue)) : null, isCustomEntrySelected || !hasOptions ? /*#__PURE__*/React.createElement("div", _extends({}, style('calendar'), {
      ref: inputsRef
    }), /*#__PURE__*/React.createElement(Stack, _extends({
      direction: "horizontal",
      spacing: "small"
    }, style('inputs')), /*#__PURE__*/React.createElement(InputBase, {
      placeholder: displayFormat,
      label: fromLabel,
      value: fromInput || formatValueDateToDisplay(selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues[0]),
      onFocus: function onFocus() {
        return setFocusedInput(FOCUSABLE_INPUTS.FROM);
      },
      onChange: function onChange(value) {
        setFromInput(value);
        var formattedValue = formatDisplayDateToValue(value);
        if (formattedValue) {
          var nextDateValues = onDateChange(formattedValue, FOCUSABLE_INPUTS.FROM);
          setValue(nextDateValues);
          toggleInputFocus(nextDateValues, setValue);
          setFromInput(null);
        } else if ((value === null || value === void 0 ? void 0 : value.length) === (displayFormat === null || displayFormat === void 0 ? void 0 : displayFormat.length)) {
          setFromInput(null);
        }
      }
    }), /*#__PURE__*/React.createElement(InputBase, {
      placeholder: displayFormat,
      label: toLabel,
      value: toInput || formatValueDateToDisplay(selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues[1]),
      onFocus: function onFocus() {
        return setFocusedInput(FOCUSABLE_INPUTS.TO);
      },
      onChange: function onChange(value) {
        setToInput(value);
        var formattedValue = formatDisplayDateToValue(value);
        if (formattedValue) {
          var nextDateValues = onDateChange(formattedValue, FOCUSABLE_INPUTS.TO);
          setValue(nextDateValues);
          toggleInputFocus(nextDateValues, setValue);
          setToInput(null);
        } else if ((value === null || value === void 0 ? void 0 : value.length) === (displayFormat === null || displayFormat === void 0 ? void 0 : displayFormat.length)) {
          setToInput(null);
        }
      }
    })), /*#__PURE__*/React.createElement(InputErrorMessage$1, {
      error: error
    }), /*#__PURE__*/React.createElement(DatePickerUnsealed, {
      value: selectedValues,
      minDate: minDate,
      maxDate: maxDate,
      onChange: function onChange(value) {
        var valueDate = new Date(value);
        var date = new Date(valueDate.getTime() - valueDate.getTimezoneOffset() * 60000);
        var formattedDate = format(date, VALUE_FORMAT);
        var nextDateValues = onDateChange(formattedDate);
        setValue(nextDateValues);
        setFromInput(null);
        setToInput(null);
        toggleInputFocus(nextDateValues, setValue);
      },
      locale: locale,
      autofocus: false
    })) : null);
  });
};
function ChipDateRangePickerOption(_ref9) {
  var label = _ref9.label,
    value = _ref9.value,
    checked = _ref9.checked,
    onClick = _ref9.onClick;
  var styles = useStyles$1(defaultRadioStyles, {}, {});
  return /*#__PURE__*/React.createElement(RadioButtonUnsealed, {
    "aria-label": label,
    value: value || '',
    style: styles,
    onClick: onClick,
    checked: checked
  }, label);
}
var validateValueFormat = function validateValueFormat(value) {
  if (!!value) {
    if (isMatch(value, VALUE_FORMAT)) {
      return true;
    } else {
      throw new Error("Value ".concat(value, " received is not in the correct format ").concat(VALUE_FORMAT));
    }
  }
  return false;
};
var CALENDAR_WIDTH = 320;
var defaultStyles$1 = function defaultStyles(_ref10) {
  var color = _ref10.color,
    spacing = _ref10.spacing;
  return {
    container: {
      display: 'flex',
      flexDirection: 'row'
    },
    radioGroup: {
      paddingTop: spacing.small,
      width: '100%',
      maxWidth: CALENDAR_WIDTH
    },
    inputs: {
      width: CALENDAR_WIDTH,
      display: 'flex',
      flexDirection: 'row'
    },
    calendar: {
      padding: "0 ".concat(spacing.xsmall, "px")
    },
    '&isCalendarOpen': {
      radioGroup: {
        width: 'unset',
        borderRight: "1px solid ".concat(color.divider.base)
      }
    }
  };
};
var defaultRadioStyles = function defaultRadioStyles(_ref11) {
  var spacing = _ref11.spacing,
    color = _ref11.color;
  return {
    padding: spacing.xsmall,
    width: '100%',
    ':hover': {
      backgroundColor: color.hover.base,
      '& i': {
        background: 'none'
      }
    }
  };
};
ChipDateRangePicker.Option = ChipDateRangePickerOption;
var ChipDateRangePicker$1 = ChipDateRangePicker;var _excluded$j = ["title", "value", "placeholder", "disabled", "error", "onChange"];
var ChipTextInput = function ChipTextInput(_ref) {
  var title = _ref.title,
    value = _ref.value,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$j);
  var styles = useStyles$1(defaultStyles, {}, {});
  var popoverRenderer = disabled ? function () {
    return false;
  } : undefined;
  var ClearableInput = uncontrollable()(clearable$1(InputBase));
  return /*#__PURE__*/React.createElement(ChipDropdown$1, _extends({}, rest, {
    title: title,
    defaultValue: value,
    disableApply: !!error,
    disabled: disabled,
    popoverRenderer: popoverRenderer
  }), function (setValue) {
    return /*#__PURE__*/React.createElement("div", styles, /*#__PURE__*/React.createElement(ClearableInput, {
      autoFocus: true,
      floatingLabelFixed: true,
      defaultValue: value,
      "aria-label": title,
      placeholder: placeholder,
      onChange: function onChange(text) {
        var sanitizedText = text === null || text === void 0 ? void 0 : text.trim();
        _onChange && _onChange(sanitizedText);
        setValue(sanitizedText);
      }
    }), /*#__PURE__*/React.createElement(InputErrorMessage$1, {
      error: error
    }));
  });
};
var defaultStyles = function defaultStyles(_ref2) {
  _ref2.color;
    var padding = _ref2.padding;
  return {
    padding: "0 ".concat(padding.normal, "px"),
    width: 300
  };
};
var ChipTextInput$1 = ChipTextInput;var Button$1 = sealStyleProp$1(Button$7);
var Breadcrumb = sealStyleProp$1(BreadcrumbUnsealed);
var BreadcrumbItem = sealStyleProp$1(BreadcrumbItemUnsealed);
var FlatOnDarkButton = sealStyleProp$1(Button$3);
var PrimaryButton = sealStyleProp$1(Button$6);
var OutlineOnDarkButton = sealStyleProp$1(Button$5);
var DangerButton = sealStyleProp$1(DangerButton$3);
var FlatDangerButton = sealStyleProp$1(DangerButton$2);
var OutlineDangerButton = sealStyleProp$1(DangerButton$1);
var IconButton$2 = sealStyleProp$1(IconButton$3);
var OnDarkIconButton = sealStyleProp$1(OnDarkIconButton$1);
var ContainedIconButton = sealStyleProp$1(ContainedIconButton$2);
var ConfirmButton$2 = sealStyleProp$1(ConfirmButtonUnsealed);
var DropdownButton$2 = sealStyleProp$1(DropdownButtonUnsealed);
var FileSelect$2 = sealStyleProp$1(FileSelectUnsealed);
var CountIndicator = sealStyleProp$1(CountIndicatorUnsealed);
var NotificationIndicator = sealStyleProp$1(NotificationIndicatorUnsealed);
var Header = sealStyleProp$1(HeaderUnsealed);
var HeaderTab = sealStyleProp$1(HeaderTabUnsealed);
var Logo = sealStyleProp$1(LogoUnsealed);
var UserMenu = sealStyleProp$1(UserMenuUnsealed);
var MenuItem = sealStyleProp$1(MenuItemUnsealed);
var AppIcon = sealStyleProp$1(AppIconUnsealed);
var Icon = sealStyleProp$1(Icon$2);
var Spinner = sealStyleProp$1(SpinnerUnsealed);
var DragHandle = sealStyleProp$1(DragHandleUnsealed);
var InputWithButton$1 = sealStyleProp$1(InputWithButtonUnsealed);
var DropdownSelect$2 = sealStyleProp$1(DropdownSelectUnsealed);
var DropdownMultiSelect = sealStyleProp$1(DropdownMultiSelectUnsealed);
var Input$1 = sealStyleProp$1(InputBase);
var EmailInput = sealStyleProp$1(EmailInputUnsealed);
var ColorInput$1 = sealStyleProp$1(ColorInputUnsealed);
var NumberInput = sealStyleProp$1(NumberInputUnsealed);
var NumberUnitInput = sealStyleProp$1(NumberUnitInputUnsealed);
var UrlInput = sealStyleProp$1(UrlInputUnsealed);
var FileInput = sealStyleProp$1(FileInputUnsealed);
var FileMultiInput = sealStyleProp$1(FileMultiInputUnsealed);
var Group = sealStyleProp$1(GroupUnsealed);
var Textarea = sealStyleProp$1(TextareaUnsealed);
var DateInput = sealStyleProp$1(DateInputUnsealed);
var TimeInput = sealStyleProp$1(TimeInputUnsealed);
var DateTimeInput = sealStyleProp$1(DateTimeInputUnsealed);
var DatePicker = sealStyleProp$1(DatePickerUnsealed);
var TitleInput = sealStyleProp$1(TitleInput$1);
var Checkbox$2 = sealStyleProp$1(CheckboxUnsealed);
var CheckboxGroup = sealStyleProp$1(CheckboxGroup$1);
var RadioButton = sealStyleProp$1(RadioButtonUnsealed);
var RadioGroup = sealStyleProp$1(RadioGroupUnsealed);
var Card = sealStyleProp$1(CardUnsealed);
var Divider = sealStyleProp$1(DividerUnsealed);
var List = sealStyleProp$1(ListUnsealed);
var Tile = sealStyleProp$1(Tile$2);
var TextTile = sealStyleProp$1(TextTileUnsealed);
var PlaceholderTile = sealStyleProp$1(PlaceholderTileUnsealed);
var TabBar = sealStyleProp$1(TabBarUnsealed);
var Tab = sealStyleProp$1(TabUnsealed);
var Sidebar = sealStyleProp$1(SidebarUnsealed);
var SidebarItem = sealStyleProp$1(SidebarItemUnsealed);
var Modal$3 = sealStyleProp$1(ModalUnsealed);
var DangerDialog = sealStyleProp$1(DangerDialogUnsealed);
var Dialog = sealStyleProp$1(DialogUnsealed);
var InfoToast = sealStyleProp$1(InfoToast$1);
var SuccessToast = sealStyleProp$1(SuccessToast$1);
var WarningToast = sealStyleProp$1(WarningToast$1);
var ProgressIndicator = sealStyleProp$1(ProgressIndicator$1);
var DangerToast = sealStyleProp$1(DangerToastUnsealed);
var ToastsContainer$2 = sealStyleProp$1(ToastsContainer$3);
var Empty = sealStyleProp$1(Empty$2);
var Popover = sealStyleProp$1(PopoverUnsealed);
var Hint$2 = sealStyleProp$1(HintUnsealed);
var ContrastHint = sealStyleProp$1(ContrastHintUnsealed);
var DangerHint = sealStyleProp$1(DangerHintUnsealed);
var DangerContrastHint = sealStyleProp$1(DangerContrastHintUnsealed);
var OhSnap = sealStyleProp$1(OhSnapUnsealed);
var Table = sealStyleProp$1(Table$1);
var Cell = sealStyleProp$1(CellUnsealed);
var HeaderCell = sealStyleProp$1(HeaderCellUnsealed);
var NumberCell = sealStyleProp$1(NumberCell$1);
var DetailsPanel = sealStyleProp$1(DetailsPanelUnsealed);
var ProgressBar = sealStyleProp$1(ProgressBarUnsealed);
var DropZone = sealStyleProp$1(DropZoneUnsealed);
var Avatar = sealStyleProp$1(AvatarUnsealed);
var Hidden = sealStyleProp$1(Hidden$1);
var Visible = sealStyleProp$1(Visible$1);
var Title1 = sealStyleProp$1(Title1Unsealed);
var Title2 = sealStyleProp$1(Title2Unsealed);
var Title3 = sealStyleProp$1(Title3Unsealed);
var Title4 = sealStyleProp$1(Title4Unsealed);
var Article = sealStyleProp$1(ArticleUnsealed);
var Body = sealStyleProp$1(BodyUnsealed);
var Caption = sealStyleProp$1(Caption$1);
var StrongCaption = sealStyleProp$1(StrongCaption$1);
var PageTitle = sealStyleProp$1(PageTitleUnsealed);var ThemeColor = PT.shape({
  primary: PT.shape({
    light: PT.string,
    lighter: PT.string,
    base: PT.string,
    dark: PT.string
  }),
  secondary: PT.shape({
    light: PT.string,
    lighter: PT.string,
    base: PT.string,
    dark: PT.string
  }),
  header: PT.shape({
    primary: PT.string,
    secondary: PT.string,
    mono: PT.string
  }),
  mono: PT.shape({
    ultradark: PT.string,
    dark: PT.string,
    middle: PT.string,
    lighter: PT.string,
    light: PT.string,
    ultralight: PT.string
  }),
  status: PT.shape({
    info: PT.string,
    warning: PT.string,
    danger: PT.string
  })
});
var ThemeFont = PT.shape({
  size: PT.shape({
    xxsmall: PT.string,
    xsmall: PT.string,
    small: PT.string,
    button: PT.string,
    normal: PT.string,
    large: PT.string,
    xlarge: PT.string,
    xxlarge: PT.string,
    h1: PT.string,
    h2: PT.string
  }),
  weight: PT.shape({
    light: PT.number,
    normal: PT.number
  }),
  family: PT.shape({
    normal: PT.string,
    heading: PT.string
  })
});
var ThemePadding = PT.shape({
  normal: PT.number,
  large: PT.number,
  small: PT.number,
  xsmall: PT.number
});
var ThemeZIndex = PT.shape({
  popover: PT.number,
  toast: PT.number,
  modal: PT.number
});
var Theme = PT.shape({
  color: ThemeColor,
  font: ThemeFont,
  padding: ThemePadding,
  lineHeight: PT.number,
  zIndex: ThemeZIndex
});var index=/*#__PURE__*/Object.freeze({__proto__:null,Theme:Theme});var glyphCharMap = {
  "bullet-edge": 57344,
  "bullet-square": 57345,
  "breadcrumb-separator": 57351,
  "value-null": 57352,
  "value-any": 57353,
  "diff-added": 57354,
  "diff-removed": 57355,
  "point-left": 57356,
  "point-right": 57357,
  "bullet-box": 57358,
  "breadcrumb-return": 57359,
  "point-up": 57360,
  "point-down": 57361,
  "link": 57376,
  "job-profile": 57379,
  "release-note": 57381,
  "news": 57382,
  "blog-post": 57385,
  "idea": 57386,
  "whitepaper": 57387,
  "process-example": 57396,
  "quick-info": 57397,
  "email": 57440,
  "signavio-platform": 57445,
  "youtube": 57450,
  "feedback": 57456,
  "salesforce": 57457,
  "gdrive": 57459,
  "boxcom": 57460,
  "zapier": 57462,
  "language-en": 57632,
  "language-de": 57633,
  "language-fr": 57634,
  "language-es": 57635,
  "language": 57663,
  "home": 57664,
  "notification-center": 57665,
  "app-gallery": 57666,
  "user-unknown": 58048,
  "user": 58049,
  "user-group": 58050,
  "user-substitute": 58051,
  "admin": 58052,
  "admin-group": 58053,
  "user-perspective": 58054,
  "process-manager": 58112,
  "process-intelligence": 58116,
  "training": 58118,
  "collaboration-hub": 58120,
  "quickmodel": 58121,
  "simulation": 58130,
  "approval-workflow": 58132,
  "access-rights": 58135,
  "explorer": 58143,
  "comparator": 58144,
  "dictionary": 58145,
  "manual": 58146,
  "plugin-feature": 58147,
  "testlab": 58151,
  "artificial-intelligence": 58152,
  "file": 58368,
  "file-unknown": 58369,
  "file-attachment": 58370,
  "folder": 58371,
  "unique-id": 58373,
  "picture": 58374,
  "microsoft-word": 58375,
  "microsoft-excel": 58376,
  "microsoft-powerpoint": 58377,
  "adobe-pdf": 58378,
  "primary-key": 58379,
  "dictionary-item": 58380,
  "attribute-item": 58382,
  "boolean": 58383,
  "number": 58384,
  "string": 58385,
  "string-multiline": 58386,
  "time": 58387,
  "date": 58388,
  "datetime": 58389,
  "duration": 58390,
  "ratio": 58391,
  "range-number": 58392,
  "enumeration": 58394,
  "hierarchy": 58395,
  "currency": 58396,
  "case": 58397,
  "task": 58398,
  "workflow": 58399,
  "report": 58400,
  "log": 58401,
  "task-complex": 58402,
  "caldav-event": 58403,
  "string-email": 58404,
  "email-item": 58405,
  "filter": 58407,
  "software-license": 58408,
  "file-connector": 58409,
  "diagram-bpmn": 58410,
  "diagram-dmn": 58411,
  "diagram-archimate": 58412,
  "diagram-epc": 58413,
  "process-map": 58414,
  "organization-chart": 58415,
  "graph-unspecified": 58416,
  "file-archive": 58417,
  "string-uri": 58418,
  "data-binding": 58419,
  "customer-journey-map": 58420,
  "graph-process-discovery": 58421,
  "key-measure": 58422,
  "graph-heatmap": 58423,
  "graph-bars-h-desc": 58424,
  "graph-bars-v-desc": 58425,
  "task-script": 58426,
  "file-script": 58427,
  "google-doc": 58428,
  "google-spreadsheet": 58429,
  "google-slide": 58430,
  "organization": 58431,
  "milestone": 58432,
  "frequency": 58433,
  "manpower": 58434,
  "cost": 58435,
  "case-adhoc": 58436,
  "task-public": 58437,
  "table": 58438,
  "spreadsheet": 58439,
  "graph-histogram": 58440,
  "graph-timeline": 58441,
  "chapter": 58442,
  "starred-item": 58443,
  "grouping": 58445,
  "case-variant": 58446,
  "dictionary-team": 58448,
  "dictionary-document": 58449,
  "dictionary-activity": 58450,
  "dictionary-event": 58451,
  "dictionary-system": 58452,
  "dictionary-goal": 58453,
  "dictionary-requirement": 58454,
  "dictionary-risk": 58455,
  "dictionary-control": 58456,
  "dictionary-category": 58457,
  "dictionary-entry": 58458,
  "recent": 58459,
  "spacing-tool": 58460,
  "formula": 58461,
  "text-style": 58462,
  "navigation-map": 58463,
  "graph-sankey": 58464,
  "graph-box-whisker": 58465,
  "graph-conformance": 58466,
  "expand": 58624,
  "collapse": 58625,
  "nav-prev": 58626,
  "nav-next": 58627,
  "menu-slide-out": 58628,
  "menu-slide-in": 58629,
  "menu-overlay-open": 58631,
  "menu-overlay-close": 58632,
  "dropdown-open": 58633,
  "dropdown-close": 58634,
  "refresh": 58639,
  "search": 58640,
  "reset": 58641,
  "remove": 58642,
  "item-create": 58644,
  "save": 58645,
  "edit": 58646,
  "comment": 58647,
  "item-rename": 58649,
  "file-move": 58650,
  "undo": 58655,
  "redo": 58656,
  "print": 58657,
  "overlay-show": 58658,
  "overlay-risk-control": 58659,
  "canvas-expand-left": 58660,
  "canvas-shrink-left": 58661,
  "canvas-expand-right": 58662,
  "canvas-shrink-right": 58663,
  "canvas-expand-top": 58664,
  "canvas-shrink-top": 58665,
  "canvas-expand-bottom": 58666,
  "canvas-shrink-bottom": 58667,
  "trace-link": 58668,
  "select-none": 58669,
  "import": 58670,
  "export": 58671,
  "merge": 58672,
  "share": 58673,
  "configure": 58674,
  "panel-pin": 58675,
  "account-logout": 58677,
  "clipboard-copy": 58678,
  "clipboard-cut": 58679,
  "clipboard-paste": 58680,
  "file-download": 58681,
  "file-upload": 58682,
  "terminate": 58683,
  "atomize": 58684,
  "differentiate": 58685,
  "decision-run": 58686,
  "remap": 58687,
  "nav-list": 58688,
  "organization-switch": 58690,
  "execute": 58691,
  "send": 58692,
  "show-more": 58695,
  "drag-sort": 58696,
  "skip-next": 58697,
  "skip-prev": 58698,
  "zoom": 58699,
  "user-reassign": 58700,
  "highlight": 58701,
  "zoom-out": 58702,
  "fullscreen-view": 58703,
  "fullscreen-escape": 58704,
  "panel-left-expand": 58705,
  "panel-left-collapse": 58706,
  "panel-right-expand": 58707,
  "panel-right-collapse": 58708,
  "panel-bottom-expand": 58709,
  "panel-bottom-collapse": 58710,
  "align-left": 58711,
  "align-right": 58712,
  "align-top": 58713,
  "align-bottom": 58714,
  "align-center-h": 58715,
  "align-center-v": 58716,
  "distribute-h": 58717,
  "distribute-v": 58718,
  "resize-equal": 58719,
  "zoom-fit": 58720,
  "zoom-reset": 58721,
  "apply-style": 58722,
  "clear-style": 58723,
  "check-conventions": 58724,
  "toolbar-group": 58725,
  "arrange-front": 58726,
  "arrange-back": 58727,
  "arrange-forward": 58728,
  "arrange-backward": 58729,
  "convert-shape": 58730,
  "outsource": 58731,
  "rotate": 58732,
  "tree-expand": 58733,
  "tree-collapse": 58734,
  "help": 58735,
  "add-lane": 58736,
  "add": 58737,
  "connect": 58738,
  "shift-row-up": 58739,
  "shift-row-down": 58740,
  "shift-column-left": 58741,
  "shift-column-right": 58742,
  "minimap": 58743,
  "dot-grid": 58744,
  "app-prev": 58745,
  "add-filter": 58746,
  "advanced-search": 58747,
  "accuracy-increase": 58748,
  "accuracy-decrease": 58749,
  "add-insight": 58750,
  "info": 59136,
  "success": 59137,
  "warning": 59138,
  "warning-emphasized": 59139,
  "error": 59140,
  "visible-confirmed": 59141,
  "visible": 59142,
  "invisible": 59143,
  "visible-conditionally": 59144,
  "starred": 59145,
  "unstarred": 59146,
  "visible-pending": 59147,
  "published": 59148,
  "concealed": 59149,
  "comment-discussing": 59150,
  "comment-agreed": 59151,
  "comment-declined": 59152,
  "risk": 59153,
  "control": 59154,
  "published-changed": 59155,
  "disabled": 59156,
  "maintenance": 59157,
  "folder-closed": 59159,
  "folder-open": 59160,
  "checkbox-false": 59161,
  "checkbox-true": 59162,
  "task-done": 59163,
  "task-undone": 59164,
  "case-closed": 59165,
  "case-open": 59166,
  "access-denied": 59167,
  "access-granted": 59168,
  "priority-unassigned": 59169,
  "priority-low": 59170,
  "priority-normal": 59171,
  "priority-high": 59172,
  "priority-escalated": 59173,
  "policy-read": 59174,
  "policy-write": 59175,
  "policy-execute": 59176,
  "policy-remove": 59177,
  "checkbox-indeterminate": 59178,
  "radio-button-false": 59179,
  "radio-button-true": 59180,
  "select-multiple": 59181,
  "order-ascending": 59182,
  "order-descending": 59183,
  "process-level": 59184,
  "view-list": 59190,
  "view-tiles": 59191,
  "font-size": 59192,
  "font-weight": 59193,
  "font-slant": 59194,
  "color-text": 59195,
  "color-fill": 59196,
  "color-stroke": 59197,
  "time-now": 59198,
  "variant": 59199,
  "relocated": 59200,
  "emotion-positive": 59201,
  "emotion-negative": 59202,
  "pass-steps": 59203,
  "pass-single": 59204,
  "pass-multi": 59205,
  "pass-reiterate": 59206,
  "pass-discontinue": 59207,
  "corner-rounded": 59208,
  "corner-straight": 59209,
  "density-compact": 59210,
  "density-default": 59211,
  "density-comfortable": 59212,
  "view-grid": 59213,
  "view-grouped": 59214,
  "notification-enabled": 59215,
  "notification-disabled": 59216,
  "landscape": 59217,
  "portrait": 59218,
  "landscape-straight": 59219,
  "landscape-clockwise": 59220,
  "landscape-counter-clockwise": 59221,
  "portrait-straight": 59222,
  "portrait-clockwise": 59223,
  "portrait-counter-clockwise": 59224,
  "flow-right": 59225,
  "flow-bottom": 59226,
  "emotion-neutral": 59227,
  "emotion-very-positive": 59228,
  "emotion-very-negative": 59229,
  "throughput-funnel": 59648,
  "process-insights": 59649,
  "metric": 59650,
  "drill-down": 59651,
  "drill-up": 59652,
  "sort": 59653,
  "trex": 60355,
  "wallet": 60358,
  "person": 60359,
  "cogwheel": 60360,
  "flash": 60361,
  "timer": 60362,
  "dashboard": 60363,
  "page": 60364,
  "exclamation-mark": 60365,
  "flag": 60366,
  "computer": 60367,
  "mail": 60368,
  "clipboard": 60369,
  "checked-tick": 60370,
  "checked-cross": 60371,
  "unchecked": 60372,
  "text": 60373,
  "balance": 60374,
  "rocket": 60375,
  "dollar": 60376,
  "bpmn-type-user": 61440,
  "bpmn-type-send": 61441,
  "bpmn-type-receive": 61442,
  "bpmn-type-manual": 61443,
  "bpmn-type-rule": 61444,
  "bpmn-type-service": 61445,
  "bpmn-type-script": 61446,
  "event-start": 61696,
  "event-end": 61697,
  "event-inter": 61698,
  "event-inter-catch-timer": 61699,
  "event-inter-throw-link": 61700,
  "gateway-xor": 61701,
  "gateway-parallel": 61702,
  "subprocess": 61703,
  "activity": 61704
};function useDeprecationWarning(componentName, futureComponentName) {
  useEffect(function () {
    warn(["Warning: You are using an outdated component. Legacy".concat(componentName, " will be removed in a future version of @signavio/ui. Please use ").concat(futureComponentName || componentName, " instead.\n"), "* replace import { Legacy".concat(componentName, " } from '@signavio/ui'"), "* with import { ".concat(futureComponentName || componentName, " } from '@signavio/ui\n")].join('\n'));
  }, [componentName, futureComponentName]);
}var _excluded$i = ["pulsate", "rippleX", "rippleY", "rippleSize", "style"],
  _excluded2$3 = ["style"];
function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Ripple = /*#__PURE__*/function (_React$Component) {
  _inherits(Ripple, _React$Component);
  var _super = _createSuper$6(Ripple);
  function Ripple() {
    var _this;
    _classCallCheck(this, Ripple);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      rippleVisible: false,
      rippleLeaving: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleEnter", function () {
      _this.setState({
        rippleVisible: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleExit", function () {
      _this.setState({
        rippleLeaving: true
      });
    });
    return _this;
  }
  _createClass(Ripple, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        pulsate = _this$props.pulsate,
        rippleX = _this$props.rippleX,
        rippleY = _this$props.rippleY,
        rippleSize = _this$props.rippleSize,
        style = _this$props.style,
        other = _objectWithoutProperties(_this$props, _excluded$i);
      var _this$state = this.state,
        rippleVisible = _this$state.rippleVisible,
        rippleLeaving = _this$state.rippleLeaving;
      var modifiedStyle = style({
        '&leaving': rippleLeaving,
        '&visible': rippleVisible,
        '&pulsate': pulsate
      });
      var _modifiedStyle = modifiedStyle('inner'),
        innerInlineStyles = _modifiedStyle.style,
        innerStyleAttrs = _objectWithoutProperties(_modifiedStyle, _excluded2$3);
      return /*#__PURE__*/React.createElement(Transition, _extends({
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), /*#__PURE__*/React.createElement("span", modifiedStyle, /*#__PURE__*/React.createElement("span", _extends({}, innerStyleAttrs, {
        style: _objectSpread$c(_objectSpread$c({}, innerInlineStyles), {}, {
          width: rippleSize,
          height: rippleSize,
          top: -(rippleSize / 2) + rippleY,
          left: -(rippleSize / 2) + rippleX
        })
      }))));
    }
  }]);
  return Ripple;
}(React.Component);
Ripple.propTypes = {
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PT.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PT.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PT.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PT.number
};
Ripple.defaultProps = {
  pulsate: false
};
var Ripple$1 = Ripple;

// Adapted from https://github.com/mui-org/material-ui
// The MIT License (MIT)

// Copyright (c) 2014 Call-Em-All

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
var _excluded$h = ["center", "style"];
function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DURATION = 550;
var DELAY_RIPPLE = 80;
var styled$f = createDefaultStyle(function (theme) {
  return {
    display: 'block',
    position: 'absolute',
    overflow: 'hidden',
    borderRadius: 'inherit',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0,
    pointerEvents: 'none',
    zIndex: 0,
    ripple: {
      opacity: 1,
      inner: {
        width: 50,
        height: 50,
        left: 0,
        top: 0,
        opacity: 0,
        position: 'absolute',
        borderRadius: '50%',
        background: theme.color.secondary.base
      },
      '&visible': {
        inner: {
          opacity: 0.3,
          transform: 'scale(1)',
          animation: "signavio-ui-ripple-enter ".concat(DURATION, "ms ease-in-out")
        }
      },
      '&pulsate': {
        position: 'absolute',
        left: 0,
        top: 0,
        display: 'block',
        width: '100%',
        height: '100%',
        animation: "signavio-ui-ripple-pulsate 1500ms ease-in-out 200ms infinite",
        inner: {
          animationDuration: '200ms'
        }
      },
      '&leaving': {
        opacity: 0,
        animation: "signavio-ui-ripple-exit ".concat(DURATION, "ms ease-in-out")
      }
    }
  };
});
var TouchRipple = /*#__PURE__*/function (_Component) {
  _inherits(TouchRipple, _Component);
  var _super = _createSuper$5(TouchRipple);
  function TouchRipple() {
    var _this;
    _classCallCheck(this, TouchRipple);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      nextKey: 0,
      ripples: []
    });
    // Used to filter out mouse emulated events on mobile.
    _defineProperty(_assertThisInitialized(_this), "ignoringMouseDown", false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    _defineProperty(_assertThisInitialized(_this), "startTimer", null);
    // This is the hook called once the previous timeout is ready.
    _defineProperty(_assertThisInitialized(_this), "startTimerCommit", null);
    _defineProperty(_assertThisInitialized(_this), "pulsate", function () {
      _this.start({}, {
        pulsate: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "start", function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? _this.props.center || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
        _this.ignoringMouseDown = false;
        return;
      }
      if (event.type === 'touchstart') {
        _this.ignoringMouseDown = true;
      }
      var element = fakeElement ? null : ReactDOM.findDOMNode(_assertThisInitialized(_this));
      var rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      };

      // Get the size of the ripple
      var rippleX;
      var rippleY;
      var rippleSize;
      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }
      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);

        // For some reason the animation is broken on Mobile Chrome if the size if even.
        if (rippleSize % 2 === 0) {
          rippleSize -= 1;
        }
      } else {
        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      }

      // Touche devices
      if (event.touches) {
        // Prepare the ripple effect.
        _this.startTimerCommit = function () {
          _this.startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        };
        // Deplay the execution of the ripple effect.
        _this.startTimer = setTimeout(function () {
          _this.startTimerCommit();
          _this.startTimerCommit = null;
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      } else {
        _this.startCommit({
          pulsate: pulsate,
          rippleX: rippleX,
          rippleY: rippleY,
          rippleSize: rippleSize,
          cb: cb
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "startCommit", function (params) {
      if (_this.props.disabled) {
        return;
      }
      var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
      var ripples = _this.state.ripples;

      // Add a ripple to the ripples array.
      ripples = [].concat(_toConsumableArray(ripples), [/*#__PURE__*/React.createElement(Ripple$1, {
        key: _this.state.nextKey,
        style: _this.props.style('ripple'),
        timeout: {
          exit: DURATION,
          enter: DURATION
        },
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
      _this.setState({
        nextKey: _this.state.nextKey + 1,
        ripples: ripples
      }, cb);
    });
    _defineProperty(_assertThisInitialized(_this), "stop", function (event, cb) {
      clearTimeout(_this.startTimer);
      var ripples = _this.state.ripples;

      // The touch interaction occures to quickly.
      // We still want to show ripple effect.
      if (event.type === 'touchend' && _this.startTimerCommit) {
        event.persist();
        _this.startTimerCommit();
        _this.startTimerCommit = null;
        _this.startTimer = setTimeout(function () {
          _this.stop(event, cb);
        }, 0);
        return;
      }
      _this.startTimerCommit = null;
      if (ripples && ripples.length) {
        _this.setState({
          ripples: ripples.slice(1)
        }, cb);
      }
    });
    return _this;
  }
  _createClass(TouchRipple, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.startTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.center;
        var style = _this$props.style,
        other = _objectWithoutProperties(_this$props, _excluded$h);
      return /*#__PURE__*/React.createElement(TransitionGroup, _extends({
        component: "span",
        enter: true,
        exit: true
      }, style, other), this.state.ripples);
    }
  }]);
  return TouchRipple;
}(Component);
TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PT.bool
};
TouchRipple.defaultProps = {
  center: false
};
var TouchRipple$1 = styled$f(resolveInnerRef(TouchRipple));

// Adapted from https://github.com/mui-org/material-ui
// The MIT License (MIT)

// Copyright (c) 2014 Call-Em-All

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
var _excluded$g = ["centerRipple", "children", "component", "disabled", "disableRipple", "focusRipple", "keyboardFocusedClassName", "onBlur", "onFocus", "onKeyboardFocus", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "type", "style"];
function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var getModifiers$5 = function getModifiers(_ref) {
  var disabled = _ref.disabled,
    block = _ref.block;
  return {
    '&disabled': disabled,
    '&block': block
  };
};
var styled$e = createDefaultStyle(function (theme) {
  return _objectSpread$b(_objectSpread$b({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    outline: 'none',
    borderWidth: 0,
    borderRadius: 0,
    padding: 0,
    // Reset default style
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    appearance: 'none',
    textDecoration: 'none',
    // fixes a weird problem in Safari when Buttons are rendered in Tile toolbars
    margin: 0,
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    ':hover': {
      color: 'inherit'
    },
    ':active': {
      color: 'inherit'
    },
    ':visited': {
      color: 'inherit'
    }
  }, navigator.userAgent.toLowerCase().indexOf('firefox') > -1 && {
    '::-moz-focus-inner': {
      border: 0 // Remove Firefox dotted outline.
    }
  }), {}, {
    rippleContainer: {},
    '&block': {
      display: 'flex',
      width: '100%'
    },
    '&disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    }
  });
}, getModifiers$5);
var ButtonBase = /*#__PURE__*/function (_Component) {
  _inherits(ButtonBase, _Component);
  var _super = _createSuper$4(ButtonBase);
  function ButtonBase() {
    var _this;
    _classCallCheck(this, ButtonBase);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      keyboardFocused: false
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyboardFocusHandler", function (event) {
      _this.keyDown = false;
      _this.setState({
        keyboardFocused: true
      });
      if (_this.props.onKeyboardFocus) {
        _this.props.onKeyboardFocus(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "ripple", null);
    _defineProperty(_assertThisInitialized(_this), "keyDown", false);
    // Used to help track keyboard activation keyDown
    _defineProperty(_assertThisInitialized(_this), "button", null);
    _defineProperty(_assertThisInitialized(_this), "keyboardFocusTimeout", null);
    _defineProperty(_assertThisInitialized(_this), "keyboardFocusCheckTime", 50);
    _defineProperty(_assertThisInitialized(_this), "keyboardFocusMaxCheckTimes", 5);
    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var _this$props = _this.props,
        component = _this$props.component,
        focusRipple = _this$props.focusRipple,
        onKeyDown = _this$props.onKeyDown,
        onClick = _this$props.onClick;
      var key = keycode(event);

      // Check if key is already down to avoid repeats being counted as multiple activations
      if (focusRipple && !_this.keyDown && _this.state.keyboardFocused && key === 'space' && _this.ripple) {
        _this.keyDown = true;
        event.persist();
        _this.ripple.stop(event, function () {
          _this.ripple.start(event);
        });
      }
      if (onKeyDown) {
        onKeyDown(event);
      }

      // Keyboard accessibility for non interactive elements
      if (event.target === _this.button && onClick && component && component !== 'a' && component !== 'button' && (key === 'space' || key === 'enter')) {
        event.preventDefault();
        onClick(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyUp", function (event) {
      if (_this.props.focusRipple && keycode(event) === 'space' && _this.state.keyboardFocused && _this.ripple) {
        _this.keyDown = false;
        event.persist();
        _this.ripple.stop(event, function () {
          return _this.ripple.pulsate(event);
        });
      }
      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", createRippleHandler(_assertThisInitialized(_this), 'MouseDown', 'start', function () {
      clearTimeout(_this.keyboardFocusTimeout);
      focusKeyPressed(false);
      if (_this.state.keyboardFocused) {
        _this.setState({
          keyboardFocused: false
        });
      }
    }));
    _defineProperty(_assertThisInitialized(_this), "handleMouseUp", createRippleHandler(_assertThisInitialized(_this), 'MouseUp', 'stop'));
    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", createRippleHandler(_assertThisInitialized(_this), 'MouseLeave', 'stop', function (event) {
      if (_this.state.keyboardFocused) {
        event.preventDefault();
      }
    }));
    _defineProperty(_assertThisInitialized(_this), "handleTouchStart", createRippleHandler(_assertThisInitialized(_this), 'TouchStart', 'start'));
    _defineProperty(_assertThisInitialized(_this), "handleTouchEnd", createRippleHandler(_assertThisInitialized(_this), 'TouchEnd', 'stop'));
    _defineProperty(_assertThisInitialized(_this), "handleTouchMove", createRippleHandler(_assertThisInitialized(_this), 'TouchEnd', 'stop'));
    _defineProperty(_assertThisInitialized(_this), "handleBlur", createRippleHandler(_assertThisInitialized(_this), 'Blur', 'stop', function () {
      clearTimeout(_this.keyboardFocusTimeout);
      focusKeyPressed(false);
      _this.setState({
        keyboardFocused: false
      });
    }));
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      if (_this.props.disabled) {
        return;
      }

      // Fix for https://github.com/facebook/react/issues/7769
      if (!_this.button) {
        _this.button = event.currentTarget;
      }
      event.persist();
      detectKeyboardFocus(_assertThisInitialized(_this), _this.button, function () {
        _this.onKeyboardFocusHandler(event);
      });
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    });
    return _this;
  }
  _createClass(ButtonBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.button = findDOMNode(this);
      listenForFocusKeys();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.
      if (!prevProps.disabled && this.props.disabled && this.state.keyboardFocused) {
        this.setState({
          keyboardFocused: false
        });
      }
      if (this.props.focusRipple && !this.props.disableRipple && this.ripple && this.state.keyboardFocused && !prevState.keyboardFocused) {
        this.ripple.pulsate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.button = null;
      clearTimeout(this.keyboardFocusTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        centerRipple = _this$props2.centerRipple,
        children = _this$props2.children,
        component = _this$props2.component,
        disabled = _this$props2.disabled,
        disableRipple = _this$props2.disableRipple;
        _this$props2.focusRipple;
        _this$props2.keyboardFocusedClassName;
        _this$props2.onBlur;
        _this$props2.onFocus;
        _this$props2.onKeyboardFocus;
        _this$props2.onKeyDown;
        _this$props2.onKeyUp;
        _this$props2.onMouseDown;
        _this$props2.onMouseLeave;
        _this$props2.onMouseUp;
        _this$props2.onTouchEnd;
        _this$props2.onTouchMove;
        _this$props2.onTouchStart;
        var tabIndex = _this$props2.tabIndex,
        type = _this$props2.type,
        style = _this$props2.style,
        rest = _objectWithoutProperties(_this$props2, _excluded$g);
      var buttonProps = {};
      var ComponentProp = component;
      if (!ComponentProp) {
        if (rest.href) {
          ComponentProp = 'a';
        } else {
          ComponentProp = 'button';
        }
      }
      if (ComponentProp === 'button') {
        buttonProps.type = type || 'button';
      }
      if (ComponentProp !== 'a') {
        buttonProps.role = buttonProps.type === 'button' ? undefined : 'button';
        buttonProps.disabled = disabled;
      }
      return /*#__PURE__*/React.createElement(ComponentProp, _extends({
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onMouseDown: this.handleMouseDown,
        onMouseLeave: this.handleMouseLeave,
        onMouseUp: this.handleMouseUp,
        onTouchEnd: this.handleTouchEnd,
        onTouchMove: this.handleTouchMove,
        onTouchStart: this.handleTouchStart,
        tabIndex: disabled ? -1 : tabIndex
      }, buttonProps, _omit(rest, 'block'), style), children, !disableRipple ? /*#__PURE__*/React.createElement(TouchRipple$1, {
        innerRef: function innerRef(node) {
          _this2.ripple = node;
        },
        disabled: disabled,
        center: centerRipple,
        style: style('rippleContainer')
      }) : null);
    }
  }]);
  return ButtonBase;
}(Component);
ButtonBase.propTypes = {
  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: PT.bool,
  /**
   * The content of the component.
   */
  children: PT.node,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * The default value is a `button`.
   */
  component: PT.oneOfType([PT.string, PT.func]),
  /**
   * If `true`, the base button will be disabled.
   */
  disabled: PT.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PT.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `disableRipple` must also be `false`.
   */
  focusRipple: PT.bool,
  /**
   * @ignore
   */
  onBlur: PT.func,
  /**
   * @ignore
   */
  onClick: PT.func,
  /**
   * @ignore
   */
  onFocus: PT.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onKeyboardFocus: PT.func,
  /**
   * @ignore
   */
  onKeyDown: PT.func,
  /**
   * @ignore
   */
  onKeyUp: PT.func,
  /**
   * @ignore
   */
  onMouseDown: PT.func,
  /**
   * @ignore
   */
  onMouseLeave: PT.func,
  /**
   * @ignore
   */
  onMouseUp: PT.func,
  /**
   * @ignore
   */
  onTouchEnd: PT.func,
  /**
   * @ignore
   */
  onTouchMove: PT.func,
  /**
   * @ignore
   */
  onTouchStart: PT.func,
  /**
   * @ignore
   */
  role: PT.string,
  /**
   * @ignore
   */
  tabIndex: PT.oneOfType([PT.number, PT.string]),
  /**
   * @ignore
   */
  type: PT.string
};
ButtonBase.defaultProps = {
  centerRipple: false,
  disableRipple: false,
  focusRipple: false,
  tabIndex: 0,
  type: 'button'
};
function createRippleHandler(instance, eventName, action, cb) {
  return function handleEvent(event) {
    if (cb) {
      cb.call(instance, event);
    }
    if (event.defaultPrevented) {
      return false;
    }
    if (instance.ripple) {
      instance.ripple[action](event);
    }
    if (instance.props && typeof instance.props["on".concat(eventName)] === 'function') {
      instance.props["on".concat(eventName)](event);
    }
    return true;
  };
}
var ButtonBase$1 = styled$e(ButtonBase);
var internal = {
  listening: false,
  focusKeyPressed: false
};
function focusKeyPressed(pressed) {
  if (typeof pressed !== 'undefined') {
    internal.focusKeyPressed = Boolean(pressed);
  }
  return internal.focusKeyPressed;
}
function detectKeyboardFocus(instance, element, callback) {
  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  instance.keyboardFocusTimeout = setTimeout(function () {
    if (focusKeyPressed() && (document.activeElement === element || element.contains(document.activeElement))) {
      callback();
    } else if (attempt < instance.keyboardFocusMaxCheckTimes) {
      detectKeyboardFocus(instance, element, callback, attempt + 1);
    }
  }, instance.keyboardFocusCheckTime);
}
var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];
function isFocusKey(event) {
  return FOCUS_KEYS.indexOf(keycode(event)) !== -1;
}
function listenForFocusKeys() {
  // It's a singleton, we only need to listen once.
  // Also, this logic is client side only, we don't need a teardown.
  if (!internal.listening) {
    window.addEventListener('keyup', function (event) {
      if (isFocusKey(event)) {
        internal.focusKeyPressed = true;
      }
    });
    internal.listening = true;
  }
}

// Adapted from https://github.com/mui-org/material-ui
// The MIT License (MIT)

// Copyright (c) 2014 Call-Em-All

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
var _excluded$f = ["icon", "children", "small", "right", "style"];
function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var getModifiers$4 = function getModifiers(props) {
  return _objectSpread$a(_objectSpread$a({}, getModifiers$5(props)), {}, {
    '&primary': props.primary && !props.disabled,
    '&danger': props.danger && !props.disabled,
    '&outline': props.outline,
    '&small': props.small
  });
};
var reverseIf = function reverseIf(condition, array) {
  return condition ? _reverse(array) : array;
};
var Button = function Button(_ref) {
  var icon = _ref.icon,
    children = _ref.children,
    small = _ref.small,
    right = _ref.right,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$f);
  useDeprecationWarning('Button');
  return /*#__PURE__*/React.createElement(ButtonBase$1, _extends({
    style: style,
    focusRipple: true
  }, _omit(rest, 'danger', 'primary', 'outline')), reverseIf(right, [icon && /*#__PURE__*/React.createElement(Icon, {
    key: "icon",
    style: style('icon'),
    small: small,
    icon: icon
  }), icon && children && /*#__PURE__*/React.createElement("div", _extends({
    key: "divider"
  }, style('divider'))), children && /*#__PURE__*/React.createElement("span", _extends({
    key: "caption"
  }, style('caption')), children)]));
};
var styled$d = createDefaultStyle(function (theme) {
  var size = styles.calculateIconSize(theme);
  var smallSize = styles.calculateSmallIconSize(theme);
  return _objectSpread$a(_objectSpread$a({
    height: size,
    minWidth: size
  }, theme.font.button1), {}, {
    lineHeight: '20px',
    backgroundColor: theme.color.mono.light,
    color: theme.color.mono.dark,
    icon: {
      zIndex: 1
    },
    divider: {
      width: 1,
      height: size,
      backgroundColor: Color$3(theme.color.mono.light).darken(0.1).hex()
    },
    caption: _objectSpread$a(_objectSpread$a({}, styles.ellipsis()), {}, {
      flexGrow: 1,
      paddingLeft: theme.padding.normal,
      paddingRight: theme.padding.normal,
      zIndex: 1
    }),
    rippleContainer: {
      ripple: {
        inner: {
          backgroundColor: styles.textColor(theme.color.mono.dark, {
            darken: 0.3,
            lighten: 0.5
          })
        }
      }
    },
    '&small': {
      fontFamily: theme.font.family.normal,
      fontSize: 12,
      fontWeight: theme.font.weight.normal,
      letterSpacing: 0.2,
      height: smallSize,
      minWidth: smallSize,
      caption: {
        paddingLeft: theme.padding.small,
        paddingRight: theme.padding.small
      },
      divider: {
        height: smallSize
      }
    },
    '&primary': {
      backgroundColor: theme.color.secondary.base,
      color: styles.color(theme.color.secondary.base),
      ':hover': {
        color: styles.color(theme.color.secondary.base)
      },
      ':active': {
        color: styles.color(theme.color.secondary.base)
      },
      ':visited': {
        color: styles.color(theme.color.secondary.base)
      },
      divider: {
        backgroundColor: styles.textColor(theme.color.secondary.base, {
          darken: 0.3,
          lighten: 0.3
        })
      },
      rippleContainer: {
        ripple: {
          inner: {
            backgroundColor: styles.textColor(theme.color.secondary.base, {
              darken: 0.3,
              lighten: 0.5
            })
          }
        }
      }
    },
    '&danger': {
      backgroundColor: theme.color.status.danger,
      color: styles.color(theme.color.status.danger),
      ':hover': {
        color: styles.color(theme.color.status.danger)
      },
      ':active': {
        color: styles.color(theme.color.status.danger)
      },
      ':visited': {
        color: styles.color(theme.color.status.danger)
      },
      divider: {
        backgroundColor: styles.textColor(theme.color.status.danger, {
          darken: 0.3,
          lighten: 0.3
        })
      },
      rippleContainer: {
        ripple: {
          inner: {
            backgroundColor: styles.textColor(theme.color.status.danger, {
              darken: 0.3,
              lighten: 0.5
            })
          }
        }
      }
    },
    '&outline': {
      backgroundColor: 'transparent',
      boxShadow: "0px 0px 0px 1px ".concat(theme.color.mono.lighter, " inset"),
      rippleContainer: {
        ripple: {
          inner: {
            backgroundColor: theme.color.mono.lighter
          }
        }
      },
      '&primary': {
        boxShadow: "0px 0px 0px 1px ".concat(theme.color.secondary.base, " inset"),
        color: theme.color.secondary.dark,
        ':hover': {
          color: theme.color.secondary.dark
        },
        ':active': {
          color: theme.color.secondary.dark
        },
        ':visited': {
          color: theme.color.secondary.dark
        },
        rippleContainer: {
          ripple: {
            inner: {
              backgroundColor: theme.color.secondary.base
            }
          }
        }
      },
      '&danger': {
        boxShadow: "0px 0px 0px 1px ".concat(theme.color.status.danger, " inset"),
        color: theme.color.status.danger,
        ':hover': {
          color: theme.color.status.danger
        },
        ':active': {
          color: theme.color.status.danger
        },
        ':visited': {
          color: theme.color.status.danger
        },
        rippleContainer: {
          ripple: {
            inner: {
              backgroundColor: Color$3(theme.color.status.danger).lighten(0.5).hex()
            }
          }
        }
      }
    },
    '&disabled': {
      opacity: 0.65
    }
  });
}, getModifiers$4);
var LegacyButton = styled$d(Button);var _excluded$e = ["icon", "small", "style", "children"];
function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var getModifiers$3 = function getModifiers(props) {
  return _objectSpread$9(_objectSpread$9({}, getModifiers$5(props)), {}, {
    '&small': props.small
  });
};
var IconButton = function IconButton(_ref) {
  var icon = _ref.icon,
    small = _ref.small,
    style = _ref.style,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$e);
  useDeprecationWarning('IconButton');
  return /*#__PURE__*/React.createElement(ButtonBase$1, _extends({}, rest, {
    style: style,
    centerRipple: true,
    focusRipple: true
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    small: small,
    style: style('icon')
  }), children);
};
var styled$c = createDefaultStyle(function (theme) {
  var iconSize = styles.calculateIconSize(theme);
  var smallIconSize = styles.calculateSmallIconSize(theme);
  return {
    rippleContainer: {
      width: iconSize,
      height: iconSize
    },
    '&small': {
      rippleContainer: {
        width: smallIconSize,
        height: smallIconSize
      }
    },
    '&disabled': {
      color: theme.color.mono.middle
    }
  };
}, getModifiers$3);
var IconButton$1 = styled$c(IconButton);function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CLOSE_DELAY = 2000;
var withConfirmation = function withConfirmation(WrappedComponent) {
  return /*#__PURE__*/function (_Component) {
    _inherits(WithConfirmation, _Component);
    var _super = _createSuper$3(WithConfirmation);
    function WithConfirmation(props) {
      var _this;
      _classCallCheck(this, WithConfirmation);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "requestConfirmation", function (ev) {
        ev.stopPropagation();
        _this.setState({
          confirm: true
        });
        _this.setTimer();
      });
      _defineProperty(_assertThisInitialized(_this), "cancel", function (ev) {
        ev.stopPropagation();
        _this.setState({
          confirm: false
        });
      });
      _defineProperty(_assertThisInitialized(_this), "confirm", function (ev) {
        ev.stopPropagation();
        _this.setState({
          confirm: false
        });
        if (_this.props.onClick) {
          _this.props.onClick(ev);
        }
      });
      _this.state = {
        confirm: false
      };
      return _this;
    }
    _createClass(WithConfirmation, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.timer) {
          window.clearTimeout(this.timer);
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
          confirm: this.state.confirm,
          onClick: this.requestConfirmation,
          onConfirm: this.confirm,
          onCancel: this.cancel
        }));
      }
    }, {
      key: "setTimer",
      value: function setTimer() {
        var _this2 = this;
        if (this.timer) {
          window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () {
          _this2.setState({
            confirm: false
          });
        }, CLOSE_DELAY);
      }
    }]);
    return WithConfirmation;
  }(Component);
};
var withConfirmation$1 = withConfirmation;var _excluded$d = ["confirm", "onCancel", "onConfirm", "style", "small", "disabled", "toLeft"],
  _excluded2$2 = ["toLeft", "confirm"];
function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ConfirmButton = function ConfirmButton(_ref) {
  var confirm = _ref.confirm,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm,
    style = _ref.style,
    small = _ref.small,
    disabled = _ref.disabled,
    toLeft = _ref.toLeft,
    rest = _objectWithoutProperties(_ref, _excluded$d);
  useDeprecationWarning('ConfirmButton');
  return /*#__PURE__*/React.createElement("div", style, /*#__PURE__*/React.createElement(TransitionGroup, null, confirm && /*#__PURE__*/React.createElement(SlideAnimation, {
    left: toLeft,
    right: !toLeft,
    style: style('confirm')
  }, /*#__PURE__*/React.createElement(LegacyButton, {
    small: small,
    danger: true,
    icon: "success",
    onClick: onConfirm
  })), confirm && /*#__PURE__*/React.createElement(SlideAnimation, {
    left: !toLeft,
    right: toLeft,
    style: style('cancel')
  }, /*#__PURE__*/React.createElement(LegacyButton, {
    small: small,
    icon: "reset",
    onClick: onCancel
  }))), /*#__PURE__*/React.createElement(LegacyButton, _extends({}, rest, {
    small: small,
    disabled: disabled || confirm,
    block: true,
    style: style('button')
  })));
};
var getModifiers$2 = function getModifiers(_ref2) {
  var toLeft = _ref2.toLeft,
    confirm = _ref2.confirm,
    rest = _objectWithoutProperties(_ref2, _excluded2$2);
  return _objectSpread$8(_objectSpread$8({}, getModifiers$4(rest)), {}, {
    '&toLeft': toLeft,
    '&confirm': confirm
  });
};
var ConfirmButton$1 = compose(withConfirmation$1, createDefaultStyle(function (_ref3) {
  _ref3.padding;
    _ref3.lineHeight;
    _ref3.font;
  return {
    position: 'relative',
    display: 'inline-block',
    boxSizing: 'border-box',
    confirm: {
      position: 'absolute',
      left: '100%',
      zIndex: 1
    },
    cancel: {
      position: 'absolute',
      right: 1,
      zIndex: 1
    },
    button: _objectSpread$8({
      transform: 'scale(1.0)'
    }, styles.transition(['transform'], 'ease', '300ms')),
    '&confirm': {
      button: {
        transform: 'scale(0.8)'
      }
    },
    '&block': {
      display: 'block',
      width: '100%'
    },
    '&toLeft': {
      confirm: {
        left: null,
        right: '100%'
      },
      cancel: {
        right: null,
        left: 1
      }
    }
  };
}, getModifiers$2))(ConfirmButton);var _excluded$c = ["dropdown", "position", "onOpen", "onClose"];
var uncontrolled = dropdownEnhancers.uncontrolled,
  toggleOnClick = dropdownEnhancers.toggleOnClick,
  closeOnClickNode = dropdownEnhancers.closeOnClickNode;
var Dropdown = compose(uncontrolled, toggleOnClick, closeOnClickNode)(Dropdown$3);
var DropdownButton = function DropdownButton(_ref) {
  var dropdown = _ref.dropdown,
    position = _ref.position,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    rest = _objectWithoutProperties(_ref, _excluded$c);
  useDeprecationWarning('DropdownButton');
  return /*#__PURE__*/React.createElement(Dropdown, {
    node: dropdown,
    position: position,
    onOpen: onOpen,
    onClose: onClose
  }, function (isOpen) {
    return /*#__PURE__*/React.createElement(LegacyButton, _extends({
      icon: isOpen ? 'dropdown-close' : 'dropdown-open'
    }, rest));
  });
};
var DropdownButton$1 = DropdownButton;var isImage = isImage$1,
  getIcon$1 = getIcon$2,
  getReadableSize = getReadableSize$1;
var FileTile = function FileTile(_ref) {
  var file = _ref.file,
    small = _ref.small,
    noPreview = _ref.noPreview,
    toolbar = _ref.toolbar;
  return /*#__PURE__*/React.createElement(TextTile, {
    small: small,
    header: isImage(file.type) && !noPreview ? /*#__PURE__*/React.createElement(ImagePreview$1, {
      file: file,
      small: small
    }) : /*#__PURE__*/React.createElement(Icon, {
      icon: getIcon$1(file),
      small: small,
      block: true
    }),
    subtitle: getReadableSize(file.size),
    toolbar: toolbar
  }, file.name);
};
var FileTile$1 = FileTile;var FileSelectMulti = function FileSelectMulti(_ref) {
  var children = _ref.children,
    value = _ref.value,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Fragment, null, value && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 1
    }
  }, /*#__PURE__*/React.createElement(List, null, value.map(function (item, index) {
    return /*#__PURE__*/React.createElement(FileTile$1, {
      key: "".concat(item.name, "_").concat(item.size, "_").concat(index),
      file: item,
      toolbar: /*#__PURE__*/React.createElement(IconButton$1, {
        icon: "reset",
        onClick: function onClick(ev) {
          // prevent open of file select
          ev.stopPropagation();
          ev.preventDefault();
          onChange([].concat(_toConsumableArray(value.slice(0, index)), _toConsumableArray(value.slice(index + 1))), ev);
        }
      })
    });
  }))), /*#__PURE__*/React.createElement(FileSelectOpener, {
    value: value,
    onChange: onChange,
    multiple: true
  }, children));
};
var FileSelectMulti$1 = FileSelectMulti;var FileSelectSingle = function FileSelectSingle(_ref) {
  var children = _ref.children,
    value = _ref.value,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(FileSelectOpener, {
    value: value,
    onChange: onChange
  }, value ? /*#__PURE__*/React.createElement(FileTile$1, {
    file: value
  }) : children);
};
var FileSelectSingle$1 = FileSelectSingle;var _excluded$b = ["children", "small", "primary", "outline"];
var FileSelect = function FileSelect(_ref) {
  var children = _ref.children,
    small = _ref.small,
    primary = _ref.primary,
    outline = _ref.outline,
    rest = _objectWithoutProperties(_ref, _excluded$b);
  useDeprecationWarning('FileSelect');
  var button = !children || _isString(children) ? /*#__PURE__*/React.createElement(LegacyButton, {
    icon: "file-upload",
    block: true,
    small: small,
    primary: primary,
    outline: outline
  }, children) : children;
  if (rest.multiple) {
    var _value = rest.value,
      _onChange = rest.onChange;
    return /*#__PURE__*/React.createElement(FileSelectDropZone, {
      multiple: true,
      value: _value || [],
      onChange: _onChange
    }, /*#__PURE__*/React.createElement(FileSelectMulti$1, _extends({
      value: _value || []
    }, rest), button));
  }
  var onChange = rest.onChange;
  return /*#__PURE__*/React.createElement(FileSelectDropZone, {
    onChange: onChange
  }, /*#__PURE__*/React.createElement(FileSelectSingle$1, rest, button));
};
var FileSelect$1 = FileSelect;function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styledAsInput = createDefaultStyle(function (_ref) {
  var color = _ref.color,
    padding = _ref.padding,
    font = _ref.font,
    lineHeight = _ref.lineHeight;
  var verticalPadding = styles.calculateVerticalPadding(styles.calculateHeight(font.size.normal, lineHeight, padding.small), font.size.button, lineHeight);
  return _objectSpread$7(_objectSpread$7(_objectSpread$7({
    display: 'block',
    width: '100%',
    fontSize: font.size.button,
    lineHeight: lineHeight,
    paddingTop: verticalPadding - 1,
    // - 1 because of border
    paddingBottom: verticalPadding - 1,
    // - 1 because of border
    paddingRight: padding.normal,
    paddingLeft: padding.normal
  }, styles.border(1, 'solid', color.mono.lighter)), styles.transition('border-color')), {}, {
    ':focus': {
      borderColor: color.primary.base,
      outline: 0
    }
  });
});function LegacyText(props) {
  useDeprecationWarning('TextInput', 'Input');
  return /*#__PURE__*/React.createElement(TextInput, props);
}
var Text = styledAsInput(LegacyText);var _excluded$a = ["buttonLabel", "icon", "defaultValue", "validate", "placeholder", "onChange", "onSubmit", "clearOnSubmit", "onKeyDown"];
function InputWithButton(_ref) {
  var buttonLabel = _ref.buttonLabel,
    icon = _ref.icon,
    defaultValue = _ref.defaultValue,
    validate = _ref.validate,
    placeholder = _ref.placeholder,
    _onChange = _ref.onChange,
    onSubmit = _ref.onSubmit,
    clearOnSubmit = _ref.clearOnSubmit,
    _onKeyDown = _ref.onKeyDown,
    rest = _objectWithoutProperties(_ref, _excluded$a);
  useDeprecationWarning('InputWithButton');
  var _useState = useState(defaultValue || ''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var handleSubmit = useCallback(function (value) {
    if (isValidValue(value, validate)) {
      onSubmit(value);
      if (clearOnSubmit) {
        setValue('');
      }
    }
  }, [clearOnSubmit, onSubmit, validate]);
  return /*#__PURE__*/React.createElement(Tile, {
    toolbar: /*#__PURE__*/React.createElement(LegacyButton, {
      icon: icon,
      disabled: !isValidValue(value, validate),
      onClick: function onClick() {
        return handleSubmit(value);
      }
    }, buttonLabel)
  }, /*#__PURE__*/React.createElement(Text, _extends({}, rest, {
    value: value,
    placeholder: placeholder,
    onChange: function onChange(value) {
      setValue(value);
      if (_onChange) {
        _onChange(value);
      }
    },
    onKeyDown: function onKeyDown(event) {
      if (event.keyCode === 13) {
        handleSubmit(value);
      }
      if (_onKeyDown) {
        _onKeyDown(event);
      }
    }
  })));
}
var isValidValue = function isValidValue(value, validator) {
  if (!validator) {
    return value && value.trim().length > 0;
  }
  return validator(value);
};function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var calculateAbsoluteLineHeight = function calculateAbsoluteLineHeight(fontSize, lineHeight) {
  return parseInt(fontSize, 10) * lineHeight;
};
var calculateHeight = function calculateHeight(fontSize, lineHeight, verticalPadding) {
  return calculateAbsoluteLineHeight(fontSize, lineHeight) + 2 * verticalPadding;
};
var calculateVerticalPadding = function calculateVerticalPadding(targetHeight, fontSize, lineHeight) {
  return (targetHeight - parseInt(fontSize, 10) * lineHeight) / 2;
};
var calculateIconSize = function calculateIconSize(_ref) {
  var font = _ref.font,
    lineHeight = _ref.lineHeight,
    padding = _ref.padding;
  return calculateHeight(font.size.normal, lineHeight, padding.small);
};
var calculateSmallIconSize = function calculateSmallIconSize(_ref2) {
  var font = _ref2.font,
    lineHeight = _ref2.lineHeight,
    padding = _ref2.padding;
  return calculateHeight(font.size.small, lineHeight, padding.xsmall);
};
function capitalize(str) {
  return str.replace(/(^| )(\w)/g, function (x) {
    return x.toUpperCase();
  });
}
function transition() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var kind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ease';
  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0.3s';
  var properties = Array.isArray(props) ? props : [props];
  return {
    transition: properties.map(function (property) {
      return "".concat(property, " ").concat(speed, " ").concat(kind);
    }).join(', ')
  };
}
function grayscale() {
  var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
  return {
    filter: "grayscale(".concat(amount, ")")
  };
}
function ellipsis() {
  return {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  };
}
function color(background) {
  var dark = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : text$1.base;
  var light = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : contrastText$1.base;
  if (!background) {
    return null;
  }
  return Color$3(background).isLight() ? dark : light;
}
var shadowOffset = '2px';
var shadowColor = 'rgba(0, 0, 0, 0.06)';
function boxShadow() {
  var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shadowOffset;
  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : shadowOffset;
  var spread = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var clr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : shadowColor;
  return {
    boxShadow: "".concat(left, " ").concat(top, " ").concat(spread, " ").concat(clr)
  };
}
function boxShadowInset() {
  var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0px';
  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '3px';
  var spread = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '5px';
  var clr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'rgba(0, 0, 0, 0.125)';
  return {
    boxShadow: "inset ".concat(left, " ").concat(top, " ").concat(spread, " ").concat(clr)
  };
}
function textColor(background) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$lighten = _ref3.lighten,
    lighten = _ref3$lighten === void 0 ? 0.5 : _ref3$lighten,
    _ref3$darken = _ref3.darken,
    darken = _ref3$darken === void 0 ? 0.4 : _ref3$darken;
  var clr = Color$3(background);
  // console.error("textColor function is deprecated,
  // please use color function instead");

  return (clr.isLight() ? clr.darken(darken) : clr.lighten(lighten)).hex();
}

// eslint-disable-next-line no-underscore-dangle
function _border() {
  var _ref4;
  var borderWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var borderStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'solid';
  var borderColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'black';
  var position = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return _ref4 = {}, _defineProperty(_ref4, "border".concat(capitalize(position), "Width"), borderWidth), _defineProperty(_ref4, "border".concat(capitalize(position), "Style"), borderStyle), _defineProperty(_ref4, "border".concat(capitalize(position), "Color"), borderColor), _ref4;
}
function border() {
  var borderWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var borderStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'solid';
  var borderColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'black';
  return _objectSpread$6(_objectSpread$6(_objectSpread$6(_objectSpread$6({}, borderTop(borderWidth, borderStyle, borderColor)), borderBottom(borderWidth, borderStyle, borderColor)), borderLeft(borderWidth, borderStyle, borderColor)), borderRight(borderWidth, borderStyle, borderColor));
}
function popover(_ref5) {
  var mono = _ref5.mono;
  var localShadowOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : shadowOffset;
  return _objectSpread$6(_objectSpread$6({}, boxShadow(localShadowOffset, localShadowOffset)), border(1, 'solid', mono.lighter));
}
function hover(backgroundColor) {
  return Color$3(backgroundColor).darken(0.2).rgb().string();
}
var borderTop = _partial(_border, _partial.placeholder, _partial.placeholder, _partial.placeholder, 'top');
var borderRight = _partial(_border, _partial.placeholder, _partial.placeholder, _partial.placeholder, 'right');
var borderBottom = _partial(_border, _partial.placeholder, _partial.placeholder, _partial.placeholder, 'bottom');
var borderLeft = _partial(_border, _partial.placeholder, _partial.placeholder, _partial.placeholder, 'left');
function clearTransition() {
  return {
    transition: null
  };
}

// TODO move to styled Input component
var input = function input(_ref6) {
  var _ref6$color = _ref6.color,
    mono = _ref6$color.mono,
    primary = _ref6$color.primary,
    font = _ref6.font,
    padding = _ref6.padding,
    lineHeight = _ref6.lineHeight;
  var targetHeight = calculateHeight(font.size.normal, lineHeight, padding.small);
  // subtract 1 to make up for border
  var verticalPadding = calculateVerticalPadding(targetHeight, font.size.button, lineHeight) - 1;
  return _objectSpread$6(_objectSpread$6(_objectSpread$6({
    boxSizing: 'border-box',
    lineHeight: lineHeight,
    paddingLeft: padding.normal,
    paddingRight: padding.normal,
    // safari adds margin for some weird reason
    marginTop: 0,
    marginBottom: 0,
    paddingTop: verticalPadding,
    paddingBottom: verticalPadding,
    fontSize: font.size.button
  }, border(1, 'solid', mono.lighter)), transition(['border-color', 'box-shadow'])), {}, {
    '&focus': {
      borderColor: primary.base,
      outline: 0
    },
    ':focus': {
      borderColor: primary.base,
      outline: 0
    },
    '&readOnly': {
      backgroundColor: mono.light,
      '&focus': {
        borderColor: mono.lighter
      },
      ':focus': {
        borderColor: mono.lighter
      }
    }
  });
};
var placeholder = function placeholder(_ref7) {
  var mono = _ref7.color.mono;
  return {
    color: mono.middle
  };
};var utils=/*#__PURE__*/Object.freeze({__proto__:null,calculateAbsoluteLineHeight:calculateAbsoluteLineHeight,calculateHeight:calculateHeight,calculateVerticalPadding:calculateVerticalPadding,calculateIconSize:calculateIconSize,calculateSmallIconSize:calculateSmallIconSize,capitalize:capitalize,transition:transition,grayscale:grayscale,ellipsis:ellipsis,color:color,boxShadow:boxShadow,boxShadowInset:boxShadowInset,textColor:textColor,border:border,popover:popover,hover:hover,borderTop:borderTop,borderRight:borderRight,borderBottom:borderBottom,borderLeft:borderLeft,clearTransition:clearTransition,input:input,placeholder:placeholder});var _excluded$9 = ["children", "value", "placeholder", "style"],
  _excluded2$1 = ["readOnly", "onChange", "searchPlaceholder", "searchEnabled", "wrapTrigger", "emptyMessage", "maxDropdownHeight", "height"];
function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styledReadOnly = createDefaultStyle({
  input: {
    value: {
      option: {
        cursor: 'default',
        marginBottom: 0
      }
    }
  }
});
var DropdownSelectReadOnly = styledReadOnly(function (_ref) {
  var children = _ref.children,
    value = _ref.value,
    placeholder = _ref.placeholder,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$9);
  var option = Children.toArray(children).find(function (_ref2) {
    var props = _ref2.props;
    return props.value === value;
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, style), option ? /*#__PURE__*/React.createElement(Tile, null, /*#__PURE__*/cloneElement(option, _objectSpread$5({}, style('input')('value')('option')))) : value == null ? /*#__PURE__*/React.createElement(TextTile, null, /*#__PURE__*/React.createElement(Empty, {
    inline: true
  }, placeholder || '---')) : /*#__PURE__*/React.createElement(TextTile, null, value));
});
var DropdownSelect = function DropdownSelect(_ref3) {
  var readOnly = _ref3.readOnly,
    onChange = _ref3.onChange,
    searchPlaceholder = _ref3.searchPlaceholder,
    searchEnabled = _ref3.searchEnabled,
    wrapTrigger = _ref3.wrapTrigger,
    emptyMessage = _ref3.emptyMessage,
    maxDropdownHeight = _ref3.maxDropdownHeight,
    height = _ref3.height,
    rest = _objectWithoutProperties(_ref3, _excluded2$1);
  useDeprecationWarning('DropdownSelect');
  if (readOnly) {
    return /*#__PURE__*/React.createElement(DropdownSelectReadOnly, _omit(rest, 'light', 'maxDropdownWidth'));
  }
  return /*#__PURE__*/React.createElement(DropdownSelect$4, _extends({}, _objectSpread$5({
    onChange: onChange,
    searchPlaceholder: searchPlaceholder,
    searchEnabled: searchEnabled,
    wrapTrigger: wrapTrigger
  }, _omit(rest, 'light', 'fixedDropdownWidth', 'maxDropdownWidth')), {
    height: height || maxDropdownHeight,
    emptyMessage: emptyMessage && /*#__PURE__*/React.createElement(Empty, null, emptyMessage)
  }));
};
var enhance$4 = compose(deprecate$1({
  height: 'Set `maxDropdownHeight` prop if you really need another value than the default of `250`. ' + 'For details see: https://github.com/signavio/ui/pull/219#issuecomment-362307532'
}), createDefaultStyle(function (theme, _ref4) {
  var maxDropdownWidth = _ref4.maxDropdownWidth;
  return {
    fontSize: theme.font.size.button,
    input: {
      cursor: 'pointer',
      placeholder: _objectSpread$5(_objectSpread$5({}, input(theme)), {}, {
        borderColor: 'transparent'
      }, styles.ellipsis()),
      value: {
        option: {
          marginBottom: 0,
          ':hover': {
            backgroundColor: 'transparent'
          }
        }
      },
      search: _objectSpread$5({}, input(theme))
    },
    widget: _objectSpread$5({
      outline: 'none',
      fontSize: theme.font.size.button
    }, styles.popover(theme.color)),
    nodeContent: {
      minWidth: "calc(100% - ".concat(styles.calculateIconSize(theme), "px)")
    },
    '&maxDropdownWidth': {
      nodeContent: {
        maxWidth: maxDropdownWidth === true ? "calc(100% - ".concat(styles.calculateIconSize(theme), "px)") : maxDropdownWidth
      }
    },
    '&light': {
      input: {
        placeholder: {
          backgroundColor: 'white',
          borderColor: theme.color.mono.lighter
        }
      }
    }
  };
}, function (_ref5) {
  var light = _ref5.light,
    maxDropdownWidth = _ref5.maxDropdownWidth;
  return {
    '&light': light,
    '&maxDropdownWidth': !_isNil(maxDropdownWidth)
  };
}), defaultProps({
  readOnly: false,
  maxDropdownHeight: 250,
  searchPlaceholder: 'Type to search',
  placeholder: 'Click to select',
  wrapTrigger: function wrapTrigger(trigger, _ref6) {
    var isExpanded = _ref6.isExpanded,
      onClick = _ref6.onClick;
    return /*#__PURE__*/React.createElement(Tile, {
      toolbar: /*#__PURE__*/React.createElement(LegacyButton, {
        block: true,
        icon: isExpanded ? 'dropdown-close' : 'dropdown-open',
        onClick: onClick
      })
    }, trigger);
  }
}));
var DropdownSelect$1 = enhance$4(DropdownSelect);var _excluded$8 = ["value", "name", "highlightedName", "children", "isFocused", "isSelected", "style"];
var Option = function Option(_ref) {
  var value = _ref.value,
    name = _ref.name,
    highlightedName = _ref.highlightedName,
    children = _ref.children;
    _ref.isFocused;
    _ref.isSelected;
    var style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$8);
  useDeprecationWarning('Option');
  if (children) {
    return /*#__PURE__*/React.createElement("div", _extends({}, _omit(rest, 'search'), style), children);
  }
  return /*#__PURE__*/React.createElement(TextTile, _extends({}, _omit(rest, 'search'), style), highlightedName || name || value);
};
var enhance$3 = compose(makeInteractive, createDefaultStyle({
  marginBottom: 1,
  backgroundColor: 'transparent',
  '&disabled': {
    opacity: 0.5
  }
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return {
    '&disabled': disabled
  };
}));
var Option$1 = enhance$3(Option);var _excluded$7 = ["checked", "children", "disabled", "indeterminate", "style", "onClick", "onChange"];
var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
    children = _ref.children,
    disabled = _ref.disabled,
    indeterminate = _ref.indeterminate,
    style = _ref.style,
    _onClick = _ref.onClick,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded$7);
  useDeprecationWarning('Checkbox');
  return /*#__PURE__*/React.createElement("button", _extends({}, rest, style, {
    disabled: disabled,
    onChange: onChange,
    onClick: function onClick() {
      if (_onClick) {
        _onClick.apply(void 0, arguments);
      }
      if (!onChange) {
        return;
      }
      onChange(!checked);
    }
  }), /*#__PURE__*/React.createElement(List, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement("div", style('iconsWrapper'), /*#__PURE__*/React.createElement("div", style('iconFilling'), /*#__PURE__*/React.createElement(Icon, {
    icon: getIcon(checked, indeterminate)
  }))), children && (_isString(children) ? /*#__PURE__*/React.createElement(TextTile, {
    transparent: true,
    style: style('label')
  }, children) : children)));
};
var getIcon = function getIcon(checked, indeterminate) {
  if (checked && !indeterminate) {
    return 'checkbox-true';
  }
  if (!checked && !indeterminate) {
    return 'checkbox-false';
  }
  return 'checkbox-indeterminate';
};
var enhance$2 = compose(withStateHandlers({
  hover: false
}, {
  onMouseEnter: function onMouseEnter(_, _ref2) {
    var _onMouseEnter = _ref2.onMouseEnter;
    return function () {
      if (_onMouseEnter) {
        _onMouseEnter.apply(void 0, arguments);
      }
      return {
        hover: true
      };
    };
  },
  onMouseLeave: function onMouseLeave(_, _ref3) {
    var _onMouseLeave = _ref3.onMouseLeave;
    return function () {
      if (_onMouseLeave) {
        _onMouseLeave.apply(void 0, arguments);
      }
      return {
        hover: false
      };
    };
  }
}), createDefaultStyle(function (_ref4) {
  var padding = _ref4.padding,
    font = _ref4.font,
    lineHeight = _ref4.lineHeight;
  return {
    backgroundColor: 'transparent',
    outline: 'none',
    borderWidth: 0,
    cursor: 'pointer',
    padding: 0,
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    lineHeight: lineHeight,
    iconsWrapper: {
      position: 'relative',
      marginRight: padding.large
    },
    iconFilling: {
      position: 'absolute',
      top: 0,
      left: 0
    },
    label: {
      main: {
        fontSize: font.size.button,
        paddingLeft: 0
      }
    },
    '&disabled': {
      opacity: 0.5,
      cursor: 'default'
    }
  };
}, function (_ref5) {
  var checked = _ref5.checked,
    hover = _ref5.hover,
    disabled = _ref5.disabled,
    indeterminate = _ref5.indeterminate;
  return {
    '&checked': checked && !indeterminate,
    '&hover': !disabled && hover,
    '&disabled': disabled,
    '&indeterminate': !checked && indeterminate
  };
}), omitProps(['hover']));
var Checkbox$1 = enhance$2(Checkbox);function LegacyEmail(props) {
  useDeprecationWarning('Email', 'EmailInput');
  return /*#__PURE__*/React.createElement(EmailInput$1, props);
}
var Email = styledAsInput(LegacyEmail);function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Color = function Color(_ref) {
  var color = _ref.color,
    _onClick = _ref.onClick,
    style = _ref.style;
  return (
    /*#__PURE__*/
    // Please fix me
    // jsx-a11y/click-events-have-key-events
    // eslint-disable-next-line
    React.createElement("div", _extends({}, style, {
      onClick: function onClick(ev) {
        return _onClick(color, ev);
      },
      title: color
    }))
  );
};
var styled$b = createDefaultStyle(function (theme, _ref2) {
  var color = _ref2.color,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? 25 : _ref2$width,
    _ref2$height = _ref2.height,
    height = _ref2$height === void 0 ? 25 : _ref2$height;
  return {
    background: color,
    cursor: 'pointer',
    float: 'left',
    height: height,
    width: width,
    ':active': _objectSpread$4({
      outline: 'none'
    }, styles.boxShadowInset()),
    ':focus': {
      outline: 'none'
    },
    ':hover': _objectSpread$4({
      position: 'relative',
      zIndex: '2',
      outline: '2px solid #fff'
    }, styles.boxShadowInset())
  };
});
var PreviewColor = styled$b(Color);var HEX_COLOR_REGEX = /(^[0-9A-F]{6}$)|(^[0-9A-F]{3}$)/i;
function isValidColor(color) {
  if (!color) {
    return false;
  }
  return HEX_COLOR_REGEX.test(color.replace(/^#/, ''));
}var DEFAULT_COLOR = '000000';
function toHexColor(color) {
  var sanitizedColor = (color || DEFAULT_COLOR).concat(isValidColor(color) ? '' : DEFAULT_COLOR).replace(/[^0-9A-F]/gi, '').substring(0, 6);
  return Color$3("#".concat(sanitizedColor)).hex().toLowerCase();
}function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultPalette = ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'];
var ColorPicker = function ColorPicker(_ref) {
  var onChange = _ref.onChange,
    style = _ref.style,
    onRequestHideWidget = _ref.onRequestHideWidget,
    _ref$palette = _ref.palette,
    palette = _ref$palette === void 0 ? defaultPalette : _ref$palette,
    innerRef = _ref.innerRef;
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: innerRef,
    tabIndex: "-1"
  }, style), /*#__PURE__*/React.createElement("div", style('palette'), palette.map(function (color) {
    return /*#__PURE__*/React.createElement(PreviewColor, {
      key: color,
      color: color,
      onClick: function onClick(newColor) {
        if (onRequestHideWidget) {
          onRequestHideWidget();
        }
        onChange(toHexColor(newColor));
      },
      style: style('color')
    });
  })));
};
var styled$a = createDefaultStyle(function (_ref2, _ref3) {
  var color = _ref2.color,
    padding = _ref2.padding;
  var _ref3$width = _ref3.width,
    width = _ref3$width === void 0 ? 200 : _ref3$width;
  return {
    display: 'block',
    ':focus': {
      outline: 'none'
    },
    ':active': _objectSpread$3({
      outline: 'none'
    }, styles.boxShadowInset()),
    palette: _objectSpread$3({
      background: '#fff',
      boxSizing: 'content-box',
      overflow: 'auto',
      padding: padding.xsmall,
      position: 'relative',
      width: width
    }, styles.border(1, 'solid', color.mono.lighter))
  };
});
var EnhancedComponent = styled$a(ColorPicker);
var ColorPicker$1 = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(EnhancedComponent, _extends({}, props, {
    innerRef: ref
  }));
});var _excluded$6 = ["style"];
function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var SimpleColorInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(SimpleColorInput, _PureComponent);
  var _super = _createSuper$2(SimpleColorInput);
  function SimpleColorInput(props) {
    var _this;
    _classCallCheck(this, SimpleColorInput);
    _this = _super.call(this, props);
    _this.state = {
      value: props.value && props.value.toLowerCase()
    };
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleColorChange = _this.handleColorChange.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(SimpleColorInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var value = this.props.value;
      var stateValue = this.state.value;
      if (!isValidColor(stateValue) || !isValidColor(value)) {
        return;
      }
      if (stateValue !== value) {
        this.setState({
          value: toHexColor(value)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        style = _this$props.style,
        rest = _objectWithoutProperties(_this$props, _excluded$6);
      return /*#__PURE__*/React.createElement("div", style, /*#__PURE__*/React.createElement(TextInput, _extends({}, _omit(rest, 'isExpanded'), {
        style: style('input'),
        inputRef: function inputRef(textInput) {
          _this2.textInput = textInput;
        },
        value: this.state.value,
        onBlur: this.handleBlur,
        onChange: this.handleColorChange,
        onKeyDown: this.handleKeyDown,
        readOnly: true
      })), /*#__PURE__*/React.createElement(PreviewColor, {
        color: this.state.value,
        onClick: function onClick() {
          return _this2.textInput.focus();
        },
        style: style('preview')
      }));
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(ev) {
      this.handleColorChange(toHexColor(this.state.value));
      this.props.onBlur(ev);
    }
  }, {
    key: "handleColorChange",
    value: function handleColorChange(newColor) {
      this.setState({
        value: newColor || '#'
      });
      if (this.state.value === newColor) {
        return;
      }
      if (isValidColor(newColor)) {
        this.props.onChange(toHexColor(newColor));
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(ev) {
      if (ev.keyCode !== 13) {
        return;
      }
      this.handleColorChange(toHexColor(this.state.value));
      this.props.onBlur();
    }
  }]);
  return SimpleColorInput;
}(PureComponent);
var styled$9 = createDefaultStyle(function (theme, _ref) {
  var value = _ref.value;
  var inputHeight = styles.calculateHeight(theme.font.size.normal, theme.lineHeight, theme.padding.small);
  var previewHeight = inputHeight - 2 * theme.padding.xsmall;
  return {
    cursor: 'pointer',
    display: 'block',
    position: 'relative',
    input: _objectSpread$2(_objectSpread$2({}, input(theme)), {}, {
      boxSizing: 'border-box',
      height: inputHeight,
      paddingBottom: theme.padding.small,
      paddingTop: theme.padding.small
    }),
    preview: _objectSpread$2(_objectSpread$2({
      boxSizing: 'border-box'
    }, styles.border(1, 'solid', Color$3(value).darken(0.2).rgb().string())), {}, {
      position: 'absolute',
      height: previewHeight,
      width: "calc(100% - ".concat(theme.padding.xsmall * 2, "px)"),
      top: theme.padding.xsmall,
      left: theme.padding.xsmall,
      ':hover': {
        position: 'absolute',
        outline: 'none',
        boxShadow: 'none'
      }
    })
  };
});
var SimpleColorInput$1 = styled$9(SimpleColorInput);var ColorInput = stickWidgetToInput(ColorPicker$1, SimpleColorInput$1);
function LegacyColorInput(props) {
  useDeprecationWarning('ColorInput');
  return /*#__PURE__*/React.createElement(ColorInput, props);
}var Label = function Label(_ref) {
  var children = _ref.children,
    label = _ref.label,
    style = _ref.style,
    htmlFor = _ref.htmlFor;
  return /*#__PURE__*/React.createElement("div", style, /*#__PURE__*/React.createElement("label", _extends({
    htmlFor: htmlFor
  }, style('label')), label), /*#__PURE__*/React.createElement("div", style('controlWrapper'), children), /*#__PURE__*/React.createElement("div", {
    style: {
      clear: 'left',
      visibility: 'hidden',
      height: 0
    }
  }));
};
var styled$8 = createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding;
  return {
    label: {
      float: 'left',
      display: 'block',
      paddingTop: padding.small,
      paddingBottom: padding.small,
      paddingRight: padding.normal,
      paddingLeft: padding.normal,
      width: '40%',
      boxSizing: 'border-box',
      textAlign: 'right'
    },
    controlWrapper: {
      float: 'left',
      width: '60%',
      boxSizing: 'border-box'
    }
  };
});
var Label$1 = styled$8(Label);var _excluded$5 = ["label"];
function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var labeled = function labeled(WrappedComponent) {
  var _class;
  return _class = /*#__PURE__*/function (_Component) {
    _inherits(_class, _Component);
    var _super = _createSuper$1(_class);
    function _class(props) {
      var _this;
      _classCallCheck(this, _class);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "fieldId", void 0);
      _this.fieldId = _uniqueId('ui_label');
      return _this;
    }
    _createClass(_class, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          label = _this$props.label,
          rest = _objectWithoutProperties(_this$props, _excluded$5);
        return /*#__PURE__*/React.createElement(Label$1, {
          label: label,
          htmlFor: this.fieldId
        }, /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, rest, {
          id: this.fieldId
        })));
      }
    }]);
    return _class;
  }(Component), _defineProperty(_class, "displayName", "labeled(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Unknown', ")")), _class;
};
var labeled$1 = labeled;function LegacyNumber(props) {
  useDeprecationWarning('Number', 'NumberInput');
  return /*#__PURE__*/React.createElement(NumberInput$1, props);
}
var Number$1 = styledAsInput(LegacyNumber);function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PORTAL_HOST_ELEMENT = 'react-stick__portalHostElement';
var styled$7 = createDefaultStyle({
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: 999,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  opacity: 0,
  dialog: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white'
  },
  '&visible': {
    opacity: 1
  }
}, function (_ref) {
  var visible = _ref.visible;
  return {
    '&visible': visible
  };
});

// Please fix me
// jsx-a11y/click-events-have-key-events jsx-a11y/no-noninteractive-element-interactions
/* eslint-disable  */
var ModalDialog = styled$7(function (_ref2) {
  var style = _ref2.style,
    containerRef = _ref2.containerRef,
    children = _ref2.children,
    onRequestHide = _ref2.onRequestHide;
  return /*#__PURE__*/React.createElement("div", _extends({}, style, {
    role: "button",
    onClick: onRequestHide,
    ref: containerRef,
    tabIndex: -1
  }), /*#__PURE__*/React.createElement("div", _extends({}, style('dialog'), {
    role: "dialog",
    onClick: function onClick(ev) {
      return ev.stopPropagation();
    }
  }), children));
});
/* eslint-enable */
var Modal$2 = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);
  var _super = _createSuper(Modal);
  // the container for the sticked node (has z-index)
  // the host element to which we portal the container (has no styles)

  function Modal(props) {
    var _this;
    _classCallCheck(this, Modal);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "container", void 0);
    _defineProperty(_assertThisInitialized(_this), "host", void 0);
    _defineProperty(_assertThisInitialized(_this), "state", {
      visible: false
    });
    _defineProperty(_assertThisInitialized(_this), "setContainer", function (ref) {
      if (_this.container !== ref) {
        _this.container = ref;
        _this.forceUpdate();
      }
    });
    _this.host = document.createElement('div');
    if (document.body) {
      document.body.appendChild(_this.host);
    }
    return _this;
  }
  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.setState({
        visible: true
      }, function () {
        var onShow = _this2.props.onShow;
        if (onShow) {
          onShow();
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;
      this.setState({
        visible: false
      }, function () {
        return window.setTimeout(function () {
          if (document.body) {
            document.body.removeChild(_this3.host);
          }
          var onHide = _this3.props.onHide;
          if (onHide) {
            onHide();
          }
        }, _this3.props.transitionDuration);
      });
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return _defineProperty({}, PORTAL_HOST_ELEMENT, this.container);
    }
  }, {
    key: "render",
    value: function render() {
      // Do not render children before the container ref is set. This ensures that
      // all descendant portals will be mounted to the right host element straight away.
      // We must not rely on context updates!
      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(ModalDialog, _extends({}, _omit(this.props, 'transitionDuration', 'onHide', 'onShow', 'children'), {
        containerRef: this.setContainer,
        visible: this.state.visible
      }), this.container && this.props.children), this.host);
    }
  }]);
  return Modal;
}(Component);
_defineProperty(Modal$2, "childContextTypes", _defineProperty({}, PORTAL_HOST_ELEMENT, window ? PT.instanceOf(window.Element) : PT.any));
_defineProperty(Modal$2, "defaultProps", {
  transitionDuration: 0
});var _excluded$4 = ["title", "footer", "children", "danger", "onRequestHide", "style"];
function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TRANSITION_DURATION = 300;
var Modal = function Modal(_ref) {
  var title = _ref.title,
    footer = _ref.footer,
    children = _ref.children;
    _ref.danger;
    var onRequestHide = _ref.onRequestHide,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded$4);
  return /*#__PURE__*/React.createElement(Modal$2, _extends({}, rest, {
    transitionDuration: TRANSITION_DURATION,
    onRequestHide: onRequestHide,
    style: style
  }), title && /*#__PURE__*/React.createElement("div", style('header'), /*#__PURE__*/React.createElement("h2", style('title'), title)), onRequestHide && /*#__PURE__*/React.createElement("button", _extends({}, style('close'), {
    onClick: onRequestHide
  }), "\xD7"), /*#__PURE__*/React.createElement("div", style('body'), children), footer && /*#__PURE__*/React.createElement("div", style('footer'), footer));
};
var getModifiers$1 = function getModifiers(props) {
  return {
    '&danger': props.danger,
    '&withTitle': !!props.title
  };
};
var enhance$1 = compose(setDisplayName('Modal'), createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    padding = _ref2.padding,
    font = _ref2.font,
    lineHeight = _ref2.lineHeight,
    zIndex = _ref2.zIndex;
  return _objectSpread$1(_objectSpread$1({
    zIndex: zIndex.modal,
    opacity: 0
  }, styles.transition(['background', 'opacity'])), {}, {
    // TODO does transition actually work for background!?!?!?

    dialog: _objectSpread$1(_objectSpread$1({
      marginTop: padding.large,
      marginBottom: padding.large,
      maxWidth: 600,
      position: 'relative'
    }, styles.popover(color)), styles.transition('margin-top')),
    header: _objectSpread$1({
      paddingLeft: padding.normal,
      paddingRight: padding.normal,
      paddingBottom: padding.normal,
      paddingTop: padding.normal
    }, styles.borderBottom('1px', 'solid', color.mono.light)),
    body: {
      paddingLeft: padding.normal,
      paddingRight: padding.normal,
      paddingBottom: padding.normal,
      paddingTop: padding.normal,
      overflowY: 'auto'
    },
    close: {
      lineHeight: lineHeight,
      background: 'none',
      position: 'absolute',
      right: 0,
      top: 0,
      borderWidth: 0,
      float: 'right',
      outline: 'none',
      cursor: 'pointer',
      fontSize: font.size.normal,
      paddingTop: padding.small,
      paddingBottom: padding.small,
      paddingLeft: 0,
      paddingRight: 0,
      width: styles.calculateHeight(font.size.normal, lineHeight, padding.small)
    },
    title: {
      fontWeight: 100,
      marginTop: 0,
      marginBottom: 0
    },
    '&visible': {
      opacity: 1,
      backgroundColor: Color$3(color.mono.ultradark).alpha(0.2).rgb().string()
    },
    '&danger': {
      header: {
        backgroundColor: color.status.danger
      },
      title: {
        color: styles.color(color.status.danger)
      },
      '&withTitle': {
        close: {
          color: styles.color(color.status.danger)
        }
      }
    }
  });
}, getModifiers$1));
var Modal$1 = enhance$1(Modal);var getSeverity = function getSeverity(_ref) {
  var danger = _ref.danger,
    warning = _ref.warning,
    success = _ref.success,
    info = _ref.info;
  if (danger) {
    return 'danger';
  }
  if (warning) {
    return 'warning';
  }
  if (success) {
    return 'success';
  }
  if (info) {
    return 'info';
  }
  return undefined;
};
var getSeverity$1 = getSeverity;var icons = {
  danger: 'error',
  warning: 'warning',
  success: 'success',
  info: 'info'
};
var icons$1 = icons;var _excluded$3 = ["children", "danger", "warning", "success", "info", "style", "toolbar", "onClose"];
var ToastMessage = function ToastMessage(_ref) {
  var children = _ref.children,
    danger = _ref.danger,
    warning = _ref.warning,
    success = _ref.success,
    info = _ref.info,
    style = _ref.style,
    Toolbar = _ref.toolbar,
    onClose = _ref.onClose,
    rest = _objectWithoutProperties(_ref, _excluded$3);
  var TileComponent = typeof children === 'string' ? TextTile : Tile;
  return /*#__PURE__*/React.createElement(TileComponent, _extends({
    style: style,
    header: /*#__PURE__*/React.createElement(Icon, {
      style: style('headerIcon'),
      icon: icons$1[getSeverity$1({
        danger: danger,
        warning: warning,
        success: success,
        info: info
      }) || 'info']
    }),
    toolbar: typeof Toolbar === 'function' ? /*#__PURE__*/React.createElement(Toolbar, {
      onClose: onClose
    }) : /*#__PURE__*/React.createElement("div", style('toolbar'), Toolbar, /*#__PURE__*/React.createElement(ContainedIconButton, {
      icon: "reset",
      onClick: onClose
    }))
  }, rest), children);
};
var styled$6 = createDefaultStyle(function (_ref2, _ref3) {
  var color = _ref2.color,
    spacing = _ref2.spacing;
  var danger = _ref3.danger,
    warning = _ref3.warning,
    success = _ref3.success,
    info = _ref3.info;
  var severity = getSeverity$1({
    danger: danger,
    warning: warning,
    success: success,
    info: info
  }) || 'info';
  return {
    backgroundColor: color.status.light[severity],
    headerIcon: {
      backgroundColor: color.status[severity],
      color: 'white'
    },
    toolbar: {
      marginRight: spacing.xxxsmall
    }
  };
});
var ToastMessage$1 = styled$6(ToastMessage);var ToastContext = /*#__PURE__*/React.createContext([function () {
  throw new Error('Cannot register toast outside of a provider.');
}, function () {
  throw new Error('Cannot unregister toast outside of a provider.');
}]);
function ToastsContainer(_ref) {
  var style = _ref.style,
    hostStyle = _ref.hostStyle,
    children = _ref.children;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    toasts = _useState2[0],
    setToasts = _useState2[1];
  var registerToast = useCallback(function (toast) {
    setToasts(function (currentToasts) {
      return [].concat(_toConsumableArray(currentToasts), [{
        toast: toast,
        id: createId()
      }]);
    });
  }, []);
  var unregisterToast = useCallback(function (toast) {
    setToasts(function (currentToasts) {
      return currentToasts.filter(function (currentToast) {
        return currentToast.toast !== toast;
      });
    });
  }, []);
  return /*#__PURE__*/React.createElement(ToastContext.Provider, {
    value: [registerToast, unregisterToast]
  }, /*#__PURE__*/React.createElement("div", style, /*#__PURE__*/React.createElement("div", styles.merge(style('host'), hostStyle), /*#__PURE__*/React.createElement(TransitionGroup, null, toasts.map(function (_ref2) {
    var toast = _ref2.toast,
      id = _ref2.id;
    return /*#__PURE__*/React.createElement(SlideAnimation, {
      down: true,
      key: id
    }, /*#__PURE__*/React.createElement("div", style('messageWrapper'), toast));
  })))), children);
}
var createId = function createId() {
  return Math.floor(Math.random() * new Date().getTime()).toString(36);
};
var styled$5 = createDefaultStyle(function (_ref3) {
  var padding = _ref3.padding,
    zIndex = _ref3.zIndex;
  return {
    host: {
      position: 'absolute',
      zIndex: zIndex.toast,
      paddingLeft: padding.large,
      paddingRight: padding.large,
      left: 0,
      right: 0
    },
    messageWrapper: {
      marginBottom: 1
    }
  };
});
var ToastsContainer$1 = styled$5(ToastsContainer);var SHOW_DURATION = 5000;
function Toast(props) {
  var toast = useRef(null);
  var _useContext = useContext(ToastContext),
    _useContext2 = _slicedToArray(_useContext, 2),
    registerToast = _useContext2[0],
    unregisterToast = _useContext2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    closed = _useState2[0],
    setClosed = _useState2[1];
  var _onClose = props.onClose;
  useEffect(function () {
    if (!closed) {
      toast.current = /*#__PURE__*/React.createElement(ToastMessage$1, _extends({}, props, {
        onClose: function onClose() {
          if (_onClose) {
            _onClose();
          }
          setClosed(true);
        }
      }));
      registerToast(toast.current);
    }
    return function () {
      if (toast.current) {
        unregisterToast(toast.current);
      }
    };
  }, [closed, _onClose, props, registerToast, unregisterToast]);
  useEffect(function () {
    var closeTimeout = setTimeout(function () {
      if (_onClose) {
        _onClose();
      }
      setClosed(true);
    }, SHOW_DURATION);
    return function () {
      clearTimeout(closeTimeout);
    };
  }, [_onClose]);
  return null;
}function HintBase(_ref) {
  var children = _ref.children,
    title = _ref.title,
    icon = _ref.icon,
    inline = _ref.inline,
    style = _ref.style;
  var ContainerElement = inline ? 'span' : 'div';
  return /*#__PURE__*/React.createElement(ContainerElement, style, /*#__PURE__*/React.createElement("div", style('message'), /*#__PURE__*/React.createElement("div", style('iconWrapper'), icon), !inline && title && /*#__PURE__*/React.createElement("h3", style('title'), title), children && /*#__PURE__*/React.createElement("div", style('content'), children)));
}
var getModifiers = function getModifiers(props) {
  return {
    '&inline': props.inline,
    '&small': props.small,
    '&view': props.view,
    '&withIcon': !!props.icon
  };
};
var calculateCompensationPadding = function calculateCompensationPadding(fontSize, baseFontSize, lineHeight) {
  return (styles.calculateAbsoluteLineHeight(baseFontSize, lineHeight) - styles.calculateAbsoluteLineHeight(fontSize, lineHeight)) / 2;
};
var styled$4 = createDefaultStyle(function (theme) {
  return {
    position: 'relative',
    color: theme.color.mono.middle,
    fontStyle: 'italic',
    textAlign: 'center',
    paddingLeft: theme.padding.normal,
    paddingRight: theme.padding.normal,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: theme.padding.large,
    marginBottom: theme.padding.large,
    iconWrapper: {
      position: 'absolute',
      top: 0,
      left: 0
    },
    message: {
      display: 'inline-block',
      position: 'relative'
    },
    title: {
      fontSize: theme.font.size.xlarge,
      fontWeight: theme.font.weight.normal,
      lineHeight: theme.lineHeight,
      marginBottom: 0,
      marginTop: theme.padding.small + calculateCompensationPadding(theme.font.size.xlarge, theme.font.size.normal, theme.lineHeight)
    },
    content: {
      fontSize: theme.font.size.normal,
      lineHeight: theme.lineHeight,
      paddingTop: theme.padding.small,
      paddingBottom: theme.padding.small
    },
    '&small': {
      title: {
        fontSize: theme.font.size.normal,
        marginTop: theme.padding.xsmall + calculateCompensationPadding(theme.font.size.normal, theme.font.size.small, theme.lineHeight)
      },
      content: {
        fontSize: theme.font.size.small,
        paddingTop: theme.padding.xsmall,
        paddingBottom: theme.padding.xsmall
      }
    },
    '&inline': {
      display: 'inline-block',
      lineHeight: theme.lineHeight,
      marginTop: null,
      marginBottom: null,
      paddingLeft: null,
      paddingRight: null,
      textAlign: null,
      content: {
        paddingTop: null,
        paddingBottom: null
      }
    },
    '&view': {
      marginTop: 200,
      marginBottom: 200
    },
    '&withIcon': {
      message: {
        paddingLeft: styles.calculateIconSize(theme) + theme.padding.small,
        textAlign: 'left'
      },
      '&small': {
        message: {
          paddingLeft: styles.calculateSmallIconSize(theme) + theme.padding.small
        }
      }
    }
  };
}, getModifiers);
var HintBase$1 = styled$4(HintBase);var _excluded$2 = ["small", "children", "style", "inline", "icon", "loading"];
var Hint = function Hint(_ref) {
  var small = _ref.small,
    children = _ref.children,
    style = _ref.style,
    inline = _ref.inline,
    icon = _ref.icon,
    loading = _ref.loading,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  var finalIcon = icon || icons$1[getSeverity$1(rest)];
  return /*#__PURE__*/React.createElement(HintBase$1, _extends({
    small: small,
    inline: inline
  }, rest, {
    style: style,
    icon: loading ? /*#__PURE__*/React.createElement(Spinner, {
      small: small,
      inline: inline,
      style: style('icon')
    }) : finalIcon && /*#__PURE__*/React.createElement(Icon, {
      icon: finalIcon,
      small: small,
      inline: inline,
      style: style('icon')
    })
  }), children);
};
var styled$3 = createDefaultStyle(function (_ref2) {
  var color = _ref2.color;
  return {
    '&danger': {
      icon: {
        color: color.status.danger
      }
    },
    '&warning': {
      icon: {
        color: color.status.warning
      }
    },
    '&success': {
      icon: {
        color: color.status.success
      }
    },
    '&info': {
      icon: {
        color: color.status.info
      }
    }
  };
}, function (props) {
  return _defineProperty({}, "&".concat(getSeverity$1(props)), !!getSeverity$1(props));
});
var enhance = compose(styled$3);
var Hint$1 = enhance(Hint);var Input = compose(triggerOnCompleteOnEnter, onBlurWithRelatedTarget)(InputBase);
var FilterHeader = function FilterHeader(_ref) {
  var placeholder = _ref.placeholder,
    style = _ref.style,
    value = _ref.value,
    onChange = _ref.onChange,
    onComplete = _ref.onComplete,
    onCancel = _ref.onCancel;
  var resetButton = /*#__PURE__*/React.createRef();
  return /*#__PURE__*/React.createElement("div", style, /*#__PURE__*/React.createElement(Input
  // Please fix me
  // eslint-disable-next-line jsx-a11y/no-autofocus
  , {
    autoFocus: true,
    inTile: true,
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    controls: /*#__PURE__*/React.createElement("div", {
      ref: resetButton
    }, /*#__PURE__*/React.createElement(ContainedIconButton, {
      icon: "reset",
      onClick: function onClick(ev) {
        ev.stopPropagation();
        onCancel();
      }
    })),
    onBlur: function onBlur(ev, relatedTarget) {
      var didClickOnReset = resetButton.current && resetButton.current.contains(relatedTarget);
      if (!ev.target.value || didClickOnReset) {
        onCancel();
      } else {
        onComplete();
      }
    },
    onComplete: onComplete,
    onKeyUp: function onKeyUp(ev) {
      if (keycode(ev) === 'esc') {
        onCancel();
      }
    },
    style: style('input')
  }));
};
var styled$2 = createDefaultStyle({
  width: '100%',
  input: {
    paddingLeft: 0,
    paddingRight: 0
  }
});
var FilterHeader$1 = styled$2(FilterHeader);var SortableHeader = function SortableHeader(_ref) {
  var style = _ref.style,
    name = _ref.name,
    ascending = _ref.ascending,
    isSorted = _ref.isSorted,
    isFiltered = _ref.isFiltered,
    setHovered = _ref.setHovered,
    searchable = _ref.searchable,
    sortDisabled = _ref.sortDisabled,
    _onClick = _ref.onClick,
    onFilterClick = _ref.onFilterClick;
  return (
    /*#__PURE__*/
    // Please fix me
    // jsx-a11y/click-events-have-key-events jsx-a11y/no-static-element-interactions
    // eslint-disable-next-line
    React.createElement("div", _extends({
      onClick: isFiltered ? onFilterClick : _onClick,
      onMouseEnter: function onMouseEnter() {
        return setHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHovered(false);
      }
    }, style), /*#__PURE__*/React.createElement(Tile$2, {
      transparent: true,
      toolbar: searchable && /*#__PURE__*/React.createElement("div", style('filter'), /*#__PURE__*/React.createElement(ContainedIconButton$2, {
        icon: "filter",
        onClick: function onClick(ev) {
          ev.stopPropagation(); // prevent toggle of sort direction
          onFilterClick();
        }
      }))
    }, /*#__PURE__*/React.createElement("div", style('caption'), /*#__PURE__*/React.createElement(Tile$2, {
      transparent: true,
      toolbar: !sortDisabled && /*#__PURE__*/React.createElement("span", style('sort'), /*#__PURE__*/React.createElement(Icon$2, {
        inline: true,
        icon: ascending || !isSorted ? 'order-ascending' : 'order-descending',
        onClick: function onClick(ev) {
          ev.stopPropagation();
          _onClick();
        }
      }))
    }, name))))
  );
};
var styled$1 = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    padding = _ref2.padding;
  return {
    width: '100%',
    cursor: 'pointer',
    verticalAlign: 'bottom',
    paddingTop: padding.small,
    paddingBottom: padding.small,
    position: 'relative',
    userSelect: 'none',
    caption: {
      display: 'inline-block'
    },
    sort: {
      opacity: 0.6,
      color: color.mono.ultradark
    },
    filter: {
      marginTop: -padding.small,
      marginBottom: -padding.small,
      opacity: 0,
      ':hover': {
        opacity: 1
      }
    },
    '&isHovered': {
      filter: {
        opacity: 0.6
      }
    },
    '&isSorted': {
      fontWeight: '600',
      sort: {
        opacity: 1
      }
    },
    '&isFiltered': {
      filter: {
        opacity: 1,
        color: color.primary.base
      }
    }
  };
}, function (_ref3) {
  var isSorted = _ref3.isSorted,
    isFiltered = _ref3.isFiltered,
    isHovered = _ref3.isHovered;
  return {
    '&isSorted': isSorted,
    '&isFiltered': isFiltered,
    '&isHovered': isHovered
  };
});
var SortableHeader$1 = compose(withState('isHovered', 'setHovered', false), styled$1)(SortableHeader);var EmptyRow = function EmptyRow(_ref) {
  var children = _ref.children,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("div", style, /*#__PURE__*/React.createElement(Empty$2, null, children));
};
var EmptyRow$1 = createDefaultStyle(function (_ref2) {
  var padding = _ref2.padding;
  return {
    paddingTop: padding.xsmall + padding.small,
    paddingBottom: padding.xsmall + padding.small
  };
})(EmptyRow);var TableHeader = function TableHeader(_ref) {
  var columns = _ref.columns,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "row"
  }, style(['tr', 'tr-header'])), columns.map(function (_ref2, index) {
    var name = _ref2.name,
      header = _ref2.header,
      _ref2$flex = _ref2.flex,
      flex = _ref2$flex === void 0 ? '1 1 auto' : _ref2$flex,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 0 : _ref2$width,
      _ref2$minWidth = _ref2.minWidth,
      minWidth = _ref2$minWidth === void 0 ? 0 : _ref2$minWidth,
      maxWidth = _ref2.maxWidth;
    return /*#__PURE__*/React.createElement("div", _extends({
      role: "columnheader"
    }, styles.merge(style('th'), {
      flex: flex,
      width: width,
      minWidth: minWidth,
      maxWidth: maxWidth
    }), {
      key: index
    }), header || /*#__PURE__*/React.createElement("div", style('header'), name));
  }));
};
var TableHeader$1 = TableHeader;// $FlowFixMe

var defaultWrapRow = function defaultWrapRow(_ref) {
  var children = _ref.children;
  return children;
};
var StringRenderer = function StringRenderer(_ref2) {
  var value = _ref2.value;
  return value ? /*#__PURE__*/React.createElement("span", null, value) : /*#__PURE__*/React.createElement(Empty$2, {
    inline: true
  });
};
var TableRows = function TableRows(_ref3) {
  var columns = _ref3.columns,
    _ref3$rows = _ref3.rows,
    rows = _ref3$rows === void 0 ? [] : _ref3$rows,
    getRowKey = _ref3.getRowKey,
    _ref3$wrapRow = _ref3.wrapRow,
    wrapRow = _ref3$wrapRow === void 0 ? defaultWrapRow : _ref3$wrapRow,
    style = _ref3.style;
  return rows.map(function (row, rowIndex) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: getRowKey && getRowKey(row, rowIndex)
    }, wrapRow({
      row: row,
      rowIndex: rowIndex,
      children: /*#__PURE__*/React.createElement("div", _extends({
        role: "row"
      }, style({
        tr: true,
        'tr-last': rowIndex === rows.length - 1
      })), columns.map(function (_ref4, columnIndex) {
        var key = _ref4.key,
          _ref4$renderCell = _ref4.renderCell,
          Cell = _ref4$renderCell === void 0 ? StringRenderer : _ref4$renderCell,
          _ref4$flex = _ref4.flex,
          flex = _ref4$flex === void 0 ? '1 1 auto' : _ref4$flex,
          _ref4$width = _ref4.width,
          width = _ref4$width === void 0 ? 0 : _ref4$width,
          _ref4$minWidth = _ref4.minWidth,
          minWidth = _ref4$minWidth === void 0 ? 0 : _ref4$minWidth,
          maxWidth = _ref4.maxWidth;
        return /*#__PURE__*/React.createElement("div", _extends({
          role: "cell",
          key: key
        }, styles.merge(style('td'), {
          flex: flex,
          width: width,
          minWidth: minWidth,
          maxWidth: maxWidth
        })), /*#__PURE__*/React.createElement(Cell, {
          value: Array.isArray(row) ? row[columnIndex] : undefined,
          row: row,
          rowIndex: rowIndex,
          columnIndex: columnIndex
        }));
      }))
    }));
  });
};
var TableRows$1 = TableRows;// $FlowFixMe

var TableBase = function TableBase(_ref) {
  var columns = _ref.columns,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? [] : _ref$rows,
    getRowKey = _ref.getRowKey,
    wrapRow = _ref.wrapRow,
    style = _ref.style,
    hideHeader = _ref.hideHeader,
    emptyMessage = _ref.emptyMessage;
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "table"
  }, style), /*#__PURE__*/React.createElement("div", _extends({
    role: "rowgroup"
  }, style('tbody')), !hideHeader && /*#__PURE__*/React.createElement(TableHeader$1, {
    columns: columns,
    style: style
  }), rows.length > 0 && /*#__PURE__*/React.createElement(TableRows$1, {
    columns: columns,
    rows: rows,
    getRowKey: getRowKey,
    wrapRow: wrapRow,
    style: style
  })), rows.length === 0 && /*#__PURE__*/React.createElement(EmptyRow$1, null, emptyMessage));
};

// $FlowFixMe
var styled = createDefaultStyle(function (_ref2) {
  var color = _ref2.color,
    padding = _ref2.padding;
  return {
    outline: 'none',
    width: '100%',
    display: 'block',
    tbody: {
      display: 'block'
    },
    tr: {
      display: 'flex',
      minWidth: '100%',
      borderBottom: "1px solid ".concat(color.mono.light),
      padding: "".concat(padding.xsmall, "px 0")
    },
    'tr-header': {
      borderBottom: "1px solid ".concat(color.mono.middle)
    },
    'tr-last': {
      borderBottom: 'none'
    },
    th: {
      display: 'block',
      verticalAlign: 'bottom',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: padding.normal,
      paddingRight: padding.normal,
      textAlign: 'left',
      color: color.mono.dark,
      fontWeight: 400
    },
    td: {
      display: 'block',
      verticalAlign: 'top',
      paddingTop: padding.small,
      paddingBottom: padding.small,
      paddingLeft: padding.normal,
      paddingRight: padding.normal,
      fontWeight: 400
    },
    header: {
      paddingTop: padding.small,
      paddingBottom: padding.small
    }
  };
});
var TableBase$1 = styled(TableBase);var _excluded$1 = ["columns", "style", "emptyMessage", "rows", "wrapRow", "searchPlaceholder", "initialSortColumn", "hideHeader"],
  _excluded2 = ["comparator", "comparatorReverse", "filter", "minWidth"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// the filter input requires a certain minimal width
var MIN_FILTERABLE_COLUMN_WIDTH = 217;
function TableNew(_ref) {
  var columns = _ref.columns,
    style = _ref.style,
    emptyMessage = _ref.emptyMessage,
    rows = _ref.rows,
    wrapRow = _ref.wrapRow,
    searchPlaceholder = _ref.searchPlaceholder,
    initialSortColumn = _ref.initialSortColumn,
    hideHeader = _ref.hideHeader;
    _objectWithoutProperties(_ref, _excluded$1);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isAscending = _useState2[0],
    setIsAscending = _useState2[1];
  var _useState3 = useState(initialSortColumn || null),
    _useState4 = _slicedToArray(_useState3, 2),
    sortedColumn = _useState4[0],
    setSortedColumn = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    search = _useState6[0],
    setSearch = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    filteredColumn = _useState8[0],
    setFilteredColumn = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isTyping = _useState10[0],
    setIsTyping = _useState10[1];
  function filterRows(rows) {
    if (filteredColumn === null) {
      return rows;
    }
    var filter = columns[filteredColumn].filter;
    var result = search && filter ? rows.filter(function (row) {
      return filter(row, search);
    }) : rows;
    return result;
  }
  function sortRows(rows) {
    if (sortedColumn === null || sortedColumn === undefined) {
      return rows;
    }
    var comparator = columns[sortedColumn].comparator;
    if (typeof comparator !== 'function') {
      return rows;
    }
    var comparatorReverse = columns[sortedColumn].comparatorReverse;
    if (typeof comparatorReverse !== 'function') {
      comparatorReverse = reverse(comparator);
    }
    var result = _toConsumableArray(rows).sort(function (a, b) {
      invariant(typeof comparatorReverse === 'function', 'comparatorReverse is not a function');
      var result = (isAscending ? comparator : comparatorReverse)(a, b);

      // make sort stable
      return result === 0 ? rows.indexOf(a) - rows.indexOf(b) : result;
    });
    return result;
  }
  function renderHeader(column, index) {
    var comparator = column.comparator,
      filter = column.filter;
    if (typeof comparator !== 'function') {
      return null; // will cause Table to use the default header (render name)
    }

    if (isTyping && index === filteredColumn) {
      return /*#__PURE__*/React.createElement(FilterHeader$1, {
        placeholder: searchPlaceholder,
        value: search,
        onChange: function onChange(newSearch) {
          return setSearch(newSearch || '');
        },
        onCancel: function onCancel() {
          setSearch(null);
          setFilteredColumn(null);
          setIsTyping(false);
        },
        onComplete: function onComplete() {
          return setIsTyping(false);
        }
      });
    }
    return /*#__PURE__*/React.createElement(SortableHeader$1, {
      name: column.name,
      ascending: isAscending,
      isSorted: index === sortedColumn,
      searchable: !!filter,
      isFiltered: !!(index === filteredColumn && search),
      onClick: function onClick() {
        setSortedColumn(index);
        setIsAscending(sortedColumn !== index ? true : !isAscending);
      },
      onFilterClick: function onFilterClick() {
        setSearch(index === filteredColumn ? search : '');
        setFilteredColumn(index);
        setIsTyping(true);
      }
    });
  }
  function mapColumn(column, index) {
    column.comparator;
      column.comparatorReverse;
      var filter = column.filter,
      _column$minWidth = column.minWidth,
      minWidth = _column$minWidth === void 0 ? 0 : _column$minWidth,
      rest = _objectWithoutProperties(column, _excluded2);
    return _objectSpread(_objectSpread({}, rest), {}, {
      minWidth: filter ? Math.max(MIN_FILTERABLE_COLUMN_WIDTH, parseInt(minWidth, 10)) : minWidth,
      header: renderHeader(column, index)
    });
  }
  var sortedAndFilteredRows = sortRows(filterRows(rows));
  return /*#__PURE__*/React.createElement(TableBase$1, {
    columns: columns.map(mapColumn),
    rows: sortedAndFilteredRows,
    totalRowCount: rows.length,
    hideHeader: hideHeader,
    wrapRow: wrapRow,
    style: style,
    emptyMessage: emptyMessage
  });
}
var reverse = function reverse(comparator) {
  return function (a, b) {
    return -comparator(a, b);
  };
};var _excluded = ["style", "children", "active"];
var InteractiveRowWrapper = function InteractiveRowWrapper(_ref) {
  var style = _ref.style,
    children = _ref.children;
    _ref.active;
    var rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, style, rest), children);
};
var InteractiveRowWrapper$1 = createDefaultStyle(function (_ref2) {
  _ref2.color;
    var padding = _ref2.padding;
  return {
    cursor: 'pointer',
    ':hover': {
      backgroundImage: "linear-gradient(to bottom, transparent ".concat(padding.xsmall, "px, #FAF7F9 ").concat(padding.xsmall, "px, #FAF7F9 calc(100% - ").concat(padding.xsmall, "px), transparent calc(100% - ").concat(padding.xsmall, "px), transparent 100%)")
    },
    '&active': {
      backgroundImage: "linear-gradient(to bottom, transparent ".concat(padding.xsmall, "px, #eee ").concat(padding.xsmall, "px, #eee calc(100% - ").concat(padding.xsmall, "px), transparent calc(100% - ").concat(padding.xsmall, "px), transparent 100%)"),
      ':hover': {
        backgroundImage: "linear-gradient(to bottom, transparent ".concat(padding.xsmall, "px, #eee ").concat(padding.xsmall, "px, #eee calc(100% - ").concat(padding.xsmall, "px), transparent calc(100% - ").concat(padding.xsmall, "px), transparent 100%)")
      }
    }
  };
}, function (_ref3) {
  var active = _ref3.active;
  return {
    '&active': active
  };
})(InteractiveRowWrapper);export{ActionBar$1 as ActionBar,AppIcon,Article,Avatar,Body,Breadcrumb,BreadcrumbItem,Button$1 as Button,Caption,Card,Cell,Checkbox$2 as Checkbox,CheckboxGroup,ChipDateRangePicker$1 as ChipDateRangePicker,ChipDropdown$1 as ChipDropdown,ChipMultiSelect$1 as ChipMultiSelect,ChipNumberRangeInput$1 as ChipNumberRangeInput,ChipTextInput$1 as ChipTextInput,CollapsibleHeader,ColorInput$1 as ColorInput,ConfirmButton$2 as ConfirmButton,ContainedIconButton,ContrastHint,ContrastTag,CountIndicator,DangerButton,DangerContrastHint,DangerDialog,DangerHint,DangerTag,DangerToast,DateInput,DatePicker,DateTimeInput,Description,DetailsPanel,Dialog,Divider,DragHandle,DropZone,DropdownButton$2 as DropdownButton,DropdownMultiSelect,DropdownSelect$2 as DropdownSelect,EmailInput,Empty,FileInput,FileMultiInput,FileSelect$2 as FileSelect,FilledTag,Button$4 as FlatButton,FlatDangerButton,FlatOnDarkButton,Group,Header,HeaderCell,HeaderTab,Hidden,HighlightTag,Hint$2 as Hint,Icon,IconButton$2 as IconButton,InfoToast,Input$1 as Input,InputWithButton$1 as InputWithButton,LegacyButton,Checkbox$1 as LegacyCheckbox,LegacyColorInput,ConfirmButton$1 as LegacyConfirmButton,DropdownButton$1 as LegacyDropdownButton,DropdownSelect$1 as LegacyDropdownSelect,Email as LegacyEmail,FileSelect$1 as LegacyFileSelect,Hint$1 as LegacyHint,IconButton$1 as LegacyIconButton,InputWithButton as LegacyInputWithButton,InteractiveRowWrapper$1 as LegacyInteractiveRowWrapper,Modal$1 as LegacyModal,Number$1 as LegacyNumber,Option$1 as LegacyOption,TableNew as LegacyTable,Text as LegacyText,Toast as LegacyToast,ToastsContainer$1 as LegacyToastsContainer,List,Logo,MenuItem,Modal$3 as Modal,NotificationIndicator,NumberCell,NumberInput,NumberUnitInput,OhSnap,OnDarkIconButton,Option$3 as Option,OutlineDangerButton,OutlineOnDarkButton,PageTitle,PlaceholderTile,Popover,PrimaryButton,ProgressBar,ProgressIndicator,RadioButton,RadioGroup,Sidebar,SidebarItem,Spinner,StrongCaption,SuccessToast,Tab,TabBar,Table,Tag,TextTile,Textarea,ThemeProvider$1 as ThemeProvider,Tile,TimeInput,Title1,Title2,Title3,Title4,TitleInput,ToastsContainer$2 as ToastsContainer,UrlInput,UserMenu,Visible,WarningToast,appIcons,beta as betaTheme,clearable$1 as clearable,createDefaultStyle as defaultStyle,defaultSignavioTheme as defaultTheme,fileUtils,fioriMorningHorizonTheme,index$1 as fioriTheme,getTheme$1 as getTheme,glyphCharMap,labeled$2 as labeled,labeled$1 as legacyLabeled,utils as legacyStyles,makeInteractive,multiValue$1 as multiValue,omitProps,index as propTypes,resolveInnerRef,styles,useBaseColor,useFioriStyles,useStyles$1 as useStyles,useTheme};//# sourceMappingURL=ui.esm.js.map
